var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/enums/user-role.ts
var UserRole = {
  USER: "USER",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN"
};
var ADMIN_ROLES = [
  UserRole.ADMIN,
  UserRole.SUPER_ADMIN
];
function isAdminRole(role) {
  return ADMIN_ROLES.includes(role);
}
__name(isAdminRole, "isAdminRole");

// src/enums/app-platform.ts
var AppPlatform = {
  ANDROID: "ANDROID",
  IOS: "IOS"
};
var APP_PLATFORM_LABELS = {
  ANDROID: "Android",
  IOS: "iOS"
};

// src/enums/session-client.ts
var SessionClient = {
  WEB: "WEB",
  APP: "APP"
};
var APP_PLATFORM_HEADER = "x-inflip-app";
function sessionClientOf(appPlatformHeader) {
  const value = Array.isArray(appPlatformHeader) ? appPlatformHeader[0] : appPlatformHeader;
  return value === AppPlatform.ANDROID || value === AppPlatform.IOS ? SessionClient.APP : SessionClient.WEB;
}
__name(sessionClientOf, "sessionClientOf");

// src/enums/order-status.ts
var OrderStatus = {
  ORDER_CREATED: "ORDER_CREATED",
  /** 결제 대기 (무통장: 입금 대기 / 카드: 승인 대기) — 결제 세부는 Payment 참조 */
  PAYMENT_PENDING: "PAYMENT_PENDING",
  /** 결제 완료 (입금 확인 또는 PG 승인) */
  PAID: "PAID",
  LICENSE_ISSUED: "LICENSE_ISSUED",
  SETTLEMENT_PENDING: "SETTLEMENT_PENDING",
  PAYOUT_COMPLETED: "PAYOUT_COMPLETED",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED",
  DISPUTED: "DISPUTED",
  /** 계약 해지 — 어드민이 살아 있는 계약을 중도 종료. 해지일까지의 사용·로열티는 유효 (ContractTerminationService) */
  TERMINATED: "TERMINATED"
};
var ORDER_STATUS_LABELS = {
  ORDER_CREATED: "\uC8FC\uBB38 \uC811\uC218",
  PAYMENT_PENDING: "\uC785\uAE08 \uB300\uAE30",
  PAID: "\uACB0\uC81C \uC644\uB8CC",
  LICENSE_ISSUED: "\uAC70\uB798 \uC644\uB8CC",
  SETTLEMENT_PENDING: "\uC815\uC0B0 \uB300\uAE30",
  PAYOUT_COMPLETED: "\uC815\uC0B0 \uC644\uB8CC",
  CANCELLED: "\uCDE8\uC18C\uB428",
  REFUNDED: "\uD658\uBD88\uB428",
  DISPUTED: "\uBD84\uC7C1 \uCC98\uB9AC \uC911",
  TERMINATED: "\uACC4\uC57D \uD574\uC9C0"
};
var ORDER_STATUS_LABELS_I18N = {
  ko: ORDER_STATUS_LABELS,
  en: {
    ORDER_CREATED: "Order received",
    PAYMENT_PENDING: "Awaiting payment",
    PAID: "Paid",
    LICENSE_ISSUED: "Completed",
    SETTLEMENT_PENDING: "Awaiting payout",
    PAYOUT_COMPLETED: "Payout completed",
    CANCELLED: "Cancelled",
    REFUNDED: "Refunded",
    DISPUTED: "In dispute",
    TERMINATED: "Contract terminated"
  },
  ja: {
    ORDER_CREATED: "\u6CE8\u6587\u53D7\u4ED8",
    PAYMENT_PENDING: "\u5165\u91D1\u5F85\u3061",
    PAID: "\u6C7A\u6E08\u5B8C\u4E86",
    LICENSE_ISSUED: "\u53D6\u5F15\u5B8C\u4E86",
    SETTLEMENT_PENDING: "\u7CBE\u7B97\u5F85\u3061",
    PAYOUT_COMPLETED: "\u7CBE\u7B97\u5B8C\u4E86",
    CANCELLED: "\u30AD\u30E3\u30F3\u30BB\u30EB\u6E08\u307F",
    REFUNDED: "\u8FD4\u91D1\u6E08\u307F",
    DISPUTED: "\u7D1B\u4E89\u5BFE\u5FDC\u4E2D",
    TERMINATED: "\u5951\u7D04\u89E3\u9664"
  }
};
var DisputeResolution = {
  DISMISSED: "DISMISSED",
  REFUNDED: "REFUNDED",
  /** 계약 해지로 종결 (선불 처리는 ContractTermination 기록) */
  TERMINATED: "TERMINATED"
};
var DISPUTE_RESOLUTION_LABELS = {
  DISMISSED: "\uBD84\uC7C1 \uAE30\uAC01",
  REFUNDED: "\uC804\uC561 \uD658\uBD88",
  TERMINATED: "\uACC4\uC57D \uD574\uC9C0\uB85C \uC885\uACB0"
};
var ViolationReportResolution = {
  /** 사용 중지·경고 등 관리자가 조치함 */
  ACTIONED: "ACTIONED",
  DISMISSED: "DISMISSED",
  /** 계약 해지로 종결 — 해지가 신고를 닫는다 (해지 취소 시 다시 처리 중) */
  TERMINATED: "TERMINATED"
};
var VIOLATION_REPORT_RESOLUTION_LABELS = {
  ACTIONED: "\uC870\uCE58 \uC644\uB8CC",
  DISMISSED: "\uC2E0\uACE0 \uAE30\uAC01",
  TERMINATED: "\uACC4\uC57D \uD574\uC9C0\uB85C \uC885\uACB0"
};
var TerminationKind = {
  MUTUAL: "MUTUAL",
  BUYER_BREACH: "BUYER_BREACH",
  SELLER_REQUEST: "SELLER_REQUEST",
  MISTAKE: "MISTAKE",
  OTHER: "OTHER"
};
var TERMINATION_KIND_LABELS = {
  MUTUAL: "\uC591\uCABD \uD569\uC758",
  BUYER_BREACH: "\uAD6C\uB9E4\uC790 \uACC4\uC57D \uC704\uBC18",
  SELLER_REQUEST: "\uD310\uB9E4\uC790 \uC0AC\uC815",
  MISTAKE: "\uCC29\uC624 \uCCB4\uACB0",
  OTHER: "\uAE30\uD0C0"
};
var TERMINATION_KIND_LABELS_I18N = {
  ko: TERMINATION_KIND_LABELS,
  en: {
    MUTUAL: "Mutual agreement",
    BUYER_BREACH: "Buyer breach of contract",
    SELLER_REQUEST: "Seller's circumstances",
    MISTAKE: "Concluded by mistake",
    OTHER: "Other"
  },
  ja: {
    MUTUAL: "\u53CC\u65B9\u5408\u610F",
    BUYER_BREACH: "\u8CFC\u5165\u8005\u306E\u5951\u7D04\u9055\u53CD",
    SELLER_REQUEST: "\u8CA9\u58F2\u8005\u306E\u4E8B\u60C5",
    MISTAKE: "\u932F\u8AA4\u306B\u3088\u308B\u7DE0\u7D50",
    OTHER: "\u305D\u306E\u4ED6"
  }
};
var TerminationRefundMode = {
  NONE: "NONE",
  PARTIAL: "PARTIAL",
  FULL: "FULL"
};
var ContractTerminationStatus = {
  EXECUTED: "EXECUTED",
  /** 해지 취소 — 해지와 함께 정한 환불을 송금하기 전에 어드민이 되돌림. 주문·라이선스는 해지 전 상태로 */
  CANCELLED: "CANCELLED"
};
var TERMINATION_REFUND_MODE_LABELS = {
  NONE: "\uBE44\uD658\uBD88",
  PARTIAL: "\uBD80\uBD84 \uD658\uBD88(\uC120\uBD88)",
  FULL: "\uC804\uC561 \uD658\uBD88(\uC120\uBD88)"
};
var TERMINATION_REFUND_MODE_LABELS_I18N = {
  ko: TERMINATION_REFUND_MODE_LABELS,
  en: {
    NONE: "No refund",
    PARTIAL: "Partial refund (prepaid)",
    FULL: "Full refund (prepaid)"
  },
  ja: {
    NONE: "\u8FD4\u91D1\u306A\u3057",
    PARTIAL: "\u4E00\u90E8\u8FD4\u91D1(\u524D\u6255\u3044)",
    FULL: "\u5168\u984D\u8FD4\u91D1(\u524D\u6255\u3044)"
  }
};
var ORDER_STATUS_TRANSITIONS = [
  {
    from: OrderStatus.ORDER_CREATED,
    to: OrderStatus.PAYMENT_PENDING,
    actors: [
      "SYSTEM"
    ]
  },
  {
    from: OrderStatus.ORDER_CREATED,
    to: OrderStatus.CANCELLED,
    actors: [
      "USER",
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.PAYMENT_PENDING,
    to: OrderStatus.PAID,
    actors: [
      "ADMIN",
      "SYSTEM"
    ]
  },
  {
    from: OrderStatus.PAYMENT_PENDING,
    to: OrderStatus.CANCELLED,
    actors: [
      "USER",
      "ADMIN",
      "SYSTEM"
    ]
  },
  // 만료 후 입금으로 되살리기 — DepositExceptionService 만 (기한 만료로 시스템이 취소한 주문, 주문 때와 같은 검사 통과 시)
  {
    from: OrderStatus.CANCELLED,
    to: OrderStatus.PAID,
    actors: [
      "ADMIN"
    ]
  },
  // 판매자 발급만 — 구매자가 확인한 발급 예정 내용 그대로 (본인 리스팅·초안 확인 검증은 LicenseIssuanceService).
  // 어드민 대리 발급은 두지 않는다. 발급 뒤 고칠 것은 어드민 수정 제안 + 양쪽 동의
  {
    from: OrderStatus.PAID,
    to: OrderStatus.LICENSE_ISSUED,
    actors: [
      "USER"
    ]
  },
  {
    from: OrderStatus.PAID,
    to: OrderStatus.REFUNDED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.LICENSE_ISSUED,
    to: OrderStatus.SETTLEMENT_PENDING,
    actors: [
      "SYSTEM"
    ]
  },
  {
    from: OrderStatus.LICENSE_ISSUED,
    to: OrderStatus.REFUNDED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.LICENSE_ISSUED,
    to: OrderStatus.DISPUTED,
    actors: [
      "USER",
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.SETTLEMENT_PENDING,
    to: OrderStatus.PAYOUT_COMPLETED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.SETTLEMENT_PENDING,
    to: OrderStatus.DISPUTED,
    actors: [
      "USER",
      "ADMIN"
    ]
  },
  // 정산 지급 전 전액 환불 — RefundService 가 대기 중 Settlement 를 CANCELLED 로 닫는다
  {
    from: OrderStatus.SETTLEMENT_PENDING,
    to: OrderStatus.REFUNDED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.DISPUTED,
    to: OrderStatus.REFUNDED,
    actors: [
      "ADMIN"
    ]
  },
  // 분쟁 기각(정산 진행) — OrderDisputeService.dismiss 가 정산을 열고(없으면 만든다) 돌려보낸다.
  // 정산 없이 바로 지급 완료로 가는 길은 두지 않는다 (지급은 항상 정산 대기에서 어드민이 처리)
  {
    from: OrderStatus.DISPUTED,
    to: OrderStatus.SETTLEMENT_PENDING,
    actors: [
      "ADMIN"
    ]
  },
  // 정산할 금액이 없는 계약(0원 로열티 등)의 분쟁 기각 — 원래대로 거래 완료로 (로열티 보고 재개)
  {
    from: OrderStatus.DISPUTED,
    to: OrderStatus.LICENSE_ISSUED,
    actors: [
      "ADMIN"
    ]
  },
  // 정산 완료 후 환불(카드 차지백 등) — RefundService 가 판매자 회수(clawback) 원장 기록을 동반한다
  {
    from: OrderStatus.PAYOUT_COMPLETED,
    to: OrderStatus.REFUNDED,
    actors: [
      "ADMIN"
    ]
  },
  // 정산 지급 뒤 분쟁 — 결론은 회수 뒤 환불 / 해지 / 기각(지급 완료로 돌아감)
  {
    from: OrderStatus.PAYOUT_COMPLETED,
    to: OrderStatus.DISPUTED,
    actors: [
      "USER",
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.DISPUTED,
    to: OrderStatus.PAYOUT_COMPLETED,
    actors: [
      "ADMIN"
    ]
  },
  // 계약 해지 — ContractTerminationService 만. PAID 는 선불 0원 주문만 (발급 전 유상 주문은 전액 환불로)
  {
    from: OrderStatus.PAID,
    to: OrderStatus.TERMINATED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.LICENSE_ISSUED,
    to: OrderStatus.TERMINATED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.SETTLEMENT_PENDING,
    to: OrderStatus.TERMINATED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.PAYOUT_COMPLETED,
    to: OrderStatus.TERMINATED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.DISPUTED,
    to: OrderStatus.TERMINATED,
    actors: [
      "ADMIN"
    ]
  },
  // 해지 뒤 따로 생긴 전액 환불(차지백 등). 해지 때 고른 환불은 상태를 바꾸지 않는다
  {
    from: OrderStatus.TERMINATED,
    to: OrderStatus.REFUNDED,
    actors: [
      "ADMIN"
    ]
  },
  // 해지 취소 — ContractTerminationService.cancel 만. 해지 기록에 남긴 해지 전 상태로 돌아간다
  {
    from: OrderStatus.TERMINATED,
    to: OrderStatus.PAID,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.TERMINATED,
    to: OrderStatus.LICENSE_ISSUED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.TERMINATED,
    to: OrderStatus.SETTLEMENT_PENDING,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.TERMINATED,
    to: OrderStatus.PAYOUT_COMPLETED,
    actors: [
      "ADMIN"
    ]
  },
  {
    from: OrderStatus.TERMINATED,
    to: OrderStatus.DISPUTED,
    actors: [
      "ADMIN"
    ]
  }
];
var DISPUTABLE_ORDER_STATUSES = [
  OrderStatus.LICENSE_ISSUED,
  OrderStatus.SETTLEMENT_PENDING,
  OrderStatus.PAYOUT_COMPLETED
];
var VIOLATION_REPORTABLE_ORDER_STATUSES = [
  OrderStatus.LICENSE_ISSUED,
  OrderStatus.SETTLEMENT_PENDING,
  OrderStatus.PAYOUT_COMPLETED
];
var TERMINAL_ORDER_STATUSES = [
  OrderStatus.CANCELLED,
  OrderStatus.REFUNDED
];
function isTerminalOrderStatus(status) {
  return TERMINAL_ORDER_STATUSES.includes(status);
}
__name(isTerminalOrderStatus, "isTerminalOrderStatus");

// src/enums/order-issue.ts
var OrderIssue = {
  /** 분쟁 진행 중 (주문 DISPUTED) */
  DISPUTE: "DISPUTE",
  /** 판매자 위반 신고 처리 중 */
  VIOLATION_REPORT: "VIOLATION_REPORT",
  /** 환불 신청·승인됨 (완료 전) */
  REFUND: "REFUND",
  /** 지급한 정산 회수 대기·기한 지남 — 판매자 쪽만 */
  CLAWBACK: "CLAWBACK",
  /** 라이선스 사용 중지 */
  LICENSE_SUSPENDED: "LICENSE_SUSPENDED"
};
var ORDER_ISSUE_LABELS = {
  DISPUTE: "\uBD84\uC7C1 \uC9C4\uD589 \uC911",
  VIOLATION_REPORT: "\uC704\uBC18 \uC2E0\uACE0 \uC811\uC218",
  REFUND: "\uD658\uBD88 \uC9C4\uD589 \uC911",
  CLAWBACK: "\uC815\uC0B0 \uD68C\uC218 \uB300\uAE30",
  LICENSE_SUSPENDED: "\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uC911\uC9C0"
};
var ORDER_ISSUE_LABELS_I18N = {
  ko: ORDER_ISSUE_LABELS,
  en: {
    DISPUTE: "Dispute in progress",
    VIOLATION_REPORT: "Violation report filed",
    REFUND: "Refund in progress",
    CLAWBACK: "Awaiting payout clawback",
    LICENSE_SUSPENDED: "License suspended"
  },
  ja: {
    DISPUTE: "\u7D1B\u4E89\u5BFE\u5FDC\u4E2D",
    VIOLATION_REPORT: "\u9055\u53CD\u5831\u544A\u53D7\u4ED8",
    REFUND: "\u8FD4\u91D1\u624B\u7D9A\u304D\u4E2D",
    CLAWBACK: "\u7CBE\u7B97\u56DE\u53CE\u5F85\u3061",
    LICENSE_SUSPENDED: "\u30E9\u30A4\u30BB\u30F3\u30B9\u4F7F\u7528\u505C\u6B62"
  }
};

// src/enums/support.ts
var SupportInquiryStatus = {
  /** 관리자 답변 대기 — 새 문의, 또는 답변 뒤 회원이 이어 물음 */
  WAITING: "WAITING",
  /** 관리자가 답함 (회원이 이어 물으면 다시 대기) */
  ANSWERED: "ANSWERED",
  /** 종료 — 더 이어 쓸 수 없다 (새 문의로) */
  CLOSED: "CLOSED"
};
var SUPPORT_INQUIRY_STATUS_LABELS = {
  WAITING: "\uB2F5\uBCC0 \uB300\uAE30",
  ANSWERED: "\uB2F5\uBCC0 \uC644\uB8CC",
  CLOSED: "\uC885\uB8CC"
};
var SUPPORT_INQUIRY_STATUS_LABELS_I18N = {
  ko: SUPPORT_INQUIRY_STATUS_LABELS,
  en: {
    WAITING: "Awaiting reply",
    ANSWERED: "Answered",
    CLOSED: "Closed"
  },
  ja: {
    WAITING: "\u56DE\u7B54\u5F85\u3061",
    ANSWERED: "\u56DE\u7B54\u6E08\u307F",
    CLOSED: "\u7D42\u4E86"
  }
};
var SupportInquiryCategory = {
  ORDER: "ORDER",
  DISPUTE: "DISPUTE",
  REFUND: "REFUND",
  PAYOUT: "PAYOUT",
  LISTING: "LISTING",
  ACCOUNT: "ACCOUNT",
  OTHER: "OTHER"
};
var SUPPORT_INQUIRY_CATEGORY_LABELS = {
  ORDER: "\uAC70\uB798\xB7\uB77C\uC774\uC120\uC2A4",
  DISPUTE: "\uBD84\uC7C1\xB7\uC704\uBC18 \uC2E0\uACE0",
  REFUND: "\uD658\uBD88",
  PAYOUT: "\uC815\uC0B0",
  LISTING: "IP \uB4F1\uB85D\xB7\uC2EC\uC0AC",
  ACCOUNT: "\uACC4\uC815\xB7\uD68C\uC6D0",
  OTHER: "\uAE30\uD0C0"
};
var SUPPORT_INQUIRY_CATEGORY_LABELS_I18N = {
  ko: SUPPORT_INQUIRY_CATEGORY_LABELS,
  en: {
    ORDER: "Transactions & licenses",
    DISPUTE: "Disputes & violation reports",
    REFUND: "Refunds",
    PAYOUT: "Payouts",
    LISTING: "IP listing & review",
    ACCOUNT: "Account & membership",
    OTHER: "Other"
  },
  ja: {
    ORDER: "\u53D6\u5F15\u30FB\u30E9\u30A4\u30BB\u30F3\u30B9",
    DISPUTE: "\u7D1B\u4E89\u30FB\u9055\u53CD\u5831\u544A",
    REFUND: "\u8FD4\u91D1",
    PAYOUT: "\u7CBE\u7B97",
    LISTING: "IP\u767B\u9332\u30FB\u5BE9\u67FB",
    ACCOUNT: "\u30A2\u30AB\u30A6\u30F3\u30C8\u30FB\u4F1A\u54E1",
    OTHER: "\u305D\u306E\u4ED6"
  }
};
var SupportMessageAuthor = {
  USER: "USER",
  ADMIN: "ADMIN"
};
var SUPPORT_INQUIRY_TITLE_MAX = 100;
var SUPPORT_INQUIRY_BODY_MAX = 3e3;
var SUPPORT_INQUIRY_BODY_MIN = 10;
var SUPPORT_INQUIRY_OPEN_MAX = 10;

// src/enums/listing-status.ts
var ListingStatus = {
  DRAFT: "DRAFT",
  PENDING_REVIEW: "PENDING_REVIEW",
  PUBLISHED: "PUBLISHED",
  SUSPENDED: "SUSPENDED",
  /** 판매 종료 — 판매자가 내린 IP. [판매 재개]로 다시 심사에 올린다 */
  ENDED: "ENDED"
};
var PUBLIC_VISIBLE_LISTING_STATUSES = [
  ListingStatus.PUBLISHED
];
var ListingOfferStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED"
};

// src/i18n/lang.ts
var LANGS = [
  "ko",
  "en",
  "ja"
];
var DEFAULT_LANG = "ko";
function tr(lang, text) {
  return text[lang];
}
__name(tr, "tr");
function toLang(input) {
  const tag = (input ?? "").split(",")[0].split(";")[0].trim().toLowerCase();
  return LANGS.find((l) => tag === l || tag.startsWith(`${l}-`) || tag.startsWith(`${l}_`)) ?? DEFAULT_LANG;
}
__name(toLang, "toLang");
var INTL_LOCALE = {
  ko: "ko-KR",
  en: "en-US",
  ja: "ja-JP"
};

// src/enums/license-status.ts
var LicenseStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  /** 전액 환불 회수 — 처음부터 없던 계약 */
  REVOKED: "REVOKED",
  /** 계약 해지 — 해지 시각(revokedAt)까지는 정당하게 쓴 계약. 증서는 계속 받을 수 있다 */
  TERMINATED: "TERMINATED",
  /**
  * 사용 중지 — 어드민이 조사·분쟁 중에 사용을 잠시 멈춘 계약. 돈·계약은 그대로이고, 풀면 ACTIVE 로 돌아간다.
  * 만료일은 늘어나지 않는다. 중지 중에도 해지·환불·만료될 수 있다 (LicenseSuspension 이 이력)
  */
  SUSPENDED: "SUSPENDED"
};
var LICENSE_VIEW_STATES = [
  "ACTIVE",
  "CONTRACTED",
  "UPCOMING",
  "SUSPENDED",
  "ENDED",
  "TERMINATED",
  "REVOKED"
];
function licenseViewStateOf(license, now) {
  if (license.status === LicenseStatus.REVOKED) return "REVOKED";
  if (license.status === LicenseStatus.TERMINATED) return "TERMINATED";
  if (license.status === LicenseStatus.EXPIRED) return "ENDED";
  if (license.status === LicenseStatus.SUSPENDED) return "SUSPENDED";
  if (license.rightType === "APPEARANCE") return "CONTRACTED";
  if (license.expiresAt && license.expiresAt.getTime() <= now.getTime()) return "ENDED";
  if (license.startsAt.getTime() > now.getTime()) return "UPCOMING";
  return "ACTIVE";
}
__name(licenseViewStateOf, "licenseViewStateOf");
var LicenseAmendmentStatus = {
  /** 양쪽 동의 대기 */
  PENDING: "PENDING",
  /** 양쪽 동의 — 라이선스에 반영됨 */
  APPLIED: "APPLIED",
  /** 구매자 또는 판매자가 거절 */
  DECLINED: "DECLINED",
  /** 어드민이 철회 */
  CANCELLED: "CANCELLED"
};
var LICENSE_AMENDMENT_STATUS_LABELS = {
  PENDING: "\uB3D9\uC758 \uB300\uAE30",
  APPLIED: "\uC218\uC815\uB428",
  DECLINED: "\uAC70\uC808\uB428",
  CANCELLED: "\uCCA0\uD68C\uB428"
};
var LICENSE_AMENDMENT_STATUS_LABELS_I18N = {
  ko: LICENSE_AMENDMENT_STATUS_LABELS,
  en: {
    PENDING: "Awaiting consent",
    APPLIED: "Amended",
    DECLINED: "Declined",
    CANCELLED: "Withdrawn"
  },
  ja: {
    PENDING: "\u540C\u610F\u5F85\u3061",
    APPLIED: "\u4FEE\u6B63\u6E08\u307F",
    DECLINED: "\u62D2\u5426",
    CANCELLED: "\u64A4\u56DE"
  }
};
var LICENSE_AMENDMENT_NOTICES = {
  PROPOSED: /* @__PURE__ */ __name((listingTitle, lang = DEFAULT_LANG) => ({
    title: tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4 \uC218\uC815 \uC81C\uC548\uC774 \uC654\uC5B4\uC694",
      en: "You have a license amendment proposal",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u4FEE\u6B63\u306E\u63D0\u6848\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: tr(lang, {
      ko: `${listingTitle} \u2014 \uAD00\uB9AC\uC790\uAC00 \uB77C\uC774\uC120\uC2A4 \uC218\uC815\uC744 \uC81C\uC548\uD588\uC5B4\uC694. \uBC14\uB00C\uB294 \uB0B4\uC6A9\uC744 \uD655\uC778\uD558\uACE0 \uB3D9\uC758\uD574 \uC8FC\uC138\uC694. \uB450 \uBD84 \uBAA8\uB450 \uB3D9\uC758\uD574\uC57C \uC218\uC815\uB3FC\uC694.`,
      en: `${listingTitle} \u2014 An admin proposed an amendment to the license. Please review the changes and consent. The license is amended only when both of you consent.`,
      ja: `${listingTitle} \u2014 \u7BA1\u7406\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4FEE\u6B63\u3092\u63D0\u6848\u3057\u307E\u3057\u305F\u3002\u5909\u66F4\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u540C\u610F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u304A\u4E8C\u4EBA\u3068\u3082\u540C\u610F\u3059\u308B\u3068\u4FEE\u6B63\u3055\u308C\u307E\u3059\u3002`
    })
  }), "PROPOSED"),
  APPLIED: /* @__PURE__ */ __name((listingTitle, lang = DEFAULT_LANG) => ({
    title: tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4\uAC00 \uC218\uC815\uB410\uC5B4\uC694",
      en: "The license was amended",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u4FEE\u6B63\u3055\u308C\u307E\u3057\u305F"
    }),
    body: tr(lang, {
      ko: `${listingTitle} \u2014 \uB450 \uBD84 \uBAA8\uB450 \uB3D9\uC758\uD574 \uB77C\uC774\uC120\uC2A4\uAC00 \uC218\uC815\uB410\uC5B4\uC694. \uC99D\uC11C\uC5D0\uB3C4 \uBC14\uB010 \uB0B4\uC6A9\uC774 \uB2F4\uACA8\uC694.`,
      en: `${listingTitle} \u2014 You both consented, so the license was amended. The certificate also reflects the changes.`,
      ja: `${listingTitle} \u2014 \u304A\u4E8C\u4EBA\u3068\u3082\u540C\u610F\u3057\u305F\u305F\u3081\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u4FEE\u6B63\u3055\u308C\u307E\u3057\u305F\u3002\u8A3C\u66F8\u306B\u3082\u5909\u66F4\u5185\u5BB9\u304C\u53CD\u6620\u3055\u308C\u307E\u3059\u3002`
    })
  }), "APPLIED"),
  DECLINED: /* @__PURE__ */ __name((listingTitle, by, lang = DEFAULT_LANG) => ({
    title: tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4 \uC218\uC815\uC774 \uAC70\uC808\uB410\uC5B4\uC694",
      en: "The license amendment was declined",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4FEE\u6B63\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F"
    }),
    body: tr(lang, {
      ko: `${listingTitle} \u2014 ${by === "BUYER" ? "\uAD6C\uB9E4\uC790" : "\uD310\uB9E4\uC790"}\uAC00 \uC218\uC815\uC744 \uAC70\uC808\uD574 \uB77C\uC774\uC120\uC2A4\uB294 \uADF8\uB300\uB85C\uC608\uC694.`,
      en: `${listingTitle} \u2014 The ${by === "BUYER" ? "buyer" : "seller"} declined the amendment, so the license stays the same.`,
      ja: `${listingTitle} \u2014 ${by === "BUYER" ? "\u8CFC\u5165\u8005" : "\u8CA9\u58F2\u8005"}\u304C\u4FEE\u6B63\u3092\u62D2\u5426\u3057\u305F\u305F\u3081\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u305D\u306E\u307E\u307E\u3067\u3059\u3002`
    })
  }), "DECLINED"),
  CANCELLED: /* @__PURE__ */ __name((listingTitle, lang = DEFAULT_LANG) => ({
    title: tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4 \uC218\uC815 \uC81C\uC548\uC774 \uCCA0\uD68C\uB410\uC5B4\uC694",
      en: "The license amendment proposal was withdrawn",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u4FEE\u6B63\u306E\u63D0\u6848\u304C\u64A4\u56DE\u3055\u308C\u307E\u3057\u305F"
    }),
    body: tr(lang, {
      ko: `${listingTitle} \u2014 \uAD00\uB9AC\uC790\uAC00 \uC218\uC815 \uC81C\uC548\uC744 \uCCA0\uD68C\uD588\uC5B4\uC694. \uB77C\uC774\uC120\uC2A4\uB294 \uADF8\uB300\uB85C\uC608\uC694.`,
      en: `${listingTitle} \u2014 An admin withdrew the amendment proposal. The license stays the same.`,
      ja: `${listingTitle} \u2014 \u7BA1\u7406\u8005\u304C\u4FEE\u6B63\u306E\u63D0\u6848\u3092\u64A4\u56DE\u3057\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u305D\u306E\u307E\u307E\u3067\u3059\u3002`
    })
  }), "CANCELLED")
};
var LICENSE_SUSPENSION_NOTICES = {
  SUSPENDED: /* @__PURE__ */ __name((listingTitle, reason, lang = DEFAULT_LANG) => ({
    title: tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9\uC774 \uC911\uC9C0\uB410\uC5B4\uC694",
      en: "License use was suspended",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u304C\u505C\u6B62\u3055\u308C\u307E\u3057\u305F"
    }),
    body: tr(lang, {
      ko: `${listingTitle} \u2014 \uAD00\uB9AC\uC790\uAC00 \uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9\uC744 \uC7A0\uC2DC \uC911\uC9C0\uD588\uC5B4\uC694. \uB2E4\uC2DC \uD480\uB9B4 \uB54C\uAE4C\uC9C0 \uC0AC\uC6A9\uD558\uC9C0 \uB9D0\uC544 \uC8FC\uC138\uC694. \uC0AC\uC720: ${reason}`,
      en: `${listingTitle} \u2014 An admin temporarily suspended use of the license. Please don't use it until the suspension is lifted. Reason: ${reason}`,
      ja: `${listingTitle} \u2014 \u7BA1\u7406\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u3092\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002\u505C\u6B62\u304C\u89E3\u9664\u3055\u308C\u308B\u307E\u3067\u4F7F\u7528\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u7406\u7531\uFF1A${reason}`
    })
  }), "SUSPENDED"),
  RESUMED: /* @__PURE__ */ __name((listingTitle, lang = DEFAULT_LANG) => ({
    title: tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4\uB97C \uB2E4\uC2DC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694",
      en: "You can use the license again",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u518D\u3073\u4F7F\u7528\u3067\u304D\u307E\u3059"
    }),
    body: tr(lang, {
      ko: `${listingTitle} \u2014 \uAD00\uB9AC\uC790\uAC00 \uC0AC\uC6A9 \uC911\uC9C0\uB97C \uD480\uC5C8\uC5B4\uC694. \uACC4\uC57D \uB0B4\uC6A9\uB300\uB85C \uB2E4\uC2DC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.`,
      en: `${listingTitle} \u2014 An admin lifted the suspension. You can use it again under the contract terms.`,
      ja: `${listingTitle} \u2014 \u7BA1\u7406\u8005\u304C\u4F7F\u7528\u505C\u6B62\u3092\u89E3\u9664\u3057\u307E\u3057\u305F\u3002\u5951\u7D04\u5185\u5BB9\u3069\u304A\u308A\u518D\u3073\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002`
    })
  }), "RESUMED")
};

// src/enums/settlement-status.ts
var SettlementStatus = {
  SCHEDULED: "SCHEDULED",
  HOLDING: "HOLDING",
  READY: "READY",
  PAID_OUT: "PAID_OUT",
  ON_HOLD: "ON_HOLD",
  CANCELLED: "CANCELLED"
};

// src/constants/time-zone.ts
var DEFAULT_TIME_ZONE = "Asia/Seoul";
var DAY_MS = 864e5;
var partsFormatters = /* @__PURE__ */ new Map();
function partsFormatter(timeZone) {
  let f = partsFormatters.get(timeZone);
  if (!f) {
    f = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
    partsFormatters.set(timeZone, f);
  }
  return f;
}
__name(partsFormatter, "partsFormatter");
function isValidTimeZone(timeZone) {
  try {
    partsFormatter(timeZone);
    return true;
  } catch {
    return false;
  }
}
__name(isValidTimeZone, "isValidTimeZone");
function zonedParts(at, timeZone) {
  const p = {};
  for (const { type, value } of partsFormatter(timeZone).formatToParts(at)) {
    if (type !== "literal") p[type] = Number(value);
  }
  return {
    year: p.year,
    month: p.month,
    day: p.day,
    hour: p.hour % 24,
    minute: p.minute,
    second: p.second
  };
}
__name(zonedParts, "zonedParts");
function offsetMs(at, timeZone) {
  const p = zonedParts(at, timeZone);
  const wall = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  return wall - Math.floor(at.getTime() / 1e3) * 1e3;
}
__name(offsetMs, "offsetMs");
function zonedTimeToUtc(timeZone, year, month, day, hour = 0, minute = 0, second = 0, ms = 0) {
  const wall = Date.UTC(year, month - 1, day, hour, minute, second, ms);
  let at = wall - offsetMs(new Date(wall), timeZone);
  const second2 = wall - offsetMs(new Date(at), timeZone);
  if (second2 !== at) at = Math.max(at, second2);
  return new Date(at);
}
__name(zonedTimeToUtc, "zonedTimeToUtc");
var pad2 = /* @__PURE__ */ __name((n) => String(n).padStart(2, "0"), "pad2");
function zonedDateOf(at, timeZone) {
  const p = zonedParts(at, timeZone);
  return `${p.year}-${pad2(p.month)}-${pad2(p.day)}`;
}
__name(zonedDateOf, "zonedDateOf");
function zonedPeriodOf(at, timeZone) {
  return zonedDateOf(at, timeZone).slice(0, 7);
}
__name(zonedPeriodOf, "zonedPeriodOf");
function isValidDateOnly(date) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  return addDateDays(date, 0) === date;
}
__name(isValidDateOnly, "isValidDateOnly");
function startOfZonedDate(date, timeZone) {
  const [y = 0, m = 1, d = 1] = date.split("-").map(Number);
  return zonedTimeToUtc(timeZone, y, m, d);
}
__name(startOfZonedDate, "startOfZonedDate");
function addDateDays(date, days) {
  const [y = 0, m = 1, d = 1] = date.split("-").map(Number);
  const t = new Date(Date.UTC(y, m - 1, d) + days * DAY_MS);
  return `${t.getUTCFullYear()}-${pad2(t.getUTCMonth() + 1)}-${pad2(t.getUTCDate())}`;
}
__name(addDateDays, "addDateDays");
function timeZoneLabel(timeZone, at = /* @__PURE__ */ new Date(), lang = DEFAULT_LANG) {
  if (timeZone === "Asia/Seoul") return tr(lang, {
    ko: "\uD55C\uAD6D \uC2DC\uAC04",
    en: "Korea time",
    ja: "\u97D3\u56FD\u6642\u9593"
  });
  const name = new Intl.DateTimeFormat(INTL_LOCALE[lang], {
    timeZone,
    timeZoneName: "short"
  }).formatToParts(at).find((p) => p.type === "timeZoneName")?.value;
  return name ?? timeZone;
}
__name(timeZoneLabel, "timeZoneLabel");
var displayFormatters = /* @__PURE__ */ new Map();
function formatInTimeZone(at, timeZone, options, locale = "ko-KR") {
  const key = `${locale}|${timeZone}|${JSON.stringify(options)}`;
  let f = displayFormatters.get(key);
  if (!f) {
    f = new Intl.DateTimeFormat(locale, {
      ...options,
      timeZone
    });
    displayFormatters.set(key, f);
  }
  return f.format(typeof at === "string" ? new Date(at) : at);
}
__name(formatInTimeZone, "formatInTimeZone");
function formatDateDots(at, timeZone) {
  return zonedDateOf(typeof at === "string" ? new Date(at) : at, timeZone).replaceAll("-", ".");
}
__name(formatDateDots, "formatDateDots");
var DATE_NUMERIC = {
  year: "numeric",
  month: "numeric",
  day: "numeric"
};
var DATE_TIME = {
  ...DATE_NUMERIC,
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
};

// src/types/money.ts
var krw = /* @__PURE__ */ __name((amount) => ({
  amount,
  currency: "KRW"
}), "krw");
function addMoney(a, b) {
  if (a.currency !== b.currency) {
    throw new Error(`Currency mismatch: ${a.currency} vs ${b.currency}`);
  }
  return {
    amount: a.amount + b.amount,
    currency: a.currency
  };
}
__name(addMoney, "addMoney");
function subtractMoney(a, b) {
  if (a.currency !== b.currency) {
    throw new Error(`Currency mismatch: ${a.currency} vs ${b.currency}`);
  }
  return {
    amount: a.amount - b.amount,
    currency: a.currency
  };
}
__name(subtractMoney, "subtractMoney");
function multiplyMoney(m, factor) {
  return {
    amount: Math.round(m.amount * factor),
    currency: m.currency
  };
}
__name(multiplyMoney, "multiplyMoney");
function formatWon(amount, lang = DEFAULT_LANG) {
  const n = amount.toLocaleString(INTL_LOCALE[lang]);
  return tr(lang, {
    ko: `${n}\uC6D0`,
    en: `\u20A9${n}`,
    ja: `${n}\u30A6\u30A9\u30F3`
  });
}
__name(formatWon, "formatWon");

// src/enums/chat.ts
var ChatMessageType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  FILE: "FILE",
  SYSTEM: "SYSTEM"
};
var ChatParticipantRole = {
  BUYER: "BUYER",
  SELLER: "SELLER",
  ADMIN: "ADMIN"
};
var ChatRoomStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED"
};
var ChatRoomType = {
  ORDER: "ORDER",
  DIRECT: "DIRECT"
};
var CHAT_ROOM_TYPE_LABELS = {
  ORDER: "\uAC70\uB798 \uCC44\uD305",
  DIRECT: "1:1 \uCC44\uD305"
};
var CHAT_ROOM_TYPE_LABELS_I18N = {
  ko: CHAT_ROOM_TYPE_LABELS,
  en: {
    ORDER: "Order chat",
    DIRECT: "1:1 chat"
  },
  ja: {
    ORDER: "\u53D6\u5F15\u30C1\u30E3\u30C3\u30C8",
    DIRECT: "1:1\u30C1\u30E3\u30C3\u30C8"
  }
};
var ChatReportReason = {
  SPAM: "SPAM",
  FRAUD: "FRAUD",
  ABUSE: "ABUSE",
  OTHER: "OTHER"
};
var CHAT_REPORT_REASON_LABELS = {
  [ChatReportReason.SPAM]: "\uC2A4\uD338\xB7\uAD11\uACE0\uC608\uC694",
  [ChatReportReason.FRAUD]: "\uC0AC\uAE30\uAC00 \uC758\uC2EC\uB3FC\uC694",
  [ChatReportReason.ABUSE]: "\uC695\uC124\xB7\uBE44\uBC29\uC744 \uD574\uC694",
  [ChatReportReason.OTHER]: "\uAE30\uD0C0"
};
var CHAT_REPORT_REASON_LABELS_I18N = {
  ko: CHAT_REPORT_REASON_LABELS,
  en: {
    SPAM: "Spam or advertising",
    FRAUD: "Suspected fraud",
    ABUSE: "Abusive or insulting language",
    OTHER: "Other"
  },
  ja: {
    SPAM: "\u30B9\u30D1\u30E0\u30FB\u5E83\u544A\u3067\u3059",
    FRAUD: "\u8A50\u6B3A\u306E\u7591\u3044\u304C\u3042\u308A\u307E\u3059",
    ABUSE: "\u66B4\u8A00\u30FB\u8AB9\u8B17\u4E2D\u50B7\u304C\u3042\u308A\u307E\u3059",
    OTHER: "\u305D\u306E\u4ED6"
  }
};
var CHAT_PARTICIPANT_LEFT_MESSAGE = "\uC0C1\uB300\uBC29\uC774 \uCC44\uD305\uBC29\uC744 \uB098\uAC14\uC2B5\uB2C8\uB2E4.";
var CHAT_PARTICIPANT_LEFT_MESSAGE_I18N = {
  ko: CHAT_PARTICIPANT_LEFT_MESSAGE,
  en: "The other person has left the chat.",
  ja: "\u76F8\u624B\u304C\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u3092\u9000\u51FA\u3057\u307E\u3057\u305F\u3002"
};
var CHAT_ROOM_CLOSED_MESSAGE_I18N = {
  ko: "\uAC70\uB798\uAC00 \uC885\uACB0\uB418\uC5B4 \uCC44\uD305\uC774 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC774\uC804 \uB300\uD654\uB294 \uACC4\uC18D \uC5F4\uB78C\uD560 \uC218 \uC788\uC5B4\uC694.",
  en: "The transaction has ended, so this chat is closed. You can still view earlier messages.",
  ja: "\u53D6\u5F15\u304C\u7D42\u4E86\u3057\u305F\u305F\u3081\u3001\u30C1\u30E3\u30C3\u30C8\u306F\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u3053\u308C\u307E\u3067\u306E\u4F1A\u8A71\u306F\u5F15\u304D\u7D9A\u304D\u95B2\u89A7\u3067\u304D\u307E\u3059\u3002"
};
var ORDER_STATUS_SYSTEM_MESSAGE = {
  [OrderStatus.PAID]: "\uACB0\uC81C\uAC00 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  [OrderStatus.LICENSE_ISSUED]: "\uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uAD6C\uB9E4\uC790\uB294 \uBC1B\uC740 \uB77C\uC774\uC120\uC2A4\uC640 \uC790\uB8CC\uB97C \uD655\uC778\uD558\uACE0 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uAD6C\uB9E4\uD655\uC815\uD574 \uC8FC\uC138\uC694. \uD655\uC815\uD558\uC9C0 \uC54A\uC544\uB3C4 \uAE30\uD55C\uC774 \uC9C0\uB098\uBA74 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB3FC\uC694.",
  [OrderStatus.DISPUTED]: "\uBD84\uC7C1\uC774 \uC811\uC218\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC5B4\uB4DC\uBBFC\uC774 \uACE7 \uD569\uB958\uD569\uB2C8\uB2E4.",
  [OrderStatus.REFUNDED]: "\uD658\uBD88\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  [OrderStatus.CANCELLED]: "\uC8FC\uBB38\uC774 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  [OrderStatus.PAYOUT_COMPLETED]: "\uD310\uB9E4\uC790 \uC815\uC0B0\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  [OrderStatus.SETTLEMENT_PENDING]: "\uAD6C\uB9E4\uD655\uC815\uB418\uC5B4 \uD310\uB9E4\uC790 \uC815\uC0B0 \uCC98\uB9AC\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  [OrderStatus.TERMINATED]: "\uAD00\uB9AC\uC790\uAC00 \uACC4\uC57D\uC744 \uD574\uC9C0\uD588\uC2B5\uB2C8\uB2E4. \uD574\uC9C0 \uC0AC\uC720\uC640 \uC120\uBD88 \uCC98\uB9AC \uBC29\uC2DD\uC740 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694. \uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC740 \uD574\uC9C0\uC77C\uC774 \uC788\uB294 \uB2EC\uAE4C\uC9C0 \uACC4\uC18D \uBCF4\uACE0\xB7\uC815\uC0B0\uB429\uB2C8\uB2E4."
};
var ORDER_STATUS_SYSTEM_MESSAGE_I18N = {
  ko: ORDER_STATUS_SYSTEM_MESSAGE,
  en: {
    [OrderStatus.PAID]: "Payment confirmed.",
    [OrderStatus.LICENSE_ISSUED]: "The license has been issued. Buyer, please check the license and materials you received, then confirm the purchase on the order details page. If you don't, it will be confirmed automatically once the deadline passes.",
    [OrderStatus.DISPUTED]: "A dispute has been filed. An admin will join shortly.",
    [OrderStatus.REFUNDED]: "The refund is complete.",
    [OrderStatus.CANCELLED]: "The order has been cancelled.",
    [OrderStatus.PAYOUT_COMPLETED]: "The seller payout is complete.",
    [OrderStatus.SETTLEMENT_PENDING]: "Purchase confirmed. The seller payout has started.",
    [OrderStatus.TERMINATED]: "An admin has terminated the contract. You can find the reason and how the prepayment was handled on the order details page. Royalty contracts keep being reported and paid out through the month of termination."
  },
  ja: {
    [OrderStatus.PAID]: "\u304A\u652F\u6255\u3044\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002",
    [OrderStatus.LICENSE_ISSUED]: "\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u307E\u3057\u305F\u3002\u8CFC\u5165\u8005\u306F\u53D7\u3051\u53D6\u3063\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u3068\u8CC7\u6599\u3092\u78BA\u8A8D\u3057\u3001\u6CE8\u6587\u8A73\u7D30\u304B\u3089\u8CFC\u5165\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u78BA\u5B9A\u3057\u306A\u304F\u3066\u3082\u671F\u9650\u304C\u904E\u304E\u308B\u3068\u81EA\u52D5\u3067\u78BA\u5B9A\u3055\u308C\u307E\u3059\u3002",
    [OrderStatus.DISPUTED]: "\u7D1B\u4E89\u304C\u53D7\u3051\u4ED8\u3051\u3089\u308C\u307E\u3057\u305F\u3002\u307E\u3082\u306A\u304F\u7BA1\u7406\u8005\u304C\u53C2\u52A0\u3057\u307E\u3059\u3002",
    [OrderStatus.REFUNDED]: "\u8FD4\u91D1\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002",
    [OrderStatus.CANCELLED]: "\u6CE8\u6587\u304C\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002",
    [OrderStatus.PAYOUT_COMPLETED]: "\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002",
    [OrderStatus.SETTLEMENT_PENDING]: "\u8CFC\u5165\u78BA\u5B9A\u3055\u308C\u3001\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u51E6\u7406\u304C\u59CB\u307E\u308A\u307E\u3057\u305F\u3002",
    [OrderStatus.TERMINATED]: "\u7BA1\u7406\u8005\u304C\u5951\u7D04\u3092\u89E3\u9664\u3057\u307E\u3057\u305F\u3002\u89E3\u9664\u7406\u7531\u3068\u524D\u6255\u3044\u306E\u51E6\u7406\u65B9\u6CD5\u306F\u6CE8\u6587\u8A73\u7D30\u3067\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u306F\u89E3\u9664\u65E5\u306E\u3042\u308B\u6708\u307E\u3067\u5F15\u304D\u7D9A\u304D\u5831\u544A\u30FB\u7CBE\u7B97\u3055\u308C\u307E\u3059\u3002"
  }
};
function licenseIssuedChatMessage(input, lang = DEFAULT_LANG) {
  const { purchaseConfirmDueAt: dueAt, issuedAt, startsAt, timeZone } = input;
  const startsLater = !!startsAt && startsAt > issuedAt;
  const base = startsLater ? startsAt : issuedAt;
  const hours = Math.round((dueAt.getTime() - base.getTime()) / 36e5);
  const inDays = hours % 24 === 0 && hours >= 48;
  const span = inDays ? tr(lang, {
    ko: `${hours / 24}\uC77C`,
    en: `${hours / 24} days`,
    ja: `${hours / 24}\u65E5`
  }) : tr(lang, {
    ko: `${hours}\uC2DC\uAC04`,
    en: hours === 1 ? "1 hour" : `${hours} hours`,
    ja: `${hours}\u6642\u9593`
  });
  const when = `${zonedDateOf(dueAt, timeZone).replaceAll("-", ".")} ${formatInTimeZone(dueAt, timeZone, {
    hour: "numeric",
    minute: "2-digit"
  }, INTL_LOCALE[lang])}`;
  return tr(lang, {
    ko: `\uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uAD6C\uB9E4\uC790\uB294 \uBC1B\uC740 \uB77C\uC774\uC120\uC2A4\uC640 \uC790\uB8CC\uB97C \uD655\uC778\uD558\uACE0 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uAD6C\uB9E4\uD655\uC815\uD574 \uC8FC\uC138\uC694. \uD655\uC815\uD558\uC9C0 \uC54A\uC544\uB3C4 ${startsLater ? "\uC0AC\uC6A9 \uC2DC\uC791\uC77C\uBD80\uD130" : "\uBC1C\uAE09 \uD6C4"} ${span}(${when})\uC774 \uC9C0\uB098\uBA74 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB3FC\uC694.`,
    en: `The license has been issued. Buyer, please check the license and materials you received, then confirm the purchase on the order details page. If you don't, it will be confirmed automatically ${span} ${startsLater ? "after the usage start date" : "after issuance"} (${when}).`,
    ja: `\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u307E\u3057\u305F\u3002\u8CFC\u5165\u8005\u306F\u53D7\u3051\u53D6\u3063\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u3068\u8CC7\u6599\u3092\u78BA\u8A8D\u3057\u3001\u6CE8\u6587\u8A73\u7D30\u304B\u3089\u8CFC\u5165\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u78BA\u5B9A\u3057\u306A\u304F\u3066\u3082${startsLater ? "\u4F7F\u7528\u958B\u59CB\u65E5\u304B\u3089" : "\u767A\u884C\u5F8C"}${span}\uFF08${when}\uFF09\u304C\u904E\u304E\u308B\u3068\u81EA\u52D5\u3067\u78BA\u5B9A\u3055\u308C\u307E\u3059\u3002`
  });
}
__name(licenseIssuedChatMessage, "licenseIssuedChatMessage");
var TERMINATION_CANCELLED_SYSTEM_MESSAGE = "\uAD00\uB9AC\uC790\uAC00 \uACC4\uC57D \uD574\uC9C0\uB97C \uCDE8\uC18C\uD588\uC2B5\uB2C8\uB2E4. \uACC4\uC57D\uC740 \uD574\uC9C0 \uC804 \uC0C1\uD0DC\uB85C \uC774\uC5B4\uC9C0\uACE0, \uD574\uC9C0\uC640 \uD568\uAED8 \uC815\uD55C \uD658\uBD88\uB3C4 \uCDE8\uC18C\uB410\uC5B4\uC694.";
var TERMINATION_CANCELLED_SYSTEM_MESSAGE_I18N = {
  ko: TERMINATION_CANCELLED_SYSTEM_MESSAGE,
  en: "An admin has cancelled the contract termination. The contract continues as it was before the termination, and the refund set with it has been cancelled.",
  ja: "\u7BA1\u7406\u8005\u304C\u5951\u7D04\u89E3\u9664\u3092\u53D6\u308A\u6D88\u3057\u307E\u3057\u305F\u3002\u5951\u7D04\u306F\u89E3\u9664\u524D\u306E\u72B6\u614B\u3067\u7D99\u7D9A\u3055\u308C\u3001\u89E3\u9664\u3068\u3042\u308F\u305B\u3066\u6C7A\u3081\u305F\u8FD4\u91D1\u3082\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F\u3002"
};
var DISPUTE_DISMISSED_SYSTEM_MESSAGES = {
  SETTLEMENT_PENDING: "\uAD00\uB9AC\uC790\uAC00 \uBD84\uC7C1\uC744 \uAC80\uD1A0\uD574 \uC885\uB8CC\uD588\uC2B5\uB2C8\uB2E4. \uD310\uB9E4\uC790 \uC815\uC0B0\uC774 \uB2E4\uC2DC \uC9C4\uD589\uB429\uB2C8\uB2E4.",
  LICENSE_ISSUED: "\uAD00\uB9AC\uC790\uAC00 \uBD84\uC7C1\uC744 \uAC80\uD1A0\uD574 \uC885\uB8CC\uD588\uC2B5\uB2C8\uB2E4. \uAC70\uB798\uAC00 \uADF8\uB300\uB85C \uC774\uC5B4\uC9D1\uB2C8\uB2E4.",
  PAYOUT_COMPLETED: "\uAD00\uB9AC\uC790\uAC00 \uBD84\uC7C1\uC744 \uAC80\uD1A0\uD574 \uC885\uB8CC\uD588\uC2B5\uB2C8\uB2E4. \uAC70\uB798\uAC00 \uADF8\uB300\uB85C \uC774\uC5B4\uC9D1\uB2C8\uB2E4."
};
var DISPUTE_DISMISSED_SYSTEM_MESSAGES_I18N = {
  ko: DISPUTE_DISMISSED_SYSTEM_MESSAGES,
  en: {
    SETTLEMENT_PENDING: "An admin reviewed and closed the dispute. The seller payout will resume.",
    LICENSE_ISSUED: "An admin reviewed and closed the dispute. The transaction continues as is.",
    PAYOUT_COMPLETED: "An admin reviewed and closed the dispute. The transaction continues as is."
  },
  ja: {
    SETTLEMENT_PENDING: "\u7BA1\u7406\u8005\u304C\u7D1B\u4E89\u3092\u78BA\u8A8D\u3057\u3001\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u304C\u518D\u958B\u3055\u308C\u307E\u3059\u3002",
    LICENSE_ISSUED: "\u7BA1\u7406\u8005\u304C\u7D1B\u4E89\u3092\u78BA\u8A8D\u3057\u3001\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u53D6\u5F15\u306F\u305D\u306E\u307E\u307E\u7D99\u7D9A\u3055\u308C\u307E\u3059\u3002",
    PAYOUT_COMPLETED: "\u7BA1\u7406\u8005\u304C\u7D1B\u4E89\u3092\u78BA\u8A8D\u3057\u3001\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u53D6\u5F15\u306F\u305D\u306E\u307E\u307E\u7D99\u7D9A\u3055\u308C\u307E\u3059\u3002"
  }
};
var CHAT_ROOM_WELCOME_MESSAGE = "\uC8FC\uBB38 \uCC44\uD305\uC774 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uAC70\uB798\uC5D0 \uB300\uD574 \uC790\uC720\uB86D\uAC8C \uB300\uD654\uD558\uC138\uC694.";
var CHAT_ROOM_WELCOME_MESSAGE_I18N = {
  ko: CHAT_ROOM_WELCOME_MESSAGE,
  en: "Order chat has started. Feel free to talk about the transaction.",
  ja: "\u6CE8\u6587\u30C1\u30E3\u30C3\u30C8\u304C\u59CB\u307E\u308A\u307E\u3057\u305F\u3002\u53D6\u5F15\u306B\u3064\u3044\u3066\u81EA\u7531\u306B\u304A\u8A71\u3057\u304F\u3060\u3055\u3044\u3002"
};
var CHAT_ADMIN_JOINED_MESSAGE = "\uAD00\uB9AC\uC790\uAC00 \uCC44\uD305\uC5D0 \uCC38\uC5EC\uD588\uC2B5\uB2C8\uB2E4.";
var CHAT_ADMIN_JOINED_MESSAGE_I18N = {
  ko: CHAT_ADMIN_JOINED_MESSAGE,
  en: "An admin has joined the chat.",
  ja: "\u7BA1\u7406\u8005\u304C\u30C1\u30E3\u30C3\u30C8\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\u3002"
};
var CHAT_ADMIN_LEFT_MESSAGE = "\uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uAC00 \uD1F4\uC7A5\uD588\uC2B5\uB2C8\uB2E4.";
var CHAT_ADMIN_LEFT_MESSAGE_I18N = {
  ko: CHAT_ADMIN_LEFT_MESSAGE,
  en: "The Inflip operator has left the chat.",
  ja: "Inflip\u904B\u55B6\u8005\u304C\u9000\u51FA\u3057\u307E\u3057\u305F\u3002"
};
var CHAT_DIRECT_WELCOME_MESSAGE = "1:1 \uCC44\uD305\uC774 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uAD81\uAE08\uD55C \uC810\uC744 \uC790\uC720\uB86D\uAC8C \uB300\uD654\uD558\uC138\uC694.";
var CHAT_DIRECT_WELCOME_MESSAGE_I18N = {
  ko: CHAT_DIRECT_WELCOME_MESSAGE,
  en: "1:1 chat has started. Feel free to ask anything.",
  ja: "1:1\u30C1\u30E3\u30C3\u30C8\u304C\u59CB\u307E\u308A\u307E\u3057\u305F\u3002\u6C17\u306B\u306A\u308B\u3053\u3068\u3092\u81EA\u7531\u306B\u304A\u8A71\u3057\u304F\u3060\u3055\u3044\u3002"
};
var CHAT_LISTING_INQUIRY_EVENT_PREFIX = "LISTING_INQUIRY:";
function inquiryListingIdOf(systemEvent) {
  return systemEvent?.startsWith(CHAT_LISTING_INQUIRY_EVENT_PREFIX) ? systemEvent.slice(CHAT_LISTING_INQUIRY_EVENT_PREFIX.length) : null;
}
__name(inquiryListingIdOf, "inquiryListingIdOf");
var titlePrefix = /* @__PURE__ */ __name((title) => title ? `[${title}] ` : "", "titlePrefix");
var CHAT_LICENSE_DRAFT_EVENT = "LICENSE_DRAFT_UPDATED";
var LICENSE_DRAFT_SYSTEM_MESSAGES = {
  CREATED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uD310\uB9E4\uC790\uB2D8\uC774 ${titlePrefix(title)}\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uC62C\uB838\uC5B4\uC694. \uAD6C\uB9E4\uC790\uB2D8\uC740 \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.`,
    en: `${titlePrefix(title)}The seller posted the license draft. Buyer, please review it.`,
    ja: `${titlePrefix(title)}\u8CA9\u58F2\u8005\u304C\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u767B\u9332\u3057\u307E\u3057\u305F\u3002\u8CFC\u5165\u8005\u306F\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002`
  }), "CREATED"),
  UPDATED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uD310\uB9E4\uC790\uB2D8\uC774 ${titlePrefix(title)}\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uACE0\uCCE4\uC5B4\uC694. \uAD6C\uB9E4\uC790\uB2D8\uC740 \uBC14\uB010 \uB0B4\uC6A9\uC744 \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.`,
    en: `${titlePrefix(title)}The seller updated the license draft. Buyer, please review the changes again.`,
    ja: `${titlePrefix(title)}\u8CA9\u58F2\u8005\u304C\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u4FEE\u6B63\u3057\u307E\u3057\u305F\u3002\u8CFC\u5165\u8005\u306F\u5909\u66F4\u3055\u308C\u305F\u5185\u5BB9\u3092\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002`
  }), "UPDATED"),
  CONFIRMED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD6C\uB9E4\uC790\uB2D8\uC774 ${titlePrefix(title)}\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uD655\uC778\uD588\uC5B4\uC694. \uD310\uB9E4\uC790\uB2D8\uC740 \uC774 \uB0B4\uC6A9\uC73C\uB85C \uBC1C\uAE09\uD560 \uC218 \uC788\uC5B4\uC694.`,
    en: `${titlePrefix(title)}The buyer confirmed the license draft. Seller, you can now issue it as is.`,
    ja: `${titlePrefix(title)}\u8CFC\u5165\u8005\u304C\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002\u8CA9\u58F2\u8005\u306F\u3053\u306E\u5185\u5BB9\u3067\u767A\u884C\u3067\u304D\u307E\u3059\u3002`
  }), "CONFIRMED")
};
var CHAT_LICENSE_AMENDMENT_EVENT = "LICENSE_AMENDMENT_UPDATED";
var partyIn = /* @__PURE__ */ __name((by, lang) => tr(lang, {
  ko: by === "BUYER" ? "\uAD6C\uB9E4\uC790\uB2D8\uC774" : "\uD310\uB9E4\uC790\uB2D8\uC774",
  en: by === "BUYER" ? "The buyer" : "The seller",
  ja: by === "BUYER" ? "\u8CFC\u5165\u8005" : "\u8CA9\u58F2\u8005"
}), "partyIn");
var LICENSE_AMENDMENT_CHAT_MESSAGES = {
  PROPOSED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD00\uB9AC\uC790\uAC00 ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4 \uC218\uC815\uC744 \uC81C\uC548\uD588\uC5B4\uC694. \uC704\uCABD \uCE74\uB4DC\uC5D0\uC11C \uBC14\uB00C\uB294 \uB0B4\uC6A9\uC744 \uD655\uC778\uD558\uACE0 \uB3D9\uC758\uD574 \uC8FC\uC138\uC694. \uB450 \uBD84 \uBAA8\uB450 \uB3D9\uC758\uD558\uBA74 \uC218\uC815\uB3FC\uC694.`,
    en: `${titlePrefix(title)}An admin proposed a change to the license. Check what changes in the card above and agree to it. It takes effect once you both agree.`,
    ja: `${titlePrefix(title)}\u7BA1\u7406\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4FEE\u6B63\u3092\u63D0\u6848\u3057\u307E\u3057\u305F\u3002\u4E0A\u306E\u30AB\u30FC\u30C9\u3067\u5909\u66F4\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3001\u540C\u610F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u304A\u4E8C\u4EBA\u3068\u3082\u540C\u610F\u3059\u308B\u3068\u4FEE\u6B63\u3055\u308C\u307E\u3059\u3002`
  }), "PROPOSED"),
  AGREED: /* @__PURE__ */ __name((title, by, lang = DEFAULT_LANG) => tr(lang, {
    ko: `${partyIn(by, "ko")} ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4 \uC218\uC815\uC5D0 \uB3D9\uC758\uD588\uC5B4\uC694.`,
    en: `${titlePrefix(title)}${partyIn(by, "en")} agreed to the license change.`,
    ja: `${titlePrefix(title)}${partyIn(by, "ja")}\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4FEE\u6B63\u306B\u540C\u610F\u3057\u307E\u3057\u305F\u3002`
  }), "AGREED"),
  APPLIED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uB450 \uBD84 \uBAA8\uB450 \uB3D9\uC758\uD574 ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4\uAC00 \uC218\uC815\uB410\uC5B4\uC694. \uC99D\uC11C\uC5D0\uB3C4 \uBC14\uB010 \uB0B4\uC6A9\uC774 \uB2F4\uACA8\uC694.`,
    en: `${titlePrefix(title)}You both agreed, so the license has been updated. The certificate reflects the changes too.`,
    ja: `${titlePrefix(title)}\u304A\u4E8C\u4EBA\u3068\u3082\u540C\u610F\u3057\u305F\u305F\u3081\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u4FEE\u6B63\u3055\u308C\u307E\u3057\u305F\u3002\u8A3C\u66F8\u306B\u3082\u5909\u66F4\u5185\u5BB9\u304C\u53CD\u6620\u3055\u308C\u307E\u3059\u3002`
  }), "APPLIED"),
  DECLINED: /* @__PURE__ */ __name((title, by, lang = DEFAULT_LANG) => tr(lang, {
    ko: `${partyIn(by, "ko")} ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4 \uC218\uC815\uC744 \uAC70\uC808\uD588\uC5B4\uC694. \uB77C\uC774\uC120\uC2A4\uB294 \uADF8\uB300\uB85C\uC608\uC694.`,
    en: `${titlePrefix(title)}${partyIn(by, "en")} declined the license change. The license stays the same.`,
    ja: `${titlePrefix(title)}${partyIn(by, "ja")}\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4FEE\u6B63\u3092\u62D2\u5426\u3057\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u5909\u308F\u308A\u307E\u305B\u3093\u3002`
  }), "DECLINED"),
  CANCELLED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD00\uB9AC\uC790\uAC00 ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4 \uC218\uC815 \uC81C\uC548\uC744 \uCCA0\uD68C\uD588\uC5B4\uC694. \uB77C\uC774\uC120\uC2A4\uB294 \uADF8\uB300\uB85C\uC608\uC694.`,
    en: `${titlePrefix(title)}An admin withdrew the license change proposal. The license stays the same.`,
    ja: `${titlePrefix(title)}\u7BA1\u7406\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4FEE\u6B63\u63D0\u6848\u3092\u53D6\u308A\u4E0B\u3052\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u5909\u308F\u308A\u307E\u305B\u3093\u3002`
  }), "CANCELLED")
};
var CHAT_LICENSE_SUSPENSION_EVENT = "LICENSE_SUSPENSION_UPDATED";
var LICENSE_SUSPENSION_CHAT_MESSAGES = {
  SUSPENDED: /* @__PURE__ */ __name((title, reason, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD00\uB9AC\uC790\uAC00 ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9\uC744 \uC7A0\uC2DC \uC911\uC9C0\uD588\uC5B4\uC694. \uB2E4\uC2DC \uD480\uB9B4 \uB54C\uAE4C\uC9C0 \uC0AC\uC6A9\uD558\uC9C0 \uB9D0\uC544 \uC8FC\uC138\uC694. \uC0AC\uC720: ${reason}`,
    en: `${titlePrefix(title)}An admin has temporarily suspended use of the license. Please don't use it until the suspension is lifted. Reason: ${reason}`,
    ja: `${titlePrefix(title)}\u7BA1\u7406\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u3092\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002\u89E3\u9664\u3055\u308C\u308B\u307E\u3067\u4F7F\u7528\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u7406\u7531\uFF1A${reason}`
  }), "SUSPENDED"),
  RESUMED: /* @__PURE__ */ __name((title, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD00\uB9AC\uC790\uAC00 ${titlePrefix(title)}\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uC911\uC9C0\uB97C \uD480\uC5C8\uC5B4\uC694. \uACC4\uC57D \uB0B4\uC6A9\uB300\uB85C \uB2E4\uC2DC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.`,
    en: `${titlePrefix(title)}An admin lifted the license suspension. You can use it again under the contract terms.`,
    ja: `${titlePrefix(title)}\u7BA1\u7406\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u505C\u6B62\u3092\u89E3\u9664\u3057\u307E\u3057\u305F\u3002\u5951\u7D04\u5185\u5BB9\u3069\u304A\u308A\u306B\u518D\u3073\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002`
  }), "RESUMED")
};
var CHAT_LICENSE_ISSUE_DELAYED_EVENT = "LICENSE_ISSUE_DELAYED";
function licenseIssueDelayedChatMessage(title, days, draft, lang = DEFAULT_LANG) {
  const head = tr(lang, {
    ko: `${titlePrefix(title)}\uC785\uAE08 \uD655\uC778 \uD6C4 ${days}\uC77C\uC774 \uC9C0\uB0AC\uB294\uB370 \uC544\uC9C1 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD558\uC9C0 \uC54A\uC558\uC5B4\uC694.`,
    en: `${titlePrefix(title)}It's been ${days === 1 ? "1 day" : `${days} days`} since the payment was confirmed, but the license hasn't been issued yet.`,
    ja: `${titlePrefix(title)}\u5165\u91D1\u78BA\u8A8D\u304B\u3089${days}\u65E5\u304C\u7D4C\u3061\u307E\u3057\u305F\u304C\u3001\u307E\u3060\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3057\u3066\u3044\u307E\u305B\u3093\u3002`
  });
  const next = tr(lang, draft === "NONE" ? {
    ko: "\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uC62C\uB9AC\uACE0 \uAD6C\uB9E4\uC790\uB2D8 \uD655\uC778\uC744 \uBC1B\uC544 \uBC1C\uAE09\uD574 \uC8FC\uC138\uC694.",
    en: "Post the license draft, get the buyer to confirm it, then issue the license.",
    ja: "\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u767B\u9332\u3057\u3001\u8CFC\u5165\u8005\u306E\u78BA\u8A8D\u3092\u53D7\u3051\u3066\u304B\u3089\u767A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  } : draft === "AWAITING_BUYER" ? {
    ko: "\uAD6C\uB9E4\uC790\uB2D8\uC774 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uC544\uC9C1 \uD655\uC778\uD558\uC9C0 \uC54A\uC558\uC5B4\uC694. \uCC44\uD305\uC73C\uB85C \uD655\uC778\uC744 \uC694\uCCAD\uD574 \uC8FC\uC138\uC694.",
    en: "The buyer hasn't confirmed the license draft yet. Please ask them to confirm it in chat.",
    ja: "\u8CFC\u5165\u8005\u304C\u307E\u3060\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u8A8D\u3092\u4F9D\u983C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  } : {
    ko: "\uAD6C\uB9E4\uC790\uB2D8\uC774 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uD655\uC778\uD588\uC5B4\uC694. \uC9C0\uAE08 \uBC1C\uAE09\uD560 \uC218 \uC788\uC5B4\uC694.",
    en: "The buyer has confirmed the license draft. You can issue it now.",
    ja: "\u8CFC\u5165\u8005\u304C\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002\u4ECA\u3059\u3050\u767A\u884C\u3067\u304D\u307E\u3059\u3002"
  });
  return `${head} ${next}`;
}
__name(licenseIssueDelayedChatMessage, "licenseIssueDelayedChatMessage");
var CHAT_ADDON_PAYMENT_EVENT = "ADDON_PAYMENT_UPDATED";
var ADDON_PAYMENT_SYSTEM_MESSAGES = {
  REQUESTED: /* @__PURE__ */ __name((amount, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uD310\uB9E4\uC790\uAC00 \uCD94\uAC00\uAE08 ${amount} \uC785\uAE08\uC744 \uC694\uCCAD\uD588\uC2B5\uB2C8\uB2E4. \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uC785\uAE08 \uC548\uB0B4\uB97C \uD655\uC778\uD558\uC138\uC694.`,
    en: `The seller requested an additional payment of ${amount}. Check the payment instructions on the order details page.`,
    ja: `\u8CA9\u58F2\u8005\u304C\u8FFD\u52A0\u6599\u91D1${amount}\u306E\u5165\u91D1\u3092\u4F9D\u983C\u3057\u307E\u3057\u305F\u3002\u6CE8\u6587\u8A73\u7D30\u3067\u5165\u91D1\u6848\u5185\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002`
  }), "REQUESTED"),
  CANCELLED: /* @__PURE__ */ __name((amount, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uCD94\uAC00\uAE08 ${amount} \uC694\uCCAD\uC774 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.`,
    en: `The additional payment request of ${amount} has been cancelled.`,
    ja: `\u8FFD\u52A0\u6599\u91D1${amount}\u306E\u4F9D\u983C\u304C\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002`
  }), "CANCELLED"),
  CONFIRMED: /* @__PURE__ */ __name((amount, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uCD94\uAC00\uAE08 ${amount} \uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4.`,
    en: `The additional payment of ${amount} has been confirmed.`,
    ja: `\u8FFD\u52A0\u6599\u91D1${amount}\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002`
  }), "CONFIRMED")
};
var CHAT_ROYALTY_EVENT = "ROYALTY_UPDATED";
var CHAT_PURCHASE_CONFIRMED_EVENT = "PURCHASE_CONFIRMED";
var CHAT_REFUND_EVENT = "REFUND";
var CHAT_VIOLATION_REPORT_EVENT = "VIOLATION_REPORT";
var CHAT_LICENSE_EXPIRED_EVENT = "LICENSE_EXPIRED";
var LICENSE_EXPIRED_CHAT_MESSAGE = "IP \uACC4\uC57D \uAE30\uAC04\uC774 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC7AC\uACC4\uC57D\uC744 \uC6D0\uD558\uC2DC\uBA74 IP \uC8FC\uBB38\uC744 \uB2E4\uC2DC \uC9C4\uD589\uD574 \uC8FC\uC138\uC694.";
var LICENSE_EXPIRED_CHAT_MESSAGE_I18N = {
  ko: LICENSE_EXPIRED_CHAT_MESSAGE,
  en: "The IP contract period has ended. To renew, please place a new IP order.",
  ja: "IP\u5951\u7D04\u671F\u9593\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u518D\u5951\u7D04\u3092\u3054\u5E0C\u671B\u306E\u5834\u5408\u306F\u3001IP\u306E\u6CE8\u6587\u3092\u3082\u3046\u4E00\u5EA6\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002"
};
var ChatMessageShortcut = {
  ROYALTY: "ROYALTY",
  ORDER: "ORDER"
};
function chatMessageShortcutOf(systemEvent) {
  switch (systemEvent) {
    case CHAT_ROYALTY_EVENT:
      return ChatMessageShortcut.ROYALTY;
    case CHAT_PURCHASE_CONFIRMED_EVENT:
    case CHAT_REFUND_EVENT:
    case CHAT_VIOLATION_REPORT_EVENT:
    case CHAT_LICENSE_ISSUE_DELAYED_EVENT:
    case CHAT_LICENSE_EXPIRED_EVENT:
      return ChatMessageShortcut.ORDER;
    default:
      return null;
  }
}
__name(chatMessageShortcutOf, "chatMessageShortcutOf");
var VIOLATION_REPORT_CHAT_MESSAGES = {
  OPENED: "\uD310\uB9E4\uC790\uAC00 \uAD6C\uB9E4\uC790\uC758 \uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uC704\uBC18\uC744 \uC2E0\uACE0\uD588\uC2B5\uB2C8\uB2E4. \uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uAC00 \uD655\uC778\uD560 \uC608\uC815\uC785\uB2C8\uB2E4. \uAD6C\uB9E4\uC790\uB294 \uCC44\uD305\uC73C\uB85C \uC0C1\uD669\uC744 \uC124\uBA85\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
  ACTIONED: /* @__PURE__ */ __name((note) => `\uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uAC00 \uD310\uB9E4\uC790\uC758 \uC704\uBC18 \uC2E0\uACE0\uB97C \uD655\uC778\uD558\uACE0 \uC870\uCE58\uD588\uC2B5\uB2C8\uB2E4. \uCC98\uB9AC \uB0B4\uC6A9: ${note}`, "ACTIONED"),
  DISMISSED: /* @__PURE__ */ __name((note) => `\uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uAC00 \uD310\uB9E4\uC790\uC758 \uC704\uBC18 \uC2E0\uACE0\uB97C \uAE30\uAC01\uD588\uC2B5\uB2C8\uB2E4. \uC0AC\uC720: ${note}`, "DISMISSED")
};
var VIOLATION_REPORT_CHAT_MESSAGES_I18N = {
  ko: VIOLATION_REPORT_CHAT_MESSAGES,
  en: {
    OPENED: "The seller reported a license use violation by the buyer. The Inflip operator will review it. Buyer, you can explain the situation in chat.",
    ACTIONED: /* @__PURE__ */ __name((note) => `The Inflip operator reviewed the seller's violation report and took action. Details: ${note}`, "ACTIONED"),
    DISMISSED: /* @__PURE__ */ __name((note) => `The Inflip operator dismissed the seller's violation report. Reason: ${note}`, "DISMISSED")
  },
  ja: {
    OPENED: "\u8CA9\u58F2\u8005\u304C\u8CFC\u5165\u8005\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u4F7F\u7528\u9055\u53CD\u3092\u5831\u544A\u3057\u307E\u3057\u305F\u3002Inflip\u904B\u55B6\u8005\u304C\u78BA\u8A8D\u3059\u308B\u4E88\u5B9A\u3067\u3059\u3002\u8CFC\u5165\u8005\u306F\u30C1\u30E3\u30C3\u30C8\u3067\u72B6\u6CC1\u3092\u8AAC\u660E\u3067\u304D\u307E\u3059\u3002",
    ACTIONED: /* @__PURE__ */ __name((note) => `Inflip\u904B\u55B6\u8005\u304C\u8CA9\u58F2\u8005\u306E\u9055\u53CD\u5831\u544A\u3092\u78BA\u8A8D\u3057\u3001\u5BFE\u5FDC\u3057\u307E\u3057\u305F\u3002\u5BFE\u5FDC\u5185\u5BB9\uFF1A${note}`, "ACTIONED"),
    DISMISSED: /* @__PURE__ */ __name((note) => `Inflip\u904B\u55B6\u8005\u304C\u8CA9\u58F2\u8005\u306E\u9055\u53CD\u5831\u544A\u3092\u5374\u4E0B\u3057\u307E\u3057\u305F\u3002\u7406\u7531\uFF1A${note}`, "DISMISSED")
  }
};
function refundRequestedChatMessage(rightLabel2, lang = DEFAULT_LANG) {
  return tr(lang, {
    ko: `\uAD6C\uB9E4\uC790\uAC00 [${rightLabel2}] \uD658\uBD88\uC744 \uC2E0\uCCAD\uD588\uC2B5\uB2C8\uB2E4. \uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09 \uC804\uC774\uB77C \uD310\uB9E4\uC790 \uB3D9\uC758 \uC5C6\uC774 \uC9C4\uD589\uB420 \uC608\uC815\uC785\uB2C8\uB2E4.`,
    en: `The buyer requested a refund for [${rightLabel2}]. Since the license hasn't been issued yet, it will proceed without the seller's consent.`,
    ja: `\u8CFC\u5165\u8005\u304C[${rightLabel2}]\u306E\u8FD4\u91D1\u3092\u7533\u8ACB\u3057\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u767A\u884C\u524D\u306E\u305F\u3081\u3001\u8CA9\u58F2\u8005\u306E\u540C\u610F\u306A\u3057\u3067\u9032\u3081\u3089\u308C\u308B\u4E88\u5B9A\u3067\u3059\u3002`
  });
}
__name(refundRequestedChatMessage, "refundRequestedChatMessage");
function refundRejectedChatMessage(rightLabel2, lang = DEFAULT_LANG) {
  return tr(lang, {
    ko: `[${rightLabel2}] \uD658\uBD88 \uC2E0\uCCAD\uC774 \uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uC5D0 \uC758\uD574 \uAC70\uC808\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uD310\uB9E4\uC790\uB294 \uB2E4\uC2DC \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.`,
    en: `The refund request for [${rightLabel2}] was rejected by the Inflip operator. The seller can issue the license again.`,
    ja: `[${rightLabel2}]\u306E\u8FD4\u91D1\u7533\u8ACB\u306FInflip\u904B\u55B6\u8005\u306B\u3088\u308A\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F\u3002\u8CA9\u58F2\u8005\u306F\u518D\u3073\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3067\u304D\u307E\u3059\u3002`
  });
}
__name(refundRejectedChatMessage, "refundRejectedChatMessage");
var dotPeriod = /* @__PURE__ */ __name((period) => period.replace("-", "."), "dotPeriod");
var won = /* @__PURE__ */ __name((amount, lang) => formatWon(amount, lang), "won");
var periodList = /* @__PURE__ */ __name((periods, lang) => periods.map(dotPeriod).join(lang === "ja" ? "\u3001" : ", "), "periodList");
var ROYALTY_CHAT_MESSAGES = {
  REPORTED: /* @__PURE__ */ __name((period, royalty, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD6C\uB9E4\uC790\uB2D8\uC774 ${dotPeriod(period)} \uB9E4\uCD9C\uC744 \uBCF4\uACE0\uD588\uC5B4\uC694 \xB7 \uB85C\uC5F4\uD2F0 ${won(royalty, "ko")}`,
    en: `The buyer reported sales for ${dotPeriod(period)} \xB7 Royalty ${won(royalty, "en")}`,
    ja: `\u8CFC\u5165\u8005\u304C${dotPeriod(period)}\u306E\u58F2\u4E0A\u3092\u5831\u544A\u3057\u307E\u3057\u305F \xB7 \u30ED\u30A4\u30E4\u30EA\u30C6\u30A3 ${won(royalty, "ja")}`
  }), "REPORTED"),
  REVISED: /* @__PURE__ */ __name((period, before, after, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD6C\uB9E4\uC790\uB2D8\uC774 ${dotPeriod(period)} \uB9E4\uCD9C \uBCF4\uACE0\uB97C \uACE0\uCCE4\uC5B4\uC694 \xB7 \uB85C\uC5F4\uD2F0 ${won(before, "ko")} \u2192 ${won(after, "ko")}`,
    en: `The buyer revised the sales report for ${dotPeriod(period)} \xB7 Royalty ${won(before, "en")} \u2192 ${won(after, "en")}`,
    ja: `\u8CFC\u5165\u8005\u304C${dotPeriod(period)}\u306E\u58F2\u4E0A\u5831\u544A\u3092\u4FEE\u6B63\u3057\u307E\u3057\u305F \xB7 \u30ED\u30A4\u30E4\u30EA\u30C6\u30A3 ${won(before, "ja")} \u2192 ${won(after, "ja")}`
  }), "REVISED"),
  VOIDED: /* @__PURE__ */ __name((period, by, reason, lang = DEFAULT_LANG) => tr(lang, {
    ko: `${by === "SELLER" ? "\uD310\uB9E4\uC790\uB2D8\uC774" : "\uAD00\uB9AC\uC790\uAC00"} ${dotPeriod(period)} \uB9E4\uCD9C \uBCF4\uACE0\uB97C \uBC18\uB824\uD588\uC5B4\uC694 \xB7 \uC0AC\uC720: ${reason}`,
    en: `${by === "SELLER" ? "The seller" : "An admin"} returned the sales report for ${dotPeriod(period)} \xB7 Reason: ${reason}`,
    ja: `${by === "SELLER" ? "\u8CA9\u58F2\u8005" : "\u7BA1\u7406\u8005"}\u304C${dotPeriod(period)}\u306E\u58F2\u4E0A\u5831\u544A\u3092\u5DEE\u3057\u623B\u3057\u307E\u3057\u305F \xB7 \u7406\u7531\uFF1A${reason}`
  }), "VOIDED"),
  OBJECTED: /* @__PURE__ */ __name((period, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uD310\uB9E4\uC790\uB2D8\uC774 ${dotPeriod(period)} \uB9E4\uCD9C \uBCF4\uACE0\uC5D0 \uC774\uC758\uB97C \uC81C\uAE30\uD588\uC5B4\uC694. \uAD00\uB9AC\uC790\uAC00 \uD655\uC778\uD574\uC694.`,
    en: `The seller raised an objection to the sales report for ${dotPeriod(period)}. An admin will review it.`,
    ja: `\u8CA9\u58F2\u8005\u304C${dotPeriod(period)}\u306E\u58F2\u4E0A\u5831\u544A\u306B\u7570\u8B70\u3092\u7533\u3057\u7ACB\u3066\u307E\u3057\u305F\u3002\u7BA1\u7406\u8005\u304C\u78BA\u8A8D\u3057\u307E\u3059\u3002`
  }), "OBJECTED"),
  OBJECTION_DISMISSED: /* @__PURE__ */ __name((period, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD00\uB9AC\uC790\uAC00 ${dotPeriod(period)} \uB9E4\uCD9C \uBCF4\uACE0\uC5D0 \uB300\uD55C \uC774\uC758\uB97C \uAE30\uAC01\uD588\uC5B4\uC694. \uBCF4\uACE0\uB294 \uADF8\uB300\uB85C \uC720\uC9C0\uB3FC\uC694.`,
    en: `An admin dismissed the objection to the sales report for ${dotPeriod(period)}. The report stays as is.`,
    ja: `\u7BA1\u7406\u8005\u304C${dotPeriod(period)}\u306E\u58F2\u4E0A\u5831\u544A\u306B\u5BFE\u3059\u308B\u7570\u8B70\u3092\u5374\u4E0B\u3057\u307E\u3057\u305F\u3002\u5831\u544A\u306F\u305D\u306E\u307E\u307E\u7DAD\u6301\u3055\u308C\u307E\u3059\u3002`
  }), "OBJECTION_DISMISSED"),
  ADJUSTED: /* @__PURE__ */ __name((period, delta, lang = DEFAULT_LANG) => tr(lang, {
    ko: `\uAD00\uB9AC\uC790\uAC00 ${dotPeriod(period)} \uB85C\uC5F4\uD2F0\uB97C \uC815\uC815\uD588\uC5B4\uC694 \xB7 ${delta >= 0 ? `\uCD94\uAC00 \uC785\uAE08 ${won(delta, "ko")}` : `\uAD6C\uB9E4\uC790 \uD658\uAE09 ${won(-delta, "ko")}`}`,
    en: `An admin corrected the royalty for ${dotPeriod(period)} \xB7 ${delta >= 0 ? `Additional payment ${won(delta, "en")}` : `Buyer refund ${won(-delta, "en")}`}`,
    ja: `\u7BA1\u7406\u8005\u304C${dotPeriod(period)}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u3092\u8A02\u6B63\u3057\u307E\u3057\u305F \xB7 ${delta >= 0 ? `\u8FFD\u52A0\u5165\u91D1 ${won(delta, "ja")}` : `\u8CFC\u5165\u8005\u3078\u306E\u6255\u3044\u623B\u3057 ${won(-delta, "ja")}`}`
  }), "ADJUSTED"),
  DEPOSIT_CONFIRMED: /* @__PURE__ */ __name((periods, total, lang = DEFAULT_LANG) => tr(lang, {
    ko: `${periodList(periods, "ko")} \uB85C\uC5F4\uD2F0 ${won(total, "ko")} \uC785\uAE08\uC774 \uD655\uC778\uB410\uC5B4\uC694.`,
    en: `The royalty payment of ${won(total, "en")} for ${periodList(periods, "en")} has been confirmed.`,
    ja: `${periodList(periods, "ja")}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3 ${won(total, "ja")}\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002`
  }), "DEPOSIT_CONFIRMED"),
  REFUND_COMPLETED: /* @__PURE__ */ __name((period, amount, lang = DEFAULT_LANG) => tr(lang, {
    ko: `${dotPeriod(period)} \uB85C\uC5F4\uD2F0 \uC815\uC815 \uD658\uAE09 ${won(amount, "ko")}\uC774 \uC644\uB8CC\uB410\uC5B4\uC694.`,
    en: `The royalty correction refund of ${won(amount, "en")} for ${dotPeriod(period)} is complete.`,
    ja: `${dotPeriod(period)}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u8A02\u6B63\u306B\u3088\u308B\u6255\u3044\u623B\u3057 ${won(amount, "ja")}\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002`
  }), "REFUND_COMPLETED")
};
function purchaseConfirmedChatMessage(by, totalAmount, lang = DEFAULT_LANG) {
  const head = tr(lang, by === "USER" ? {
    ko: "\uAD6C\uB9E4\uC790\uB2D8\uC774 \uAD6C\uB9E4\uD655\uC815\uD588\uC5B4\uC694.",
    en: "The buyer confirmed the purchase.",
    ja: "\u8CFC\u5165\u8005\u304C\u8CFC\u5165\u78BA\u5B9A\u3057\u307E\u3057\u305F\u3002"
  } : {
    ko: "\uAD6C\uB9E4\uD655\uC815 \uAE30\uD55C\uC774 \uC9C0\uB098 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB410\uC5B4\uC694.",
    en: "The purchase confirmation deadline passed, so it was confirmed automatically.",
    ja: "\u8CFC\u5165\u78BA\u5B9A\u306E\u671F\u9650\u304C\u904E\u304E\u305F\u305F\u3081\u3001\u81EA\u52D5\u3067\u78BA\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002"
  });
  const tail = tr(lang, {
    ko: "\uD310\uB9E4\uC790 \uC815\uC0B0\uC774 \uC2DC\uC791\uB3FC\uC694.",
    en: "The seller payout will start.",
    ja: "\u8CA9\u58F2\u8005\u3078\u306E\u7CBE\u7B97\u304C\u59CB\u307E\u308A\u307E\u3059\u3002"
  });
  return totalAmount > 0 ? `${head} ${tail}` : head;
}
__name(purchaseConfirmedChatMessage, "purchaseConfirmedChatMessage");

// src/enums/report.ts
var ReportStatus = {
  PENDING: "PENDING",
  ACTIONED: "ACTIONED",
  DISMISSED: "DISMISSED"
};
var REPORT_STATUS_LABELS = {
  PENDING: "\uAC80\uD1A0 \uB300\uAE30",
  ACTIONED: "\uC870\uCE58\uD568",
  DISMISSED: "\uAE30\uAC01"
};

// src/enums/auth-provider.ts
var AuthProvider = {
  LOCAL: "LOCAL",
  GOOGLE: "GOOGLE",
  APPLE: "APPLE",
  KAKAO: "KAKAO"
};
var OAUTH_PROVIDERS = [
  AuthProvider.GOOGLE,
  AuthProvider.APPLE,
  AuthProvider.KAKAO
];

// src/enums/payment.ts
var PaymentMethod = {
  /** 무통장입금 — depositReference/depositDueAt 사용 */
  BANK_TRANSFER: "BANK_TRANSFER",
  /** 카드 (PG) — pgProvider/pgTransactionId 사용. 아직 미연동 */
  CARD: "CARD"
};
var PaymentKind = {
  /** 주문 생성 시 계약 금액 결제 */
  INITIAL: "INITIAL",
  /** 발급 전 협의로 늘어난 추가금 — 같은 주문에 결제만 더한다 (Order 상태 전이 없음) */
  ADDON: "ADDON"
};
var PaymentStatus = {
  /** 결제 대기 — 무통장: 입금 대기 / 카드: 승인 대기 */
  PENDING: "PENDING",
  /** 입금 확인(어드민) 또는 PG 승인 완료 */
  CONFIRMED: "CONFIRMED",
  /** PG 승인 실패 (무통장에는 없음) */
  FAILED: "FAILED",
  /** 기한 내 미입금 만료 (scheduler) */
  EXPIRED: "EXPIRED",
  /** 주문 취소에 따른 결제 취소 */
  CANCELLED: "CANCELLED"
};
var PAYMENT_STATUS_TRANSITIONS = [
  {
    from: PaymentStatus.PENDING,
    to: PaymentStatus.CONFIRMED
  },
  {
    from: PaymentStatus.PENDING,
    to: PaymentStatus.FAILED
  },
  {
    from: PaymentStatus.PENDING,
    to: PaymentStatus.EXPIRED
  },
  {
    from: PaymentStatus.PENDING,
    to: PaymentStatus.CANCELLED
  },
  // 만료 후 입금으로 되살리기 (DepositExceptionService) — 기한 만료 결제만
  {
    from: PaymentStatus.EXPIRED,
    to: PaymentStatus.CONFIRMED
  }
];
var DepositReturnKind = {
  OVERPAYMENT: "OVERPAYMENT",
  UNDERPAYMENT: "UNDERPAYMENT",
  LATE_DEPOSIT: "LATE_DEPOSIT"
};
var DEPOSIT_RETURN_KIND_LABELS = {
  OVERPAYMENT: "\uCD08\uACFC \uC785\uAE08 \uBC18\uD658",
  UNDERPAYMENT: "\uBD80\uC871 \uC785\uAE08 \uBC18\uD658",
  LATE_DEPOSIT: "\uB9CC\uB8CC \uD6C4 \uC785\uAE08 \uBC18\uD658"
};
var DEPOSIT_RETURN_KIND_LABELS_I18N = {
  ko: DEPOSIT_RETURN_KIND_LABELS,
  en: {
    OVERPAYMENT: "Overpayment return",
    UNDERPAYMENT: "Underpayment return",
    LATE_DEPOSIT: "Late deposit return"
  },
  ja: {
    OVERPAYMENT: "\u904E\u5165\u91D1\u306E\u8FD4\u9084",
    UNDERPAYMENT: "\u5165\u91D1\u4E0D\u8DB3\u5206\u306E\u8FD4\u9084",
    LATE_DEPOSIT: "\u671F\u9650\u5207\u308C\u5F8C\u306E\u5165\u91D1\u306E\u8FD4\u9084"
  }
};
var DepositReturnStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED"
};
var DEPOSIT_RETURN_STATUS_LABELS = {
  PENDING: "\uBC18\uD658 \uB300\uAE30",
  COMPLETED: "\uBC18\uD658 \uC644\uB8CC"
};
var TERMINAL_PAYMENT_STATUSES = [
  PaymentStatus.CONFIRMED,
  PaymentStatus.FAILED,
  PaymentStatus.EXPIRED,
  PaymentStatus.CANCELLED
];

// src/enums/refund.ts
var RefundStatus = {
  /** 환불 요청됨 (구매자 요청 또는 어드민 직권) */
  REQUESTED: "REQUESTED",
  /** 어드민 승인 — 송금/PG 취소 대기 */
  APPROVED: "APPROVED",
  /** 거절 — 요청을 받아들이지 않음 (요청됨에서만) */
  REJECTED: "REJECTED",
  /**
  * 취소 — 운영자가 자기가 승인·만든 환불을 송금 전에 거둬들임 (승인 취소, 계약 해지 취소).
  * 구매자 요청에 대한 판단이 아니라서 거절과 나눈다. 금액 계산에서는 거절처럼 빠진다
  */
  CANCELLED: "CANCELLED",
  /** 환불금 지급 완료 (무통장: 계좌 송금 / 카드: PG 취소 승인) */
  COMPLETED: "COMPLETED"
};
var REFUND_STATUS_TRANSITIONS = [
  {
    from: RefundStatus.REQUESTED,
    to: RefundStatus.APPROVED
  },
  {
    from: RefundStatus.REQUESTED,
    to: RefundStatus.REJECTED
  },
  {
    from: RefundStatus.APPROVED,
    to: RefundStatus.COMPLETED
  },
  // 취소 (Refund.cancel) — 승인 취소·계약 해지 취소. 송금 전 착오를 되돌릴 때만. 거절은 요청됨에서만
  {
    from: RefundStatus.APPROVED,
    to: RefundStatus.CANCELLED
  },
  {
    from: RefundStatus.REQUESTED,
    to: RefundStatus.CANCELLED
  }
];
var TERMINAL_REFUND_STATUSES = [
  RefundStatus.REJECTED,
  RefundStatus.CANCELLED,
  RefundStatus.COMPLETED
];

// src/enums/payout-clawback.ts
var PayoutClawbackStatus = {
  /** 판매자 입금 대기 */
  PENDING: "PENDING",
  /** 기한 경과 — 계정 접속 정지. 그 뒤에도 입금하면 회수 확인할 수 있다 */
  OVERDUE: "OVERDUE",
  /** 입금 확인 — 원장 PAYOUT_CLAWBACK */
  COLLECTED: "COLLECTED",
  /** 환불 승인 취소로 회수할 필요가 없어짐 */
  CANCELLED: "CANCELLED"
};
var PAYOUT_CLAWBACK_STATUS_LABELS = {
  PENDING: "\uD68C\uC218 \uB300\uAE30",
  OVERDUE: "\uAE30\uD55C \uACBD\uACFC",
  COLLECTED: "\uD68C\uC218 \uC644\uB8CC",
  CANCELLED: "\uD68C\uC218 \uCDE8\uC18C"
};
var PAYOUT_CLAWBACK_STATUS_LABELS_I18N = {
  ko: PAYOUT_CLAWBACK_STATUS_LABELS,
  en: {
    PENDING: "Awaiting repayment",
    OVERDUE: "Overdue",
    COLLECTED: "Repaid",
    CANCELLED: "Repayment cancelled"
  },
  ja: {
    PENDING: "\u56DE\u53CE\u5F85\u3061",
    OVERDUE: "\u671F\u9650\u8D85\u904E",
    COLLECTED: "\u56DE\u53CE\u5B8C\u4E86",
    CANCELLED: "\u56DE\u53CE\u53D6\u308A\u6D88\u3057"
  }
};
var OUTSTANDING_PAYOUT_CLAWBACK_STATUSES = [
  PayoutClawbackStatus.PENDING,
  PayoutClawbackStatus.OVERDUE
];
var PAYOUT_CLAWBACK_SUSPEND_REASON = "\uC815\uC0B0 \uD68C\uC218 \uAE30\uD55C \uACBD\uACFC \u2014 \uD68C\uC218 \uAE08\uC561\uC744 \uC785\uAE08\uD558\uBA74 \uC811\uC18D \uC815\uC9C0\uAC00 \uD480\uB824\uC694.";
var PAYOUT_CLAWBACK_SUSPEND_REASON_I18N = {
  ko: PAYOUT_CLAWBACK_SUSPEND_REASON,
  en: "Payout repayment overdue \u2014 your access will be restored once you transfer the repayment amount.",
  ja: "\u7CBE\u7B97\u56DE\u53CE\u306E\u671F\u9650\u8D85\u904E \u2014 \u56DE\u53CE\u91D1\u984D\u3092\u5165\u91D1\u3059\u308B\u3068\u3001\u30A2\u30AF\u30BB\u30B9\u505C\u6B62\u304C\u89E3\u9664\u3055\u308C\u307E\u3059\u3002"
};

// src/enums/fulfillment.ts
var FulfillmentType = {
  /** 디지털 라이선스 — 발급 즉시 이행 완료 */
  DIGITAL: "DIGITAL",
  /** 실물 (굿즈 등) — Shipment 로 이행 추적 */
  PHYSICAL: "PHYSICAL"
};
var ShipmentStatus = {
  PREPARING: "PREPARING",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  /** 배송 문제로 반송 처리 */
  RETURNED: "RETURNED"
};
var SHIPMENT_STATUS_TRANSITIONS = [
  {
    from: ShipmentStatus.PREPARING,
    to: ShipmentStatus.SHIPPED
  },
  {
    from: ShipmentStatus.SHIPPED,
    to: ShipmentStatus.DELIVERED
  },
  {
    from: ShipmentStatus.SHIPPED,
    to: ShipmentStatus.RETURNED
  }
];

// src/enums/ledger.ts
var LedgerEntryType = {
  /** 구매자 → 플랫폼 (입금 확인 / PG 승인) */
  PAYMENT_RECEIVED: "PAYMENT_RECEIVED",
  /** 플랫폼 → 구매자 (환불 지급) */
  REFUND_PAID: "REFUND_PAID",
  /** 플랫폼 → 판매자 (정산 지급) */
  PAYOUT_SENT: "PAYOUT_SENT",
  /** 판매자 → 플랫폼 (정산 후 환불에 따른 회수) */
  PAYOUT_CLAWBACK: "PAYOUT_CLAWBACK",
  /** 구매자 → 플랫폼 (로열티 입금 확인) */
  ROYALTY_RECEIVED: "ROYALTY_RECEIVED",
  /** 플랫폼 → 판매자 (로열티 정산 지급, 수수료 차감 후) */
  ROYALTY_PAYOUT: "ROYALTY_PAYOUT",
  /** 플랫폼 → 구매자 (로열티 정정 — 과다 납부분 환급) */
  ROYALTY_REFUNDED: "ROYALTY_REFUNDED",
  /** 판매자 → 플랫폼 (로열티 정정 — 과다 지급분 회수) */
  ROYALTY_CLAWBACK: "ROYALTY_CLAWBACK",
  /** 구매자 → 플랫폼 (주문 대금이 아닌 입금 — 초과·부족·만료 후 입금. 반환 대상, 참조 = 입금 반환 id) */
  DEPOSIT_UNMATCHED: "DEPOSIT_UNMATCHED",
  /** 플랫폼 → 구매자 (입금 반환 완료) */
  DEPOSIT_RETURNED: "DEPOSIT_RETURNED"
};
var LedgerCounterparty = {
  BUYER: "BUYER",
  SELLER: "SELLER"
};

// src/enums/notification.ts
var NotificationType = {
  /** 주문 생성 — 입금 계좌/코드/기한 안내 */
  DEPOSIT_INSTRUCTION: "DEPOSIT_INSTRUCTION",
  PAYMENT_CONFIRMED: "PAYMENT_CONFIRMED",
  LICENSE_ISSUED: "LICENSE_ISSUED",
  /** 판매자용 — 입금 확인됨, 라이선스 발급 필요 */
  LICENSE_ISSUE_REQUESTED: "LICENSE_ISSUE_REQUESTED",
  /** 구매자용 — 판매자가 발급 예정 내용을 올리거나 고침, 확인 필요 / 판매자용 — 구매자가 확인함, 발급 가능 */
  LICENSE_DRAFT_CONFIRM_REQUESTED: "LICENSE_DRAFT_CONFIRM_REQUESTED",
  LICENSE_DRAFT_CONFIRMED: "LICENSE_DRAFT_CONFIRMED",
  /** 구매자·판매자 — 어드민이 라이선스 수정을 제안함(동의 필요) / 양쪽 동의로 수정됨 / 거절됨 / 철회됨 */
  LICENSE_AMENDMENT_REQUESTED: "LICENSE_AMENDMENT_REQUESTED",
  LICENSE_AMENDED: "LICENSE_AMENDED",
  LICENSE_AMENDMENT_DECLINED: "LICENSE_AMENDMENT_DECLINED",
  LICENSE_AMENDMENT_CANCELLED: "LICENSE_AMENDMENT_CANCELLED",
  LICENSE_SUSPENDED: "LICENSE_SUSPENDED",
  LICENSE_RESUMED: "LICENSE_RESUMED",
  /** 구매자·판매자 — 라이선스 사용 기간이 곧 끝남 (만료 7일·3일 전) / 기간이 끝나 만료됨 */
  LICENSE_EXPIRING: "LICENSE_EXPIRING",
  LICENSE_EXPIRED: "LICENSE_EXPIRED",
  ORDER_CANCELLED: "ORDER_CANCELLED",
  ORDER_REFUNDED: "ORDER_REFUNDED",
  /** 판매자 — 구매자가 발급 전 환불을 신청함 (판매자 동의 없이 관리자 확인으로 진행) */
  REFUND_REQUESTED: "REFUND_REQUESTED",
  /** 환불 워크플로 진행 알림 (구매자) — 완료 전액분은 ORDER_REFUNDED 로 */
  REFUND_APPROVED: "REFUND_APPROVED",
  REFUND_REJECTED: "REFUND_REJECTED",
  REFUND_COMPLETED: "REFUND_COMPLETED",
  DISPUTE_OPENED: "DISPUTE_OPENED",
  /** 구매자·판매자 — 관리자가 분쟁을 기각해 정산이 다시 진행됨 */
  DISPUTE_DISMISSED: "DISPUTE_DISMISSED",
  /** 구매자 — 판매자가 라이선스 사용 위반을 신고함 / 구매자·판매자 — 관리자가 신고를 처리함(조치·기각) */
  VIOLATION_REPORTED: "VIOLATION_REPORTED",
  VIOLATION_REPORT_RESOLVED: "VIOLATION_REPORT_RESOLVED",
  /** 구매자·판매자 — 관리자가 계약을 해지함 (선불 처리 포함) */
  CONTRACT_TERMINATED: "CONTRACT_TERMINATED",
  /** 판매자 — 구매확정돼 정산할 거래가 있는데 정산 계좌가 없음 (등록해야 지급) */
  PAYOUT_ACCOUNT_REQUIRED: "PAYOUT_ACCOUNT_REQUIRED",
  /** 구매자·판매자 — 관리자가 계약 해지를 취소함 (해지 전 상태로) */
  CONTRACT_TERMINATION_CANCELLED: "CONTRACT_TERMINATION_CANCELLED",
  /** 구매자 — 주문 대금이 아닌 입금(초과·부족·만료 후)을 돌려줄 예정 / 돌려줬음 */
  DEPOSIT_RETURN_CREATED: "DEPOSIT_RETURN_CREATED",
  DEPOSIT_RETURNED: "DEPOSIT_RETURNED",
  /** 구매자용 — 자동 구매확정 예정 안내 / 판매자용 — 구매확정됨(정산 시작) */
  PURCHASE_CONFIRM_DUE: "PURCHASE_CONFIRM_DUE",
  PURCHASE_CONFIRMED: "PURCHASE_CONFIRMED",
  /** 판매자용 — 판매 대금 정산 지급 완료 */
  SETTLEMENT_PAID_OUT: "SETTLEMENT_PAID_OUT",
  /** 판매자용 — 정산 지급 뒤 환불: 회수 요청(기한·계좌·불이행 시 조치) / 기한 임박 / 기한 경과(접속 정지) / 회수 확인 / 회수 취소 */
  PAYOUT_CLAWBACK_REQUESTED: "PAYOUT_CLAWBACK_REQUESTED",
  PAYOUT_CLAWBACK_DUE: "PAYOUT_CLAWBACK_DUE",
  PAYOUT_CLAWBACK_OVERDUE: "PAYOUT_CLAWBACK_OVERDUE",
  PAYOUT_CLAWBACK_COLLECTED: "PAYOUT_CLAWBACK_COLLECTED",
  PAYOUT_CLAWBACK_CANCELLED: "PAYOUT_CLAWBACK_CANCELLED",
  /** 작성자 — 신고 검토 결과 운영자가 커뮤니티 글·댓글을 삭제함 (사유 포함) */
  COMMUNITY_CONTENT_REMOVED: "COMMUNITY_CONTENT_REMOVED",
  /** 글쓴이 — 내 글에 댓글(답글 포함)이 달림 / 댓글 작성자 — 내 댓글에 답글이 달림 / 글쓴이 — 내 글에 좋아요. 내가 한 건 빼고 */
  COMMUNITY_POST_COMMENTED: "COMMUNITY_POST_COMMENTED",
  COMMUNITY_COMMENT_REPLIED: "COMMUNITY_COMMENT_REPLIED",
  COMMUNITY_POST_LIKED: "COMMUNITY_POST_LIKED",
  /** 판매자용 — listing 심사 결과 */
  LISTING_PUBLISHED: "LISTING_PUBLISHED",
  LISTING_REJECTED: "LISTING_REJECTED",
  /** 판매자용 — 어드민 판매 중지(사유 포함)·판매 재개. 거래에 영향이 커서 끌 수 없는 알림 */
  LISTING_SUSPENDED: "LISTING_SUSPENDED",
  LISTING_UNSUSPENDED: "LISTING_UNSUSPENDED",
  /** 판매자용 — 판매 중 리스팅에 추가한 오퍼(권리) 심사 결과 */
  OFFER_APPROVED: "OFFER_APPROVED",
  OFFER_REJECTED: "OFFER_REJECTED",
  /** 조건 협의 (로열티 계약 등) */
  PROPOSAL_RECEIVED: "PROPOSAL_RECEIVED",
  PROPOSAL_COUNTERED: "PROPOSAL_COUNTERED",
  PROPOSAL_ACCEPTED: "PROPOSAL_ACCEPTED",
  PROPOSAL_DECLINED: "PROPOSAL_DECLINED",
  /** 제안한 사람이 응답 전에 조건을 고침 / 취소함 */
  PROPOSAL_AMENDED: "PROPOSAL_AMENDED",
  PROPOSAL_WITHDRAWN: "PROPOSAL_WITHDRAWN",
  /** 응답 기한이 지나 협의가 끝남 (양측) / 어드민이 협의를 닫음 (양측, 사유 포함) */
  PROPOSAL_EXPIRED: "PROPOSAL_EXPIRED",
  PROPOSAL_CLOSED: "PROPOSAL_CLOSED",
  /** 추가금 — 구매자: 입금 요청 도착 / 양측: 입금 확인 */
  ADDON_PAYMENT_REQUESTED: "ADDON_PAYMENT_REQUESTED",
  ADDON_PAYMENT_CONFIRMED: "ADDON_PAYMENT_CONFIRMED",
  /** 로열티 — 판매자: 매출 보고 도착 / 구매자: 입금 확인 / 판매자: 지급 완료 */
  ROYALTY_REPORTED: "ROYALTY_REPORTED",
  ROYALTY_CONFIRMED: "ROYALTY_CONFIRMED",
  ROYALTY_PAID_OUT: "ROYALTY_PAID_OUT",
  /** 로열티 — 판매자: 구매자가 보고 매출을 고침 / 양측: 어드민 반려 / 양측: 입금 확인 이후 정정(차액) */
  ROYALTY_REPORT_CORRECTED: "ROYALTY_REPORT_CORRECTED",
  ROYALTY_REPORT_VOIDED: "ROYALTY_REPORT_VOIDED",
  ROYALTY_ADJUSTED: "ROYALTY_ADJUSTED",
  /** 로열티 — 구매자: 지급일 임박 보고 리마인더 / 구매자·판매자: 보고 연체 */
  ROYALTY_REPORT_DUE: "ROYALTY_REPORT_DUE",
  ROYALTY_REPORT_OVERDUE: "ROYALTY_REPORT_OVERDUE",
  /** SNS 채널 수동 인증 요청(어드민 처리) 결과 */
  SNS_VERIFICATION_APPROVED: "SNS_VERIFICATION_APPROVED",
  SNS_VERIFICATION_REJECTED: "SNS_VERIFICATION_REJECTED",
  /** 어드민이 인증된 채널을 해제함 */
  SNS_VERIFICATION_REVOKED: "SNS_VERIFICATION_REVOKED",
  /** 협찬 — 등록자: 심사 결과(공개·반려), 지원 도착 / 지원자: 승인·거절 결과, 등록자 수정으로 지원 취소 */
  SPONSORSHIP_PUBLISHED: "SPONSORSHIP_PUBLISHED",
  SPONSORSHIP_REVIEW_REJECTED: "SPONSORSHIP_REVIEW_REJECTED",
  SPONSORSHIP_APPLIED: "SPONSORSHIP_APPLIED",
  SPONSORSHIP_APPROVED: "SPONSORSHIP_APPROVED",
  SPONSORSHIP_REJECTED: "SPONSORSHIP_REJECTED",
  SPONSORSHIP_APPLICATION_CANCELLED: "SPONSORSHIP_APPLICATION_CANCELLED",
  /** 지원자: 방문일이 지나도록 확정되지 않아 자동 취소 / 등록자: 미션 등록됨 / 지원자: 미션 확인됨 */
  SPONSORSHIP_APPLICATION_EXPIRED: "SPONSORSHIP_APPLICATION_EXPIRED",
  SPONSORSHIP_MISSION_SUBMITTED: "SPONSORSHIP_MISSION_SUBMITTED",
  SPONSORSHIP_MISSION_CONFIRMED: "SPONSORSHIP_MISSION_CONFIRMED",
  /** 고객센터 — 관리자가 1:1 문의에 답함 (끌 수 없음, TRADE) */
  SUPPORT_INQUIRY_ANSWERED: "SUPPORT_INQUIRY_ANSWERED",
  /** 계정 보안 — 정산 계좌 등록·변경, 간편비밀번호 변경·운영자 초기화. 끌 수 없음(TRADE) */
  ACCOUNT_SECURITY: "ACCOUNT_SECURITY"
};
var PushPlatform = {
  IOS: "IOS",
  ANDROID: "ANDROID",
  WEB: "WEB"
};
var NotificationCategory = {
  TRADE: "TRADE",
  PROPOSAL: "PROPOSAL",
  REVIEW: "REVIEW",
  SPONSORSHIP: "SPONSORSHIP",
  /** 커뮤니티 — 내 글·댓글에 달린 댓글·답글·좋아요, 운영자 삭제 안내 */
  COMMUNITY: "COMMUNITY",
  /** 채팅 메시지 푸시 — 알림함 알림이 아니라 푸시만 (api-chat → worker 채팅 푸시 잡) */
  CHAT: "CHAT"
};
var OPTIONAL_NOTIFICATION_CATEGORIES = [
  NotificationCategory.PROPOSAL,
  NotificationCategory.REVIEW,
  NotificationCategory.SPONSORSHIP,
  NotificationCategory.COMMUNITY,
  NotificationCategory.CHAT
];
var CATEGORY_BY_TYPE = {
  PROPOSAL_RECEIVED: NotificationCategory.PROPOSAL,
  PROPOSAL_COUNTERED: NotificationCategory.PROPOSAL,
  PROPOSAL_ACCEPTED: NotificationCategory.PROPOSAL,
  PROPOSAL_DECLINED: NotificationCategory.PROPOSAL,
  PROPOSAL_AMENDED: NotificationCategory.PROPOSAL,
  PROPOSAL_WITHDRAWN: NotificationCategory.PROPOSAL,
  PROPOSAL_EXPIRED: NotificationCategory.PROPOSAL,
  LISTING_PUBLISHED: NotificationCategory.REVIEW,
  LISTING_REJECTED: NotificationCategory.REVIEW,
  OFFER_APPROVED: NotificationCategory.REVIEW,
  OFFER_REJECTED: NotificationCategory.REVIEW,
  SNS_VERIFICATION_APPROVED: NotificationCategory.REVIEW,
  SNS_VERIFICATION_REJECTED: NotificationCategory.REVIEW,
  SNS_VERIFICATION_REVOKED: NotificationCategory.REVIEW,
  SPONSORSHIP_PUBLISHED: NotificationCategory.REVIEW,
  SPONSORSHIP_REVIEW_REJECTED: NotificationCategory.REVIEW,
  SPONSORSHIP_APPLIED: NotificationCategory.SPONSORSHIP,
  SPONSORSHIP_APPROVED: NotificationCategory.SPONSORSHIP,
  SPONSORSHIP_REJECTED: NotificationCategory.SPONSORSHIP,
  SPONSORSHIP_APPLICATION_CANCELLED: NotificationCategory.SPONSORSHIP,
  SPONSORSHIP_APPLICATION_EXPIRED: NotificationCategory.SPONSORSHIP,
  SPONSORSHIP_MISSION_SUBMITTED: NotificationCategory.SPONSORSHIP,
  SPONSORSHIP_MISSION_CONFIRMED: NotificationCategory.SPONSORSHIP,
  COMMUNITY_CONTENT_REMOVED: NotificationCategory.COMMUNITY,
  COMMUNITY_POST_COMMENTED: NotificationCategory.COMMUNITY,
  COMMUNITY_COMMENT_REPLIED: NotificationCategory.COMMUNITY,
  COMMUNITY_POST_LIKED: NotificationCategory.COMMUNITY
};
function notificationCategoryOf(type) {
  return CATEGORY_BY_TYPE[type] ?? NotificationCategory.TRADE;
}
__name(notificationCategoryOf, "notificationCategoryOf");
function notificationTypesOf(category) {
  return Object.values(NotificationType).filter((type) => notificationCategoryOf(type) === category);
}
__name(notificationTypesOf, "notificationTypesOf");
function isPushEnabled(preferences, type) {
  return isCategoryPushEnabled(preferences, notificationCategoryOf(type));
}
__name(isPushEnabled, "isPushEnabled");
function isCategoryPushEnabled(preferences, category) {
  if (category === NotificationCategory.TRADE) return true;
  return preferences?.[category] !== false;
}
__name(isCategoryPushEnabled, "isCategoryPushEnabled");
var EMAIL_NOTIFICATION_TYPES = /* @__PURE__ */ new Set([
  NotificationType.PAYOUT_CLAWBACK_REQUESTED,
  NotificationType.PAYOUT_CLAWBACK_DUE,
  NotificationType.PAYOUT_CLAWBACK_OVERDUE,
  NotificationType.PAYOUT_CLAWBACK_COLLECTED,
  NotificationType.PAYOUT_CLAWBACK_CANCELLED
]);
function isEmailNotification(type) {
  return EMAIL_NOTIFICATION_TYPES.has(type);
}
__name(isEmailNotification, "isEmailNotification");

// src/enums/ip-rights.ts
var IpRightType = {
  /** 이름/브랜드 사용권 */
  NAME_BRAND: "NAME_BRAND",
  /** 사진 사용권 */
  FACE_PHOTO: "FACE_PHOTO",
  /** 영상 사용권 */
  CONTENT_SECONDARY: "CONTENT_SECONDARY",
  /** 음성 사용권 */
  AI_VOICE: "AI_VOICE",
  /** 공동 브랜딩 */
  CO_BRANDING: "CO_BRANDING",
  /** 굿즈 제작권 */
  MERCHANDISE: "MERCHANDISE",
  /** 판매 종료 — 기존 상품·계약 조회용 */
  COLLABORATION: "COLLABORATION",
  /** 출연권 */
  APPEARANCE: "APPEARANCE"
};
var ACTIVE_IP_RIGHT_TYPES = Object.values(IpRightType).filter((type) => type !== IpRightType.COLLABORATION);
var IP_RIGHT_LABELS = {
  NAME_BRAND: "\uC774\uB984/\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C",
  FACE_PHOTO: "\uC0AC\uC9C4 \uC0AC\uC6A9\uAD8C",
  CONTENT_SECONDARY: "\uC601\uC0C1 \uC0AC\uC6A9\uAD8C",
  AI_VOICE: "\uC74C\uC131 \uC0AC\uC6A9\uAD8C",
  CO_BRANDING: "\uACF5\uB3D9 \uBE0C\uB79C\uB529",
  MERCHANDISE: "\uAD7F\uC988 \uC81C\uC791\uAD8C",
  COLLABORATION: "\uCF5C\uB77C\uBCF4 \uC0C1\uD488\uAD8C",
  APPEARANCE: "\uCD9C\uC5F0\uAD8C"
};
var IP_RIGHT_LABELS_I18N = {
  ko: IP_RIGHT_LABELS,
  en: {
    NAME_BRAND: "Name/brand usage rights",
    FACE_PHOTO: "Photo usage rights",
    CONTENT_SECONDARY: "Video usage rights",
    AI_VOICE: "Voice usage rights",
    CO_BRANDING: "Co-branding",
    MERCHANDISE: "Merchandise rights",
    COLLABORATION: "Collaboration product rights",
    APPEARANCE: "Appearance rights"
  },
  ja: {
    NAME_BRAND: "\u540D\u524D/\u30D6\u30E9\u30F3\u30C9\u4F7F\u7528\u6A29",
    FACE_PHOTO: "\u5199\u771F\u4F7F\u7528\u6A29",
    CONTENT_SECONDARY: "\u6620\u50CF\u4F7F\u7528\u6A29",
    AI_VOICE: "\u97F3\u58F0\u4F7F\u7528\u6A29",
    CO_BRANDING: "\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0",
    MERCHANDISE: "\u30B0\u30C3\u30BA\u5236\u4F5C\u6A29",
    COLLABORATION: "\u30B3\u30E9\u30DC\u5546\u54C1\u6A29",
    APPEARANCE: "\u51FA\u6F14\u6A29"
  }
};
var SPECIAL_TERMS_PLACEHOLDERS = {
  NAME_BRAND: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.\n\uC608) \uC0AC\uC6A9 \uD45C\uAE30: 'OOO' \uD55C\uAE00 \uD45C\uAE30 1\uC885\uC5D0 \uD55C\uD568 (\uB85C\uACE0\xB7\uC601\uBB38 \uD45C\uAE30\uB294 \uBCC4\uB3C4 \uD611\uC758)\n\uC608) \uC0AC\uC6A9 \uC704\uCE58: \uC0C1\uD488 \uC0C1\uC138 \uD398\uC774\uC9C0\xB7\uD328\uD0A4\uC9C0 \uBB38\uAD6C\n\uC608) \uC0AC\uC6A9 \uC218\uB7C9: \uC801\uC6A9 \uC0C1\uD488 1\uC885(SKU 3\uAC1C \uC774\uB0B4), \uAD11\uACE0 \uC18C\uC7AC 2\uAC74 \uC774\uB0B4\n\uC608) \uBE0C\uB79C\uB4DC\uBA85\uC758 \uC0C1\uD45C \uCD9C\uC6D0\xB7\uC0C1\uD638 \uB4F1\uB85D\uC740 \uAE08\uC9C0",
  FACE_PHOTO: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.\n\uC608) \uB300\uC0C1: \uCC44\uD305\uC5D0\uC11C \uD569\uC758\uD55C \uCD2C\uC601\uBCF8 A\xB7B\xB7C, \uCD5C\uC885 3\uC7A5\n\uC608) \uAE30\uBCF8 1\uC7A5 \u2192 3\uC7A5\uC73C\uB85C \uBCC0\uACBD, \uCD94\uAC00 2\uC7A5 10\uB9CC \uC6D0 / \uC0C1\uC138\uD398\uC774\uC9C0 3\uAC1C\uC6D4\n\uC608) \uBCF4\uC815\xB7\uD06C\uB86D \uD5C8\uC6A9, \uC5BC\uAD74 \uD569\uC131\xB7AI \uD559\uC2B5 \uD65C\uC6A9 \uAE08\uC9C0\n\uC608) \uC758\uB8CC\xB7\uAE08\uC735 \uB4F1 \uC2EC\uC758 \uD544\uC694 \uAD11\uACE0\uB294 \uAC8C\uC2DC \uC804 \uD655\uC778",
  CONTENT_SECONDARY: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.\n\uC608) \uB300\uC0C1: \uAD6C\uB9E4\uC790\uAC00 \uCC44\uD305\uC5D0\uC11C \uC9C0\uC815\uD55C \uC601\uC0C1 1\uAC74, 00:10~00:30 \uAD6C\uAC04\n\uC608) \uBE0C\uB79C\uB4DC \uC7AC\uAC8C\uC2DC \u2192 \uBE0C\uB79C\uB4DC \uC720\uB8CC \uAD11\uACE0 \uD3EC\uD568\uC73C\uB85C \uBCC0\uACBD, \uCD94\uAC00\uAE08 5\uB9CC \uC6D0\n\uC608) \uCEF7 \uD3B8\uC9D1\xB7\uC790\uB9C9 \uD5C8\uC6A9, \uBC1C\uC5B8 \uCDE8\uC9C0\uB97C \uC65C\uACE1\uD558\uB294 \uD3B8\uC9D1 \uAE08\uC9C0\n\uC608) \uC81C3\uC790 \uD50C\uB7AB\uD3FC \uC7AC\uC5C5\uB85C\uB4DC \uAE08\uC9C0",
  AI_VOICE: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.\n\uC608) \uB300\uC0C1: \uD569\uC758\uD55C \uC74C\uC131 \uD30C\uC77C A \uB610\uB294 \uCD5C\uC885 \uB300\uC0AC, 1\uAC1C\xB7\uCD1D 30\uCD08 \uC774\uB0B4\n\uC608) \uC0C8 \uC81C\uC791: \uB300\uC0AC \uD655\uC815\uC77C\xB7\uCD08\uC548 \uC804\uB2EC\uC77C\xB7\uD569\uC758\uD55C \uC218\uC815 \uB0B4\uC6A9\n\uC608) \uC0AC\uC6A9 \uC704\uCE58\xB7\uD3B8\uC9D1 \uB0B4\uC6A9\uC740 \uAD6C\uB9E4 \uC870\uAC74 \uC548\uC5D0\uC11C \uD655\uC815\n\uC608) \uAD6C\uB9E4\uC790 AI \uC0DD\uC131: \uC0AC\uC6A9\uD560 \uBAA9\uC18C\uB9AC\xB7\uC11C\uBE44\uC2A4\xB7\uC811\uADFC \uC81C\uACF5\uC77C\xB7\uC0DD\uC131 \uAC00\uB2A5 \uAE30\uAC04\xB7\uD5C8\uC6A9 \uC5B8\uC5B4 \uD655\uC815",
  CO_BRANDING: "\uAD6C\uB9E4\uD55C \uC870\uAC74 \uC548\uC5D0\uC11C \uC2E4\uC81C \uACF5\uB3D9\uBE0C\uB79C\uB529 \uB0B4\uC6A9\uC744 \uD655\uC815\uD574 \uC8FC\uC138\uC694.\n\uC608) \uC0C1\uB300 \uBE0C\uB79C\uB4DC\xB7\uCEA0\uD398\uC778: \uD569\uC758\uD55C \uBE0C\uB79C\uB4DC A, \uAC00\uC744 \uACF5\uB3D9 \uCEA0\uD398\uC778 1\uAC74\n\uC608) \uB450 \uBE0C\uB79C\uB4DC \uD45C\uC2DC \uBC29\uC2DD: '\uBE0C\uB79C\uB4DC A \xD7 \uBE0C\uB79C\uB4DC B', \uCD5C\uC885 \uB85C\uACE0 \uBC30\uC5F4 \uC2DC\uC548 v2\n\uC608) \uAD6C\uB9E4\uD55C SNS \uC77C\uBC18 \uAC8C\uC2DC\xB7\uC6F9\uC0AC\uC774\uD2B8\uC5D0\uC11C \uC0AC\uC6A9, \uACF5\uAC1C \uC804 \uCD5C\uC885 \uBB38\uAD6C\xB7\uC2DC\uC548 \uD655\uC778\n\uC608) \uC885\uB8CC \uD6C4 \uCC98\uB9AC\uB294 \uACC4\uC57D \uC870\uAC74\uC5D0 \uB530\uB984. \uAE30\uB85D\uC6A9 \uC720\uC9C0 \uC2DC \uC885\uB8CC\uB41C \uCEA0\uD398\uC778\uC784\uC744 \uD45C\uC2DC",
  MERCHANDISE: "\uAD6C\uB9E4\uD55C \uC870\uAC74 \uC548\uC5D0\uC11C \uC2E4\uC81C \uC81C\uC791\xB7\uD310\uB9E4\xB7\uBC30\uD3EC \uB0B4\uC6A9\uC744 \uD655\uC815\uD574 \uC8FC\uC138\uC694.\n\uC608) \uC0AC\uC6A9\uD560 \uC790\uB8CC\xB7\uCD5C\uC885 \uC2DC\uC548: \uB300\uD654\uB85C \uD569\uC758\uD55C \uCE90\uB9AD\uD130 \uD30C\uC77C\uACFC \uD0A4\uB9C1 \uC2DC\uC548 v2\n\uC608) \uCD1D \uC81C\uC791 500\uAC1C: \uD310\uB9E4 390\uAC1C\xB7\uC99D\uC815 100\uAC1C\xB7\uC2B9\uC778\uC6A9 \uC0D8\uD50C 10\uAC1C (\uBE44\uB9E4\uD488 \uC804\uC6A9\uC774\uBA74 \uD310\uB9E4 \uC81C\uC678)\n\uC608) \uD310\uB9E4\xB7\uBC30\uD3EC\uCC98: \uD569\uC758\uD55C \uC628\uB77C\uC778\uBAB0\xB7\uD589\uC0AC, \uC591\uC0B0 \uC804 \uCD5C\uC885 \uC2DC\uC548\xB7\uC0D8\uD50C \uD655\uC778\n\uC608) \uAE30\uAC04 \uC885\uB8CC \uD6C4: \uAD6C\uB9E4\uD55C \uC7AC\uACE0 \uC815\uB9AC \uC870\uAC74\uC5D0 \uB530\uB77C \uCC98\uB9AC, \uC0C8 \uC0DD\uC0B0 \uAE08\uC9C0\n\uC608) \uB9E4\uCD9C \uB85C\uC5F4\uD2F0\uAC00 \uC788\uB2E4\uBA74 \uD310\uB9E4\uBD84\uC758 \uC815\uC0B0 \uAE30\uC900\xB7\uC99D\uBE59 \uD655\uC815",
  COLLABORATION: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.\n\uC608) \uCF5C\uB77C\uBCF4 \uC0C1\uD488 \uBC94\uC704: OO \uC5D0\uB514\uC158 1\uC885\n\uC608) \uCD9C\uC2DC \uC804 \uCD5C\uC885 \uB514\uC790\uC778 \uC0C1\uD638 \uD655\uC778\n\uC608) \uC7AC\uBC1C\uC8FC(\uB9AC\uC624\uB354)\uB294 \uBCC4\uB3C4 \uD611\uC758",
  APPEARANCE: "\uC774 \uAD6C\uB9E4\uC790\uC5D0\uAC8C\uB9CC \uC801\uC6A9\uB418\uB294 \uB0B4\uC6A9\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.\n\uC608) \uCD9C\uC5F0 \uC77C\uC2DC\xB7\uC7A5\uC18C \uB610\uB294 \uC811\uC18D \uBC29\uBC95: \uD569\uC758\uD55C \uB0A0\uC9DC\xB7\uC11C\uC6B8 \uD589\uC0AC\uC7A5 \uB610\uB294 \uC628\uB77C\uC778 \uC811\uC18D \uB9C1\uD06C\n\uC608) \uD65C\uB3D9\xB7\uC2DC\uAC04: \uC778\uD130\uBDF0\uC640 \uC0AC\uC9C4 \uCD2C\uC601, 1\uD68C\xB760\uBD84 \uC774\uB0B4, \uB9AC\uD5C8\uC124 \uD3EC\uD568 \uC5EC\uBD80 \uD655\uC815\n\uC608) \uAD50\uD1B5\xB7\uC219\uBC15\uBE44\uC640 \uC5F0\uC7A5 \uC5EC\uBD80\xB7\uCD94\uAC00 \uBE44\uC6A9\uC740 \uC2E4\uC81C \uD569\uC758\uD55C \uB0B4\uC6A9 \uAE30\uB85D\n\uC608) \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58\xB7\uAE30\uAC04\uC740 \uAD6C\uB9E4 \uC870\uAC74\uC5D0 \uB530\uB974\uACE0, \uCD2C\uC601\xB7\uC6D0\uBCF8 \uC804\uB2EC\xB7\uD3B8\uC9D1 \uB2F4\uB2F9\uC790 \uD655\uC815\n\uC608) \uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C \uC2DC \uC801\uC6A9\uD560 \uC870\uAC74 \uD655\uC815"
};
var SPECIAL_TERMS_PLACEHOLDERS_I18N = {
  ko: SPECIAL_TERMS_PLACEHOLDERS,
  en: {
    NAME_BRAND: "Write anything that applies only to this buyer.\ne.g. Name usage: limited to the Korean spelling 'OOO' only (logo and English spelling negotiated separately)\ne.g. Where used: product detail page and packaging copy\ne.g. Quantity: 1 product (up to 3 SKUs), up to 2 ad creatives\ne.g. Trademark filing or trade name registration of the brand name is not allowed",
    FACE_PHOTO: "Write anything that applies only to this buyer.\ne.g. Covered: shots A, B and C agreed in chat, 3 final photos\ne.g. Changed from 1 photo to 3, \u20A9100,000 for 2 extra / detail page for 3 months\ne.g. Retouching and cropping allowed; face compositing and AI training not allowed\ne.g. Ads that require review (medical, financial, etc.) are checked before posting",
    CONTENT_SECONDARY: "Write anything that applies only to this buyer.\ne.g. Covered: 1 video chosen by the buyer in chat, 00:10\u201300:30\ne.g. Changed from brand reposting to including paid brand ads, \u20A950,000 extra\ne.g. Cut edits and subtitles allowed; edits that distort what was said are not allowed\ne.g. Re-uploading to third-party platforms is not allowed",
    AI_VOICE: "Write anything that applies only to this buyer.\ne.g. Covered: agreed voice file A or the final script, 1 clip, 30 seconds total or less\ne.g. New recording: script confirmation date, draft delivery date and agreed revisions\ne.g. Where it is used and how it is edited are set within the purchased terms\ne.g. Buyer AI generation: set the voice, service, access date, generation period and allowed languages",
    CO_BRANDING: "Set the actual co-branding details within the purchased terms.\ne.g. Partner brand and campaign: agreed brand A, 1 joint fall campaign\ne.g. How both brands appear: 'Brand A \xD7 Brand B', final logo layout draft v2\ne.g. Used on purchased regular social posts and the website; final copy and drafts checked before release\ne.g. After it ends, follow the contract terms. If kept for the record, mark it as a finished campaign",
    MERCHANDISE: "Set the actual production, sales and distribution details within the purchased terms.\ne.g. Materials and final design: the character file agreed in chat and keyring draft v2\ne.g. 500 made in total: 390 for sale, 100 giveaways, 10 approval samples (no sales if not-for-sale only)\ne.g. Where sold or distributed: agreed online stores and events; final design and sample checked before mass production\ne.g. After the term ends: clear remaining stock per the purchased terms, no new production\ne.g. If there is a sales royalty, set how sales are counted and what proof is provided",
    COLLABORATION: "Write anything that applies only to this buyer.\ne.g. Collaboration product scope: 1 OO edition\ne.g. Both sides confirm the final design before release\ne.g. Reorders are negotiated separately",
    APPEARANCE: "Write anything that applies only to this buyer.\ne.g. Date, time and place or how to join: agreed date, Seoul venue or online link\ne.g. Activities and time: interview and photo shoot, once, up to 60 minutes, whether rehearsal is included\ne.g. Record the actual agreement on travel and lodging, extensions and extra costs\ne.g. Where and how long footage is used follows the purchased terms; set who shoots, delivers originals and edits\ne.g. Set the terms that apply if the schedule changes or is cancelled"
  },
  ja: {
    NAME_BRAND: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u5185\u5BB9\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u4F7F\u7528\u8868\u8A18\uFF1A\u97D3\u56FD\u8A9E\u8868\u8A18\u300COOO\u300D1\u7A2E\u306B\u9650\u308B\uFF08\u30ED\u30B4\u30FB\u82F1\u8A9E\u8868\u8A18\u306F\u5225\u9014\u5354\u8B70\uFF09\n\u4F8B\uFF09\u4F7F\u7528\u5834\u6240\uFF1A\u5546\u54C1\u8A73\u7D30\u30DA\u30FC\u30B8\u30FB\u30D1\u30C3\u30B1\u30FC\u30B8\u306E\u6587\u8A00\n\u4F8B\uFF09\u4F7F\u7528\u6570\u91CF\uFF1A\u5BFE\u8C61\u5546\u54C11\u7A2E\uFF08SKU 3\u500B\u4EE5\u5185\uFF09\u3001\u5E83\u544A\u7D20\u67502\u4EF6\u4EE5\u5185\n\u4F8B\uFF09\u30D6\u30E9\u30F3\u30C9\u540D\u306E\u5546\u6A19\u51FA\u9858\u30FB\u5546\u53F7\u767B\u9332\u306F\u7981\u6B62",
    FACE_PHOTO: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u5185\u5BB9\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u5BFE\u8C61\uFF1A\u30C1\u30E3\u30C3\u30C8\u3067\u5408\u610F\u3057\u305F\u64AE\u5F71\u30C7\u30FC\u30BFA\u30FBB\u30FBC\u3001\u6700\u7D423\u679A\n\u4F8B\uFF09\u57FA\u672C1\u679A \u2192 3\u679A\u306B\u5909\u66F4\u3001\u8FFD\u52A02\u679A10\u4E07\u30A6\u30A9\u30F3 / \u8A73\u7D30\u30DA\u30FC\u30B83\u304B\u6708\n\u4F8B\uFF09\u88DC\u6B63\u30FB\u30C8\u30EA\u30DF\u30F3\u30B0\u53EF\u3001\u9854\u306E\u5408\u6210\u30FBAI\u5B66\u7FD2\u3078\u306E\u5229\u7528\u306F\u7981\u6B62\n\u4F8B\uFF09\u533B\u7642\u30FB\u91D1\u878D\u306A\u3069\u5BE9\u67FB\u304C\u5FC5\u8981\u306A\u5E83\u544A\u306F\u63B2\u8F09\u524D\u306B\u78BA\u8A8D",
    CONTENT_SECONDARY: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u5185\u5BB9\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u5BFE\u8C61\uFF1A\u8CFC\u5165\u8005\u304C\u30C1\u30E3\u30C3\u30C8\u3067\u6307\u5B9A\u3057\u305F\u52D5\u753B1\u672C\u300100:10\u301C00:30\u306E\u533A\u9593\n\u4F8B\uFF09\u30D6\u30E9\u30F3\u30C9\u518D\u6295\u7A3F \u2192 \u30D6\u30E9\u30F3\u30C9\u6709\u6599\u5E83\u544A\u3092\u542B\u3080\u306B\u5909\u66F4\u3001\u8FFD\u52A0\u6599\u91D15\u4E07\u30A6\u30A9\u30F3\n\u4F8B\uFF09\u30AB\u30C3\u30C8\u7DE8\u96C6\u30FB\u5B57\u5E55\u53EF\u3001\u767A\u8A00\u306E\u8DA3\u65E8\u3092\u6B6A\u3081\u308B\u7DE8\u96C6\u306F\u7981\u6B62\n\u4F8B\uFF09\u7B2C\u4E09\u8005\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u518D\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306F\u7981\u6B62",
    AI_VOICE: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u5185\u5BB9\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u5BFE\u8C61\uFF1A\u5408\u610F\u3057\u305F\u97F3\u58F0\u30D5\u30A1\u30A4\u30EBA\u307E\u305F\u306F\u6700\u7D42\u30BB\u30EA\u30D5\u30011\u672C\u30FB\u5408\u8A0830\u79D2\u4EE5\u5185\n\u4F8B\uFF09\u65B0\u898F\u5236\u4F5C\uFF1A\u30BB\u30EA\u30D5\u78BA\u5B9A\u65E5\u30FB\u521D\u7A3F\u306E\u53D7\u3051\u6E21\u3057\u65E5\u30FB\u5408\u610F\u3057\u305F\u4FEE\u6B63\u5185\u5BB9\n\u4F8B\uFF09\u4F7F\u7528\u5834\u6240\u30FB\u7DE8\u96C6\u5185\u5BB9\u306F\u8CFC\u5165\u6761\u4EF6\u306E\u7BC4\u56F2\u3067\u78BA\u5B9A\n\u4F8B\uFF09\u8CFC\u5165\u8005\u306EAI\u751F\u6210\uFF1A\u4F7F\u7528\u3059\u308B\u58F0\u30FB\u30B5\u30FC\u30D3\u30B9\u30FB\u30A2\u30AF\u30BB\u30B9\u63D0\u4F9B\u65E5\u30FB\u751F\u6210\u53EF\u80FD\u671F\u9593\u30FB\u8A31\u53EF\u3059\u308B\u8A00\u8A9E\u3092\u78BA\u5B9A",
    CO_BRANDING: "\u8CFC\u5165\u3057\u305F\u6761\u4EF6\u306E\u7BC4\u56F2\u3067\u3001\u5B9F\u969B\u306E\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u306E\u5185\u5BB9\u3092\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u76F8\u624B\u30D6\u30E9\u30F3\u30C9\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\uFF1A\u5408\u610F\u3057\u305F\u30D6\u30E9\u30F3\u30C9A\u3001\u79CB\u306E\u5171\u540C\u30AD\u30E3\u30F3\u30DA\u30FC\u30F31\u4EF6\n\u4F8B\uFF092\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u306E\u8868\u793A\u65B9\u6CD5\uFF1A\u300C\u30D6\u30E9\u30F3\u30C9A \xD7 \u30D6\u30E9\u30F3\u30C9B\u300D\u3001\u6700\u7D42\u30ED\u30B4\u914D\u7F6E\u6848v2\n\u4F8B\uFF09\u8CFC\u5165\u3057\u305FSNS\u901A\u5E38\u6295\u7A3F\u30FB\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u4F7F\u7528\u3001\u516C\u958B\u524D\u306B\u6700\u7D42\u306E\u6587\u8A00\u30FB\u6848\u3092\u78BA\u8A8D\n\u4F8B\uFF09\u7D42\u4E86\u5F8C\u306E\u6271\u3044\u306F\u5951\u7D04\u6761\u4EF6\u306B\u5F93\u3046\u3002\u8A18\u9332\u7528\u306B\u6B8B\u3059\u5834\u5408\u306F\u7D42\u4E86\u3057\u305F\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u3067\u3042\u308B\u3053\u3068\u3092\u8868\u793A",
    MERCHANDISE: "\u8CFC\u5165\u3057\u305F\u6761\u4EF6\u306E\u7BC4\u56F2\u3067\u3001\u5B9F\u969B\u306E\u5236\u4F5C\u30FB\u8CA9\u58F2\u30FB\u914D\u5E03\u306E\u5185\u5BB9\u3092\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u4F7F\u7528\u3059\u308B\u8CC7\u6599\u30FB\u6700\u7D42\u30C7\u30B6\u30A4\u30F3\uFF1A\u30C1\u30E3\u30C3\u30C8\u3067\u5408\u610F\u3057\u305F\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u30D5\u30A1\u30A4\u30EB\u3068\u30AD\u30FC\u30DB\u30EB\u30C0\u30FC\u6848v2\n\u4F8B\uFF09\u5408\u8A08500\u500B\u5236\u4F5C\uFF1A\u8CA9\u58F2390\u500B\u30FB\u914D\u5E03100\u500B\u30FB\u627F\u8A8D\u7528\u30B5\u30F3\u30D7\u30EB10\u500B\uFF08\u975E\u58F2\u54C1\u306E\u307F\u306A\u3089\u8CA9\u58F2\u306A\u3057\uFF09\n\u4F8B\uFF09\u8CA9\u58F2\u30FB\u914D\u5E03\u5148\uFF1A\u5408\u610F\u3057\u305F\u30AA\u30F3\u30E9\u30A4\u30F3\u30B7\u30E7\u30C3\u30D7\u30FB\u30A4\u30D9\u30F3\u30C8\u3001\u91CF\u7523\u524D\u306B\u6700\u7D42\u30C7\u30B6\u30A4\u30F3\u30FB\u30B5\u30F3\u30D7\u30EB\u3092\u78BA\u8A8D\n\u4F8B\uFF09\u671F\u9593\u7D42\u4E86\u5F8C\uFF1A\u8CFC\u5165\u3057\u305F\u5728\u5EAB\u51E6\u7406\u306E\u6761\u4EF6\u306B\u5F93\u3063\u3066\u51E6\u7406\u3001\u65B0\u305F\u306A\u751F\u7523\u306F\u7981\u6B62\n\u4F8B\uFF09\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304C\u3042\u308B\u5834\u5408\u306F\u8CA9\u58F2\u5206\u306E\u7CBE\u7B97\u57FA\u6E96\u30FB\u8A3C\u6191\u3092\u78BA\u5B9A",
    COLLABORATION: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u5185\u5BB9\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u30B3\u30E9\u30DC\u5546\u54C1\u306E\u7BC4\u56F2\uFF1AOO\u30A8\u30C7\u30A3\u30B7\u30E7\u30F31\u7A2E\n\u4F8B\uFF09\u767A\u58F2\u524D\u306B\u6700\u7D42\u30C7\u30B6\u30A4\u30F3\u3092\u76F8\u4E92\u78BA\u8A8D\n\u4F8B\uFF09\u518D\u767A\u6CE8\uFF08\u30EA\u30AA\u30FC\u30C0\u30FC\uFF09\u306F\u5225\u9014\u5354\u8B70",
    APPEARANCE: "\u3053\u306E\u8CFC\u5165\u8005\u306B\u3060\u3051\u9069\u7528\u3055\u308C\u308B\u5185\u5BB9\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F8B\uFF09\u51FA\u6F14\u65E5\u6642\u30FB\u5834\u6240\u307E\u305F\u306F\u53C2\u52A0\u65B9\u6CD5\uFF1A\u5408\u610F\u3057\u305F\u65E5\u4ED8\u30FB\u30BD\u30A6\u30EB\u306E\u30A4\u30D9\u30F3\u30C8\u4F1A\u5834\u307E\u305F\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u53C2\u52A0\u30EA\u30F3\u30AF\n\u4F8B\uFF09\u6D3B\u52D5\u30FB\u6642\u9593\uFF1A\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC\u3068\u5199\u771F\u64AE\u5F71\u30011\u56DE\u30FB60\u5206\u4EE5\u5185\u3001\u30EA\u30CF\u30FC\u30B5\u30EB\u3092\u542B\u3080\u304B\u3092\u78BA\u5B9A\n\u4F8B\uFF09\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u3068\u5EF6\u9577\u306E\u6709\u7121\u30FB\u8FFD\u52A0\u8CBB\u7528\u306F\u5B9F\u969B\u306B\u5408\u610F\u3057\u305F\u5185\u5BB9\u3092\u8A18\u9332\n\u4F8B\uFF09\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u5834\u6240\u30FB\u671F\u9593\u306F\u8CFC\u5165\u6761\u4EF6\u306B\u5F93\u3044\u3001\u64AE\u5F71\u30FB\u5143\u30C7\u30FC\u30BF\u306E\u53D7\u3051\u6E21\u3057\u30FB\u7DE8\u96C6\u306E\u62C5\u5F53\u8005\u3092\u78BA\u5B9A\n\u4F8B\uFF09\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u6642\u306B\u9069\u7528\u3059\u308B\u6761\u4EF6\u3092\u78BA\u5B9A"
  }
};
var OFFER_DURATION_MONTHS = [
  1,
  3,
  6,
  12
];
function addonMonthsOf(months) {
  return months > 0 ? months : 1;
}
__name(addonMonthsOf, "addonMonthsOf");
function monthlyAddonLabel(amount, lang = DEFAULT_LANG) {
  const n = amount.toLocaleString(INTL_LOCALE[lang]);
  return tr(lang, {
    ko: `\uC6D4 +${n}\uC6D0`,
    en: `+\u20A9${n}/mo`,
    ja: `\u6708 +${n}\u30A6\u30A9\u30F3`
  });
}
__name(monthlyAddonLabel, "monthlyAddonLabel");
var UsageRegion = {
  /** 국내(한국) 한정 */
  DOMESTIC: "DOMESTIC",
  GLOBAL: "GLOBAL"
};
var USAGE_REGION_LABELS = {
  DOMESTIC: "\uAD6D\uB0B4(\uD55C\uAD6D) \uD55C\uC815",
  GLOBAL: "\uAE00\uB85C\uBC8C \uAC00\uB2A5"
};
var USAGE_REGION_LABELS_I18N = {
  ko: USAGE_REGION_LABELS,
  en: {
    DOMESTIC: "Korea only",
    GLOBAL: "Worldwide"
  },
  ja: {
    DOMESTIC: "\u56FD\u5185(\u97D3\u56FD)\u9650\u5B9A",
    GLOBAL: "\u30B0\u30ED\u30FC\u30D0\u30EB\u53EF"
  }
};
var Exclusivity = {
  NON_EXCLUSIVE: "NON_EXCLUSIVE",
  CATEGORY_EXCLUSIVE: "CATEGORY_EXCLUSIVE",
  FULL_EXCLUSIVE: "FULL_EXCLUSIVE"
};
var EXCLUSIVITY_LABELS = {
  NON_EXCLUSIVE: "\uBE44\uB3C5\uC810",
  CATEGORY_EXCLUSIVE: "\uCE74\uD14C\uACE0\uB9AC \uB3C5\uC810",
  FULL_EXCLUSIVE: "\uC644\uC804 \uB3C5\uC810"
};
var EXCLUSIVITY_LABELS_I18N = {
  ko: EXCLUSIVITY_LABELS,
  en: {
    NON_EXCLUSIVE: "Non-exclusive",
    CATEGORY_EXCLUSIVE: "Category exclusive",
    FULL_EXCLUSIVE: "Fully exclusive"
  },
  ja: {
    NON_EXCLUSIVE: "\u975E\u72EC\u5360",
    CATEGORY_EXCLUSIVE: "\u30AB\u30C6\u30B4\u30EA\u30FC\u72EC\u5360",
    FULL_EXCLUSIVE: "\u5B8C\u5168\u72EC\u5360"
  }
};
var ModificationRight = {
  CROP_ALLOWED: "CROP_ALLOWED",
  COLOR_EDIT_ALLOWED: "COLOR_EDIT_ALLOWED",
  AI_EDIT_FORBIDDEN: "AI_EDIT_FORBIDDEN",
  /** 일체 수정 금지 — 이름/브랜드처럼 자산 변형 자체를 막는 유형용 */
  EDIT_FORBIDDEN: "EDIT_FORBIDDEN",
  RETOUCH_ALLOWED: "RETOUCH_ALLOWED",
  BACKGROUND_EDIT_ALLOWED: "BACKGROUND_EDIT_ALLOWED",
  CUT_ALLOWED: "CUT_ALLOWED",
  SUBTITLE_ALLOWED: "SUBTITLE_ALLOWED",
  TRANSLATION_ALLOWED: "TRANSLATION_ALLOWED",
  MUSIC_REPLACE_ALLOWED: "MUSIC_REPLACE_ALLOWED",
  AUDIO_TRIM_ALLOWED: "AUDIO_TRIM_ALLOWED",
  AUDIO_CLEANUP_ALLOWED: "AUDIO_CLEANUP_ALLOWED",
  AUDIO_MUSIC_ALLOWED: "AUDIO_MUSIC_ALLOWED",
  AUDIO_SPEED_PITCH_ALLOWED: "AUDIO_SPEED_PITCH_ALLOWED"
};
var MODIFICATION_RIGHT_LABELS = {
  CROP_ALLOWED: "\uD06C\uB86D \uAC00\uB2A5",
  COLOR_EDIT_ALLOWED: "\uC0C9\uC0C1 \uBCC0\uACBD \uAC00\uB2A5",
  AI_EDIT_FORBIDDEN: "AI \uC218\uC815 \uAE08\uC9C0",
  EDIT_FORBIDDEN: "\uC218\uC815 \uAE08\uC9C0",
  RETOUCH_ALLOWED: "\uD53C\uBD80\xB7\uBC1D\uAE30 \uBCF4\uC815 \uAC00\uB2A5",
  BACKGROUND_EDIT_ALLOWED: "\uBC30\uACBD \uAD50\uCCB4 \uAC00\uB2A5",
  CUT_ALLOWED: "\uCEF7\xB7\uAD6C\uAC04 \uD3B8\uC9D1 \uAC00\uB2A5",
  SUBTITLE_ALLOWED: "\uC790\uB9C9 \uCD94\uAC00 \uAC00\uB2A5",
  TRANSLATION_ALLOWED: "\uBC88\uC5ED \uC790\uB9C9 \uAC00\uB2A5",
  MUSIC_REPLACE_ALLOWED: "\uC74C\uC6D0 \uAD50\uCCB4 \uAC00\uB2A5",
  AUDIO_TRIM_ALLOWED: "\uC790\uB974\uAE30\xB7\uC774\uC5B4 \uBD99\uC774\uAE30 \uAC00\uB2A5",
  AUDIO_CLEANUP_ALLOWED: "\uBCFC\uB968 \uC870\uC808\xB7\uB178\uC774\uC988 \uC81C\uAC70 \uAC00\uB2A5",
  AUDIO_MUSIC_ALLOWED: "\uBC30\uACBD\uC74C\uC545 \uACB0\uD569 \uAC00\uB2A5",
  AUDIO_SPEED_PITCH_ALLOWED: "\uC18D\uB3C4\xB7\uC74C\uB192\uC774 \uBCC0\uACBD \uAC00\uB2A5"
};
var MODIFICATION_RIGHT_LABELS_I18N = {
  ko: MODIFICATION_RIGHT_LABELS,
  en: {
    CROP_ALLOWED: "Cropping allowed",
    COLOR_EDIT_ALLOWED: "Color changes allowed",
    AI_EDIT_FORBIDDEN: "No AI editing",
    EDIT_FORBIDDEN: "No editing",
    RETOUCH_ALLOWED: "Skin & brightness retouching allowed",
    BACKGROUND_EDIT_ALLOWED: "Background replacement allowed",
    CUT_ALLOWED: "Cut & segment editing allowed",
    SUBTITLE_ALLOWED: "Adding subtitles allowed",
    TRANSLATION_ALLOWED: "Translated subtitles allowed",
    MUSIC_REPLACE_ALLOWED: "Music replacement allowed",
    AUDIO_TRIM_ALLOWED: "Trimming & splicing allowed",
    AUDIO_CLEANUP_ALLOWED: "Volume adjustment & noise removal allowed",
    AUDIO_MUSIC_ALLOWED: "Adding background music allowed",
    AUDIO_SPEED_PITCH_ALLOWED: "Speed & pitch changes allowed"
  },
  ja: {
    CROP_ALLOWED: "\u30C8\u30EA\u30DF\u30F3\u30B0\u53EF",
    COLOR_EDIT_ALLOWED: "\u8272\u306E\u5909\u66F4\u53EF",
    AI_EDIT_FORBIDDEN: "AI\u306B\u3088\u308B\u4FEE\u6B63\u7981\u6B62",
    EDIT_FORBIDDEN: "\u4FEE\u6B63\u7981\u6B62",
    RETOUCH_ALLOWED: "\u808C\u30FB\u660E\u308B\u3055\u306E\u88DC\u6B63\u53EF",
    BACKGROUND_EDIT_ALLOWED: "\u80CC\u666F\u306E\u5DEE\u3057\u66FF\u3048\u53EF",
    CUT_ALLOWED: "\u30AB\u30C3\u30C8\u30FB\u533A\u9593\u7DE8\u96C6\u53EF",
    SUBTITLE_ALLOWED: "\u5B57\u5E55\u306E\u8FFD\u52A0\u53EF",
    TRANSLATION_ALLOWED: "\u7FFB\u8A33\u5B57\u5E55\u53EF",
    MUSIC_REPLACE_ALLOWED: "\u97F3\u6E90\u306E\u5DEE\u3057\u66FF\u3048\u53EF",
    AUDIO_TRIM_ALLOWED: "\u30AB\u30C3\u30C8\u30FB\u3064\u306A\u304E\u5408\u308F\u305B\u53EF",
    AUDIO_CLEANUP_ALLOWED: "\u97F3\u91CF\u8ABF\u6574\u30FB\u30CE\u30A4\u30BA\u9664\u53BB\u53EF",
    AUDIO_MUSIC_ALLOWED: "BGM\u3068\u306E\u7D44\u307F\u5408\u308F\u305B\u53EF",
    AUDIO_SPEED_PITCH_ALLOWED: "\u901F\u5EA6\u30FB\u30D4\u30C3\u30C1\u306E\u5909\u66F4\u53EF"
  }
};
var ForbiddenIndustry = {
  GAMBLING: "GAMBLING",
  ADULT: "ADULT",
  POLITICS: "POLITICS",
  MEDICAL: "MEDICAL",
  INVESTMENT: "INVESTMENT",
  ALCOHOL: "ALCOHOL"
};
var FORBIDDEN_INDUSTRY_LABELS = {
  GAMBLING: "\uB3C4\uBC15",
  ADULT: "\uC131\uC778",
  POLITICS: "\uC815\uCE58",
  MEDICAL: "\uC758\uB8CC",
  INVESTMENT: "\uD22C\uC790",
  ALCOHOL: "\uC8FC\uB958"
};
var FORBIDDEN_INDUSTRY_LABELS_I18N = {
  ko: FORBIDDEN_INDUSTRY_LABELS,
  en: {
    GAMBLING: "Gambling",
    ADULT: "Adult",
    POLITICS: "Politics",
    MEDICAL: "Medical",
    INVESTMENT: "Investment",
    ALCOHOL: "Alcohol"
  },
  ja: {
    GAMBLING: "\u30AE\u30E3\u30F3\u30D6\u30EB",
    ADULT: "\u6210\u4EBA\u5411\u3051",
    POLITICS: "\u653F\u6CBB",
    MEDICAL: "\u533B\u7642",
    INVESTMENT: "\u6295\u8CC7",
    ALCOHOL: "\u9152\u985E"
  }
};
var BrandAsset = {
  KOREAN_NAME: "KOREAN_NAME",
  ENGLISH_NAME: "ENGLISH_NAME",
  LOGO: "LOGO",
  SYMBOL: "SYMBOL",
  SLOGAN: "SLOGAN"
};
var BRAND_ASSET_LABELS = {
  KOREAN_NAME: "\uD55C\uAE00 \uD45C\uAE30",
  ENGLISH_NAME: "\uC601\uBB38 \uD45C\uAE30",
  LOGO: "\uB85C\uACE0",
  SYMBOL: "\uC2EC\uBCFC",
  SLOGAN: "\uC2AC\uB85C\uAC74"
};
var BRAND_ASSET_LABELS_I18N = {
  ko: BRAND_ASSET_LABELS,
  en: {
    KOREAN_NAME: "Korean name",
    ENGLISH_NAME: "English name",
    LOGO: "Logo",
    SYMBOL: "Symbol",
    SLOGAN: "Slogan"
  },
  ja: {
    KOREAN_NAME: "\u30CF\u30F3\u30B0\u30EB\u8868\u8A18",
    ENGLISH_NAME: "\u82F1\u8A9E\u8868\u8A18",
    LOGO: "\u30ED\u30B4",
    SYMBOL: "\u30B7\u30F3\u30DC\u30EB",
    SLOGAN: "\u30B9\u30ED\u30FC\u30AC\u30F3"
  }
};
var UsagePlacement = {
  BRAND_SOCIAL: "BRAND_SOCIAL",
  PRODUCT_PAGE: "PRODUCT_PAGE",
  PAID_ADS: "PAID_ADS",
  PRODUCT_NAME: "PRODUCT_NAME",
  OFFLINE: "OFFLINE",
  PACKAGING: "PACKAGING"
};
var USAGE_PLACEMENT_LABELS = {
  BRAND_SOCIAL: "\uBE0C\uB79C\uB4DC SNS \uC77C\uBC18 \uAC8C\uC2DC",
  PRODUCT_PAGE: "\uC6F9\uC0AC\uC774\uD2B8\xB7\uC0C1\uD488 \uC0C1\uC138\uD398\uC774\uC9C0",
  PAID_ADS: "\uC720\uB8CC \uAD11\uACE0\uC5D0 \uC0AC\uC6A9",
  PRODUCT_NAME: "\uC0C1\uD488\uBA85\uC5D0 \uC0AC\uC6A9",
  OFFLINE: "\uB9E4\uC7A5\xB7\uD589\uC0AC\xB7\uC625\uC678 \uB9E4\uCCB4",
  PACKAGING: "\uC0C1\uD488 \uD328\uD0A4\uC9C0"
};
var USAGE_PLACEMENT_LABELS_I18N = {
  ko: USAGE_PLACEMENT_LABELS,
  en: {
    BRAND_SOCIAL: "Regular brand social posts",
    PRODUCT_PAGE: "Website & product pages",
    PAID_ADS: "Paid advertising",
    PRODUCT_NAME: "In product names",
    OFFLINE: "Stores, events & outdoor media",
    PACKAGING: "Product packaging"
  },
  ja: {
    BRAND_SOCIAL: "\u30D6\u30E9\u30F3\u30C9SNS\u306E\u901A\u5E38\u6295\u7A3F",
    PRODUCT_PAGE: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u30FB\u5546\u54C1\u8A73\u7D30\u30DA\u30FC\u30B8",
    PAID_ADS: "\u6709\u6599\u5E83\u544A\u3067\u306E\u4F7F\u7528",
    PRODUCT_NAME: "\u5546\u54C1\u540D\u3067\u306E\u4F7F\u7528",
    OFFLINE: "\u5E97\u8217\u30FB\u30A4\u30D9\u30F3\u30C8\u30FB\u5C4B\u5916\u30E1\u30C7\u30A3\u30A2",
    PACKAGING: "\u5546\u54C1\u30D1\u30C3\u30B1\u30FC\u30B8"
  }
};
var BrandLegalUse = {
  TRADE_NAME_REGISTRATION: "TRADE_NAME_REGISTRATION",
  CORPORATE_NAME: "CORPORATE_NAME",
  TRADEMARK_FILING: "TRADEMARK_FILING"
};
var BRAND_LEGAL_USE_LABELS = {
  TRADE_NAME_REGISTRATION: "\uC0C1\uD638(\uAC04\uD310) \uB4F1\uB85D",
  CORPORATE_NAME: "\uBC95\uC778\uBA85 \uC0AC\uC6A9",
  TRADEMARK_FILING: "\uC0C1\uD45C \uCD9C\uC6D0"
};
var BRAND_LEGAL_USE_LABELS_I18N = {
  ko: BRAND_LEGAL_USE_LABELS,
  en: {
    TRADE_NAME_REGISTRATION: "Trade name (signage) registration",
    CORPORATE_NAME: "Use as company name",
    TRADEMARK_FILING: "Trademark filing"
  },
  ja: {
    TRADE_NAME_REGISTRATION: "\u5546\u53F7(\u770B\u677F)\u767B\u9332",
    CORPORATE_NAME: "\u6CD5\u4EBA\u540D\u3067\u306E\u4F7F\u7528",
    TRADEMARK_FILING: "\u5546\u6A19\u51FA\u9858"
  }
};
var PricingModel = {
  FIXED: "FIXED",
  REVENUE_SHARE: "REVENUE_SHARE",
  FIXED_PLUS_ROYALTY: "FIXED_PLUS_ROYALTY"
};
var PRICING_MODEL_LABELS = {
  FIXED: "\uACE0\uC815\uAC00",
  REVENUE_SHARE: "\uB9E4\uCD9C \uB85C\uC5F4\uD2F0",
  FIXED_PLUS_ROYALTY: "\uACE0\uC815\uAC00 + \uB9E4\uCD9C \uB85C\uC5F4\uD2F0"
};
var PRICING_MODEL_LABELS_I18N = {
  ko: PRICING_MODEL_LABELS,
  en: {
    FIXED: "Fixed price",
    REVENUE_SHARE: "Revenue royalty",
    FIXED_PLUS_ROYALTY: "Fixed price + revenue royalty"
  },
  ja: {
    FIXED: "\u56FA\u5B9A\u4FA1\u683C",
    REVENUE_SHARE: "\u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3",
    FIXED_PLUS_ROYALTY: "\u56FA\u5B9A\u4FA1\u683C + \u58F2\u4E0A\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3"
  }
};
var ViolationPolicy = {
  SUSPEND_USE: "SUSPEND_USE",
  PENALTY_FEE: "PENALTY_FEE",
  DAMAGES: "DAMAGES"
};
var VIOLATION_POLICY_LABELS = {
  SUSPEND_USE: "\uC0AC\uC6A9 \uC911\uB2E8",
  PENALTY_FEE: "\uC704\uC57D\uAE08",
  DAMAGES: "\uC190\uD574\uBC30\uC0C1"
};
var VIOLATION_POLICY_LABELS_I18N = {
  ko: VIOLATION_POLICY_LABELS,
  en: {
    SUSPEND_USE: "Suspension of use",
    PENALTY_FEE: "Penalty fee",
    DAMAGES: "Damages"
  },
  ja: {
    SUSPEND_USE: "\u4F7F\u7528\u4E2D\u6B62",
    PENALTY_FEE: "\u9055\u7D04\u91D1",
    DAMAGES: "\u640D\u5BB3\u8CE0\u511F"
  }
};
var ProposalStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  WITHDRAWN: "WITHDRAWN",
  EXPIRED: "EXPIRED",
  CLOSED: "CLOSED"
};
var PROPOSAL_STATUS_LABELS = {
  PENDING: "\uD611\uC758 \uC911",
  ACCEPTED: "\uACC4\uC57D \uC131\uB9BD",
  DECLINED: "\uAC70\uC808\uB428",
  WITHDRAWN: "\uC81C\uC548 \uCDE8\uC18C",
  EXPIRED: "\uAE30\uD55C \uB9CC\uB8CC",
  CLOSED: "\uC6B4\uC601\uC790 \uC885\uB8CC"
};
var PROPOSAL_STATUS_LABELS_I18N = {
  ko: PROPOSAL_STATUS_LABELS,
  en: {
    PENDING: "Negotiating",
    ACCEPTED: "Contract agreed",
    DECLINED: "Declined",
    WITHDRAWN: "Offer withdrawn",
    EXPIRED: "Expired",
    CLOSED: "Closed by admin"
  },
  ja: {
    PENDING: "\u4EA4\u6E09\u4E2D",
    ACCEPTED: "\u5951\u7D04\u6210\u7ACB",
    DECLINED: "\u62D2\u5426",
    WITHDRAWN: "\u63D0\u6848\u53D6\u308A\u6D88\u3057",
    EXPIRED: "\u671F\u9650\u5207\u308C",
    CLOSED: "\u904B\u55B6\u8005\u306B\u3088\u308B\u7D42\u4E86"
  }
};
var ProposalListTab = {
  TODO: "TODO",
  WAITING: "WAITING",
  ACCEPTED: "ACCEPTED",
  ENDED: "ENDED"
};
var RoyaltyReportStatus = {
  REPORTED: "REPORTED",
  CONFIRMED: "CONFIRMED",
  PAID_OUT: "PAID_OUT",
  /** 어드민 반려(무효) — 입금 확인 전에만. 같은 달을 다시 보고할 수 있다 */
  VOIDED: "VOIDED"
};
var RoyaltyReportKind = {
  ORIGINAL: "ORIGINAL",
  ADJUSTMENT: "ADJUSTMENT"
};
var RoyaltyObjectionStatus = {
  OPEN: "OPEN",
  ADJUSTED: "ADJUSTED",
  DISMISSED: "DISMISSED"
};
var ROYALTY_FILE_RULES = {
  mimeTypes: [
    "application/pdf",
    "image/jpeg",
    "image/png"
  ],
  /** input accept 값 */
  accept: ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png",
  maxBytes: 10 * 1024 * 1024
};
var DEFAULT_FORM_CONFIG = {
  duration: true,
  exclusivity: true,
  modification: true,
  modificationOptions: [
    ModificationRight.CROP_ALLOWED,
    ModificationRight.COLOR_EDIT_ALLOWED,
    ModificationRight.AI_EDIT_FORBIDDEN
  ],
  regionLabel: "\uC0AC\uC6A9 \uC9C0\uC5ED",
  pricingModels: [
    PricingModel.FIXED,
    PricingModel.REVENUE_SHARE,
    PricingModel.FIXED_PLUS_ROYALTY
  ],
  brandScope: false
};
var RIGHT_TYPE_FORM_CONFIG = {
  // 이름/브랜드는 자산 변형 여부만 — 크롭/색상/AI 세분화는 의미 없음
  NAME_BRAND: {
    ...DEFAULT_FORM_CONFIG,
    brandScope: true,
    modificationOptions: [
      ModificationRight.EDIT_FORBIDDEN
    ]
  },
  FACE_PHOTO: {
    ...DEFAULT_FORM_CONFIG,
    modificationOptions: [
      ...DEFAULT_FORM_CONFIG.modificationOptions,
      ModificationRight.RETOUCH_ALLOWED,
      ModificationRight.BACKGROUND_EDIT_ALLOWED
    ]
  },
  CONTENT_SECONDARY: {
    ...DEFAULT_FORM_CONFIG,
    modificationOptions: [
      ...DEFAULT_FORM_CONFIG.modificationOptions,
      ModificationRight.CUT_ALLOWED,
      ModificationRight.SUBTITLE_ALLOWED,
      ModificationRight.TRANSLATION_ALLOWED,
      ModificationRight.MUSIC_REPLACE_ALLOWED
    ]
  },
  AI_VOICE: {
    ...DEFAULT_FORM_CONFIG,
    modificationOptions: [
      ModificationRight.AUDIO_TRIM_ALLOWED,
      ModificationRight.AUDIO_CLEANUP_ALLOWED,
      ModificationRight.AUDIO_MUSIC_ALLOWED,
      ModificationRight.AUDIO_SPEED_PITCH_ALLOWED
    ]
  },
  CO_BRANDING: {
    ...DEFAULT_FORM_CONFIG,
    modification: false
  },
  MERCHANDISE: DEFAULT_FORM_CONFIG,
  COLLABORATION: DEFAULT_FORM_CONFIG,
  APPEARANCE: {
    duration: false,
    exclusivity: false,
    modification: false,
    modificationOptions: [],
    regionLabel: "\uCD9C\uC5F0 \uAC00\uB2A5 \uC9C0\uC5ED",
    pricingModels: [
      PricingModel.FIXED
    ],
    brandScope: false
  }
};
var RIGHT_TYPE_REGION_LABELS = Object.fromEntries(Object.entries(RIGHT_TYPE_FORM_CONFIG).map(([type, config]) => [
  type,
  config.regionLabel
]));
var RIGHT_TYPE_REGION_LABELS_I18N = {
  ko: RIGHT_TYPE_REGION_LABELS,
  en: Object.fromEntries(Object.values(IpRightType).map((type) => [
    type,
    type === IpRightType.APPEARANCE ? "Available regions" : "Usage region"
  ])),
  ja: Object.fromEntries(Object.values(IpRightType).map((type) => [
    type,
    type === IpRightType.APPEARANCE ? "\u51FA\u6F14\u53EF\u80FD\u5730\u57DF" : "\u4F7F\u7528\u5730\u57DF"
  ]))
};

// src/enums/forbidden-industries.ts
var MAX_CUSTOM_FORBIDDEN_INDUSTRIES = 10;
var MAX_FORBIDDEN_INDUSTRY_LENGTH = 40;
function isPresetForbiddenIndustry(value) {
  return Object.hasOwn(FORBIDDEN_INDUSTRY_LABELS, value);
}
__name(isPresetForbiddenIndustry, "isPresetForbiddenIndustry");
function forbiddenIndustryLabel(value, lang = DEFAULT_LANG) {
  return isPresetForbiddenIndustry(value) ? FORBIDDEN_INDUSTRY_LABELS_I18N[lang][value] : value;
}
__name(forbiddenIndustryLabel, "forbiddenIndustryLabel");
function normalizeForbiddenIndustry(value) {
  const trimmed = value.normalize("NFKC").trim().replace(/\s+/g, " ");
  const preset = Object.entries(FORBIDDEN_INDUSTRY_LABELS).find(([key, label]) => key === trimmed.toUpperCase() || label === trimmed);
  return preset?.[0] ?? trimmed;
}
__name(normalizeForbiddenIndustry, "normalizeForbiddenIndustry");
function forbiddenIndustryKey(value) {
  return normalizeForbiddenIndustry(value).replace(/\s+/g, "").toLowerCase();
}
__name(forbiddenIndustryKey, "forbiddenIndustryKey");
function isAdultIndustryForbidden(values) {
  return values.some((value) => normalizeForbiddenIndustry(value) === "ADULT");
}
__name(isAdultIndustryForbidden, "isAdultIndustryForbidden");

// src/enums/appearance-scope.ts
var AppearanceMode = {
  ONSITE: "ONSITE",
  ONLINE: "ONLINE",
  AUDIO: "AUDIO",
  /** Historical avatar appearances remain video appearances, never audio-only. */
  AVATAR: "AVATAR"
};
var APPEARANCE_PARTICIPATION_LABELS = {
  ONSITE: "\uD604\uC7A5 \uBC29\uBB38",
  ONLINE: "\uC628\uB77C\uC778 \uCC38\uC5EC"
};
var APPEARANCE_PARTICIPATION_LABELS_I18N = {
  ko: APPEARANCE_PARTICIPATION_LABELS,
  en: {
    ONSITE: "On-site visit",
    ONLINE: "Online participation"
  },
  ja: {
    ONSITE: "\u73FE\u5730\u8A2A\u554F",
    ONLINE: "\u30AA\u30F3\u30E9\u30A4\u30F3\u53C2\u52A0"
  }
};
var APPEARANCE_ONLINE_FORM_LABELS = {
  ONLINE: "\uC601\uC0C1 \uCD9C\uC5F0",
  AUDIO: "\uC74C\uC131 \uCD9C\uC5F0"
};
var APPEARANCE_ONLINE_FORM_LABELS_I18N = {
  ko: APPEARANCE_ONLINE_FORM_LABELS,
  en: {
    ONLINE: "Video appearance",
    AUDIO: "Voice appearance"
  },
  ja: {
    ONLINE: "\u6620\u50CF\u51FA\u6F14",
    AUDIO: "\u97F3\u58F0\u51FA\u6F14"
  }
};
var APPEARANCE_MODE_LABELS = {
  ONSITE: APPEARANCE_PARTICIPATION_LABELS.ONSITE,
  ONLINE: `${APPEARANCE_PARTICIPATION_LABELS.ONLINE} \xB7 ${APPEARANCE_ONLINE_FORM_LABELS.ONLINE}`,
  AUDIO: `${APPEARANCE_PARTICIPATION_LABELS.ONLINE} \xB7 ${APPEARANCE_ONLINE_FORM_LABELS.AUDIO}`,
  AVATAR: `${APPEARANCE_PARTICIPATION_LABELS.ONLINE} \xB7 ${APPEARANCE_ONLINE_FORM_LABELS.ONLINE} (\uC544\uBC14\uD0C0)`
};
var APPEARANCE_MODE_LABELS_I18N = {
  ko: APPEARANCE_MODE_LABELS,
  en: {
    ONSITE: APPEARANCE_PARTICIPATION_LABELS_I18N.en.ONSITE,
    ONLINE: `${APPEARANCE_PARTICIPATION_LABELS_I18N.en.ONLINE} \xB7 ${APPEARANCE_ONLINE_FORM_LABELS_I18N.en.ONLINE}`,
    AUDIO: `${APPEARANCE_PARTICIPATION_LABELS_I18N.en.ONLINE} \xB7 ${APPEARANCE_ONLINE_FORM_LABELS_I18N.en.AUDIO}`,
    AVATAR: `${APPEARANCE_PARTICIPATION_LABELS_I18N.en.ONLINE} \xB7 ${APPEARANCE_ONLINE_FORM_LABELS_I18N.en.ONLINE} (avatar)`
  },
  ja: {
    ONSITE: APPEARANCE_PARTICIPATION_LABELS_I18N.ja.ONSITE,
    ONLINE: `${APPEARANCE_PARTICIPATION_LABELS_I18N.ja.ONLINE}\u30FB${APPEARANCE_ONLINE_FORM_LABELS_I18N.ja.ONLINE}`,
    AUDIO: `${APPEARANCE_PARTICIPATION_LABELS_I18N.ja.ONLINE}\u30FB${APPEARANCE_ONLINE_FORM_LABELS_I18N.ja.AUDIO}`,
    AVATAR: `${APPEARANCE_PARTICIPATION_LABELS_I18N.ja.ONLINE}\u30FB${APPEARANCE_ONLINE_FORM_LABELS_I18N.ja.ONLINE}\uFF08\u30A2\u30D0\u30BF\u30FC\uFF09`
  }
};
var AppearanceActivity = {
  ATTENDANCE: "ATTENDANCE",
  HOST: "HOST",
  TALK: "TALK",
  PERFORMANCE: "PERFORMANCE",
  PHOTO: "PHOTO",
  VIDEO: "VIDEO",
  LIVE_COMMERCE: "LIVE_COMMERCE"
};
var APPEARANCE_ACTIVITY_LABELS = {
  ATTENDANCE: "\uD589\uC0AC \uCC38\uC11D\xB7\uC778\uC0AC",
  HOST: "\uC9C4\uD589\xB7\uC0AC\uD68C",
  TALK: "\uD1A0\uD06C\xB7\uC778\uD130\uBDF0",
  PERFORMANCE: "\uACF5\uC5F0",
  PHOTO: "\uC0AC\uC9C4 \uCD2C\uC601 \uCD9C\uC5F0",
  VIDEO: "\uC601\uC0C1 \uCD2C\uC601 \uCD9C\uC5F0",
  LIVE_COMMERCE: "\uB77C\uC774\uBE0C \uCEE4\uBA38\uC2A4"
};
var APPEARANCE_ACTIVITY_LABELS_I18N = {
  ko: APPEARANCE_ACTIVITY_LABELS,
  en: {
    ATTENDANCE: "Event attendance & greetings",
    HOST: "Hosting & MC",
    TALK: "Talks & interviews",
    PERFORMANCE: "Performance",
    PHOTO: "Photo shoot appearance",
    VIDEO: "Video shoot appearance",
    LIVE_COMMERCE: "Live commerce"
  },
  ja: {
    ATTENDANCE: "\u30A4\u30D9\u30F3\u30C8\u53C2\u52A0\u30FB\u3042\u3044\u3055\u3064",
    HOST: "\u9032\u884C\u30FB\u53F8\u4F1A",
    TALK: "\u30C8\u30FC\u30AF\u30FB\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC",
    PERFORMANCE: "\u516C\u6F14",
    PHOTO: "\u5199\u771F\u64AE\u5F71\u51FA\u6F14",
    VIDEO: "\u6620\u50CF\u64AE\u5F71\u51FA\u6F14",
    LIVE_COMMERCE: "\u30E9\u30A4\u30D6\u30B3\u30DE\u30FC\u30B9"
  }
};
var APPEARANCE_VARIANT_LABELS = {
  ONSITE: "\uD604\uC7A5 \uBC29\uBB38",
  ONLINE: "\uC628\uB77C\uC778 \uC601\uC0C1",
  AUDIO: "\uC628\uB77C\uC778 \uC74C\uC131"
};
var APPEARANCE_VARIANT_LABELS_I18N = {
  ko: APPEARANCE_VARIANT_LABELS,
  en: {
    ONSITE: "On-site visit",
    ONLINE: "Online video",
    AUDIO: "Online voice"
  },
  ja: {
    ONSITE: "\u73FE\u5730\u8A2A\u554F",
    ONLINE: "\u30AA\u30F3\u30E9\u30A4\u30F3\u6620\u50CF",
    AUDIO: "\u30AA\u30F3\u30E9\u30A4\u30F3\u97F3\u58F0"
  }
};
function appearanceVariantMode(mode) {
  return mode === AppearanceMode.AVATAR ? AppearanceMode.ONLINE : mode;
}
__name(appearanceVariantMode, "appearanceVariantMode");
function appearanceActivityLabels(mode, lang = DEFAULT_LANG) {
  if (mode === AppearanceMode.ONSITE) return APPEARANCE_ACTIVITY_LABELS_I18N[lang];
  if (mode === AppearanceMode.AUDIO) return tr(lang, {
    ko: {
      ATTENDANCE: "\uC74C\uC131 \uD32C \uC18C\uD1B5",
      HOST: "\uC74C\uC131 \uC9C4\uD589",
      TALK: "\uC74C\uC131 \uD1A0\uD06C\xB7\uC778\uD130\uBDF0",
      PERFORMANCE: "\uB77C\uC774\uBE0C \uB178\uB798\xB7\uB0AD\uB3C5"
    },
    en: {
      ATTENDANCE: "Voice fan chat",
      HOST: "Voice hosting",
      TALK: "Voice talk / interview",
      PERFORMANCE: "Live singing / reading"
    },
    ja: {
      ATTENDANCE: "\u97F3\u58F0\u3067\u306E\u30D5\u30A1\u30F3\u4EA4\u6D41",
      HOST: "\u97F3\u58F0\u3067\u306E\u9032\u884C",
      TALK: "\u97F3\u58F0\u30C8\u30FC\u30AF\u30FB\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC",
      PERFORMANCE: "\u30E9\u30A4\u30D6\u6B4C\u5531\u30FB\u6717\u8AAD"
    }
  });
  return tr(lang, {
    ko: {
      ATTENDANCE: "\uB77C\uC774\uBE0C \uC778\uC0AC\xB7\uD32C \uC18C\uD1B5",
      HOST: "\uC628\uB77C\uC778 \uC9C4\uD589\xB7\uC0AC\uD68C",
      TALK: "\uD654\uC0C1 \uD1A0\uD06C\xB7\uC778\uD130\uBDF0",
      PERFORMANCE: "\uB77C\uC774\uBE0C \uACF5\uC5F0",
      LIVE_COMMERCE: "\uB77C\uC774\uBE0C \uCEE4\uBA38\uC2A4"
    },
    en: {
      ATTENDANCE: "Live greetings / fan chat",
      HOST: "Online hosting / MC",
      TALK: "Video talk / interview",
      PERFORMANCE: "Live performance",
      LIVE_COMMERCE: "Live commerce"
    },
    ja: {
      ATTENDANCE: "\u30E9\u30A4\u30D6\u3042\u3044\u3055\u3064\u30FB\u30D5\u30A1\u30F3\u4EA4\u6D41",
      HOST: "\u30AA\u30F3\u30E9\u30A4\u30F3\u9032\u884C\u30FB\u53F8\u4F1A",
      TALK: "\u30D3\u30C7\u30AA\u30C8\u30FC\u30AF\u30FB\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC",
      PERFORMANCE: "\u30E9\u30A4\u30D6\u516C\u6F14",
      LIVE_COMMERCE: "\u30E9\u30A4\u30D6\u30B3\u30DE\u30FC\u30B9"
    }
  });
}
__name(appearanceActivityLabels, "appearanceActivityLabels");
function appearanceActivityLabel(mode, activity, lang = DEFAULT_LANG) {
  return appearanceActivityLabels(mode, lang)[activity] ?? APPEARANCE_ACTIVITY_LABELS_I18N[lang][activity];
}
__name(appearanceActivityLabel, "appearanceActivityLabel");
var AppearanceTravel = {
  INCLUDED: "INCLUDED",
  SEPARATE: "SEPARATE"
};
var APPEARANCE_TRAVEL_LABELS = {
  INCLUDED: "\uAE30\uBCF8\uAC00 \uD3EC\uD568",
  SEPARATE: "\uBCC4\uB3C4 \uBE44\uC6A9 \uD611\uC758"
};
var APPEARANCE_TRAVEL_LABELS_I18N = {
  ko: APPEARANCE_TRAVEL_LABELS,
  en: {
    INCLUDED: "Included in base price",
    SEPARATE: "Cost negotiated separately"
  },
  ja: {
    INCLUDED: "\u57FA\u672C\u6599\u91D1\u306B\u542B\u3080",
    SEPARATE: "\u5225\u9014\u8CBB\u7528\u3092\u4EA4\u6E09"
  }
};
var AppearanceOvertime = {
  NOT_ALLOWED: "NOT_ALLOWED",
  NEGOTIATE: "NEGOTIATE",
  PAID: "PAID"
};
var APPEARANCE_OVERTIME_LABELS = {
  NOT_ALLOWED: "\uC5F0\uC7A5 \uBD88\uAC00",
  NEGOTIATE: "\uC2DC\uAC04\xB7\uBE44\uC6A9 \uBCC4\uB3C4 \uD611\uC758",
  PAID: "\uC815\uD574\uC9C4 \uCD94\uAC00\uAE08\uC73C\uB85C \uC5F0\uC7A5"
};
var APPEARANCE_OVERTIME_LABELS_I18N = {
  ko: APPEARANCE_OVERTIME_LABELS,
  en: {
    NOT_ALLOWED: "No overtime",
    NEGOTIATE: "Time & cost negotiated separately",
    PAID: "Overtime at a set extra fee"
  },
  ja: {
    NOT_ALLOWED: "\u5EF6\u9577\u4E0D\u53EF",
    NEGOTIATE: "\u6642\u9593\u30FB\u8CBB\u7528\u306F\u5225\u9014\u4EA4\u6E09",
    PAID: "\u6240\u5B9A\u306E\u8FFD\u52A0\u6599\u91D1\u3067\u5EF6\u9577"
  }
};
var AppearanceRecording = {
  NOT_ALLOWED: "NOT_ALLOWED",
  INTERNAL: "INTERNAL",
  PUBLIC: "PUBLIC"
};
var APPEARANCE_RECORDING_LABELS = {
  NOT_ALLOWED: "\uCD2C\uC601\xB7\uB179\uD654 \uBD88\uAC00",
  INTERNAL: "\uB0B4\uBD80 \uAE30\uB85D\uB9CC \uD5C8\uC6A9",
  PUBLIC: "\uACF5\uAC1C \uC0AC\uC6A9 \uD5C8\uC6A9"
};
var APPEARANCE_RECORDING_LABELS_I18N = {
  ko: APPEARANCE_RECORDING_LABELS,
  en: {
    NOT_ALLOWED: "No filming or recording",
    INTERNAL: "Internal records only",
    PUBLIC: "Public use allowed"
  },
  ja: {
    NOT_ALLOWED: "\u64AE\u5F71\u30FB\u9332\u753B\u4E0D\u53EF",
    INTERNAL: "\u793E\u5185\u8A18\u9332\u306E\u307F\u53EF",
    PUBLIC: "\u516C\u958B\u5229\u7528\u53EF"
  }
};
var AppearanceChannel = {
  BRAND_SOCIAL: "BRAND_SOCIAL",
  PRODUCT_PAGE: "PRODUCT_PAGE",
  ADVERTISING: "ADVERTISING",
  OFFLINE: "OFFLINE"
};
var APPEARANCE_CHANNEL_LABELS = {
  BRAND_SOCIAL: USAGE_PLACEMENT_LABELS.BRAND_SOCIAL,
  PRODUCT_PAGE: USAGE_PLACEMENT_LABELS.PRODUCT_PAGE,
  ADVERTISING: USAGE_PLACEMENT_LABELS.PAID_ADS,
  OFFLINE: USAGE_PLACEMENT_LABELS.OFFLINE
};
var APPEARANCE_CHANNEL_LABELS_I18N = {
  ko: APPEARANCE_CHANNEL_LABELS,
  en: {
    BRAND_SOCIAL: "Regular brand social posts",
    PRODUCT_PAGE: "Website & product pages",
    ADVERTISING: "Paid advertising",
    OFFLINE: "Stores, events & outdoor media"
  },
  ja: {
    BRAND_SOCIAL: "\u30D6\u30E9\u30F3\u30C9SNS\u306E\u901A\u5E38\u6295\u7A3F",
    PRODUCT_PAGE: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u30FB\u5546\u54C1\u8A73\u7D30\u30DA\u30FC\u30B8",
    ADVERTISING: "\u6709\u6599\u5E83\u544A\u3067\u306E\u4F7F\u7528",
    OFFLINE: "\u5E97\u8217\u30FB\u30A4\u30D9\u30F3\u30C8\u30FB\u5C4B\u5916\u30E1\u30C7\u30A3\u30A2"
  }
};
function isAppearanceChannel(value) {
  return Object.hasOwn(AppearanceChannel, value);
}
__name(isAppearanceChannel, "isAppearanceChannel");
var APPEARANCE_BOUNDARY = "\uD569\uC758\uD55C \uC77C\uC815\uC5D0 1\uD68C \uCC38\uC5EC\uD558\uB294 \uC0C1\uD488\uC774\uC5D0\uC694. \uAD6C\uB9E4 \uC804 \uC77C\uC815 \uAC00\uB2A5 \uC5EC\uBD80\uB97C \uD655\uC778\uD558\uACE0, \uC2E4\uC81C \uC77C\uC2DC\xB7\uC7A5\uC18C \uB610\uB294 \uC811\uC18D \uBC29\uBC95\uACFC \uC9C4\uD589 \uB0B4\uC6A9\uC744 \uB300\uD654\uB85C \uD655\uC815\uD574 \uC8FC\uC138\uC694.";
var APPEARANCE_BOUNDARY_I18N = {
  ko: APPEARANCE_BOUNDARY,
  en: "This is a one-time appearance on an agreed date. Check availability before buying, then settle the exact date, place or connection method, and what happens, in chat.",
  ja: "\u5408\u610F\u3057\u305F\u65E5\u7A0B\u306B1\u56DE\u53C2\u52A0\u3059\u308B\u5546\u54C1\u3067\u3059\u3002\u8CFC\u5165\u524D\u306B\u65E5\u7A0B\u306E\u53EF\u5426\u3092\u78BA\u8A8D\u3057\u3001\u5B9F\u969B\u306E\u65E5\u6642\u30FB\u5834\u6240\u307E\u305F\u306F\u63A5\u7D9A\u65B9\u6CD5\u3068\u9032\u884C\u5185\u5BB9\u3092\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
};
function appearancePackageMinimum(packages) {
  return Math.min(...packages.map((item) => item.fixedAmount));
}
__name(appearancePackageMinimum, "appearancePackageMinimum");
function appearancePackageTotal(packages) {
  return packages.reduce((total, item) => total + item.fixedAmount, 0);
}
__name(appearancePackageTotal, "appearancePackageTotal");
function appearanceVariants(scope, legacyAmount) {
  if (scope.variants) return scope.variants;
  const { variants: _variants, ...session } = scope;
  return [
    {
      ...session,
      fixedAmount: legacyAmount
    }
  ];
}
__name(appearanceVariants, "appearanceVariants");
function appearanceVariantScope(variant) {
  const { fixedAmount: _amount, ...scope } = variant;
  return scope;
}
__name(appearanceVariantScope, "appearanceVariantScope");
function appearanceMinimumPrice(variants) {
  const fixed2 = variants.flatMap((v) => v.fixedAmount == null ? [] : [
    v.fixedAmount
  ]);
  return fixed2.length ? Math.min(...fixed2) : null;
}
__name(appearanceMinimumPrice, "appearanceMinimumPrice");
var APPEARANCE_SERVICE_AREA_NATIONWIDE = "\uC804\uAD6D";
function defaultAppearanceScope() {
  return {
    kind: IpRightType.APPEARANCE,
    mode: AppearanceMode.ONSITE,
    activities: [],
    durationMinutes: 60,
    serviceArea: APPEARANCE_SERVICE_AREA_NATIONWIDE,
    travelPolicy: AppearanceTravel.INCLUDED,
    travelNotes: "",
    overtimePolicy: AppearanceOvertime.NOT_ALLOWED,
    recordingPolicy: AppearanceRecording.NOT_ALLOWED,
    channels: [],
    cancellationNotes: "",
    guidelines: ""
  };
}
__name(defaultAppearanceScope, "defaultAppearanceScope");
function appearancePriceBasis(scope, lang = DEFAULT_LANG) {
  if (scope.variants) return tr(lang, {
    ko: "\uC120\uD0DD\uD55C \uCD9C\uC5F0 \uBC29\uC2DD \xB7 1\uD68C \uAE30\uC900",
    en: "Selected appearance type \xB7 per appearance",
    ja: "\u9078\u629E\u3057\u305F\u51FA\u6F14\u65B9\u6CD5\u30FB1\u56DE\u3042\u305F\u308A"
  });
  if (scope.onsitePackages) return tr(lang, {
    ko: "\uD604\uC7A5 \uBC29\uBB38 \xB7 \uAD6C\uC131\uBCC4 \uC2DC\uAC04\xB7\uAC00\uACA9",
    en: "On-site visit \xB7 time and price by package",
    ja: "\u73FE\u5730\u8A2A\u554F\u30FB\u69CB\u6210\u5225\u306E\u6642\u9593\u30FB\u4FA1\u683C"
  });
  const minutes = scope.durationMinutes;
  return tr(lang, {
    ko: `\uCD9C\uC5F0 1\uD68C \xB7 ${minutes}\uBD84 \uC774\uB0B4`,
    en: `One appearance \xB7 up to ${minutes} min`,
    ja: `\u51FA\u6F141\u56DE\u30FB${minutes}\u5206\u4EE5\u5185`
  });
}
__name(appearancePriceBasis, "appearancePriceBasis");
function appearanceActivityRecordings(scope) {
  return scope.activities.map((activity) => ({
    activity,
    policy: scope.activityRecordings ? scope.activityRecordings.find((item) => item.activity === activity)?.policy ?? AppearanceRecording.NOT_ALLOWED : scope.recordingPolicy
  }));
}
__name(appearanceActivityRecordings, "appearanceActivityRecordings");
function appearanceIncludedActivities(scope, lang = DEFAULT_LANG) {
  return [
    ...appearanceActivityRecordings(scope).map(({ activity, policy }) => ({
      label: appearanceActivityLabel(scope.mode, activity, lang),
      policy
    })),
    ...(scope.customActivities ?? []).map((item) => ({
      label: item.title,
      policy: item.policy ?? AppearanceRecording.NOT_ALLOWED
    }))
  ];
}
__name(appearanceIncludedActivities, "appearanceIncludedActivities");
function appearancePublicActivities(scope) {
  return appearanceActivityRecordings(scope).filter((item) => item.policy === AppearanceRecording.PUBLIC).map((item) => item.activity);
}
__name(appearancePublicActivities, "appearancePublicActivities");
function isSimpleOnlineAppearance(scope) {
  return scope.mode !== AppearanceMode.ONSITE && scope.activities.length === 0 && !scope.customActivities?.length;
}
__name(isSimpleOnlineAppearance, "isSimpleOnlineAppearance");
function appearancePackageRequiresRecording(item) {
  return item.id === "onsite-preset-shoot";
}
__name(appearancePackageRequiresRecording, "appearancePackageRequiresRecording");
function hasAppearancePackageRecordings(scope) {
  return !!scope.onsitePackages?.length && scope.onsitePackages.every((item) => item.recordingPolicy !== void 0);
}
__name(hasAppearancePackageRecordings, "hasAppearancePackageRecordings");
function inheritedAppearancePackageRecording(scope) {
  const policies = appearanceIncludedActivities(scope).map((item) => item.policy);
  return policies.length ? new Set(policies).size === 1 ? policies[0] : void 0 : scope.recordingPolicy;
}
__name(inheritedAppearancePackageRecording, "inheritedAppearancePackageRecording");
function withAppearancePackages(scope, onsitePackages) {
  const next = {
    ...scope,
    onsitePackages,
    customActivities: scope.customActivities ? [] : void 0
  };
  if (!hasAppearancePackageRecordings(next)) return next;
  const policy = onsitePackages.some((item) => item.recordingPolicy === AppearanceRecording.PUBLIC) ? AppearanceRecording.PUBLIC : onsitePackages.some((item) => item.recordingPolicy === AppearanceRecording.INTERNAL) ? AppearanceRecording.INTERNAL : AppearanceRecording.NOT_ALLOWED;
  return withAppearanceRecordingPolicy({
    ...next,
    activities: [],
    activityRecordings: void 0
  }, policy);
}
__name(withAppearancePackages, "withAppearancePackages");
function usesAppearanceSessionRecording(scope) {
  return isSimpleOnlineAppearance(scope) || !!scope.onsitePackages && !hasAppearancePackageRecordings(scope) && !scope.activities.length && !scope.customActivities?.length;
}
__name(usesAppearanceSessionRecording, "usesAppearanceSessionRecording");
function appearanceAllowsPublicRecording(scope) {
  if (hasAppearancePackageRecordings(scope)) return scope.onsitePackages.some((item) => item.recordingPolicy === AppearanceRecording.PUBLIC);
  return usesAppearanceSessionRecording(scope) ? scope.recordingPolicy === AppearanceRecording.PUBLIC : appearanceIncludedActivities(scope).some((item) => item.policy === AppearanceRecording.PUBLIC);
}
__name(appearanceAllowsPublicRecording, "appearanceAllowsPublicRecording");
function joinList(items, lang) {
  return items.join(tr(lang, {
    ko: ", ",
    en: ", ",
    ja: "\u3001"
  }));
}
__name(joinList, "joinList");
function won2(amount, lang) {
  const n = amount.toLocaleString(INTL_LOCALE[lang]);
  return tr(lang, {
    ko: `${n}\uC6D0`,
    en: `\u20A9${n}`,
    ja: `${n}\u30A6\u30A9\u30F3`
  });
}
__name(won2, "won");
function appearancePublicRecordingLabel(scope, lang = DEFAULT_LANG) {
  if (hasAppearancePackageRecordings(scope)) return joinList(scope.onsitePackages.filter((item) => item.recordingPolicy === AppearanceRecording.PUBLIC).map((item) => item.title), lang);
  return usesAppearanceSessionRecording(scope) ? scope.mode === AppearanceMode.ONSITE ? joinList(scope.onsitePackages.map((p) => p.title), lang) : scope.mode === AppearanceMode.AUDIO ? tr(lang, {
    ko: "\uC628\uB77C\uC778 \uC74C\uC131 \uCD9C\uC5F0",
    en: "Online voice appearance",
    ja: "\u30AA\u30F3\u30E9\u30A4\u30F3\u97F3\u58F0\u51FA\u6F14"
  }) : tr(lang, {
    ko: "\uC628\uB77C\uC778 \uC601\uC0C1 \uCD9C\uC5F0",
    en: "Online video appearance",
    ja: "\u30AA\u30F3\u30E9\u30A4\u30F3\u52D5\u753B\u51FA\u6F14"
  }) : joinList(appearanceIncludedActivities(scope, lang).filter((item) => item.policy === AppearanceRecording.PUBLIC).map((item) => item.label), lang);
}
__name(appearancePublicRecordingLabel, "appearancePublicRecordingLabel");
function withAppearanceRecordingPolicy(scope, recordingPolicy) {
  return {
    ...scope,
    recordingPolicy,
    recordingMonths: recordingPolicy === AppearanceRecording.PUBLIC ? scope.recordingMonths ?? 3 : void 0,
    channels: recordingPolicy === AppearanceRecording.PUBLIC ? scope.channels : [],
    channelAddons: recordingPolicy === AppearanceRecording.PUBLIC ? scope.channelAddons : []
  };
}
__name(withAppearanceRecordingPolicy, "withAppearanceRecordingPolicy");
function withAppearanceActivityRecordings(scope, activityRecordings, activities = activityRecordings.map((item) => item.activity), customActivities = scope.customActivities) {
  const policies = [
    ...activityRecordings.map((item) => item.policy),
    ...(customActivities ?? []).flatMap((item) => item.policy ? [
      item.policy
    ] : [])
  ];
  const recordingPolicy = policies.includes(AppearanceRecording.PUBLIC) ? AppearanceRecording.PUBLIC : policies.includes(AppearanceRecording.INTERNAL) ? AppearanceRecording.INTERNAL : AppearanceRecording.NOT_ALLOWED;
  return {
    ...scope,
    activities,
    activityRecordings,
    customActivities,
    recordingPolicy,
    recordingMonths: recordingPolicy === AppearanceRecording.PUBLIC ? scope.recordingMonths ?? 3 : void 0,
    channels: recordingPolicy === AppearanceRecording.PUBLIC ? scope.channels : [],
    channelAddons: recordingPolicy === AppearanceRecording.PUBLIC ? scope.channelAddons : []
  };
}
__name(withAppearanceActivityRecordings, "withAppearanceActivityRecordings");
function appearanceScopeRows(scope, lang = DEFAULT_LANG) {
  const sep = tr(lang, {
    ko: " \xB7 ",
    en: " \xB7 ",
    ja: "\u30FB"
  });
  const notSet = tr(lang, {
    ko: "\uBBF8\uC124\uC815",
    en: "Not set",
    ja: "\u672A\u8A2D\u5B9A"
  });
  if (scope.variants) return scope.variants.flatMap((variant) => {
    const prefix = APPEARANCE_VARIANT_LABELS_I18N[lang][appearanceVariantMode(variant.mode)];
    const feeLabel = tr(lang, {
      ko: "1\uD68C \uAE30\uBCF8 \uCD9C\uC5F0\uB8CC",
      en: "Base appearance fee (per appearance)",
      ja: "1\u56DE\u306E\u57FA\u672C\u51FA\u6F14\u6599"
    });
    return [
      {
        label: `${prefix}${sep}${feeLabel}`,
        value: variant.fixedAmount == null ? tr(lang, {
          ko: "\uAC00\uACA9 \uD611\uC758",
          en: "Price negotiable",
          ja: "\u4FA1\u683C\u5FDC\u76F8\u8AC7"
        }) : won2(variant.fixedAmount, lang),
        group: prefix,
        groupLabel: feeLabel
      },
      ...appearanceScopeRows(appearanceVariantScope(variant), lang).map((row) => ({
        ...row,
        label: `${prefix}${sep}${row.label}`,
        group: row.group ? `${prefix}${sep}${row.group}` : prefix,
        groupLabel: row.groupLabel ?? row.label
      }))
    ];
  });
  const audio = scope.mode === AppearanceMode.AUDIO;
  const footage = tr(lang, {
    ko: "\uCD2C\uC601\uBB3C",
    en: audio ? "recordings" : "footage",
    ja: audio ? "\u9332\u97F3\u7269" : "\u64AE\u5F71\u7269"
  });
  const Footage = footage.charAt(0).toUpperCase() + footage.slice(1);
  const noRecording = audio && lang !== "ko";
  const recordingLabel = /* @__PURE__ */ __name((policy) => tr(lang, {
    ko: APPEARANCE_RECORDING_LABELS[policy],
    en: noRecording && policy === AppearanceRecording.NOT_ALLOWED ? "No recording" : APPEARANCE_RECORDING_LABELS_I18N.en[policy],
    ja: noRecording && policy === AppearanceRecording.NOT_ALLOWED ? "\u9332\u97F3\u4E0D\u53EF" : APPEARANCE_RECORDING_LABELS_I18N.ja[policy]
  }), "recordingLabel");
  const filmingUse = tr(lang, {
    ko: "\uCD2C\uC601\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704",
    en: "Filming and usage allowed",
    ja: "\u64AE\u5F71\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2"
  });
  const rows = [
    {
      label: tr(lang, {
        ko: "\uCC38\uC5EC \uBC29\uC2DD",
        en: "Participation",
        ja: "\u53C2\u52A0\u65B9\u6CD5"
      }),
      value: APPEARANCE_PARTICIPATION_LABELS_I18N[lang][scope.mode === AppearanceMode.ONSITE ? "ONSITE" : "ONLINE"]
    },
    ...scope.mode === AppearanceMode.ONSITE ? [] : [
      {
        label: tr(lang, {
          ko: "\uC628\uB77C\uC778 \uCC38\uC5EC \uD615\uD0DC",
          en: "Online format",
          ja: "\u30AA\u30F3\u30E9\u30A4\u30F3\u53C2\u52A0\u306E\u5F62\u5F0F"
        }),
        value: APPEARANCE_ONLINE_FORM_LABELS_I18N[lang][scope.mode === AppearanceMode.AUDIO ? "AUDIO" : "ONLINE"]
      }
    ],
    ...scope.mode === AppearanceMode.AVATAR ? [
      {
        label: tr(lang, {
          ko: "\uC601\uC0C1 \uCD9C\uC5F0 \uD615\uD0DC",
          en: "Video appearance format",
          ja: "\u6620\u50CF\u51FA\u6F14\u306E\u5F62\u5F0F"
        }),
        value: tr(lang, {
          ko: "\uC544\uBC14\uD0C0",
          en: "Avatar",
          ja: "\u30A2\u30D0\u30BF\u30FC"
        })
      }
    ] : [],
    {
      label: tr(lang, {
        ko: "\uAE30\uBCF8 \uAC00\uACA9 \uAE30\uC900",
        en: "Base price basis",
        ja: "\u57FA\u672C\u4FA1\u683C\u306E\u57FA\u6E96"
      }),
      value: appearancePriceBasis(scope, lang)
    },
    ...usesAppearanceSessionRecording(scope) || hasAppearancePackageRecordings(scope) ? [] : [
      {
        label: tr(lang, {
          ko: "\uD3EC\uD568 \uD65C\uB3D9",
          en: "Included activities",
          ja: "\u542B\u307E\u308C\u308B\u6D3B\u52D5"
        }),
        value: joinList(appearanceIncludedActivities(scope, lang).map((item) => item.label), lang) || notSet
      }
    ],
    {
      label: tr(lang, {
        ko: "\uC77C\uC815 \uD655\uC778",
        en: "Scheduling",
        ja: "\u65E5\u7A0B\u306E\u78BA\u8A8D"
      }),
      value: APPEARANCE_BOUNDARY_I18N[lang]
    }
  ];
  if (scope.mode === AppearanceMode.ONSITE) {
    rows.push(scope.serviceArea ? {
      label: tr(lang, {
        ko: "\uBC29\uBB38 \uAC00\uB2A5 \uC9C0\uC5ED",
        en: "Visit areas",
        ja: "\u8A2A\u554F\u53EF\u80FD\u306A\u5730\u57DF"
      }),
      // "전국"은 보는 사람 언어로 (지역 이름은 저장한 한국어 그대로)
      value: scope.serviceArea === APPEARANCE_SERVICE_AREA_NATIONWIDE ? tr(lang, {
        ko: "\uC804\uAD6D",
        en: "Nationwide",
        ja: "\u5168\u56FD"
      }) : scope.serviceArea
    } : {
      label: tr(lang, {
        ko: "\uBC29\uBB38 \uC7A5\uC18C",
        en: "Visit place",
        ja: "\u8A2A\u554F\u5834\u6240"
      }),
      value: tr(lang, {
        ko: "\uAD6C\uB9E4\uC790\uC640 \uB300\uD654\uB85C \uD655\uC815",
        en: "Settled with the buyer in chat",
        ja: "\u8CFC\u5165\u8005\u3068\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A"
      })
    }, {
      label: tr(lang, {
        ko: "\uAD50\uD1B5\xB7\uC219\uBC15\uBE44",
        en: "Travel and accommodation",
        ja: "\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB"
      }),
      value: `${scope.travelPolicy ? APPEARANCE_TRAVEL_LABELS_I18N[lang][scope.travelPolicy] : notSet}${scope.travelNotes ? `${sep}${scope.travelNotes}` : ""}`
    });
  }
  const overtimeLabel = tr(lang, {
    ko: "\uC2DC\uAC04 \uCD08\uACFC",
    en: "Overtime",
    ja: "\u6642\u9593\u8D85\u904E"
  });
  if (scope.onsitePackages) {
    for (const item of scope.onsitePackages) {
      const minutes = item.durationMinutes;
      const price = won2(item.fixedAmount, lang);
      const unit = item.overtimeUnitMinutes;
      const extra = won2(item.overtimeAmount ?? 0, lang);
      rows.push({
        label: `${tr(lang, {
          ko: "\uAD6C\uC131",
          en: "Package",
          ja: "\u69CB\u6210"
        })}${sep}${item.title}`,
        value: tr(lang, {
          ko: `${minutes}\uBD84 \xB7 \uB4F1\uB85D \uAC00\uACA9 ${price}`,
          en: `${minutes} min \xB7 listed price ${price}`,
          ja: `${minutes}\u5206\u30FB\u767B\u9332\u4FA1\u683C ${price}`
        }),
        group: item.title,
        groupLabel: tr(lang, {
          ko: "\uC2DC\uAC04\xB7\uAC00\uACA9",
          en: "Time and price",
          ja: "\u6642\u9593\u30FB\u4FA1\u683C"
        })
      }, {
        label: `${item.title}${sep}${overtimeLabel}`,
        group: item.title,
        groupLabel: overtimeLabel,
        value: item.overtimePolicy === AppearanceOvertime.PAID ? tr(lang, {
          ko: `\uC5F0\uC7A5 \uD569\uC758 \uC2DC ${unit}\uBD84\uB2F9 ${extra} (\uAE30\uBCF8 \uACB0\uC81C\uAE08\uC5D0 \uBBF8\uD3EC\uD568)`,
          en: `If an extension is agreed, ${extra} per ${unit} min (not included in the base payment)`,
          ja: `\u5EF6\u9577\u306B\u5408\u610F\u3057\u305F\u5834\u5408\u3001${unit}\u5206\u3054\u3068\u306B${extra}\uFF08\u57FA\u672C\u306E\u652F\u6255\u984D\u306B\u542B\u307E\u306A\u3044\uFF09`
        }) : APPEARANCE_OVERTIME_LABELS_I18N[lang][item.overtimePolicy]
      });
    }
  } else {
    const unit = scope.overtimeUnitMinutes;
    const extra = won2(scope.overtimeAmount ?? 0, lang);
    rows.push({
      label: overtimeLabel,
      value: scope.overtimePolicy === AppearanceOvertime.PAID ? tr(lang, {
        ko: `\uD310\uB9E4\uC790\uC640 \uC5F0\uC7A5 \uD569\uC758 \uC2DC ${unit}\uBD84\uB2F9 ${extra} (\uAE30\uBCF8 \uACB0\uC81C\uAE08\uC5D0 \uBBF8\uD3EC\uD568)`,
        en: `If an extension is agreed with the seller, ${extra} per ${unit} min (not included in the base payment)`,
        ja: `\u8CA9\u58F2\u8005\u3068\u5EF6\u9577\u306B\u5408\u610F\u3057\u305F\u5834\u5408\u3001${unit}\u5206\u3054\u3068\u306B${extra}\uFF08\u57FA\u672C\u306E\u652F\u6255\u984D\u306B\u542B\u307E\u306A\u3044\uFF09`
      }) : APPEARANCE_OVERTIME_LABELS_I18N[lang][scope.overtimePolicy]
    });
  }
  if (hasAppearancePackageRecordings(scope)) rows.push(...scope.onsitePackages.map((item) => ({
    label: `${item.title}${sep}${filmingUse}`,
    value: recordingLabel(item.recordingPolicy),
    group: item.title,
    groupLabel: filmingUse
  })));
  const recordings = appearanceIncludedActivities(scope, lang);
  rows.push(...recordings.map(({ label: name, policy }) => ({
    label: tr(lang, {
      ko: `${name} ${audio ? "\uB179\uC74C\xB7\uC0AC\uC6A9" : "\uCD2C\uC601\xB7\uC0AC\uC6A9"}`,
      en: `${name}: ${audio ? "recording" : "filming"} and usage`,
      ja: `${name}\u306E${audio ? "\u9332\u97F3" : "\u64AE\u5F71"}\u30FB\u4F7F\u7528`
    }),
    value: recordingLabel(policy)
  })));
  if (usesAppearanceSessionRecording(scope)) rows.push({
    label: audio ? tr(lang, {
      ko: "\uB179\uC74C\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704",
      en: "Recording and usage allowed",
      ja: "\u9332\u97F3\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2"
    }) : scope.mode === AppearanceMode.ONSITE ? filmingUse : tr(lang, {
      ko: "\uB179\uD654\xB7\uC0AC\uC6A9 \uD5C8\uC6A9 \uBC94\uC704",
      en: "Recording and usage allowed",
      ja: "\u9332\u753B\u30FB\u4F7F\u7528\u306E\u8A31\u53EF\u7BC4\u56F2"
    }),
    value: recordingLabel(scope.recordingPolicy)
  });
  if (usesAppearanceSessionRecording(scope) && scope.recordingPolicy === AppearanceRecording.INTERNAL || recordings.some((item) => item.policy === AppearanceRecording.INTERNAL) || hasAppearancePackageRecordings(scope) && scope.onsitePackages.some((item) => item.recordingPolicy === AppearanceRecording.INTERNAL)) rows.push({
    label: tr(lang, {
      ko: "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uBC94\uC704",
      en: `${Footage} usage scope`,
      ja: `${footage}\u306E\u4F7F\u7528\u7BC4\u56F2`
    }),
    value: tr(lang, {
      ko: "\u2018\uB0B4\uBD80 \uAE30\uB85D\uB9CC \uD5C8\uC6A9\u2019\uD55C \uAD6C\uC131\xB7\uD65C\uB3D9\uC758 \uCD2C\uC601\uBB3C\uC740 \uC678\uBD80 \uAC8C\uC2DC\xB7\uD64D\uBCF4\xB7\uC720\uB8CC \uAD11\uACE0\xB7\uC81C3\uC790 \uBC30\uD3EC\uAC00 \uD5C8\uC6A9\uB418\uC9C0 \uC54A\uC544\uC694.",
      en: `${Footage} from packages or activities set to \u201CInternal records only\u201D can\u2019t be used for external posting, promotion, paid ads or third-party distribution.`,
      ja: `\u300C\u793E\u5185\u8A18\u9332\u306E\u307F\u53EF\u300D\u306B\u3057\u305F\u69CB\u6210\u30FB\u6D3B\u52D5\u306E${footage}\u306F\u3001\u5916\u90E8\u3078\u306E\u63B2\u8F09\u30FB\u5BA3\u4F1D\u30FB\u6709\u6599\u5E83\u544A\u30FB\u7B2C\u4E09\u8005\u3078\u306E\u914D\u5E03\u304C\u8A31\u53EF\u3055\u308C\u307E\u305B\u3093\u3002`
    })
  });
  if (appearanceAllowsPublicRecording(scope)) {
    const targets = appearancePublicRecordingLabel(scope, lang);
    const months = scope.recordingMonths;
    rows.push({
      label: tr(lang, {
        ko: "\uACF5\uAC1C \uCD2C\uC601\uBB3C \uC870\uAC74 \uC801\uC6A9 \uB300\uC0C1",
        en: `Public ${footage} terms apply to`,
        ja: `\u516C\u958B${footage}\u306E\u6761\u4EF6\u306E\u9069\u7528\u5BFE\u8C61`
      }),
      value: tr(lang, {
        ko: targets + "\uC758 \uCD2C\uC601\uBB3C\uC5D0\uB9CC \uC544\uB798 \uAE30\uAC04\xB7\uC0AC\uC6A9 \uC704\uCE58\xB7\uCD94\uAC00\uAE08\uC774 \uACF5\uD1B5 \uC801\uC6A9\uB3FC\uC694.",
        en: `The period, placements and add-on fees below apply only to ${footage} from ${targets}.`,
        ja: `${targets}\u306E${footage}\u306B\u306E\u307F\u3001\u4E0B\u306E\u671F\u9593\u30FB\u4F7F\u7528\u5834\u6240\u30FB\u8FFD\u52A0\u6599\u91D1\u304C\u5171\u901A\u3067\u9069\u7528\u3055\u308C\u307E\u3059\u3002`
      })
    }, {
      label: tr(lang, {
        ko: "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uAE30\uAC04",
        en: `${Footage} usage period`,
        ja: `${footage}\u306E\u4F7F\u7528\u671F\u9593`
      }),
      value: tr(lang, {
        ko: `\uCD9C\uC5F0\uC77C\uBD80\uD130 ${months}\uAC1C\uC6D4`,
        en: `${months} ${months === 1 ? "month" : "months"} from the appearance date`,
        ja: `\u51FA\u6F14\u65E5\u304B\u3089${months}\u304B\u6708`
      })
    }, {
      label: tr(lang, {
        ko: "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58",
        en: `Where ${footage} can be used`,
        ja: `${footage}\u306E\u4F7F\u7528\u5834\u6240`
      }),
      value: joinList(scope.channels.map((key) => APPEARANCE_CHANNEL_LABELS_I18N[lang][key]), lang) || notSet
    });
    if (scope.channelAddons?.length) rows.push({
      label: tr(lang, {
        ko: "\uCD94\uAC00 \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58",
        en: `Additional placements for ${footage}`,
        ja: `\u8FFD\u52A0\u306E${footage}\u306E\u4F7F\u7528\u5834\u6240`
      }),
      value: joinList(scope.channelAddons.map((o) => {
        const channel = APPEARANCE_CHANNEL_LABELS_I18N[lang][o.key];
        const amount = won2(o.addonAmount, lang);
        return tr(lang, {
          ko: `${channel} +${amount} (\uC120\uD0DD \uC2DC \uD3EC\uD568)`,
          en: `${channel} +${amount} (included if selected)`,
          ja: `${channel} +${amount}\uFF08\u9078\u629E\u6642\u306B\u542B\u3080\uFF09`
        });
      }), lang)
    });
    rows.push({
      label: tr(lang, {
        ko: "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC885\uB8CC",
        en: `End of ${footage} use`,
        ja: `${footage}\u306E\u4F7F\u7528\u7D42\u4E86`
      }),
      value: tr(lang, {
        ko: "\uC0AC\uC6A9 \uAE30\uAC04\uC774 \uB05D\uB098\uBA74 \uACF5\uAC1C \uAC8C\uC2DC\xB7\uAD11\uACE0\uB97C \uC911\uB2E8\uD558\uACE0 \uAD6C\uB9E4\uC790\uAC00 \uAD00\uB9AC\uD558\uB294 \uAC8C\uC2DC\uBB3C\uC744 \uB0B4\uB824 \uC8FC\uC138\uC694. \uC6D0\uBCF8 \uC804\uB2EC\xB7\uD3B8\uC9D1 \uC81C\uC791\uC740 \uBCC4\uB3C4 \uD569\uC758\uD574\uC694.",
        en: "When the usage period ends, stop public posts and ads and take down posts the buyer manages. Delivering originals or producing edits needs a separate agreement.",
        ja: "\u4F7F\u7528\u671F\u9593\u304C\u7D42\u308F\u3063\u305F\u3089\u516C\u958B\u63B2\u8F09\u30FB\u5E83\u544A\u3092\u4E2D\u6B62\u3057\u3001\u8CFC\u5165\u8005\u304C\u7BA1\u7406\u3059\u308B\u6295\u7A3F\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u539F\u672C\u306E\u7D0D\u54C1\u30FB\u7DE8\u96C6\u5236\u4F5C\u306F\u5225\u9014\u5408\u610F\u3057\u307E\u3059\u3002"
      })
    });
  }
  if (audio && lang === "ko") {
    for (const row of rows) {
      row.label = row.label.replaceAll("\uCD2C\uC601\uBB3C", "\uB179\uC74C\uBB3C").replaceAll("\uCD2C\uC601\xB7\uC0AC\uC6A9", "\uB179\uC74C\xB7\uC0AC\uC6A9");
      row.value = row.value.replaceAll("\uCD2C\uC601\uBB3C", "\uB179\uC74C\uBB3C").replaceAll("\uCD2C\uC601\xB7\uB179\uD654", "\uB179\uC74C");
    }
  }
  rows.push({
    label: tr(lang, {
      ko: "\uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C",
      en: "Rescheduling and cancellation",
      ja: "\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB"
    }),
    value: scope.cancellationNotes
  });
  if (scope.guidelines) rows.push({
    label: audio ? tr(lang, {
      ko: "\uB179\uC74C\xB7\uD3B8\uC9D1 \uAC00\uC774\uB4DC",
      en: "Recording and editing guide",
      ja: "\u9332\u97F3\u30FB\u7DE8\u96C6\u30AC\u30A4\u30C9"
    }) : tr(lang, {
      ko: "\uCD2C\uC601\xB7\uD3B8\uC9D1 \uAC00\uC774\uB4DC",
      en: "Filming and editing guide",
      ja: "\u64AE\u5F71\u30FB\u7DE8\u96C6\u30AC\u30A4\u30C9"
    }),
    value: scope.guidelines
  });
  return rows;
}
__name(appearanceScopeRows, "appearanceScopeRows");
function appearanceContractSelection(scope, channels = []) {
  const { channelAddons: _options, variants: _variants, ...included } = scope;
  return {
    ...included,
    channels: [
      .../* @__PURE__ */ new Set([
        ...scope.channels,
        ...channels
      ])
    ]
  };
}
__name(appearanceContractSelection, "appearanceContractSelection");

// src/enums/co-branding-scope.ts
var CoBrandingAsset = {
  BRAND_NAME: "BRAND_NAME",
  LOGO: "LOGO",
  SYMBOL: "SYMBOL"
};
var CO_BRANDING_ASSET_LABELS = {
  BRAND_NAME: "\uD65C\uB3D9\uBA85\xB7\uBE0C\uB79C\uB4DC\uBA85",
  LOGO: "\uB85C\uACE0",
  SYMBOL: "\uC2EC\uBCFC"
};
var CO_BRANDING_ASSET_LABELS_I18N = {
  ko: CO_BRANDING_ASSET_LABELS,
  en: {
    BRAND_NAME: "Stage name / brand name",
    LOGO: "Logo",
    SYMBOL: "Symbol"
  },
  ja: {
    BRAND_NAME: "\u6D3B\u52D5\u540D\u30FB\u30D6\u30E9\u30F3\u30C9\u540D",
    LOGO: "\u30ED\u30B4",
    SYMBOL: "\u30B7\u30F3\u30DC\u30EB"
  }
};
var CoBrandingChannel = {
  BRAND_SOCIAL: "BRAND_SOCIAL",
  PRODUCT_PAGE: "PRODUCT_PAGE",
  ADVERTISING: "ADVERTISING",
  OFFLINE: "OFFLINE"
};
var CO_BRANDING_CHANNEL_LABELS = {
  BRAND_SOCIAL: USAGE_PLACEMENT_LABELS.BRAND_SOCIAL,
  PRODUCT_PAGE: USAGE_PLACEMENT_LABELS.PRODUCT_PAGE,
  ADVERTISING: USAGE_PLACEMENT_LABELS.PAID_ADS,
  OFFLINE: USAGE_PLACEMENT_LABELS.OFFLINE
};
var CO_BRANDING_CHANNEL_LABELS_I18N = {
  ko: CO_BRANDING_CHANNEL_LABELS,
  en: {
    BRAND_SOCIAL: "Regular brand social posts",
    PRODUCT_PAGE: "Website & product pages",
    ADVERTISING: "Paid advertising",
    OFFLINE: "Stores, events & outdoor media"
  },
  ja: {
    BRAND_SOCIAL: "\u30D6\u30E9\u30F3\u30C9SNS\u306E\u901A\u5E38\u6295\u7A3F",
    PRODUCT_PAGE: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u30FB\u5546\u54C1\u8A73\u7D30\u30DA\u30FC\u30B8",
    ADVERTISING: "\u6709\u6599\u5E83\u544A\u3067\u306E\u4F7F\u7528",
    OFFLINE: "\u5E97\u8217\u30FB\u30A4\u30D9\u30F3\u30C8\u30FB\u5C4B\u5916\u30E1\u30C7\u30A3\u30A2"
  }
};
function isCoBrandingChannel(value) {
  return Object.hasOwn(CoBrandingChannel, value);
}
__name(isCoBrandingChannel, "isCoBrandingChannel");
var CoBrandingExpiry = {
  REMOVE: "REMOVE",
  ARCHIVE: "ARCHIVE"
};
var CO_BRANDING_EXPIRY_LABELS = {
  REMOVE: "\uAE30\uAC04 \uC885\uB8CC \uC2DC \uB450 \uBE0C\uB79C\uB4DC \uD45C\uC2DC\xB7\uAC8C\uC2DC\uBB3C \uC81C\uAC70",
  ARCHIVE: "\uAE30\uC874 \uAC8C\uC2DC\uBB3C\uB9CC \uAE30\uB85D\uC6A9\uC73C\uB85C \uC720\uC9C0"
};
var CO_BRANDING_EXPIRY_LABELS_I18N = {
  ko: CO_BRANDING_EXPIRY_LABELS,
  en: {
    REMOVE: "Remove both brands' displays and posts when the term ends",
    ARCHIVE: "Keep existing posts as records only"
  },
  ja: {
    REMOVE: "\u671F\u9593\u7D42\u4E86\u6642\u306B\u4E21\u30D6\u30E9\u30F3\u30C9\u306E\u8868\u793A\u30FB\u6295\u7A3F\u3092\u524A\u9664",
    ARCHIVE: "\u65E2\u5B58\u306E\u6295\u7A3F\u306E\u307F\u8A18\u9332\u7528\u3068\u3057\u3066\u4FDD\u6301"
  }
};
var CO_BRANDING_BOUNDARY = "\uAD6C\uB9E4\uC790 \uBE0C\uB79C\uB4DC\uC640 \uD310\uB9E4\uC790\uC758 \uC774\uB984\xB7\uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uB0B4\uC138\uC6CC \uD569\uC758\uD55C \uACF5\uB3D9 \uCEA0\uD398\uC778\uC744 \uC9C4\uD589\uD558\uB294 \uAD8C\uB9AC\uC608\uC694. \uB450 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uD45C\uC2DC\uD560 \uB54C \uC120\uD0DD\uD55C \uC774\uB984\xB7\uB85C\uACE0 \uB4F1\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC73C\uBBC0\uB85C, \uAC19\uC740 \uBC94\uC704\uC758 \uC774\uB984/\uBE0C\uB79C\uB4DC \uC0AC\uC6A9\uAD8C\uC744 \uB530\uB85C \uAD6C\uB9E4\uD560 \uD544\uC694\uAC00 \uC5C6\uC5B4\uC694.";
var CO_BRANDING_EXCLUSIONS = "\uCEA0\uD398\uC778 \uBC16\uC758 \uB3C5\uB9BD\uC801\uC778 \uC774\uB984\xB7\uB85C\uACE0 \uC0AC\uC6A9\uC740 \uD3EC\uD568\uD558\uC9C0 \uC54A\uC544\uC694.";
var CO_BRANDING_ARCHIVE_BOUNDARY = "\uAE30\uAC04 \uC911 \uD5C8\uC6A9\uB41C \uC704\uCE58\uC5D0 \uAC8C\uC2DC\uD55C \uC790\uB8CC\uB9CC \uC885\uB8CC\uB41C \uCEA0\uD398\uC778\uC758 \uAE30\uB85D\uC73C\uB85C \uC720\uC9C0\uD574\uC694. \uC2E0\uADDC \uAC8C\uC2DC\xB7\uC7AC\uAC8C\uC2DC\xB7\uC720\uB8CC \uAD11\uACE0\xB7\uD604\uC7AC \uC9C4\uD589 \uC911\uC778 \uD611\uC5C5\uC73C\uB85C\uC758 \uD45C\uC2DC\uB294 \uC911\uB2E8\uD558\uACE0, \uC624\uD504\uB77C\uC778 \uB9E4\uCCB4\uC5D0\uC11C \uB450 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uD45C\uC2DC\uD55C \uBD80\uBD84\uC740 \uC81C\uAC70\uD574\uC694.";
var CO_BRANDING_WORDING_GUIDE = "\uB450 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uD45C\uC2DC\uD560 \uC218 \uC788\uC5B4\uC694. \uC2E4\uC81C \uC0AC\uC6A9\uD560 \uBB38\uAD6C\uC640 \uB85C\uACE0 \uBC30\uCE58\uB294 \uAD6C\uB9E4\uC790\uC640 \uB300\uD654\uB85C \uD655\uC815\uD574 \uC8FC\uC138\uC694.";
var CO_BRANDING_WORDING_EXAMPLES = "\uC608: \u2018\uBE0C\uB79C\uB4DC A \xD7 \uBE0C\uB79C\uB4DC B\u2019, \u2018A\uC640 B\uAC00 \uD568\uAED8\uD558\uB294 \uC5EC\uB984 \uC774\uBCA4\uD2B8\u2019";
var CO_BRANDING_BOUNDARY_I18N = {
  ko: CO_BRANDING_BOUNDARY,
  en: "The right to run an agreed joint campaign that features the buyer\u2019s brand together with the seller\u2019s name and brand. Since the chosen name, logo and so on can be used when showing both brands together, you don\u2019t need to buy name/brand usage rights for the same scope separately.",
  ja: "\u8CFC\u5165\u8005\u306E\u30D6\u30E9\u30F3\u30C9\u3068\u8CA9\u58F2\u8005\u306E\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9\u3092\u4E00\u7DD2\u306B\u6253\u3061\u51FA\u3057\u3001\u5408\u610F\u3057\u305F\u5171\u540C\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u3092\u884C\u3046\u6A29\u5229\u3067\u3059\u30022\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u3092\u4E00\u7DD2\u306B\u8868\u793A\u3059\u308B\u969B\u306B\u9078\u3093\u3060\u540D\u524D\u30FB\u30ED\u30B4\u306A\u3069\u3092\u4F7F\u7528\u3067\u304D\u308B\u305F\u3081\u3001\u540C\u3058\u7BC4\u56F2\u306E\u540D\u524D\uFF0F\u30D6\u30E9\u30F3\u30C9\u4F7F\u7528\u6A29\u3092\u5225\u9014\u8CFC\u5165\u3059\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
};
var CO_BRANDING_EXCLUSIONS_I18N = {
  ko: CO_BRANDING_EXCLUSIONS,
  en: "Using the name or logo on its own, outside the campaign, isn\u2019t included.",
  ja: "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u5916\u3067\u306E\u540D\u524D\u30FB\u30ED\u30B4\u306E\u5358\u72EC\u4F7F\u7528\u306F\u542B\u307F\u307E\u305B\u3093\u3002"
};
var CO_BRANDING_ARCHIVE_BOUNDARY_I18N = {
  ko: CO_BRANDING_ARCHIVE_BOUNDARY,
  en: "Only materials posted in allowed placements during the period stay up as a record of the finished campaign. New posts, reposts, paid ads and presenting it as an ongoing collaboration stop, and co-branded parts on offline media are removed.",
  ja: "\u671F\u9593\u4E2D\u306B\u8A31\u53EF\u3055\u308C\u305F\u5834\u6240\u306B\u63B2\u8F09\u3057\u305F\u8CC7\u6599\u306E\u307F\u3001\u7D42\u4E86\u3057\u305F\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306E\u8A18\u9332\u3068\u3057\u3066\u6B8B\u3057\u307E\u3059\u3002\u65B0\u898F\u63B2\u8F09\u30FB\u518D\u63B2\u8F09\u30FB\u6709\u6599\u5E83\u544A\u30FB\u73FE\u5728\u9032\u884C\u4E2D\u306E\u30B3\u30E9\u30DC\u3068\u3057\u3066\u306E\u8868\u793A\u306F\u4E2D\u6B62\u3057\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u5A92\u4F53\u30672\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u3092\u4E00\u7DD2\u306B\u8868\u793A\u3057\u305F\u90E8\u5206\u306F\u64A4\u53BB\u3057\u307E\u3059\u3002"
};
var CO_BRANDING_WORDING_GUIDE_I18N = {
  ko: CO_BRANDING_WORDING_GUIDE,
  en: "Both brands can be shown together. Settle the actual wording and logo placement with the buyer in chat.",
  ja: "2\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u3092\u4E00\u7DD2\u306B\u8868\u793A\u3067\u304D\u307E\u3059\u3002\u5B9F\u969B\u306B\u4F7F\u3046\u6587\u8A00\u3068\u30ED\u30B4\u306E\u914D\u7F6E\u306F\u3001\u8CFC\u5165\u8005\u3068\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
};
var CO_BRANDING_WORDING_EXAMPLES_I18N = {
  ko: CO_BRANDING_WORDING_EXAMPLES,
  en: "e.g. \u2018Brand A \xD7 Brand B\u2019, \u2018A summer event by A and B\u2019",
  ja: "\u4F8B\uFF1A\u300C\u30D6\u30E9\u30F3\u30C9A \xD7 \u30D6\u30E9\u30F3\u30C9B\u300D\u300CA\u3068B\u304C\u4E00\u7DD2\u306B\u8D08\u308B\u590F\u306E\u30A4\u30D9\u30F3\u30C8\u300D"
};
function defaultCoBrandingScope() {
  return {
    kind: IpRightType.CO_BRANDING,
    assets: [],
    campaignPricing: "PER_CAMPAIGN",
    campaignCount: 1,
    channels: [],
    expiryPolicy: CoBrandingExpiry.REMOVE,
    delivery: "",
    rights: ""
  };
}
__name(defaultCoBrandingScope, "defaultCoBrandingScope");
function coBrandingPriceBasis(scope, lang = DEFAULT_LANG) {
  const n = scope.campaignCount;
  return tr(lang, {
    ko: `\uACF5\uB3D9 \uCEA0\uD398\uC778 ${n}\uAC74 \uAE30\uC900`,
    en: `Based on ${n} joint ${n === 1 ? "campaign" : "campaigns"}`,
    ja: `\u5171\u540C\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3${n}\u4EF6\u57FA\u6E96`
  });
}
__name(coBrandingPriceBasis, "coBrandingPriceBasis");
function coBrandingScopeRows(scope, lang = DEFAULT_LANG) {
  const join = lang === "ja" ? "\u3001" : ", ";
  const labels = /* @__PURE__ */ __name((values, map) => [
    ...values
  ].sort().map((key) => map[key]).join(join) || tr(lang, {
    ko: "\uBBF8\uC124\uC815",
    en: "Not set",
    ja: "\u672A\u8A2D\u5B9A"
  }), "labels");
  const included = tr(lang, {
    ko: " (\uC120\uD0DD \uC2DC \uD3EC\uD568)",
    en: " (included if selected)",
    ja: "\uFF08\u9078\u629E\u6642\u306B\u542B\u3080\uFF09"
  });
  return [
    {
      key: "assets",
      label: tr(lang, {
        ko: "\uD568\uAED8 \uD45C\uC2DC\uD560 \uBE0C\uB79C\uB4DC \uC694\uC18C",
        en: "Brand elements to show together",
        ja: "\u4E00\u7DD2\u306B\u8868\u793A\u3059\u308B\u30D6\u30E9\u30F3\u30C9\u8981\u7D20"
      }),
      value: labels(scope.assets, CO_BRANDING_ASSET_LABELS_I18N[lang])
    },
    {
      key: "wording",
      label: tr(lang, {
        ko: "\uB450 \uBE0C\uB79C\uB4DC \uD45C\uC2DC \uBC29\uC2DD",
        en: "How both brands are shown",
        ja: "2\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u306E\u8868\u793A\u65B9\u6CD5"
      }),
      value: CO_BRANDING_WORDING_GUIDE_I18N[lang]
    },
    {
      key: "priceBasis",
      label: tr(lang, {
        ko: "\uAE30\uBCF8 \uAC00\uACA9 \uAE30\uC900",
        en: "Base price basis",
        ja: "\u57FA\u672C\u4FA1\u683C\u306E\u57FA\u6E96"
      }),
      value: coBrandingPriceBasis(scope, lang)
    },
    ...scope.campaignPricing === "PER_CAMPAIGN" ? [
      {
        key: "participatingBrands",
        label: tr(lang, {
          ko: "\uCC38\uC5EC \uBE0C\uB79C\uB4DC",
          en: "Participating brands",
          ja: "\u53C2\u52A0\u30D6\u30E9\u30F3\u30C9"
        }),
        value: tr(lang, {
          ko: "\uBE0C\uB79C\uB4DC \uC218\uC5D0 \uB530\uB978 \uCD94\uAC00\uAE08 \uC5C6\uC774 \uAD6C\uB9E4\uC790\uC640 \uB300\uD654\uB85C \uD655\uC815\uD574\uC694.",
          en: "Settled with the buyer in chat, with no extra fee based on the number of brands.",
          ja: "\u30D6\u30E9\u30F3\u30C9\u6570\u306B\u3088\u308B\u8FFD\u52A0\u6599\u91D1\u306A\u3057\u3067\u3001\u8CFC\u5165\u8005\u3068\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A\u3057\u307E\u3059\u3002"
        })
      }
    ] : [],
    {
      key: "channels",
      label: tr(lang, {
        ko: "\uC0AC\uC6A9 \uC704\uCE58",
        en: "Placements",
        ja: "\u4F7F\u7528\u5834\u6240"
      }),
      value: labels(scope.channels, CO_BRANDING_CHANNEL_LABELS_I18N[lang])
    },
    ...scope.channelAddons?.length ? [
      {
        key: "addonChannels",
        label: tr(lang, {
          ko: "\uCD94\uAC00 \uC0AC\uC6A9 \uC704\uCE58",
          en: "Add-on placements",
          ja: "\u8FFD\u52A0\u306E\u4F7F\u7528\u5834\u6240"
        }),
        value: [
          ...scope.channelAddons
        ].sort((a, b) => a.key.localeCompare(b.key)).map((item) => `${CO_BRANDING_CHANNEL_LABELS_I18N[lang][item.key]} ${monthlyAddonLabel(item.addonAmount, lang)}${included}`).join(join)
      }
    ] : [],
    ...scope.adultUsage ? [
      {
        key: "adultUsage",
        label: tr(lang, {
          ko: "\uC131\uC778 \uC5C5\uC885 \uC0AC\uC6A9",
          en: "Adult industry use",
          ja: "\u6210\u4EBA\u5411\u3051\u696D\u7A2E\u3067\u306E\u4F7F\u7528"
        }),
        value: scope.adultUsage.addonAmount > 0 ? tr(lang, {
          ko: `\uCD94\uAC00 \uC635\uC158 \uC120\uD0DD \uC2DC \uD5C8\uC6A9 (${monthlyAddonLabel(scope.adultUsage.addonAmount, lang)})`,
          en: `Allowed if the add-on is selected (${monthlyAddonLabel(scope.adultUsage.addonAmount, lang)})`,
          ja: `\u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3\u9078\u629E\u6642\u306B\u8A31\u53EF\uFF08${monthlyAddonLabel(scope.adultUsage.addonAmount, lang)}\uFF09`
        }) : tr(lang, {
          ko: "\uD5C8\uC6A9",
          en: "Allowed",
          ja: "\u8A31\u53EF"
        })
      }
    ] : [],
    {
      key: "expiry",
      label: tr(lang, {
        ko: "\uAE30\uAC04 \uC885\uB8CC \uD6C4 \uCC98\uB9AC",
        en: "After the period ends",
        ja: "\u671F\u9593\u7D42\u4E86\u5F8C\u306E\u51E6\u7406"
      }),
      value: scope.expiryPolicy === CoBrandingExpiry.ARCHIVE ? CO_BRANDING_ARCHIVE_BOUNDARY_I18N[lang] : tr(lang, {
        ko: "\uAE30\uAC04 \uC885\uB8CC \uC2DC \uB450 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uD45C\uC2DC\uD55C \uBD80\uBD84\uACFC \uAC8C\uC2DC\uBB3C\xB7\uAD11\uACE0\uB97C \uC81C\uAC70\uD558\uACE0 \uC2E0\uADDC \uAC8C\uC2DC\xB7\uC7AC\uAC8C\uC2DC\uB97C \uC911\uB2E8\uD574\uC694.",
        en: "When the period ends, the co-branded parts and related posts and ads are removed, and new posts and reposts stop.",
        ja: "\u671F\u9593\u7D42\u4E86\u6642\u306B\u30012\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u3092\u4E00\u7DD2\u306B\u8868\u793A\u3057\u305F\u90E8\u5206\u3068\u6295\u7A3F\u30FB\u5E83\u544A\u3092\u524A\u9664\u3057\u3001\u65B0\u898F\u63B2\u8F09\u30FB\u518D\u63B2\u8F09\u3092\u4E2D\u6B62\u3057\u307E\u3059\u3002"
      })
    },
    {
      key: "boundary",
      label: tr(lang, {
        ko: "\uACF5\uB3D9\uBE0C\uB79C\uB529 \uBC94\uC704",
        en: "Co-branding scope",
        ja: "\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u306E\u7BC4\u56F2"
      }),
      value: CO_BRANDING_BOUNDARY_I18N[lang]
    },
    {
      key: "exclusions",
      label: tr(lang, {
        ko: "\uBCC4\uB3C4 \uD569\uC758 \uBC94\uC704",
        en: "Requires separate agreement",
        ja: "\u5225\u9014\u5408\u610F\u306E\u7BC4\u56F2"
      }),
      value: CO_BRANDING_EXCLUSIONS_I18N[lang]
    },
    {
      key: "campaignConfirmation",
      label: tr(lang, {
        ko: "\uCEA0\uD398\uC778 \uD655\uC815",
        en: "Confirming the campaign",
        ja: "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306E\u78BA\u5B9A"
      }),
      value: tr(lang, {
        ko: "\uC2E4\uC81C \uC0C1\uB300 \uBE0C\uB79C\uB4DC\xB7\uCEA0\uD398\uC778\uBA85\xB7\uB450 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uD45C\uC2DC\uD560 \uBB38\uAD6C\xB7\uCD5C\uC885 \uC2DC\uC548\uC744 \uAD6C\uB9E4 \uC870\uAC74 \uC548\uC5D0\uC11C \uB300\uD654\uB85C \uC815\uD558\uACE0 \uBC1C\uAE09 \uC804 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D. \uD569\uC758\uD55C \uBB38\uAD6C\uB294 \uD574\uB2F9 \uCEA0\uD398\uC778\xB7\uAE30\uAC04 \uC548\uC5D0\uC11C\uB9CC \uC0AC\uC6A9.",
        en: "Settle the partner brand, campaign name, co-branded wording and final draft in chat within the purchase terms, and record them in the additional agreements before issuance. The agreed wording is used only for that campaign and period.",
        ja: "\u5B9F\u969B\u306E\u76F8\u624B\u30D6\u30E9\u30F3\u30C9\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u540D\u30FB2\u3064\u306E\u30D6\u30E9\u30F3\u30C9\u3092\u4E00\u7DD2\u306B\u8868\u793A\u3059\u308B\u6587\u8A00\u30FB\u6700\u7D42\u6848\u3092\u8CFC\u5165\u6761\u4EF6\u306E\u7BC4\u56F2\u5185\u3067\u30C1\u30E3\u30C3\u30C8\u3067\u6C7A\u3081\u3001\u767A\u884C\u524D\u306B\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332\u3002\u5408\u610F\u3057\u305F\u6587\u8A00\u306F\u8A72\u5F53\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u30FB\u671F\u9593\u5185\u3067\u306E\u307F\u4F7F\u7528\u3002"
      })
    },
    ...scope.delivery ? [
      {
        key: "delivery",
        label: tr(lang, {
          ko: "\uC774\uB984\xB7\uB85C\uACE0 \uC790\uB8CC \uC81C\uACF5",
          en: "Name & logo materials",
          ja: "\u540D\u524D\u30FB\u30ED\u30B4\u8CC7\u6599\u306E\u63D0\u4F9B"
        }),
        value: scope.delivery
      }
    ] : [],
    ...scope.rights ? [
      {
        key: "rights",
        label: tr(lang, {
          ko: "\uAD8C\uB9AC\xB7\uC81C\uC678 \uBC94\uC704",
          en: "Rights & exclusions",
          ja: "\u6A29\u5229\u30FB\u9664\u5916\u7BC4\u56F2"
        }),
        value: scope.rights
      }
    ] : []
  ];
}
__name(coBrandingScopeRows, "coBrandingScopeRows");
function coBrandingContractSelection(scope, forbiddenIndustries, channels = [], adultSelected = false, campaignCount = scope.campaignCount) {
  const allowed = !isAdultIndustryForbidden(forbiddenIndustries) && (!scope.adultUsage?.addonAmount || adultSelected);
  const { channelAddons: _options, adultUsage: _adult, ...included } = scope;
  return {
    scope: {
      ...included,
      ...scope.campaignPricing === "PER_CAMPAIGN" ? {
        campaignCount
      } : {},
      channels: [
        .../* @__PURE__ */ new Set([
          ...scope.channels,
          ...channels
        ])
      ],
      ...allowed ? {
        adultUsage: {
          addonAmount: 0
        }
      } : {}
    },
    forbiddenIndustries: allowed || isAdultIndustryForbidden(forbiddenIndustries) ? [
      ...forbiddenIndustries
    ] : [
      ...forbiddenIndustries,
      "ADULT"
    ]
  };
}
__name(coBrandingContractSelection, "coBrandingContractSelection");

// src/enums/merchandise-scope.ts
var MerchandiseDistribution = {
  SALE: "SALE",
  GIVEAWAY: "GIVEAWAY"
};
var MERCHANDISE_DISTRIBUTION_LABELS = {
  SALE: "\uD310\uB9E4\uC6A9 \uC81C\uC791",
  GIVEAWAY: "\uBE44\uB9E4\uD488 \uC81C\uC791\xB7\uBC30\uD3EC"
};
var MERCHANDISE_DISTRIBUTION_LABELS_I18N = {
  ko: MERCHANDISE_DISTRIBUTION_LABELS,
  en: {
    SALE: "Made for sale",
    GIVEAWAY: "Made for free distribution"
  },
  ja: {
    SALE: "\u8CA9\u58F2\u7528\u306B\u5236\u4F5C",
    GIVEAWAY: "\u975E\u58F2\u54C1\u3068\u3057\u3066\u5236\u4F5C\u30FB\u914D\u5E03"
  }
};
var MerchandiseProduct = {
  PRINT: "PRINT",
  STATIONERY: "STATIONERY",
  APPAREL: "APPAREL",
  ACCESSORY: "ACCESSORY",
  LIVING: "LIVING",
  OTHER: "OTHER"
};
var MERCHANDISE_PRODUCT_LABELS = {
  PRINT: "\uD3EC\uD1A0\uCE74\uB4DC\xB7\uD3EC\uC2A4\uD130",
  STATIONERY: "\uBB38\uAD6C",
  APPAREL: "\uC758\uB958\xB7\uD328\uBE0C\uB9AD",
  ACCESSORY: "\uD0A4\uB9C1\xB7\uBC30\uC9C0\xB7\uC7A1\uD654",
  LIVING: "\uCEF5\xB7\uC0DD\uD65C\uC6A9\uD488",
  OTHER: "\uAE30\uD0C0 \uD488\uBAA9"
};
var MERCHANDISE_PRODUCT_LABELS_I18N = {
  ko: MERCHANDISE_PRODUCT_LABELS,
  en: {
    PRINT: "Photo cards & posters",
    STATIONERY: "Stationery",
    APPAREL: "Apparel & fabric",
    ACCESSORY: "Keyrings, badges & accessories",
    LIVING: "Cups & lifestyle goods",
    OTHER: "Other items"
  },
  ja: {
    PRINT: "\u30D5\u30A9\u30C8\u30AB\u30FC\u30C9\u30FB\u30DD\u30B9\u30BF\u30FC",
    STATIONERY: "\u6587\u5177",
    APPAREL: "\u8863\u985E\u30FB\u30D5\u30A1\u30D6\u30EA\u30C3\u30AF",
    ACCESSORY: "\u30AD\u30FC\u30DB\u30EB\u30C0\u30FC\u30FB\u30D0\u30C3\u30B8\u30FB\u96D1\u8CA8",
    LIVING: "\u30AB\u30C3\u30D7\u30FB\u751F\u6D3B\u7528\u54C1",
    OTHER: "\u305D\u306E\u4ED6\u306E\u54C1\u76EE"
  }
};
var MerchandiseAsset = {
  NAME_LOGO: "NAME_LOGO",
  PHOTO: "PHOTO",
  CHARACTER: "CHARACTER",
  ARTWORK: "ARTWORK"
};
var MERCHANDISE_ASSET_LABELS = {
  NAME_LOGO: "\uC774\uB984\xB7\uB85C\uACE0",
  PHOTO: "\uC0AC\uC9C4",
  CHARACTER: "\uCE90\uB9AD\uD130",
  ARTWORK: "\uC77C\uB7EC\uC2A4\uD2B8\xB7\uB514\uC790\uC778"
};
var MERCHANDISE_ASSET_LABELS_I18N = {
  ko: MERCHANDISE_ASSET_LABELS,
  en: {
    NAME_LOGO: "Name & logo",
    PHOTO: "Photo",
    CHARACTER: "Character",
    ARTWORK: "Illustration & design"
  },
  ja: {
    NAME_LOGO: "\u540D\u524D\u30FB\u30ED\u30B4",
    PHOTO: "\u5199\u771F",
    CHARACTER: "\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC",
    ARTWORK: "\u30A4\u30E9\u30B9\u30C8\u30FB\u30C7\u30B6\u30A4\u30F3"
  }
};
var MerchandiseChannel = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  EVENT: "EVENT"
};
var MERCHANDISE_CHANNEL_LABELS = {
  ONLINE: "\uC628\uB77C\uC778 \uD310\uB9E4\xB7\uBC30\uD3EC",
  OFFLINE: "\uC624\uD504\uB77C\uC778 \uB9E4\uC7A5",
  EVENT: "\uD589\uC0AC\xB7\uC774\uBCA4\uD2B8"
};
var MERCHANDISE_CHANNEL_LABELS_I18N = {
  ko: MERCHANDISE_CHANNEL_LABELS,
  en: {
    ONLINE: "Online sales & distribution",
    OFFLINE: "Offline stores",
    EVENT: "Events & promotions"
  },
  ja: {
    ONLINE: "\u30AA\u30F3\u30E9\u30A4\u30F3\u8CA9\u58F2\u30FB\u914D\u5E03",
    OFFLINE: "\u30AA\u30D5\u30E9\u30A4\u30F3\u5E97\u8217",
    EVENT: "\u30A4\u30D9\u30F3\u30C8\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3"
  }
};
var MerchandiseReproduction = {
  NOT_ALLOWED: "NOT_ALLOWED",
  AGREEMENT_REQUIRED: "AGREEMENT_REQUIRED"
};
var MERCHANDISE_REPRODUCTION_LABELS = {
  NOT_ALLOWED: "\uCD94\uAC00 \uC81C\uC791 \uBD88\uAC00",
  AGREEMENT_REQUIRED: "\uCD94\uAC00 \uC218\uB7C9\xB7\uAE08\uC561 \uBCC4\uB3C4 \uD569\uC758"
};
var MERCHANDISE_REPRODUCTION_LABELS_I18N = {
  ko: MERCHANDISE_REPRODUCTION_LABELS,
  en: {
    NOT_ALLOWED: "No additional production",
    AGREEMENT_REQUIRED: "Additional quantity & price agreed separately"
  },
  ja: {
    NOT_ALLOWED: "\u8FFD\u52A0\u5236\u4F5C\u4E0D\u53EF",
    AGREEMENT_REQUIRED: "\u8FFD\u52A0\u6570\u91CF\u30FB\u91D1\u984D\u306F\u5225\u9014\u5408\u610F"
  }
};
var MerchandiseInventory = {
  STOP: "STOP",
  SELL_OFF: "SELL_OFF"
};
var MERCHANDISE_INVENTORY_LABELS = {
  STOP: "\uAE30\uAC04 \uC885\uB8CC \uC2DC \uD310\uB9E4\xB7\uBC30\uD3EC \uC911\uB2E8",
  SELL_OFF: "\uAE30\uC874 \uC7AC\uACE0\uB9CC \uC815\uD574\uC9C4 \uAE30\uAC04 \uB3D9\uC548 \uD310\uB9E4\xB7\uBC30\uD3EC"
};
var MERCHANDISE_INVENTORY_LABELS_I18N = {
  ko: MERCHANDISE_INVENTORY_LABELS,
  en: {
    STOP: "Stop sales and distribution when the term ends",
    SELL_OFF: "Sell or distribute existing stock only for a set period"
  },
  ja: {
    STOP: "\u671F\u9593\u7D42\u4E86\u6642\u306B\u8CA9\u58F2\u30FB\u914D\u5E03\u3092\u4E2D\u6B62",
    SELL_OFF: "\u65E2\u5B58\u5728\u5EAB\u306E\u307F\u6240\u5B9A\u671F\u9593\u5185\u306B\u8CA9\u58F2\u30FB\u914D\u5E03"
  }
};
var MERCHANDISE_MAX_QUANTITY = 1e6;
var MERCHANDISE_USAGE_BOUNDARY = "\uD569\uC758\uD55C \uC774\uB984\xB7\uB85C\uACE0\xB7\uC0AC\uC9C4\xB7\uCE90\uB9AD\uD130 \uB4F1\uC744 \uAD7F\uC988\uC5D0 \uC801\uC6A9\uD574 \uC81C\uC791\uD558\uACE0, \uD5C8\uC6A9\uB41C \uBC29\uC2DD\uC73C\uB85C \uD310\uB9E4\xB7\uBC30\uD3EC\uD558\uB294 \uAD8C\uB9AC\uC608\uC694. \uC2E4\uBB3C \uC81C\uC791\xB7\uBC30\uC1A1 \uBE44\uC6A9\uACFC \uBCC4\uB3C4\uC758 \uAD11\uACE0 \uCF58\uD150\uCE20 \uC0AC\uC6A9\uC740 \uD3EC\uD568\uD558\uC9C0 \uC54A\uC544\uC694.";
var MERCHANDISE_USAGE_BOUNDARY_I18N = {
  ko: MERCHANDISE_USAGE_BOUNDARY,
  en: "The right to make merchandise using the agreed name, logo, photos, characters and so on, and to sell or distribute it in the allowed ways. Physical production and shipping costs, and use in separate ad content, aren\u2019t included.",
  ja: "\u5408\u610F\u3057\u305F\u540D\u524D\u30FB\u30ED\u30B4\u30FB\u5199\u771F\u30FB\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u306A\u3069\u3092\u30B0\u30C3\u30BA\u306B\u4F7F\u3063\u3066\u5236\u4F5C\u3057\u3001\u8A31\u53EF\u3055\u308C\u305F\u65B9\u6CD5\u3067\u8CA9\u58F2\u30FB\u914D\u5E03\u3059\u308B\u6A29\u5229\u3067\u3059\u3002\u5B9F\u7269\u306E\u5236\u4F5C\u30FB\u914D\u9001\u8CBB\u7528\u3068\u3001\u5225\u9014\u306E\u5E83\u544A\u30B3\u30F3\u30C6\u30F3\u30C4\u3067\u306E\u4F7F\u7528\u306F\u542B\u307F\u307E\u305B\u3093\u3002"
};
var MERCHANDISE_QUANTITY_BASIS = "\uC120\uD0DD\uD55C \uD488\uBAA9 \uC804\uCCB4\uC758 \uCD1D \uC81C\uC791 \uC218\uB7C9\uC774\uC5D0\uC694. \uD310\uB9E4\uBD84\xB7\uC99D\uC815\uBD84\xB7\uC2B9\uC778\uC6A9 \uC0D8\uD50C\uC744 \uD569\uC0B0\uD558\uBA70, \uC138\uD2B8\uB294 \uAD6C\uC131\uD488\uBCC4\uB85C \uACC4\uC0B0\uD574\uC694. \uD488\uBAA9\uBCC4 \uC218\uB7C9\uACFC \uC2B9\uC778\uC6A9 \uC0D8\uD50C \uC218\uB7C9\uC740 \uC81C\uC791 \uC804\uC5D0 \uB300\uD654\uB85C \uD655\uC815\uD574 \uC8FC\uC138\uC694.";
var MERCHANDISE_QUANTITY_BASIS_I18N = {
  ko: MERCHANDISE_QUANTITY_BASIS,
  en: "The total quantity across all selected items. Sold items, giveaways and approval samples are added together, and sets are counted by component. Settle per-item quantities and the number of approval samples in chat before production.",
  ja: "\u9078\u3093\u3060\u54C1\u76EE\u5168\u4F53\u306E\u7DCF\u5236\u4F5C\u6570\u91CF\u3067\u3059\u3002\u8CA9\u58F2\u5206\u30FB\u914D\u5E03\u5206\u30FB\u627F\u8A8D\u7528\u30B5\u30F3\u30D7\u30EB\u3092\u5408\u7B97\u3057\u3001\u30BB\u30C3\u30C8\u306F\u69CB\u6210\u54C1\u3054\u3068\u306B\u6570\u3048\u307E\u3059\u3002\u54C1\u76EE\u3054\u3068\u306E\u6570\u91CF\u3068\u627F\u8A8D\u7528\u30B5\u30F3\u30D7\u30EB\u306E\u6570\u91CF\u306F\u3001\u5236\u4F5C\u524D\u306B\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
};
function defaultMerchandiseScope() {
  return {
    kind: IpRightType.MERCHANDISE,
    distributionModes: [],
    products: [],
    otherProduct: "",
    assets: [],
    includedQuantity: 100,
    distributionChannels: [],
    additionalProduction: MerchandiseReproduction.AGREEMENT_REQUIRED,
    sampleApprovalRequired: false,
    inventoryPolicy: MerchandiseInventory.STOP,
    delivery: "",
    rights: "",
    guidelines: ""
  };
}
__name(defaultMerchandiseScope, "defaultMerchandiseScope");
function isGiveawayOnly(scope) {
  return scope?.kind === IpRightType.MERCHANDISE && scope.distributionModes.length === 1 && scope.distributionModes[0] === MerchandiseDistribution.GIVEAWAY;
}
__name(isGiveawayOnly, "isGiveawayOnly");
function merchandisePriceBasis(scope, lang = DEFAULT_LANG) {
  const n = scope.includedQuantity;
  const count = n.toLocaleString(INTL_LOCALE[lang]);
  return tr(lang, {
    ko: `\uAD7F\uC988 \uCD1D ${count}\uAC1C \uC81C\uC791 \uD5C8\uB77D \uAE30\uC900`,
    en: `Based on permission to make ${count} ${n === 1 ? "item" : "items"} of merchandise in total`,
    ja: `\u30B0\u30C3\u30BA\u5408\u8A08${count}\u500B\u306E\u5236\u4F5C\u8A31\u53EF\u57FA\u6E96`
  });
}
__name(merchandisePriceBasis, "merchandisePriceBasis");
function merchandiseScopeRows(scope, lang = DEFAULT_LANG) {
  const join = lang === "ja" ? "\u3001" : ", ";
  const labels = /* @__PURE__ */ __name((values, dictionary) => [
    ...values
  ].sort().map((value) => dictionary[value]).join(join) || tr(lang, {
    ko: "\uBBF8\uC124\uC815",
    en: "Not set",
    ja: "\u672A\u8A2D\u5B9A"
  }), "labels");
  const adultLabel2 = tr(lang, {
    ko: "\uC131\uC778 \uC5C5\uC885 \uC0AC\uC6A9",
    en: "Adult industry use",
    ja: "\u6210\u4EBA\u5411\u3051\u696D\u7A2E\u3067\u306E\u4F7F\u7528"
  });
  return [
    {
      key: "distributionModes",
      label: tr(lang, {
        ko: "\uD310\uB9E4\xB7\uBC30\uD3EC \uBC29\uC2DD",
        en: "Sales and distribution type",
        ja: "\u8CA9\u58F2\u30FB\u914D\u5E03\u65B9\u6CD5"
      }),
      value: labels(scope.distributionModes, MERCHANDISE_DISTRIBUTION_LABELS_I18N[lang])
    },
    {
      key: "products",
      label: tr(lang, {
        ko: "\uC81C\uC791 \uD488\uBAA9",
        en: "Items to make",
        ja: "\u5236\u4F5C\u54C1\u76EE"
      }),
      value: labels(scope.products, MERCHANDISE_PRODUCT_LABELS_I18N[lang]) + (scope.products.includes(MerchandiseProduct.OTHER) && scope.otherProduct ? lang === "ja" ? `\uFF08${scope.otherProduct}\uFF09` : ` (${scope.otherProduct})` : "")
    },
    {
      key: "assets",
      label: tr(lang, {
        ko: "\uC0AC\uC6A9\uD560 \uC694\uC18C",
        en: "Elements to use",
        ja: "\u4F7F\u7528\u3059\u308B\u8981\u7D20"
      }),
      value: labels(scope.assets, MERCHANDISE_ASSET_LABELS_I18N[lang])
    },
    {
      key: "priceBasis",
      label: tr(lang, {
        ko: "\uAE30\uBCF8 \uAC00\uACA9 \uAE30\uC900",
        en: "Base price basis",
        ja: "\u57FA\u672C\u4FA1\u683C\u306E\u57FA\u6E96"
      }),
      value: merchandisePriceBasis(scope, lang)
    },
    {
      key: "quantityBasis",
      label: tr(lang, {
        ko: "\uC81C\uC791 \uC218\uB7C9 \uAE30\uC900",
        en: "Quantity basis",
        ja: "\u5236\u4F5C\u6570\u91CF\u306E\u57FA\u6E96"
      }),
      value: MERCHANDISE_QUANTITY_BASIS_I18N[lang]
    },
    {
      key: "distributionChannels",
      label: tr(lang, {
        ko: "\uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C",
        en: "Sales and distribution channels",
        ja: "\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF"
      }),
      value: labels(scope.distributionChannels, MERCHANDISE_CHANNEL_LABELS_I18N[lang])
    },
    ...scope.distributionChannelAddons?.length ? [
      {
        key: "addonChannels",
        label: tr(lang, {
          ko: "\uC120\uD0DD \uAC00\uB2A5\uD55C \uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C",
          en: "Optional sales and distribution channels",
          ja: "\u9078\u629E\u53EF\u80FD\u306A\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF"
        }),
        value: scope.distributionChannelAddons.map((item) => `${MERCHANDISE_CHANNEL_LABELS_I18N[lang][item.key]} ${monthlyAddonLabel(item.addonAmount, lang)}`).join(join)
      }
    ] : [],
    ...scope.adultUsage ? [
      {
        key: "adultUsage",
        label: adultLabel2,
        value: scope.adultUsage.addonAmount > 0 ? tr(lang, {
          ko: `\uCD94\uAC00 \uC635\uC158 \uC120\uD0DD \uC2DC \uD5C8\uC6A9 (${monthlyAddonLabel(scope.adultUsage.addonAmount, lang)})`,
          en: `Allowed if the add-on is selected (${monthlyAddonLabel(scope.adultUsage.addonAmount, lang)})`,
          ja: `\u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3\u9078\u629E\u6642\u306B\u8A31\u53EF\uFF08${monthlyAddonLabel(scope.adultUsage.addonAmount, lang)}\uFF09`
        }) : tr(lang, {
          ko: "\uD5C8\uC6A9",
          en: "Allowed",
          ja: "\u8A31\u53EF"
        })
      }
    ] : [],
    {
      key: "additionalProduction",
      label: tr(lang, {
        ko: "\uCD94\uAC00 \uC81C\uC791",
        en: "Additional production",
        ja: "\u8FFD\u52A0\u5236\u4F5C"
      }),
      value: MERCHANDISE_REPRODUCTION_LABELS_I18N[lang][scope.additionalProduction]
    },
    {
      key: "sampleApproval",
      label: tr(lang, {
        ko: "\uC0D8\uD50C \uC2B9\uC778",
        en: "Sample approval",
        ja: "\u30B5\u30F3\u30D7\u30EB\u627F\u8A8D"
      }),
      value: scope.sampleApprovalRequired ? tr(lang, {
        ko: "\uB300\uB7C9 \uC0DD\uC0B0 \uC804 \uC2E4\uBB3C \uC0D8\uD50C \uC2B9\uC778 \uD544\uC694",
        en: "Physical sample approval required before mass production",
        ja: "\u91CF\u7523\u524D\u306B\u5B9F\u7269\u30B5\u30F3\u30D7\u30EB\u306E\u627F\u8A8D\u304C\u5FC5\u8981"
      }) : tr(lang, {
        ko: "\uBCC4\uB3C4 \uC0D8\uD50C \uC2B9\uC778 \uBD88\uD544\uC694",
        en: "No separate sample approval needed",
        ja: "\u5225\u9014\u30B5\u30F3\u30D7\u30EB\u627F\u8A8D\u306F\u4E0D\u8981"
      })
    },
    {
      key: "inventory",
      label: tr(lang, {
        ko: "\uAE30\uAC04 \uC885\uB8CC \uD6C4 \uC7AC\uACE0",
        en: "Stock after the period ends",
        ja: "\u671F\u9593\u7D42\u4E86\u5F8C\u306E\u5728\u5EAB"
      }),
      value: scope.inventoryPolicy === MerchandiseInventory.SELL_OFF ? sellOffText(scope.sellOffDays ?? 0, lang) : tr(lang, {
        ko: "\uAE30\uAC04 \uC885\uB8CC \uC2DC \uD310\uB9E4\xB7\uBC30\uD3EC\xB7\uCD94\uAC00 \uC0DD\uC0B0 \uC911\uB2E8. \uB0A8\uC740 \uC7AC\uACE0\uB294 \uB300\uD654\uB85C \uD655\uC815\uD55C \uD68C\uC218\xB7\uD3D0\uAE30 \uBC29\uC2DD\uC5D0 \uB530\uB77C \uCC98\uB9AC.",
        en: "Sales, distribution and additional production stop when the period ends. Remaining stock is handled by the collection or disposal method settled in chat.",
        ja: "\u671F\u9593\u7D42\u4E86\u6642\u306B\u8CA9\u58F2\u30FB\u914D\u5E03\u30FB\u8FFD\u52A0\u751F\u7523\u3092\u4E2D\u6B62\u3002\u6B8B\u308A\u5728\u5EAB\u306F\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A\u3057\u305F\u56DE\u53CE\u30FB\u5EC3\u68C4\u65B9\u6CD5\u306B\u5F93\u3063\u3066\u51E6\u7406\u3002"
      })
    },
    {
      key: "boundary",
      label: tr(lang, {
        ko: "\uAD7F\uC988 \uC774\uC6A9 \uBC94\uC704",
        en: "Merchandise usage scope",
        ja: "\u30B0\u30C3\u30BA\u306E\u5229\u7528\u7BC4\u56F2"
      }),
      value: MERCHANDISE_USAGE_BOUNDARY_I18N[lang]
    },
    {
      key: "preProductionConfirmation",
      label: tr(lang, {
        ko: "\uC81C\uC791 \uC804 \uD655\uC815",
        en: "Before production",
        ja: "\u5236\u4F5C\u524D\u306E\u78BA\u5B9A"
      }),
      value: tr(lang, {
        ko: "\uC2E4\uC81C \uC0AC\uC6A9\uD560 \uC790\uB8CC\xB7\uD488\uBAA9\uBCC4 \uB514\uC790\uC778\xB7\uC218\uB7C9\xB7\uD310\uB9E4 \uB610\uB294 \uBC30\uD3EC\uCC98\uB97C \uB300\uD654\uB85C \uD655\uC815\uD558\uACE0, \uBC1C\uAE09 \uC804 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D",
        en: "Settle the materials to use, the design and quantity of each item, and where it will be sold or distributed in chat, and record them in the additional agreements before issuance",
        ja: "\u5B9F\u969B\u306B\u4F7F\u7528\u3059\u308B\u8CC7\u6599\u30FB\u54C1\u76EE\u3054\u3068\u306E\u30C7\u30B6\u30A4\u30F3\u30FB\u6570\u91CF\u30FB\u8CA9\u58F2\u307E\u305F\u306F\u914D\u5E03\u5148\u3092\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u5B9A\u3057\u3001\u767A\u884C\u524D\u306B\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332"
      })
    },
    ...scope.delivery ? [
      {
        key: "delivery",
        label: tr(lang, {
          ko: "\uC81C\uC791\uC6A9 \uC790\uB8CC \uC81C\uACF5",
          en: "Production materials",
          ja: "\u5236\u4F5C\u7528\u8CC7\u6599\u306E\u63D0\u4F9B"
        }),
        value: scope.delivery
      }
    ] : [],
    ...scope.rights ? [
      {
        key: "rights",
        label: tr(lang, {
          ko: "\uAD8C\uB9AC\xB7\uC81C\uC678 \uBC94\uC704",
          en: "Rights & exclusions",
          ja: "\u6A29\u5229\u30FB\u9664\u5916\u7BC4\u56F2"
        }),
        value: scope.rights
      }
    ] : [],
    ...scope.guidelines ? [
      {
        key: "guidelines",
        label: tr(lang, {
          ko: "\uC81C\uC791\xB7\uD45C\uAE30 \uAC00\uC774\uB4DC",
          en: "Production & labeling guide",
          ja: "\u5236\u4F5C\u30FB\u8868\u8A18\u30AC\u30A4\u30C9"
        }),
        value: scope.guidelines
      }
    ] : []
  ];
}
__name(merchandiseScopeRows, "merchandiseScopeRows");
function sellOffText(days, lang) {
  return tr(lang, {
    ko: `\uAE30\uAC04 \uC885\uB8CC \uD6C4 ${days}\uC77C \uB3D9\uC548 \uAE30\uC874 \uC7AC\uACE0\uB9CC \uAE30\uC874\uC5D0 \uD5C8\uC6A9\uD55C \uBC29\uC2DD\xB7\uACBD\uB85C\uB85C \uD310\uB9E4\xB7\uBC30\uD3EC \uAC00\uB2A5. \uC774\uD6C4 \uC911\uB2E8. \uCD94\uAC00 \uC0DD\uC0B0 \uBD88\uAC00.`,
    en: `For ${days} ${days === 1 ? "day" : "days"} after the period ends, only existing stock may be sold or distributed in the previously allowed ways and channels. After that, it stops. No additional production.`,
    ja: `\u671F\u9593\u7D42\u4E86\u5F8C${days}\u65E5\u9593\u306F\u3001\u65E2\u5B58\u5728\u5EAB\u306E\u307F\u4EE5\u524D\u306B\u8A31\u53EF\u3057\u305F\u65B9\u6CD5\u30FB\u7D4C\u8DEF\u3067\u8CA9\u58F2\u30FB\u914D\u5E03\u53EF\u80FD\u3002\u305D\u306E\u5F8C\u306F\u4E2D\u6B62\u3002\u8FFD\u52A0\u751F\u7523\u4E0D\u53EF\u3002`
  });
}
__name(sellOffText, "sellOffText");
function merchandiseContractSelection(scope, forbiddenIndustries, channels = [], adultSelected = false) {
  const allowed = !isAdultIndustryForbidden(forbiddenIndustries) && (!scope.adultUsage?.addonAmount || adultSelected);
  const { distributionChannelAddons: _options, adultUsage: _adult, ...included } = scope;
  return {
    scope: {
      ...included,
      distributionChannels: [
        .../* @__PURE__ */ new Set([
          ...scope.distributionChannels,
          ...channels
        ])
      ],
      ...allowed ? {
        adultUsage: {
          addonAmount: 0
        }
      } : {}
    },
    forbiddenIndustries: allowed || isAdultIndustryForbidden(forbiddenIndustries) ? [
      ...forbiddenIndustries
    ] : [
      ...forbiddenIndustries,
      "ADULT"
    ]
  };
}
__name(merchandiseContractSelection, "merchandiseContractSelection");

// src/enums/usage-scope.ts
var MEDIA_USAGE_DESCRIPTION = "\uAE30\uC874 \uC790\uB8CC\uB97C \uD569\uC758\uD55C \uBC94\uC704\uC5D0\uC11C \uC0AC\uC6A9\uD558\uB294 \uAD8C\uB9AC\uC608\uC694. \uC0C8 \uCD2C\uC601\xB7\uC81C\uC791\uC740 \uBCC4\uB3C4 \uD569\uC758\uD574\uC694.";
var MEDIA_USAGE_DESCRIPTION_I18N = {
  ko: MEDIA_USAGE_DESCRIPTION,
  en: "Rights to use existing material within the agreed scope. New shoots or productions are agreed on separately.",
  ja: "\u65E2\u5B58\u306E\u7D20\u6750\u3092\u5408\u610F\u3057\u305F\u7BC4\u56F2\u3067\u4F7F\u7528\u3059\u308B\u6A29\u5229\u3067\u3059\u3002\u65B0\u3057\u3044\u64AE\u5F71\u30FB\u5236\u4F5C\u306F\u5225\u9014\u5408\u610F\u3057\u307E\u3059\u3002"
};
var UsagePurpose = {
  PERSONAL: "PERSONAL",
  BUSINESS: "BUSINESS"
};
var USAGE_PURPOSE_LABELS = {
  PERSONAL: "\uAC1C\uC778 \uAC10\uC0C1\uC6A9",
  BUSINESS: "\uC0AC\uC5C5\xB7\uD64D\uBCF4\uC6A9"
};
var USAGE_PURPOSE_LABELS_I18N = {
  ko: USAGE_PURPOSE_LABELS,
  en: {
    PERSONAL: "Personal enjoyment",
    BUSINESS: "Business & promotion"
  },
  ja: {
    PERSONAL: "\u500B\u4EBA\u9451\u8CDE\u7528",
    BUSINESS: "\u4E8B\u696D\u30FBPR\u7528"
  }
};
var PERSONAL_USAGE_BOUNDARY = "\uAD6C\uB9E4\uC790 \uBCF8\uC778\uC774 \uC120\uD0DD\uD55C \uC774\uC6A9 \uAE30\uAC04 \uB3D9\uC548 \uAC1C\uC778\uC801\uC73C\uB85C \uAC10\uC0C1\uD558\uB294 \uC6A9\uB3C4\uC608\uC694. SNS\xB7\uC6F9\uC0AC\uC774\uD2B8 \uACF5\uAC1C, \uAD11\uACE0\xB7\uD64D\uBCF4, \uC7AC\uD310\uB9E4\xB7\uC7AC\uBC30\uD3EC\uC640 \uC81C3\uC790 \uACF5\uC720\uB294 \uD5C8\uC6A9\uB418\uC9C0 \uC54A\uC544\uC694.";
var PERSONAL_USAGE_BOUNDARY_I18N = {
  ko: PERSONAL_USAGE_BOUNDARY,
  en: "For the buyer's own personal viewing during the chosen usage period. Posting on social media or websites, advertising or promotion, resale or redistribution, and sharing with third parties are not allowed.",
  ja: "\u8CFC\u5165\u8005\u672C\u4EBA\u304C\u9078\u3093\u3060\u5229\u7528\u671F\u9593\u4E2D\u306B\u500B\u4EBA\u7684\u306B\u9451\u8CDE\u3059\u308B\u7528\u9014\u3067\u3059\u3002SNS\u30FBWeb\u30B5\u30A4\u30C8\u3067\u306E\u516C\u958B\u3001\u5E83\u544A\u30FB\u5BA3\u4F1D\u3001\u518D\u8CA9\u58F2\u30FB\u518D\u914D\u5E03\u3001\u7B2C\u4E09\u8005\u3068\u306E\u5171\u6709\u306F\u8A8D\u3081\u3089\u308C\u307E\u305B\u3093\u3002"
};
function supportsUsagePurpose(rightType) {
  return rightType === IpRightType.CONTENT_SECONDARY || rightType === IpRightType.AI_VOICE;
}
__name(supportsUsagePurpose, "supportsUsagePurpose");
function getUsagePurpose(scope) {
  return scope && (scope.kind === IpRightType.CONTENT_SECONDARY || scope.kind === IpRightType.AI_VOICE) ? scope.purpose ?? UsagePurpose.BUSINESS : null;
}
__name(getUsagePurpose, "getUsagePurpose");
function isPersonalUsage(scope) {
  return getUsagePurpose(scope) === UsagePurpose.PERSONAL;
}
__name(isPersonalUsage, "isPersonalUsage");
var UsageChannel = {
  BRAND_SOCIAL: "BRAND_SOCIAL",
  PRODUCT_PAGE: "PRODUCT_PAGE",
  ADVERTISING: "ADVERTISING",
  OFFLINE: "OFFLINE",
  PACKAGING: "PACKAGING",
  PRODUCT_NAME: "PRODUCT_NAME"
};
var USAGE_CHANNEL_LABELS = {
  BRAND_SOCIAL: USAGE_PLACEMENT_LABELS.BRAND_SOCIAL,
  PRODUCT_PAGE: "\uC6F9\uC0AC\uC774\uD2B8\xB7\uC0C1\uD488 \uC0C1\uC138\uD398\uC774\uC9C0",
  ADVERTISING: USAGE_PLACEMENT_LABELS.PAID_ADS,
  OFFLINE: USAGE_PLACEMENT_LABELS.OFFLINE,
  PACKAGING: "\uC0C1\uD488 \uD328\uD0A4\uC9C0 \uD45C\uAE30",
  PRODUCT_NAME: "\uC0C1\uD488\uBA85\uC5D0 \uC0AC\uC6A9"
};
var USAGE_CHANNEL_LABELS_I18N = {
  ko: USAGE_CHANNEL_LABELS,
  en: {
    BRAND_SOCIAL: "Regular brand social posts",
    PRODUCT_PAGE: "Website & product pages",
    ADVERTISING: "Paid advertising",
    OFFLINE: "Stores, events & outdoor media",
    PACKAGING: "On product packaging",
    PRODUCT_NAME: "In product names"
  },
  ja: {
    BRAND_SOCIAL: "\u30D6\u30E9\u30F3\u30C9SNS\u306E\u901A\u5E38\u6295\u7A3F",
    PRODUCT_PAGE: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u30FB\u5546\u54C1\u8A73\u7D30\u30DA\u30FC\u30B8",
    ADVERTISING: "\u6709\u6599\u5E83\u544A\u3067\u306E\u4F7F\u7528",
    OFFLINE: "\u5E97\u8217\u30FB\u30A4\u30D9\u30F3\u30C8\u30FB\u5C4B\u5916\u30E1\u30C7\u30A3\u30A2",
    PACKAGING: "\u5546\u54C1\u30D1\u30C3\u30B1\u30FC\u30B8\u3078\u306E\u8868\u8A18",
    PRODUCT_NAME: "\u5546\u54C1\u540D\u3067\u306E\u4F7F\u7528"
  }
};
var BrandExpression = {
  NAME_ONLY: "NAME_ONLY",
  OFFICIAL_PARTNER: "OFFICIAL_PARTNER",
  ENDORSEMENT: "ENDORSEMENT"
};
var BRAND_EXPRESSION_LABELS = {
  NAME_ONLY: "\uC774\uB984\xB7\uB85C\uACE0 \uB2E8\uC21C \uD45C\uAE30",
  OFFICIAL_PARTNER: "\uACF5\uC2DD \uD611\uC5C5\xB7\uD30C\uD2B8\uB108 \uD45C\uAE30",
  ENDORSEMENT: "\uCD94\uCC9C\xB7\uBCF4\uC99D \uD45C\uD604 (\uBB38\uAD6C \uBCC4\uB3C4 \uD569\uC758)"
};
var BRAND_EXPRESSION_LABELS_I18N = {
  ko: BRAND_EXPRESSION_LABELS,
  en: {
    NAME_ONLY: "Simple name or logo display",
    OFFICIAL_PARTNER: "Official collaboration / partner mention",
    ENDORSEMENT: "Recommendation or endorsement (wording agreed separately)"
  },
  ja: {
    NAME_ONLY: "\u540D\u524D\u30FB\u30ED\u30B4\u306E\u5358\u7D14\u8868\u8A18",
    OFFICIAL_PARTNER: "\u516C\u5F0F\u30B3\u30E9\u30DC\u30FB\u30D1\u30FC\u30C8\u30CA\u30FC\u8868\u8A18",
    ENDORSEMENT: "\u63A8\u85A6\u30FB\u4FDD\u8A3C\u8868\u73FE(\u6587\u8A00\u306F\u5225\u9014\u5408\u610F)"
  }
};
var VoiceOfferingMode = {
  EXISTING: "EXISTING",
  CUSTOM: "CUSTOM",
  BUYER_GENERATED: "BUYER_GENERATED"
};
var VOICE_OFFERING_LABELS = {
  EXISTING: "\uAE30\uC874 \uC74C\uC131 \uC0AC\uC6A9",
  CUSTOM: "\uC0C8 \uC74C\uC131 \uC81C\uC791\xB7\uC804\uB2EC",
  BUYER_GENERATED: "\uAD6C\uB9E4\uC790\uAC00 AI \uC74C\uC131 \uC0DD\uC131"
};
var VOICE_OFFERING_LABELS_I18N = {
  ko: VOICE_OFFERING_LABELS,
  en: {
    EXISTING: "Use existing voice",
    CUSTOM: "Record & deliver new voice",
    BUYER_GENERATED: "Buyer generates AI voice"
  },
  ja: {
    EXISTING: "\u65E2\u5B58\u306E\u97F3\u58F0\u3092\u4F7F\u7528",
    CUSTOM: "\u65B0\u3057\u3044\u97F3\u58F0\u3092\u5236\u4F5C\u30FB\u7D0D\u54C1",
    BUYER_GENERATED: "\u8CFC\u5165\u8005\u304CAI\u97F3\u58F0\u3092\u751F\u6210"
  }
};
var VoiceGenerationMethod = {
  FROM_SAMPLE: "FROM_SAMPLE",
  EXISTING_VOICE: "EXISTING_VOICE"
};
var VOICE_GENERATION_METHOD_LABELS = {
  FROM_SAMPLE: "\uC81C\uACF5 \uC74C\uC131\uC73C\uB85C AI \uBAA9\uC18C\uB9AC \uB9CC\uB4E4\uAE30",
  EXISTING_VOICE: "\uC774\uBBF8 \uB9CC\uB4E4\uC5B4\uC9C4 AI \uBAA9\uC18C\uB9AC \uC774\uC6A9"
};
var VOICE_GENERATION_METHOD_LABELS_I18N = {
  ko: VOICE_GENERATION_METHOD_LABELS,
  en: {
    FROM_SAMPLE: "Create an AI voice from provided samples",
    EXISTING_VOICE: "Use an existing AI voice"
  },
  ja: {
    FROM_SAMPLE: "\u63D0\u4F9B\u97F3\u58F0\u304B\u3089AI\u30DC\u30A4\u30B9\u3092\u4F5C\u6210",
    EXISTING_VOICE: "\u4F5C\u6210\u6E08\u307F\u306EAI\u30DC\u30A4\u30B9\u3092\u5229\u7528"
  }
};
var VoiceServiceCostBearer = {
  BUYER: "BUYER",
  SELLER: "SELLER"
};
var VOICE_SERVICE_COST_LABELS = {
  BUYER: "\uAD6C\uB9E4\uC790 \uBD80\uB2F4 (\uC0C1\uD488 \uAC00\uACA9\uACFC \uBCC4\uB3C4)",
  SELLER: "\uD310\uB9E4\uC790 \uBD80\uB2F4 (\uC0C1\uD488 \uAC00\uACA9\uC5D0 \uD3EC\uD568)"
};
var VOICE_SERVICE_COST_LABELS_I18N = {
  ko: VOICE_SERVICE_COST_LABELS,
  en: {
    BUYER: "Paid by buyer (separate from product price)",
    SELLER: "Paid by seller (included in product price)"
  },
  ja: {
    BUYER: "\u8CFC\u5165\u8005\u8CA0\u62C5(\u5546\u54C1\u4FA1\u683C\u3068\u306F\u5225)",
    SELLER: "\u8CA9\u58F2\u8005\u8CA0\u62C5(\u5546\u54C1\u4FA1\u683C\u306B\u542B\u3080)"
  }
};
var VoiceSource = {
  RECORDED: "RECORDED",
  AI_GENERATED: "AI_GENERATED"
};
var VOICE_SOURCE_LABELS = {
  RECORDED: "\uC9C1\uC811 \uB179\uC74C",
  AI_GENERATED: "AI \uC0DD\uC131"
};
var VOICE_SOURCE_LABELS_I18N = {
  ko: VOICE_SOURCE_LABELS,
  en: {
    RECORDED: "Recorded directly",
    AI_GENERATED: "AI-generated"
  },
  ja: {
    RECORDED: "\u76F4\u63A5\u9332\u97F3",
    AI_GENERATED: "AI\u751F\u6210"
  }
};
var VOICE_USAGE_BOUNDARY = "\uC804\uB2EC\uBC1B\uC740 \uC74C\uC131 \uD30C\uC77C\uC744 \uC0AC\uC6A9\uD558\uB294 \uAD8C\uB9AC\uC608\uC694. \uAD6C\uB9E4\uC790\uC758 AI \uC74C\uC131 \uC0DD\uC131\xB7\uBCF5\uC81C\xB7\uD559\uC2B5\uACFC \uC74C\uC131 \uBAA8\uB378 \uC81C\uACF5\uC740 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC544\uC694.";
var VOICE_GENERATION_BOUNDARY = "\uD569\uC758\uD55C \uBAA9\uC18C\uB9AC\uB85C \uAD6C\uB9E4\uC790\uAC00 \uC9C0\uC815\uD55C \uC11C\uBE44\uC2A4\uC5D0\uC11C AI \uC74C\uC131\uC744 \uC0DD\uC131\uD574 \uC0AC\uC6A9\uD558\uB294 \uAD8C\uB9AC\uC608\uC694. \uD5C8\uC6A9\uB41C \uC0DD\uC131 \uBC29\uBC95 \uC678\uC758 \uCD94\uAC00 \uD559\uC2B5\xB7\uBAA8\uB378 \uC7AC\uD310\uB9E4\xB7\uC81C3\uC790 \uACF5\uC720\uB294 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC544\uC694.";
var VOICE_GENERATION_EXPIRY = "\uC0DD\uC131 \uAC00\uB2A5 \uAE30\uAC04\uC774 \uB05D\uB098\uBA74 \uC0C8 \uC0DD\uC131\uC744 \uC911\uB2E8\uD558\uACE0, \uAD6C\uB9E4\uC790\uAC00 \uBCF4\uC720\uD55C \uC0DD\uC131\uC6A9 \uC74C\uC131 \uC790\uB8CC\xB7\uBAA8\uB378\uC744 \uC0AD\uC81C\uD558\uAC70\uB098 \uC811\uADFC \uAD8C\uD55C\uC744 \uC885\uB8CC\uD574\uC694. \uC774\uBBF8 \uC0DD\uC131\uD55C \uC74C\uC131\uC740 \uAD6C\uB9E4\uD55C \uC774\uC6A9 \uAE30\uAC04 \uC548\uC5D0\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.";
var VOICE_USAGE_BOUNDARY_I18N = {
  ko: VOICE_USAGE_BOUNDARY,
  en: "The right to use the delivered audio files. AI voice generation, cloning or training by the buyer, and providing a voice model, aren't included.",
  ja: "\u7D0D\u54C1\u3055\u308C\u305F\u97F3\u58F0\u30D5\u30A1\u30A4\u30EB\u3092\u4F7F\u7528\u3059\u308B\u6A29\u5229\u3067\u3059\u3002\u8CFC\u5165\u8005\u306B\u3088\u308BAI\u97F3\u58F0\u306E\u751F\u6210\u30FB\u8907\u88FD\u30FB\u5B66\u7FD2\u3068\u3001\u97F3\u58F0\u30E2\u30C7\u30EB\u306E\u63D0\u4F9B\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002"
};
var VOICE_GENERATION_BOUNDARY_I18N = {
  ko: VOICE_GENERATION_BOUNDARY,
  en: "The right for the buyer to generate and use AI audio with the agreed voice on the service they specify. Additional training beyond the allowed generation method, model resale and sharing with third parties aren't included.",
  ja: "\u5408\u610F\u3057\u305F\u58F0\u3067\u3001\u8CFC\u5165\u8005\u304C\u6307\u5B9A\u3057\u305F\u30B5\u30FC\u30D3\u30B9\u4E0A\u3067AI\u97F3\u58F0\u3092\u751F\u6210\u3057\u3066\u4F7F\u7528\u3059\u308B\u6A29\u5229\u3067\u3059\u3002\u8A31\u53EF\u3055\u308C\u305F\u751F\u6210\u65B9\u6CD5\u4EE5\u5916\u306E\u8FFD\u52A0\u5B66\u7FD2\u30FB\u30E2\u30C7\u30EB\u306E\u518D\u8CA9\u58F2\u30FB\u7B2C\u4E09\u8005\u3068\u306E\u5171\u6709\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002"
};
var VOICE_GENERATION_EXPIRY_I18N = {
  ko: VOICE_GENERATION_EXPIRY,
  en: "When the generation window ends, new generation stops, and the buyer deletes the voice materials and models they hold or their access ends. Audio already generated can be used within the purchased usage period.",
  ja: "\u751F\u6210\u53EF\u80FD\u671F\u9593\u304C\u7D42\u308F\u308B\u3068\u65B0\u898F\u751F\u6210\u3092\u4E2D\u6B62\u3057\u3001\u8CFC\u5165\u8005\u304C\u4FDD\u6709\u3059\u308B\u751F\u6210\u7528\u306E\u97F3\u58F0\u7D20\u6750\u30FB\u30E2\u30C7\u30EB\u3092\u524A\u9664\u3059\u308B\u304B\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u7D42\u4E86\u3057\u307E\u3059\u3002\u3059\u3067\u306B\u751F\u6210\u3057\u305F\u97F3\u58F0\u306F\u3001\u8CFC\u5165\u3057\u305F\u5229\u7528\u671F\u9593\u5185\u3067\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"
};
function voiceUsageBoundary(scope, lang = DEFAULT_LANG) {
  return scope.mode === VoiceOfferingMode.BUYER_GENERATED ? VOICE_GENERATION_BOUNDARY_I18N[lang] : VOICE_USAGE_BOUNDARY_I18N[lang];
}
__name(voiceUsageBoundary, "voiceUsageBoundary");
function isMediaUsageScope(scope) {
  return !!scope && (scope.kind === IpRightType.FACE_PHOTO || scope.kind === IpRightType.CONTENT_SECONDARY || scope.kind === IpRightType.AI_VOICE);
}
__name(isMediaUsageScope, "isMediaUsageScope");
function defaultUsageScope(rightType) {
  if (rightType === IpRightType.APPEARANCE) return defaultAppearanceScope();
  if (rightType === IpRightType.CO_BRANDING) return defaultCoBrandingScope();
  if (rightType === IpRightType.MERCHANDISE) return defaultMerchandiseScope();
  if (rightType === IpRightType.AI_VOICE) return {
    kind: rightType,
    purpose: UsagePurpose.BUSINESS,
    mode: VoiceOfferingMode.EXISTING,
    source: VoiceSource.RECORDED,
    includedQuantity: 1,
    totalSeconds: 30,
    channels: [],
    guidelines: "",
    delivery: "",
    rights: ""
  };
  if (rightType === IpRightType.NAME_BRAND) return {
    kind: rightType,
    brandName: "",
    expressions: [
      BrandExpression.NAME_ONLY
    ],
    guidelines: ""
  };
  if (rightType === IpRightType.FACE_PHOTO || rightType === IpRightType.CONTENT_SECONDARY) return {
    kind: rightType,
    ...rightType === IpRightType.CONTENT_SECONDARY ? {
      purpose: UsagePurpose.BUSINESS
    } : {},
    includedQuantity: 1,
    channels: [],
    guidelines: "",
    delivery: "",
    rights: ""
  };
  return null;
}
__name(defaultUsageScope, "defaultUsageScope");
function usagePriceBasis(scope, lang = DEFAULT_LANG) {
  if (!scope || scope.kind === IpRightType.NAME_BRAND) return null;
  if (scope.kind === IpRightType.APPEARANCE) return appearancePriceBasis(scope, lang);
  if (scope.kind === IpRightType.CO_BRANDING) return coBrandingPriceBasis(scope, lang);
  if (scope.kind === IpRightType.MERCHANDISE) return merchandisePriceBasis(scope, lang);
  const n = scope.includedQuantity;
  if (scope.kind === IpRightType.AI_VOICE) {
    const generated = scope.mode === VoiceOfferingMode.BUYER_GENERATED;
    const custom = scope.mode === VoiceOfferingMode.CUSTOM;
    const s = scope.totalSeconds;
    return tr(lang, {
      ko: `${generated ? "\uC0DD\uC131 \uC74C\uC131 \uCD5C\uC885 \uC0AC\uC6A9\uBCF8" : "\uC74C\uC131"} ${n}\uAC1C \xB7 \uCD1D ${s}\uCD08 \uC774\uB0B4${custom ? " \uC81C\uC791 \uD3EC\uD568" : ""}`,
      en: `${n} ${generated ? "final generated " : ""}${n === 1 ? "clip" : "clips"} \xB7 up to ${s} sec total${custom ? ", production included" : ""}`,
      ja: `${generated ? "\u751F\u6210\u97F3\u58F0\u306E\u6700\u7D42\u4F7F\u7528\u5206" : "\u97F3\u58F0"}${n}\u500B\u30FB\u5408\u8A08${s}\u79D2\u4EE5\u5185${custom ? "\uFF08\u5236\u4F5C\u8FBC\u307F\uFF09" : ""}`
    });
  }
  return scope.kind === IpRightType.FACE_PHOTO ? tr(lang, {
    ko: `\uC0AC\uC9C4 ${n}\uC7A5 \uAE30\uC900`,
    en: `Based on ${n} ${n === 1 ? "photo" : "photos"}`,
    ja: `\u5199\u771F${n}\u679A\u57FA\u6E96`
  }) : tr(lang, {
    ko: `\uCF58\uD150\uCE20 ${n}\uAC74 \uAE30\uC900`,
    en: `Based on ${n} content ${n === 1 ? "item" : "items"}`,
    ja: `\u30B3\u30F3\u30C6\u30F3\u30C4${n}\u4EF6\u57FA\u6E96`
  });
}
__name(usagePriceBasis, "usagePriceBasis");
function proposalQuantityFields(scope, lang = DEFAULT_LANG) {
  if (!scope) return [];
  if (scope.kind === IpRightType.FACE_PHOTO) return [
    {
      key: "includedQuantity",
      label: tr(lang, {
        ko: "\uC81C\uACF5 \uC0AC\uC9C4 \uC218",
        en: "Photos provided",
        ja: "\u63D0\u4F9B\u5199\u771F\u6570"
      }),
      unit: tr(lang, {
        ko: "\uC7A5",
        en: "photos",
        ja: "\u679A"
      }),
      min: 1,
      max: 1e3,
      value: scope.includedQuantity
    }
  ];
  if (scope.kind === IpRightType.CONTENT_SECONDARY) return [
    {
      key: "includedQuantity",
      label: tr(lang, {
        ko: "\uC81C\uACF5 \uCF58\uD150\uCE20 \uC218",
        en: "Content items provided",
        ja: "\u63D0\u4F9B\u30B3\u30F3\u30C6\u30F3\u30C4\u6570"
      }),
      unit: tr(lang, {
        ko: "\uAC74",
        en: "items",
        ja: "\u4EF6"
      }),
      min: 1,
      max: 1e3,
      value: scope.includedQuantity
    }
  ];
  if (scope.kind === IpRightType.AI_VOICE) return [
    {
      key: "includedQuantity",
      label: tr(lang, {
        ko: "\uC74C\uC131 \uAC1C\uC218",
        en: "Number of voice clips",
        ja: "\u97F3\u58F0\u306E\u6570"
      }),
      unit: tr(lang, {
        ko: "\uAC1C",
        en: "clips",
        ja: "\u500B"
      }),
      min: 1,
      max: 1e3,
      value: scope.includedQuantity
    },
    {
      key: "totalSeconds",
      label: tr(lang, {
        ko: "\uCD1D \uAE38\uC774",
        en: "Total length",
        ja: "\u5408\u8A08\u306E\u9577\u3055"
      }),
      unit: tr(lang, {
        ko: "\uCD08",
        en: "sec",
        ja: "\u79D2"
      }),
      min: 1,
      max: 36e3,
      value: scope.totalSeconds
    }
  ];
  if (scope.kind === IpRightType.MERCHANDISE) return [
    {
      key: "includedQuantity",
      label: tr(lang, {
        ko: "\uC81C\uC791 \uC218\uB7C9",
        en: "Production quantity",
        ja: "\u5236\u4F5C\u6570\u91CF"
      }),
      unit: tr(lang, {
        ko: "\uAC1C",
        en: "units",
        ja: "\u500B"
      }),
      min: 1,
      max: MERCHANDISE_MAX_QUANTITY,
      value: scope.includedQuantity
    }
  ];
  return [];
}
__name(proposalQuantityFields, "proposalQuantityFields");
function mediaUsageChannels(scope) {
  if (!isMediaUsageScope(scope) || isPersonalUsage(scope)) return [];
  return Object.values(UsageChannel).filter((key) => key !== UsageChannel.PRODUCT_NAME && (scope.kind === IpRightType.FACE_PHOTO || key !== UsageChannel.PACKAGING));
}
__name(mediaUsageChannels, "mediaUsageChannels");
var USAGE_SCOPE_ROW_KEYS = {
  PURPOSE: "purpose",
  PERSONAL_SCOPE: "personalScope",
  ALLOWED_CHANNELS: "allowedChannels",
  ADDON_CHANNELS: "addonChannels",
  ADDON_BASIS: "addonBasis",
  PRICE_BASIS: "priceBasis"
};
var listJoiner = /* @__PURE__ */ __name((lang) => lang === "ja" ? "\u3001" : ", ", "listJoiner");
function usageScopeRows(scope, lang = DEFAULT_LANG) {
  if (scope.kind === IpRightType.APPEARANCE) return appearanceScopeRows(scope, lang);
  if (scope.kind === IpRightType.CO_BRANDING) return coBrandingScopeRows(scope, lang);
  if (scope.kind === IpRightType.MERCHANDISE) return merchandiseScopeRows(scope, lang);
  const join = listJoiner(lang);
  const rows = [];
  if (scope.kind === IpRightType.NAME_BRAND) {
    rows.unshift({
      key: "brandName",
      label: tr(lang, {
        ko: "\uC774\uB984\xB7\uBE0C\uB79C\uB4DC",
        en: "Name / brand",
        ja: "\u540D\u524D\u30FB\u30D6\u30E9\u30F3\u30C9"
      }),
      value: scope.brandName
    });
    rows.push({
      key: "allowedExpressions",
      label: tr(lang, {
        ko: "\uD5C8\uC6A9 \uD45C\uD604",
        en: "Allowed expressions",
        ja: "\u8A31\u53EF\u3059\u308B\u8868\u73FE"
      }),
      value: [
        ...scope.expressions
      ].sort().map((e) => BRAND_EXPRESSION_LABELS_I18N[lang][e]).join(join)
    });
  } else {
    const personal = isPersonalUsage(scope);
    rows.push({
      key: personal ? USAGE_SCOPE_ROW_KEYS.PERSONAL_SCOPE : USAGE_SCOPE_ROW_KEYS.ALLOWED_CHANNELS,
      label: personal ? tr(lang, {
        ko: "\uAC1C\uC778 \uAC10\uC0C1 \uBC94\uC704",
        en: "Personal viewing scope",
        ja: "\u500B\u4EBA\u9451\u8CDE\u306E\u7BC4\u56F2"
      }) : tr(lang, {
        ko: "\uD5C8\uC6A9 \uC0AC\uC6A9\uCC98",
        en: "Allowed placements",
        ja: "\u8A31\u53EF\u3059\u308B\u4F7F\u7528\u5148"
      }),
      value: personal ? PERSONAL_USAGE_BOUNDARY_I18N[lang] : [
        ...scope.channels
      ].sort().map((c) => USAGE_CHANNEL_LABELS_I18N[lang][c]).join(join) || tr(lang, {
        ko: "\uBBF8\uC124\uC815",
        en: "Not set",
        ja: "\u672A\u8A2D\u5B9A"
      })
    });
    if (!personal && scope.channelAddons?.length) {
      rows.push({
        key: USAGE_SCOPE_ROW_KEYS.ADDON_CHANNELS,
        label: tr(lang, {
          ko: "\uCD94\uAC00 \uC0AC\uC6A9\uCC98",
          en: "Add-on placements",
          ja: "\u8FFD\u52A0\u306E\u4F7F\u7528\u5148"
        }),
        value: [
          ...scope.channelAddons
        ].sort((a, b) => a.key.localeCompare(b.key)).map((item) => `${USAGE_CHANNEL_LABELS_I18N[lang][item.key]} ${monthlyAddonLabel(item.addonAmount, lang)}`).join(join) + tr(lang, {
          ko: " (\uC120\uD0DD \uC2DC \uD3EC\uD568)",
          en: " (included if selected)",
          ja: "\uFF08\u9078\u629E\u6642\u306B\u542B\u3080\uFF09"
        })
      });
      rows.push({
        key: USAGE_SCOPE_ROW_KEYS.ADDON_BASIS,
        label: tr(lang, {
          ko: "\uCD94\uAC00\uAE08 \uAE30\uC900",
          en: "Add-on fee basis",
          ja: "\u8FFD\u52A0\u6599\u91D1\u306E\u57FA\u6E96"
        }),
        value: tr(lang, {
          ko: "\uC6D4 \uAE08\uC561 \xD7 \uC774\uC6A9 \uAC1C\uC6D4 \uC218 \xB7 \uAE30\uBCF8 \uD3EC\uD568 \uC218\uB7C9 \uC804\uCCB4 \uAE30\uC900",
          en: "Monthly amount \xD7 months of use \xB7 applies to the whole included quantity",
          ja: "\u6708\u984D \xD7 \u5229\u7528\u6708\u6570\u30FB\u57FA\u672C\u306B\u542B\u307E\u308C\u308B\u6570\u91CF\u5168\u4F53\u304C\u57FA\u6E96"
        })
      });
    }
    rows.unshift({
      key: USAGE_SCOPE_ROW_KEYS.PRICE_BASIS,
      label: tr(lang, {
        ko: "\uAE30\uBCF8 \uAC00\uACA9 \uAE30\uC900",
        en: "Base price basis",
        ja: "\u57FA\u672C\u4FA1\u683C\u306E\u57FA\u6E96"
      }),
      value: usagePriceBasis(scope, lang)
    });
    if (scope.kind === IpRightType.AI_VOICE) {
      rows.unshift({
        key: "voiceMode",
        label: tr(lang, {
          ko: "\uC74C\uC131 \uC0AC\uC6A9 \uBC29\uC2DD",
          en: "How the voice is provided",
          ja: "\u97F3\u58F0\u306E\u4F7F\u7528\u65B9\u6CD5"
        }),
        value: VOICE_OFFERING_LABELS_I18N[lang][scope.mode]
      });
      if (scope.mode !== VoiceOfferingMode.BUYER_GENERATED) rows.splice(1, 0, {
        key: "voiceSource",
        label: tr(lang, {
          ko: "\uC74C\uC131 \uC81C\uC791 \uBC29\uC2DD",
          en: "How the audio is made",
          ja: "\u97F3\u58F0\u306E\u5236\u4F5C\u65B9\u6CD5"
        }),
        value: VOICE_SOURCE_LABELS_I18N[lang][scope.source]
      });
      if (scope.mode === VoiceOfferingMode.CUSTOM && scope.production) {
        const { scriptMaxLength, deliveryDays, revisions } = scope.production;
        const length = scriptMaxLength.toLocaleString(INTL_LOCALE[lang]);
        rows.push({
          key: "scriptLength",
          label: tr(lang, {
            ko: "\uD3EC\uD568 \uB300\uC0AC \uBD84\uB7C9",
            en: "Included script length",
            ja: "\u542B\u307E\u308C\u308B\u30BB\u30EA\u30D5\u306E\u5206\u91CF"
          }),
          value: tr(lang, {
            ko: `\uCD1D ${length}\uC790 \uC774\uB0B4 (\uACF5\uBC31 \uD3EC\uD568)`,
            en: `Up to ${length} ${scriptMaxLength === 1 ? "character" : "characters"} total (including spaces)`,
            ja: `\u5408\u8A08${length}\u6587\u5B57\u4EE5\u5185\uFF08\u7A7A\u767D\u542B\u3080\uFF09`
          })
        }, {
          key: "draftDelivery",
          label: tr(lang, {
            ko: "\uCD08\uC548 \uC804\uB2EC",
            en: "Draft delivery",
            ja: "\u521D\u7A3F\u306E\u7D0D\u54C1"
          }),
          value: tr(lang, {
            ko: `\uB300\uC0AC \uCD5C\uC885 \uD655\uC815 \uD6C4 ${deliveryDays}\uC77C \uC774\uB0B4`,
            en: `Within ${deliveryDays} ${deliveryDays === 1 ? "day" : "days"} after the script is finalized`,
            ja: `\u30BB\u30EA\u30D5\u306E\u6700\u7D42\u78BA\u5B9A\u5F8C${deliveryDays}\u65E5\u4EE5\u5185`
          })
        }, {
          key: "revisions",
          label: tr(lang, {
            ko: "\uD3EC\uD568 \uC218\uC815",
            en: "Included revisions",
            ja: "\u542B\u307E\u308C\u308B\u4FEE\u6B63"
          }),
          value: tr(lang, {
            ko: `\uD569\uC758\uD55C \uB300\uC0AC \uC548\uC5D0\uC11C ${revisions}\uD68C`,
            en: `${revisions} ${revisions === 1 ? "revision" : "revisions"} within the agreed script`,
            ja: `\u5408\u610F\u3057\u305F\u30BB\u30EA\u30D5\u306E\u7BC4\u56F2\u3067${revisions}\u56DE`
          })
        }, {
          key: "productionCostBasis",
          label: tr(lang, {
            ko: "\uC81C\uC791\uBE44 \uAE30\uC900",
            en: "Production cost basis",
            ja: "\u5236\u4F5C\u8CBB\u306E\u57FA\u6E96"
          }),
          value: tr(lang, {
            ko: "\uAE30\uAC04\uBCC4 \uAE30\uBCF8\uAC00\uC5D0 \uC704 \uBD84\uB7C9\uC758 \uC81C\uC791\xB7\uC218\uC815\uACFC \uC0AC\uC6A9\uB8CC \uD3EC\uD568",
            en: "The base price per period includes production and revisions for the amount above, plus usage fees",
            ja: "\u671F\u9593\u3054\u3068\u306E\u57FA\u672C\u4FA1\u683C\u306B\u3001\u4E0A\u8A18\u5206\u91CF\u306E\u5236\u4F5C\u30FB\u4FEE\u6B63\u3068\u4F7F\u7528\u6599\u3092\u542B\u3080"
          })
        });
      }
      if (scope.mode === VoiceOfferingMode.BUYER_GENERATED && scope.generation) {
        const generation = scope.generation;
        const days = generation.generationDays;
        rows.push({
          key: "generationMethod",
          label: tr(lang, {
            ko: "AI \uC74C\uC131 \uC0DD\uC131 \uBC29\uBC95",
            en: "AI voice generation method",
            ja: "AI\u97F3\u58F0\u306E\u751F\u6210\u65B9\u6CD5"
          }),
          value: VOICE_GENERATION_METHOD_LABELS_I18N[lang][generation.method]
        }, {
          key: "languages",
          label: tr(lang, {
            ko: "\uD5C8\uC6A9 \uC5B8\uC5B4",
            en: "Allowed languages",
            ja: "\u8A31\u53EF\u3059\u308B\u8A00\u8A9E"
          }),
          value: generation.languages
        }, {
          key: "generationPeriod",
          label: tr(lang, {
            ko: "\uC0DD\uC131 \uAC00\uB2A5 \uAE30\uAC04",
            en: "Generation window",
            ja: "\u751F\u6210\u53EF\u80FD\u671F\u9593"
          }),
          value: tr(lang, {
            ko: `\uACC4\uC57D \uD6A8\uB825 \uC2DC\uC791\uC77C\uBD80\uD130 ${days}\uC77C \uC774\uB0B4 (\uAD6C\uB9E4\uD55C \uC774\uC6A9 \uAE30\uAC04 \uB0B4)`,
            en: `Within ${days} ${days === 1 ? "day" : "days"} from the contract start date (within the purchased usage period)`,
            ja: `\u5951\u7D04\u306E\u52B9\u529B\u958B\u59CB\u65E5\u304B\u3089${days}\u65E5\u4EE5\u5185\uFF08\u8CFC\u5165\u3057\u305F\u5229\u7528\u671F\u9593\u5185\uFF09`
          })
        }, {
          key: "aiServiceCost",
          label: tr(lang, {
            ko: "AI \uC11C\uBE44\uC2A4 \uBE44\uC6A9",
            en: "AI service costs",
            ja: "AI\u30B5\u30FC\u30D3\u30B9\u8CBB\u7528"
          }),
          value: VOICE_SERVICE_COST_LABELS_I18N[lang][generation.costBearer]
        }, {
          key: "scriptApproval",
          label: tr(lang, {
            ko: "\uC0DD\uC131 \uC804 \uB300\uC0AC \uD655\uC778",
            en: "Script check before generation",
            ja: "\u751F\u6210\u524D\u306E\u30BB\u30EA\u30D5\u78BA\u8A8D"
          }),
          value: generation.scriptApprovalRequired ? tr(lang, {
            ko: "\uD310\uB9E4\uC790 \uD655\uC778 \uD6C4 \uC0DD\uC131",
            en: "Generated after the seller checks the script",
            ja: "\u8CA9\u58F2\u8005\u306E\u78BA\u8A8D\u5F8C\u306B\u751F\u6210"
          }) : tr(lang, {
            ko: "\uD569\uC758\uD55C \uBC94\uC704\uC5D0\uC11C \uBCC4\uB3C4 \uD655\uC778 \uC5C6\uC774 \uC0DD\uC131",
            en: "Generated within the agreed scope without a separate check",
            ja: "\u5408\u610F\u3057\u305F\u7BC4\u56F2\u5185\u3067\u5225\u9014\u78BA\u8A8D\u306A\u3057\u306B\u751F\u6210"
          })
        }, {
          key: "generationLimitBasis",
          label: tr(lang, {
            ko: "\uC0DD\uC131 \uD55C\uB3C4 \uAE30\uC900",
            en: "Generation limit basis",
            ja: "\u751F\u6210\u4E0A\u9650\u306E\u57FA\u6E96"
          }),
          value: tr(lang, {
            ko: "\uCD5C\uC885 \uC0AC\uC6A9\uBCF8\uC758 \uAC1C\uC218\xB7\uCD1D\uAE38\uC774 \uAE30\uC900 (\uBBF8\uC0AC\uC6A9 \uD14C\uC2A4\uD2B8 \uC0DD\uC131\uBB3C \uC81C\uC678)",
            en: "Based on the number and total length of final clips used (unused test generations excluded)",
            ja: "\u6700\u7D42\u4F7F\u7528\u5206\u306E\u500B\u6570\u30FB\u5408\u8A08\u306E\u9577\u3055\u304C\u57FA\u6E96\uFF08\u672A\u4F7F\u7528\u306E\u30C6\u30B9\u30C8\u751F\u6210\u7269\u306F\u9664\u304F\uFF09"
          })
        }, {
          key: "afterGeneration",
          label: tr(lang, {
            ko: "\uC0DD\uC131 \uAE30\uAC04 \uC885\uB8CC \uD6C4",
            en: "After the generation window",
            ja: "\u751F\u6210\u671F\u9593\u7D42\u4E86\u5F8C"
          }),
          value: VOICE_GENERATION_EXPIRY_I18N[lang]
        });
      }
      rows.push({
        key: "voiceBoundary",
        label: tr(lang, {
          ko: "\uC74C\uC131 \uC0AC\uC6A9 \uBC94\uC704",
          en: "Voice usage scope",
          ja: "\u97F3\u58F0\u306E\u4F7F\u7528\u7BC4\u56F2"
        }),
        value: voiceUsageBoundary(scope, lang)
      });
    }
    const generatedVoice = scope.kind === IpRightType.AI_VOICE && scope.mode === VoiceOfferingMode.BUYER_GENERATED;
    rows.push({
      key: "targetConfirmation",
      label: tr(lang, {
        ko: "\uB300\uC0C1 \uD655\uC815",
        en: "Confirming the material",
        ja: "\u5BFE\u8C61\u306E\u78BA\u5B9A"
      }),
      value: generatedVoice ? tr(lang, {
        ko: "\uB300\uD654\uB85C \uC0AC\uC6A9\uD560 \uBAA9\uC18C\uB9AC\xB7\uC81C\uACF5 \uC790\uB8CC \uB610\uB294 \uC811\uADFC \uBC29\uBC95\xB7\uB300\uC0AC \uBC94\uC704\uB97C \uC815\uD558\uACE0 \uBC1C\uAE09 \uC804 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D",
        en: "Settle the voice to use, the materials or access method, and the script scope in chat, and record them in the additional agreements before issuance",
        ja: "\u4F7F\u7528\u3059\u308B\u58F0\u30FB\u63D0\u4F9B\u8CC7\u6599\u307E\u305F\u306F\u30A2\u30AF\u30BB\u30B9\u65B9\u6CD5\u30FB\u30BB\u30EA\u30D5\u306E\u7BC4\u56F2\u3092\u30C1\u30E3\u30C3\u30C8\u3067\u6C7A\u3081\u3001\u767A\u884C\u524D\u306B\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332"
      }) : scope.kind === IpRightType.AI_VOICE ? tr(lang, {
        ko: "\uB300\uD654\uB85C \uB300\uC0C1 \uC74C\uC131\xB7\uB300\uC0AC\xB7\uCD5C\uC885 \uBD84\uB7C9\uC744 \uC815\uD558\uACE0 \uBC1C\uAE09 \uC804 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D",
        en: "Settle the target audio, script and final amount in chat, and record them in the additional agreements before issuance",
        ja: "\u5BFE\u8C61\u306E\u97F3\u58F0\u30FB\u30BB\u30EA\u30D5\u30FB\u6700\u7D42\u5206\u91CF\u3092\u30C1\u30E3\u30C3\u30C8\u3067\u6C7A\u3081\u3001\u767A\u884C\u524D\u306B\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332"
      }) : tr(lang, {
        ko: "\uB300\uD654\uB85C \uB300\uC0C1\xB7\uC218\uB7C9\uC744 \uC815\uD558\uACE0 \uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC5D0 \uAE30\uB85D",
        en: "Settle the target material and quantity in chat, and record them in the additional agreements",
        ja: "\u5BFE\u8C61\u30FB\u6570\u91CF\u3092\u30C1\u30E3\u30C3\u30C8\u3067\u6C7A\u3081\u3001\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u306B\u8A18\u9332"
      })
    });
    if (scope.delivery) rows.push({
      key: "delivery",
      label: generatedVoice ? tr(lang, {
        ko: "\uC0DD\uC131\uC6A9 \uC790\uB8CC\xB7\uC811\uADFC \uC81C\uACF5",
        en: "Generation materials & access",
        ja: "\u751F\u6210\u7528\u7D20\u6750\u30FB\u30A2\u30AF\u30BB\u30B9\u306E\u63D0\u4F9B"
      }) : tr(lang, {
        ko: "\uD30C\uC77C \uC81C\uACF5",
        en: "File delivery",
        ja: "\u30D5\u30A1\u30A4\u30EB\u306E\u63D0\u4F9B"
      }),
      value: scope.delivery
    });
    if (scope.rights) rows.push({
      key: "rights",
      label: tr(lang, {
        ko: "\uAD8C\uB9AC\xB7\uC81C\uC678 \uBC94\uC704",
        en: "Rights & exclusions",
        ja: "\u6A29\u5229\u30FB\u9664\u5916\u7BC4\u56F2"
      }),
      value: scope.rights
    });
  }
  const purpose = getUsagePurpose(scope);
  if (purpose) rows.unshift({
    key: USAGE_SCOPE_ROW_KEYS.PURPOSE,
    label: tr(lang, {
      ko: "\uC774\uC6A9 \uBAA9\uC801",
      en: "Purpose of use",
      ja: "\u5229\u7528\u76EE\u7684"
    }),
    value: USAGE_PURPOSE_LABELS_I18N[lang][purpose]
  });
  if (scope.guidelines) rows.push({
    key: "guidelines",
    label: tr(lang, {
      ko: "\uC0AC\uC6A9 \uAC00\uC774\uB4DC",
      en: "Usage guide",
      ja: "\u4F7F\u7528\u30AC\u30A4\u30C9"
    }),
    value: scope.guidelines
  });
  return rows;
}
__name(usageScopeRows, "usageScopeRows");
function requiresIssueAgreement(scope) {
  return !!scope && scope.kind !== IpRightType.NAME_BRAND;
}
__name(requiresIssueAgreement, "requiresIssueAgreement");

// src/enums/policy.ts
var PolicyVersionStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED"
};
var POLICY_VERSION_STATUS_LABELS = {
  DRAFT: "\uCD08\uC548",
  PUBLISHED: "\uBC1C\uD589 \uC911",
  ARCHIVED: "\uBCF4\uAD00\uB428"
};
var PolicyLanguage = {
  KO: "ko",
  EN: "en",
  JA: "ja"
};
var POLICY_LANGUAGES = [
  PolicyLanguage.KO,
  PolicyLanguage.EN,
  PolicyLanguage.JA
];
var POLICY_DEFAULT_LANGUAGE = PolicyLanguage.KO;
var POLICY_LANGUAGE_LABELS = {
  ko: "\uD55C\uAD6D\uC5B4",
  en: "English",
  ja: "\u65E5\u672C\u8A9E"
};
var POLICY_LANGUAGE_LABELS_I18N = {
  ko: POLICY_LANGUAGE_LABELS,
  en: {
    ko: "\uD55C\uAD6D\uC5B4",
    en: "English",
    ja: "\u65E5\u672C\u8A9E"
  },
  ja: {
    ko: "\uD55C\uAD6D\uC5B4",
    en: "English",
    ja: "\u65E5\u672C\u8A9E"
  }
};
function toPolicyLanguage(input) {
  const tag = (input ?? "").split(",")[0].split(";")[0].trim().toLowerCase();
  return POLICY_LANGUAGES.find((lang) => tag === lang || tag.startsWith(`${lang}-`) || tag.startsWith(`${lang}_`)) ?? POLICY_DEFAULT_LANGUAGE;
}
__name(toPolicyLanguage, "toPolicyLanguage");

// src/enums/social-platform.ts
var SocialPlatform = {
  YOUTUBE: "YOUTUBE",
  INSTAGRAM: "INSTAGRAM",
  TIKTOK: "TIKTOK",
  THREADS: "THREADS",
  /** 구 아프리카TV — 2024년 SOOP 으로 리브랜딩 */
  SOOP: "SOOP",
  PANDATV: "PANDATV"
};
var SOCIAL_PLATFORM_LABELS = {
  YOUTUBE: "\uC720\uD29C\uBE0C",
  INSTAGRAM: "\uC778\uC2A4\uD0C0\uADF8\uB7A8",
  TIKTOK: "\uD2F1\uD1A1",
  THREADS: "\uC2A4\uB808\uB4DC",
  SOOP: "SOOP (\uC232)",
  PANDATV: "\uD32C\uB354TV"
};
var SOCIAL_PLATFORM_LABELS_I18N = {
  ko: SOCIAL_PLATFORM_LABELS,
  en: {
    YOUTUBE: "YouTube",
    INSTAGRAM: "Instagram",
    TIKTOK: "TikTok",
    THREADS: "Threads",
    SOOP: "SOOP",
    PANDATV: "PandaTV"
  },
  ja: {
    YOUTUBE: "YouTube",
    INSTAGRAM: "Instagram",
    TIKTOK: "TikTok",
    THREADS: "Threads",
    SOOP: "SOOP",
    PANDATV: "PandaTV"
  }
};
var MANUAL_SOCIAL_PLATFORMS = [
  SocialPlatform.THREADS,
  SocialPlatform.SOOP,
  SocialPlatform.PANDATV
];
var SocialChannelRequestStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var SOCIAL_CHANNEL_REQUEST_STATUS_LABELS = {
  PENDING: "\uB300\uAE30 \uC911",
  APPROVED: "\uC2B9\uC778\uB428",
  REJECTED: "\uAC70\uC808\uB428"
};

// src/enums/sponsorship.ts
var SponsorshipApprovalMode = {
  AUTO: "AUTO",
  MANUAL: "MANUAL"
};
var SPONSORSHIP_APPROVAL_MODE_LABELS = {
  AUTO: "\uC9C0\uC6D0\uD558\uBA74 \uBC14\uB85C \uD655\uC815",
  MANUAL: "\uC2B9\uC778 \uD6C4 \uD655\uC815"
};
var SPONSORSHIP_APPROVAL_MODE_LABELS_I18N = {
  ko: SPONSORSHIP_APPROVAL_MODE_LABELS,
  en: {
    AUTO: "Confirmed on application",
    MANUAL: "Confirmed after approval"
  },
  ja: {
    AUTO: "\u5FDC\u52DF\u3059\u308B\u3068\u3059\u3050\u78BA\u5B9A",
    MANUAL: "\u627F\u8A8D\u5F8C\u306B\u78BA\u5B9A"
  }
};
var SponsorshipStatus = {
  PENDING: "PENDING",
  OPEN: "OPEN",
  REJECTED: "REJECTED",
  CLOSED: "CLOSED",
  /** 등록자가 공개 전에 삭제(심사 요청 취소) — 소프트 삭제와 함께, 어드민 심사 목록에만 보인다 */
  CANCELLED: "CANCELLED"
};
var SPONSORSHIP_STATUS_LABELS = {
  PENDING: "\uC2EC\uC0AC \uB300\uAE30",
  OPEN: "\uBAA8\uC9D1 \uC911",
  REJECTED: "\uBC18\uB824\uB428",
  CLOSED: "\uBAA8\uC9D1 \uB9C8\uAC10",
  CANCELLED: "\uC694\uCCAD \uCDE8\uC18C"
};
var SPONSORSHIP_STATUS_LABELS_I18N = {
  ko: SPONSORSHIP_STATUS_LABELS,
  en: {
    PENDING: "Under review",
    OPEN: "Recruiting",
    REJECTED: "Rejected",
    CLOSED: "Recruitment closed",
    CANCELLED: "Request cancelled"
  },
  ja: {
    PENDING: "\u5BE9\u67FB\u5F85\u3061",
    OPEN: "\u52DF\u96C6\u4E2D",
    REJECTED: "\u5DEE\u3057\u623B\u3057",
    CLOSED: "\u52DF\u96C6\u7D42\u4E86",
    CANCELLED: "\u4F9D\u983C\u53D6\u308A\u6D88\u3057"
  }
};
var SponsorshipApplicationStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  /** 방문 예정일이 지나도록 등록자가 확정하지 않아 자동 취소 — 다시 지원할 수 있다 */
  EXPIRED: "EXPIRED",
  /** 확정 뒤 지원자가 미션을 등록하고 등록자가 확인함 — 끝 */
  COMPLETED: "COMPLETED"
};
var SPONSORSHIP_APPLICATION_STATUS_LABELS = {
  PENDING: "\uC2B9\uC778 \uB300\uAE30",
  APPROVED: "\uD655\uC815",
  REJECTED: "\uAC70\uC808\uB428",
  CANCELLED: "\uC9C0\uC6D0 \uCDE8\uC18C",
  EXPIRED: "\uC790\uB3D9 \uCDE8\uC18C",
  COMPLETED: "\uBBF8\uC158 \uC644\uB8CC"
};
var SPONSORSHIP_APPLICATION_STATUS_LABELS_I18N = {
  ko: SPONSORSHIP_APPLICATION_STATUS_LABELS,
  en: {
    PENDING: "Awaiting approval",
    APPROVED: "Confirmed",
    REJECTED: "Rejected",
    CANCELLED: "Application cancelled",
    EXPIRED: "Auto-cancelled",
    COMPLETED: "Mission completed"
  },
  ja: {
    PENDING: "\u627F\u8A8D\u5F85\u3061",
    APPROVED: "\u78BA\u5B9A",
    REJECTED: "\u4E0D\u63A1\u7528",
    CANCELLED: "\u5FDC\u52DF\u53D6\u308A\u6D88\u3057",
    EXPIRED: "\u81EA\u52D5\u30AD\u30E3\u30F3\u30BB\u30EB",
    COMPLETED: "\u30DF\u30C3\u30B7\u30E7\u30F3\u5B8C\u4E86"
  }
};
var SPONSORSHIP_MISSION_TEXT_MAX = 2e3;
var SPONSORSHIP_MISSION_LINKS_MAX = 5;
var SPONSORSHIP_ELIGIBILITY_PLATFORMS = [
  SocialPlatform.YOUTUBE,
  SocialPlatform.INSTAGRAM,
  SocialPlatform.TIKTOK,
  SocialPlatform.THREADS,
  SocialPlatform.SOOP,
  SocialPlatform.PANDATV
];
var SponsorshipRegion = {
  NATIONWIDE: "NATIONWIDE",
  SEOUL: "SEOUL",
  GYEONGGI: "GYEONGGI",
  INCHEON: "INCHEON",
  BUSAN: "BUSAN",
  DAEGU: "DAEGU",
  GWANGJU: "GWANGJU",
  DAEJEON: "DAEJEON",
  ULSAN: "ULSAN",
  SEJONG: "SEJONG",
  GANGWON: "GANGWON",
  CHUNGBUK: "CHUNGBUK",
  CHUNGNAM: "CHUNGNAM",
  JEONBUK: "JEONBUK",
  JEONNAM: "JEONNAM",
  GYEONGBUK: "GYEONGBUK",
  GYEONGNAM: "GYEONGNAM",
  JEJU: "JEJU"
};
var SPONSORSHIP_REGION_LABELS = {
  NATIONWIDE: "\uC804\uAD6D\xB7\uC628\uB77C\uC778",
  SEOUL: "\uC11C\uC6B8",
  GYEONGGI: "\uACBD\uAE30",
  INCHEON: "\uC778\uCC9C",
  BUSAN: "\uBD80\uC0B0",
  DAEGU: "\uB300\uAD6C",
  GWANGJU: "\uAD11\uC8FC",
  DAEJEON: "\uB300\uC804",
  ULSAN: "\uC6B8\uC0B0",
  SEJONG: "\uC138\uC885",
  GANGWON: "\uAC15\uC6D0",
  CHUNGBUK: "\uCDA9\uBD81",
  CHUNGNAM: "\uCDA9\uB0A8",
  JEONBUK: "\uC804\uBD81",
  JEONNAM: "\uC804\uB0A8",
  GYEONGBUK: "\uACBD\uBD81",
  GYEONGNAM: "\uACBD\uB0A8",
  JEJU: "\uC81C\uC8FC"
};
var SPONSORSHIP_REGION_LABELS_I18N = {
  ko: SPONSORSHIP_REGION_LABELS,
  en: {
    NATIONWIDE: "Nationwide / online",
    SEOUL: "Seoul",
    GYEONGGI: "Gyeonggi",
    INCHEON: "Incheon",
    BUSAN: "Busan",
    DAEGU: "Daegu",
    GWANGJU: "Gwangju",
    DAEJEON: "Daejeon",
    ULSAN: "Ulsan",
    SEJONG: "Sejong",
    GANGWON: "Gangwon",
    CHUNGBUK: "Chungbuk",
    CHUNGNAM: "Chungnam",
    JEONBUK: "Jeonbuk",
    JEONNAM: "Jeonnam",
    GYEONGBUK: "Gyeongbuk",
    GYEONGNAM: "Gyeongnam",
    JEJU: "Jeju"
  },
  ja: {
    NATIONWIDE: "\u5168\u56FD\u30FB\u30AA\u30F3\u30E9\u30A4\u30F3",
    SEOUL: "\u30BD\u30A6\u30EB",
    GYEONGGI: "\u4EAC\u757F",
    INCHEON: "\u4EC1\u5DDD",
    BUSAN: "\u91DC\u5C71",
    DAEGU: "\u5927\u90B1",
    GWANGJU: "\u5149\u5DDE",
    DAEJEON: "\u5927\u7530",
    ULSAN: "\u851A\u5C71",
    SEJONG: "\u4E16\u5B97",
    GANGWON: "\u6C5F\u539F",
    CHUNGBUK: "\u5FE0\u6E05\u5317\u9053",
    CHUNGNAM: "\u5FE0\u6E05\u5357\u9053",
    JEONBUK: "\u5168\u7F85\u5317\u9053",
    JEONNAM: "\u5168\u7F85\u5357\u9053",
    GYEONGBUK: "\u6176\u5C1A\u5317\u9053",
    GYEONGNAM: "\u6176\u5C1A\u5357\u9053",
    JEJU: "\u6E08\u5DDE"
  }
};

// src/enums/community.ts
var CommunityPostCategory = {
  GENERAL: "GENERAL",
  QUESTION: "QUESTION",
  INFO: "INFO"
};
var COMMUNITY_POST_CATEGORY_LABELS = {
  GENERAL: "\uC77C\uBC18",
  QUESTION: "\uC9C8\uBB38",
  INFO: "\uC815\uBCF4"
};
var COMMUNITY_POST_CATEGORY_LABELS_I18N = {
  ko: COMMUNITY_POST_CATEGORY_LABELS,
  en: {
    GENERAL: "General",
    QUESTION: "Question",
    INFO: "Info"
  },
  ja: {
    GENERAL: "\u4E00\u822C",
    QUESTION: "\u8CEA\u554F",
    INFO: "\u60C5\u5831"
  }
};

// src/enums/scheduler-job.ts
var SchedulerJobStatus = {
  /** 도는 중 — 같은 작업은 겹쳐 돌리지 않는다 */
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};
var SCHEDULER_JOB_STATUS_LABELS = {
  RUNNING: "\uC2E4\uD589 \uC911",
  SUCCESS: "\uC131\uACF5",
  FAILED: "\uC2E4\uD328"
};

// src/types/branded.ts
var asUserId = /* @__PURE__ */ __name((v) => v, "asUserId");
var asListingId = /* @__PURE__ */ __name((v) => v, "asListingId");
var asOrderId = /* @__PURE__ */ __name((v) => v, "asOrderId");
var asLicenseId = /* @__PURE__ */ __name((v) => v, "asLicenseId");
var asSettlementId = /* @__PURE__ */ __name((v) => v, "asSettlementId");
var asAssetId = /* @__PURE__ */ __name((v) => v, "asAssetId");

// src/types/pagination.ts
function buildPage(items, total, query) {
  return {
    items,
    total,
    page: query.page,
    pageSize: query.pageSize,
    totalPages: Math.ceil(total / query.pageSize)
  };
}
__name(buildPage, "buildPage");

// src/types/result.ts
var ok = /* @__PURE__ */ __name((value) => ({
  ok: true,
  value
}), "ok");
var err = /* @__PURE__ */ __name((error) => ({
  ok: false,
  error
}), "err");

// src/types/proposal-pricing.ts
function proposalOptionGroups(source, lang = DEFAULT_LANG) {
  const group = /* @__PURE__ */ __name((id, label, labels, options) => ({
    label,
    options: Object.entries(labels).map(([key, name]) => ({
      group: id,
      key,
      label: name,
      amount: options.find((o) => o.key === key)?.addonAmount ?? null
    }))
  }), "group");
  if (source.brandScope) {
    const placements = source.brandScope.placements;
    return [
      group("assets", tr(lang, {
        ko: "\uC81C\uACF5 \uD45C\uAE30\xB7\uC790\uC0B0",
        en: "Credits & assets provided",
        ja: "\u63D0\u4F9B\u3059\u308B\u8868\u8A18\u30FB\u7D20\u6750"
      }), BRAND_ASSET_LABELS_I18N[lang], source.brandScope.assets),
      group("placements", tr(lang, {
        ko: "\uC0AC\uC6A9 \uC704\uCE58",
        en: "Placements",
        ja: "\u4F7F\u7528\u5834\u6240"
      }), USAGE_PLACEMENT_LABELS_I18N[lang], placements),
      ...source.brandScope.legalUses.length ? [
        group("legalUses", tr(lang, {
          ko: "\uC0C1\uD638\xB7\uC0C1\uD45C \uC0AC\uC6A9",
          en: "Business name & trademark use",
          ja: "\u5546\u53F7\u30FB\u5546\u6A19\u306E\u4F7F\u7528"
        }), Object.fromEntries(source.brandScope.legalUses.map((o) => [
          o.key,
          BRAND_LEGAL_USE_LABELS_I18N[lang][o.key]
        ])), source.brandScope.legalUses)
      ] : []
    ];
  }
  const scope = source.usageScope;
  if (!scope) return [];
  const adult = /* @__PURE__ */ __name(() => group("adultUsage", tr(lang, {
    ko: "\uC5C5\uC885 \uC0AC\uC6A9",
    en: "Industry use",
    ja: "\u696D\u7A2E\u3067\u306E\u4F7F\u7528"
  }), {
    ADULT: tr(lang, {
      ko: "\uC131\uC778 \uC5C5\uC885 \uC0AC\uC6A9",
      en: "Adult industry use",
      ja: "\u6210\u4EBA\u5411\u3051\u696D\u7A2E\u3067\u306E\u4F7F\u7528"
    })
  }, isAdultIndustryForbidden(source.forbiddenIndustries) ? [] : [
    {
      key: "ADULT",
      addonAmount: scope.kind === "MERCHANDISE" || scope.kind === "CO_BRANDING" ? scope.adultUsage?.addonAmount ?? 0 : 0
    }
  ]), "adult");
  if (scope.kind === "MERCHANDISE") return [
    group("merchandiseChannels", tr(lang, {
      ko: "\uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C",
      en: "Sales and distribution channels",
      ja: "\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF"
    }), MERCHANDISE_CHANNEL_LABELS_I18N[lang], [
      ...scope.distributionChannels.map((key) => ({
        key,
        addonAmount: 0
      })),
      ...scope.distributionChannelAddons ?? []
    ]),
    adult()
  ];
  if (scope.kind === "CO_BRANDING") return [
    group("channels", tr(lang, {
      ko: "\uC0AC\uC6A9 \uC704\uCE58",
      en: "Placements",
      ja: "\u4F7F\u7528\u5834\u6240"
    }), CO_BRANDING_CHANNEL_LABELS_I18N[lang], [
      ...scope.channels.map((key) => ({
        key,
        addonAmount: 0
      })),
      ...scope.channelAddons ?? []
    ]),
    adult()
  ];
  if (scope.kind === "APPEARANCE") return appearanceAllowsPublicRecording(scope) ? [
    group("channels", scope.mode === "AUDIO" ? tr(lang, {
      ko: "\uACF5\uAC1C \uB179\uC74C\uBB3C \uC0AC\uC6A9 \uC704\uCE58",
      en: "Placements for public recordings",
      ja: "\u516C\u958B\u9332\u97F3\u7269\u306E\u4F7F\u7528\u5834\u6240"
    }) : tr(lang, {
      ko: "\uACF5\uAC1C \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC704\uCE58",
      en: "Placements for public footage",
      ja: "\u516C\u958B\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u5834\u6240"
    }), APPEARANCE_CHANNEL_LABELS_I18N[lang], [
      ...scope.channels.map((key) => ({
        key,
        addonAmount: 0
      })),
      ...scope.channelAddons ?? []
    ])
  ] : [];
  if (!isMediaUsageScope(scope) || isPersonalUsage(scope)) return [];
  return [
    group("channels", tr(lang, {
      ko: "\uC0AC\uC6A9 \uC704\uCE58",
      en: "Placements",
      ja: "\u4F7F\u7528\u5834\u6240"
    }), Object.fromEntries(mediaUsageChannels(scope).map((key) => [
      key,
      USAGE_CHANNEL_LABELS_I18N[lang][key]
    ])), [
      ...scope.channels.map((key) => ({
        key,
        addonAmount: 0
      })),
      ...scope.channelAddons ?? []
    ])
  ];
}
__name(proposalOptionGroups, "proposalOptionGroups");
function isProposalOptionSelected(addons, option) {
  return option.group === "adultUsage" ? !!addons.adultUsage : addons[option.group]?.includes(option.key) ?? false;
}
__name(isProposalOptionSelected, "isProposalOptionSelected");
function proposalAddonAmount(source, addons, months = 0) {
  return proposalOptionGroups(source).flatMap((g) => g.options).reduce((sum, o) => sum + (o.amount && isProposalOptionSelected(addons, o) ? o.amount : 0), 0) * addonMonthsOf(months);
}
__name(proposalAddonAmount, "proposalAddonAmount");
var PROPOSAL_PRICE_ROW_KEYS = {
  BASE: "baseAmount",
  CAMPAIGNS: "campaignCount",
  TOTAL: "total"
};
function proposalPriceRows(pricing, lang = DEFAULT_LANG) {
  const won4 = /* @__PURE__ */ __name((value) => formatWon(value, lang), "won");
  const months = pricing.addonMonths ?? 1;
  return [
    {
      key: PROPOSAL_PRICE_ROW_KEYS.BASE,
      label: tr(lang, {
        ko: "\uD611\uC758 \uAE30\uBCF8 \uC0AC\uC6A9\uB8CC",
        en: "Negotiated base fee",
        ja: "\u4EA4\u6E09\u3057\u305F\u57FA\u672C\u4F7F\u7528\u6599"
      }),
      value: won4(pricing.baseAmount)
    },
    ...proposalOptionGroups(pricing.source, lang).flatMap((g) => g.options).filter((o) => o.amount && isProposalOptionSelected(pricing.addons, o)).map((o) => ({
      key: `addon:${o.group}:${o.key}`,
      label: o.label,
      value: months > 1 ? tr(lang, {
        ko: `+${won4(o.amount * months)} (\uC6D4 ${won4(o.amount)} \xD7 ${months}\uAC1C\uC6D4)`,
        en: `+${won4(o.amount * months)} (${won4(o.amount)}/mo \xD7 ${months} months)`,
        ja: `+${won4(o.amount * months)}\uFF08\u6708 ${won4(o.amount)} \xD7 ${months}\u304B\u6708\uFF09`
      }) : `+${won4(o.amount)}`
    })),
    ...pricing.campaignCount > 1 ? [
      {
        key: PROPOSAL_PRICE_ROW_KEYS.CAMPAIGNS,
        label: tr(lang, {
          ko: "\uCEA0\uD398\uC778 \uC218",
          en: "Campaigns",
          ja: "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u6570"
        }),
        value: tr(lang, {
          ko: `${pricing.campaignCount}\uAC74 (\uAE30\uBCF8 \uC0AC\uC6A9\uB8CC\uC640 \uCD94\uAC00\uAE08\uC5D0 \uC801\uC6A9)`,
          en: `${pricing.campaignCount} (applies to the base fee and add-ons)`,
          ja: `${pricing.campaignCount}\u4EF6\uFF08\u57FA\u672C\u4F7F\u7528\u6599\u3068\u8FFD\u52A0\u6599\u91D1\u306B\u9069\u7528\uFF09`
        })
      }
    ] : [],
    {
      key: PROPOSAL_PRICE_ROW_KEYS.TOTAL,
      label: tr(lang, {
        ko: "\uD569\uC758 \uACB0\uC81C \uAE08\uC561",
        en: "Agreed payment",
        ja: "\u5408\u610F\u3057\u305F\u652F\u6255\u91D1\u984D"
      }),
      value: won4((pricing.baseAmount + pricing.addonAmount) * pricing.campaignCount)
    }
  ];
}
__name(proposalPriceRows, "proposalPriceRows");

// src/constants/platform-fee.ts
function platformFeeOf(amount, feeRateBp) {
  return Math.floor(amount * feeRateBp / 1e4);
}
__name(platformFeeOf, "platformFeeOf");
function sellerShareOf(amount, feeRateBp) {
  return amount - platformFeeOf(amount, feeRateBp);
}
__name(sellerShareOf, "sellerShareOf");
function feeRateLabel(feeRateBp) {
  return rateBpLabel(feeRateBp);
}
__name(feeRateLabel, "feeRateLabel");
function rateBpLabel(rateBp) {
  return `${Number((rateBp / 100).toFixed(2))}%`;
}
__name(rateBpLabel, "rateBpLabel");

// src/types/offer-terms-rows.ts
var listJoin = /* @__PURE__ */ __name((lang) => lang === "ja" ? "\u3001" : ", ", "listJoin");
function scopeValue(options, labels, isContract, lang) {
  const join = listJoin(lang);
  if (isContract) return options.map((o) => labels[o.key] ?? o.key).join(join) || "\u2014";
  const included = options.filter((o) => o.addonAmount === 0).map((o) => labels[o.key] ?? o.key);
  const addons = options.filter((o) => o.addonAmount > 0).map((o) => `${labels[o.key] ?? o.key} ${monthlyAddonLabel(o.addonAmount, lang)}`);
  const parts = [
    included.join(join)
  ];
  if (addons.length > 0) parts.push(tr(lang, {
    ko: `(\uC635\uC158: ${addons.join(join)})`,
    en: `(add-ons: ${addons.join(join)})`,
    ja: `\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3: ${addons.join(join)}\uFF09`
  }));
  return parts.filter(Boolean).join(" ") || "\u2014";
}
__name(scopeValue, "scopeValue");
function legalValue(options, isContract, lang) {
  if (options.length === 0) return tr(lang, {
    ko: "\uBAA8\uB450 \uBD88\uAC00",
    en: "None allowed",
    ja: "\u3059\u3079\u3066\u4E0D\u53EF"
  });
  const allowed = options.map((o) => {
    const label = BRAND_LEGAL_USE_LABELS_I18N[lang][o.key] ?? o.key;
    return !isContract && o.addonAmount > 0 ? `${label} ${monthlyAddonLabel(o.addonAmount, lang)}` : tr(lang, {
      ko: `${label} \uAC00\uB2A5`,
      en: `${label} allowed`,
      ja: `${label} \u53EF`
    });
  });
  const rest = Object.values(BrandLegalUse).length - options.length;
  return allowed.join(listJoin(lang)) + (rest > 0 ? tr(lang, {
    ko: " \xB7 \uADF8 \uC678 \uBD88\uAC00",
    en: " \xB7 others not allowed",
    ja: " \xB7 \u305D\u306E\u4ED6\u306F\u4E0D\u53EF"
  }) : "");
}
__name(legalValue, "legalValue");
function preApprovalValue(terms, lang) {
  if (!terms.requiresPreApproval) return tr(lang, {
    ko: "\uBD88\uD544\uC694",
    en: "Not required",
    ja: "\u4E0D\u8981"
  });
  if (terms.rightType === "APPEARANCE") return tr(lang, {
    ko: "\uCD9C\uC5F0 \uC804 \uC9C4\uD589 \uB0B4\uC6A9\xB7\uB300\uBCF8 \uD655\uC778 \uD544\uC694",
    en: "Review of plan and script required before appearance",
    ja: "\u51FA\u6F14\u524D\u306B\u9032\u884C\u5185\u5BB9\u30FB\u53F0\u672C\u306E\u78BA\u8A8D\u304C\u5FC5\u8981"
  });
  if (terms.rightType === "CO_BRANDING") return tr(lang, {
    ko: "\uACF5\uAC1C \uC804 \uB450 \uBE0C\uB79C\uB4DC \uD45C\uC2DC \uC2DC\uC548 \uC2B9\uC778 \uD544\uC694",
    en: "Approval of co-brand mockups required before release",
    ja: "\u516C\u958B\u524D\u306B\u4E21\u30D6\u30E9\u30F3\u30C9\u306E\u8868\u793A\u6848\u306E\u627F\u8A8D\u304C\u5FC5\u8981"
  });
  if (terms.rightType === "MERCHANDISE") return tr(lang, {
    ko: "\uC81C\uC791 \uC804 \uB514\uC790\uC778 \uC2DC\uC548 \uC2B9\uC778 \uD544\uC694",
    en: "Approval of design mockups required before production",
    ja: "\u5236\u4F5C\u524D\u306B\u30C7\u30B6\u30A4\u30F3\u6848\u306E\u627F\u8A8D\u304C\u5FC5\u8981"
  });
  return isPersonalUsage(terms.usageScope) ? tr(lang, {
    ko: "\uC0AC\uC6A9 \uC804 \uC2B9\uC778 \uD544\uC694",
    en: "Approval required before use",
    ja: "\u4F7F\u7528\u524D\u306B\u627F\u8A8D\u304C\u5FC5\u8981"
  }) : tr(lang, {
    ko: "\uC9D1\uD589 \uC804 \uC2B9\uC778 \uD544\uC694",
    en: "Approval required before running",
    ja: "\u5B9F\u65BD\u524D\u306B\u627F\u8A8D\u304C\u5FC5\u8981"
  });
}
__name(preApprovalValue, "preApprovalValue");
var OFFER_TERM_ROW_KEYS = {
  USAGE_TARGET: "usageTarget",
  DURATION: "duration",
  REGION: "region",
  BRAND_ASSETS: "brandAssets",
  BRAND_PLACEMENTS: "brandPlacements",
  BRAND_LEGAL_USES: "brandLegalUses",
  EXCLUSIVITY: "exclusivity",
  MODIFICATION: "modification",
  PRE_APPROVAL: "preApproval",
  FORBIDDEN_INDUSTRIES: "forbiddenIndustries",
  PRICING_MODEL: "pricingModel",
  ROYALTY_PAYMENT_DAY: "royaltyPaymentDay",
  VIOLATION: "violation"
};
function offerTermsRows(terms, lang = DEFAULT_LANG) {
  const K = OFFER_TERM_ROW_KEYS;
  const config = terms.rightType ? RIGHT_TYPE_FORM_CONFIG[terms.rightType] : null;
  const join = listJoin(lang);
  const monthsLabel = /* @__PURE__ */ __name((m) => m === 0 ? tr(lang, {
    ko: "\uAE30\uAC04 \uC5C6\uC74C (1\uD68C)",
    en: "No period (one-time)",
    ja: "\u671F\u9593\u306A\u3057\uFF081\u56DE\uFF09"
  }) : tr(lang, {
    ko: `${m}\uAC1C\uC6D4`,
    en: m === 1 ? "1 month" : `${m} months`,
    ja: `${m}\u304B\u6708`
  }), "monthsLabel");
  const negotiable = tr(lang, {
    ko: "\uBCC4\uB3C4 \uD611\uC758",
    en: "To be negotiated",
    ja: "\u5225\u9014\u5354\u8B70"
  });
  const isContract = terms.durationMonths !== void 0;
  const durationLabel = isContract ? monthsLabel(terms.durationMonths ?? 0) : (terms.durationOptions ?? []).map((d) => monthsLabel(d.months)).join(" / ");
  const scopeRows = terms.usageScope ? usageScopeRows(terms.usageScope, lang) : [];
  const scopeRow = /* @__PURE__ */ __name((row, label = row.label) => row.key ? {
    key: row.key,
    label,
    value: row.value
  } : {
    label,
    value: row.value
  }, "scopeRow");
  const rows = [];
  if (terms.proposalPricing) rows.push(...proposalPriceRows(terms.proposalPricing, lang));
  if (!isContract && (terms.rightType === "FACE_PHOTO" || terms.rightType === "CONTENT_SECONDARY")) {
    rows.push({
      key: K.USAGE_TARGET,
      label: tr(lang, {
        ko: "\uC0AC\uC6A9 \uB300\uC0C1",
        en: "Covered use",
        ja: "\u4F7F\u7528\u5BFE\u8C61"
      }),
      value: MEDIA_USAGE_DESCRIPTION_I18N[lang]
    });
  }
  for (const row of scopeRows) if (!row.group) rows.push(scopeRow(row));
  if (config?.duration ?? true) rows.push({
    key: K.DURATION,
    label: tr(lang, {
      ko: "\uC0AC\uC6A9 \uAE30\uAC04",
      en: "Usage period",
      ja: "\u4F7F\u7528\u671F\u9593"
    }),
    value: durationLabel || "\u2014"
  });
  rows.push({
    key: K.REGION,
    label: terms.rightType ? RIGHT_TYPE_REGION_LABELS_I18N[lang][terms.rightType] : tr(lang, {
      ko: "\uC0AC\uC6A9 \uC9C0\uC5ED",
      en: "Usage region",
      ja: "\u4F7F\u7528\u5730\u57DF"
    }),
    value: USAGE_REGION_LABELS_I18N[lang][terms.region]
  });
  if (terms.brandScope) {
    rows.push({
      key: K.BRAND_ASSETS,
      label: tr(lang, {
        ko: "\uC81C\uACF5 \uC790\uC0B0",
        en: "Assets provided",
        ja: "\u63D0\u4F9B\u7D20\u6750"
      }),
      value: scopeValue(terms.brandScope.assets, BRAND_ASSET_LABELS_I18N[lang], isContract, lang)
    }, {
      key: K.BRAND_PLACEMENTS,
      label: tr(lang, {
        ko: "\uC0AC\uC6A9 \uC704\uCE58",
        en: "Placements",
        ja: "\u4F7F\u7528\u5834\u6240"
      }),
      value: scopeValue(terms.brandScope.placements, USAGE_PLACEMENT_LABELS_I18N[lang], isContract, lang)
    }, {
      key: K.BRAND_LEGAL_USES,
      label: tr(lang, {
        ko: "\uC0C1\uD638\xB7\uC0C1\uD45C",
        en: "Business name & trademark",
        ja: "\u5546\u53F7\u30FB\u5546\u6A19"
      }),
      value: legalValue(terms.brandScope.legalUses, isContract, lang)
    });
  }
  if (config?.exclusivity ?? true) {
    rows.push({
      key: K.EXCLUSIVITY,
      label: tr(lang, {
        ko: "\uB3C5\uC810 \uC5EC\uBD80",
        en: "Exclusivity",
        ja: "\u72EC\u5360\u306E\u6709\u7121"
      }),
      value: EXCLUSIVITY_LABELS_I18N[lang][terms.exclusivity]
    });
  }
  if ((config?.modification ?? true) || terms.modificationRights.length > 0) {
    rows.push({
      key: K.MODIFICATION,
      label: tr(lang, {
        ko: "\uC218\uC815 \uBC94\uC704",
        en: "Modifications",
        ja: "\u6539\u5909\u306E\u7BC4\u56F2"
      }),
      value: terms.modificationRights.length > 0 ? terms.modificationRights.map((m) => MODIFICATION_RIGHT_LABELS_I18N[lang][m]).join(join) : negotiable
    });
  }
  rows.push({
    key: K.PRE_APPROVAL,
    label: tr(lang, {
      ko: "\uC0AC\uC804 \uC2B9\uC778",
      en: "Pre-approval",
      ja: "\u4E8B\u524D\u627F\u8A8D"
    }),
    value: preApprovalValue(terms, lang)
  }, {
    key: K.FORBIDDEN_INDUSTRIES,
    label: tr(lang, {
      ko: "\uAE08\uC9C0 \uC5C5\uC885",
      en: "Prohibited industries",
      ja: "\u7981\u6B62\u696D\u7A2E"
    }),
    value: terms.forbiddenIndustries.length > 0 ? terms.forbiddenIndustries.map((v) => forbiddenIndustryLabel(v, lang)).join(join) : tr(lang, {
      ko: "\uC5C6\uC74C",
      en: "None",
      ja: "\u306A\u3057"
    })
  }, {
    key: K.PRICING_MODEL,
    label: tr(lang, {
      ko: "\uAC00\uACA9 \uBC29\uC2DD",
      en: "Pricing model",
      ja: "\u4FA1\u683C\u65B9\u5F0F"
    }),
    value: PRICING_MODEL_LABELS_I18N[lang][terms.pricingModel] + (terms.royaltyRateBp ? tr(lang, {
      ko: ` (\uB9E4\uCD9C\uC758 ${rateBpLabel(terms.royaltyRateBp)})`,
      en: ` (${rateBpLabel(terms.royaltyRateBp)} of revenue)`,
      ja: `\uFF08\u58F2\u4E0A\u306E${rateBpLabel(terms.royaltyRateBp)}\uFF09`
    }) : "")
  });
  if (terms.royaltyRateBp != null && terms.royaltyRateBp > 0 && terms.royaltyPaymentDay != null) {
    const day = terms.royaltyPaymentDay;
    rows.push({
      key: K.ROYALTY_PAYMENT_DAY,
      label: tr(lang, {
        ko: "\uB85C\uC5F4\uD2F0 \uC9C0\uAE09\uC77C",
        en: "Royalty payment day",
        ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u652F\u6255\u65E5"
      }),
      value: tr(lang, {
        ko: `\uB9E4\uB2EC ${day}\uC77C (\uC804\uC6D4 \uB9E4\uCD9C \uBCF4\uACE0\xB7\uC785\uAE08)`,
        en: `Day ${day} of each month (report and pay last month's revenue)`,
        ja: `\u6BCE\u6708${day}\u65E5\uFF08\u524D\u6708\u306E\u58F2\u4E0A\u3092\u5831\u544A\u30FB\u5165\u91D1\uFF09`
      })
    });
  }
  rows.push({
    key: K.VIOLATION,
    label: tr(lang, {
      ko: "\uC704\uBC18 \uC2DC",
      en: "On violation",
      ja: "\u9055\u53CD\u6642"
    }),
    value: terms.violationPolicies.length > 0 ? terms.violationPolicies.map((v) => VIOLATION_POLICY_LABELS_I18N[lang][v]).join(join) : negotiable
  });
  const groups = /* @__PURE__ */ new Map();
  for (const row of scopeRows) {
    if (!row.group) continue;
    groups.set(row.group, [
      ...groups.get(row.group) ?? [],
      scopeRow(row, row.groupLabel ?? row.label)
    ]);
  }
  return {
    rows,
    groups: [
      ...groups
    ].map(([title, groupRows]) => ({
      title,
      rows: groupRows
    }))
  };
}
__name(offerTermsRows, "offerTermsRows");

// src/types/proposal-form.ts
function appearanceSessionOffer(offer, mode) {
  const variants = offer.usageScope?.kind === "APPEARANCE" ? offer.usageScope.variants : void 0;
  if (!variants) return offer;
  const variant = variants.find((v) => mode ? appearanceVariantMode(v.mode) === appearanceVariantMode(mode) : v.fixedAmount != null) ?? variants[0];
  return {
    ...offer,
    usageScope: appearanceVariantScope(variant),
    durationOptions: [
      {
        months: 0,
        fixedAmount: variant.fixedAmount
      }
    ]
  };
}
__name(appearanceSessionOffer, "appearanceSessionOffer");
function appearanceOffer(offer, mode, ids) {
  const session = appearanceSessionOffer(offer, mode);
  const scope = session.usageScope;
  if (scope?.kind !== "APPEARANCE" || !scope.onsitePackages) return session;
  const packages = ids ? scope.onsitePackages.filter((item) => ids.includes(item.id)) : [
    scope.onsitePackages.reduce((min, item) => item.fixedAmount < min.fixedAmount ? item : min)
  ];
  return {
    ...session,
    usageScope: withAppearancePackages(scope, packages),
    durationOptions: [
      {
        months: 0,
        fixedAmount: appearancePackageTotal(packages)
      }
    ]
  };
}
__name(appearanceOffer, "appearanceOffer");
function isCampaignPricedScope(scope) {
  return scope?.kind === "CO_BRANDING" && scope.campaignPricing === "PER_CAMPAIGN";
}
__name(isCampaignPricedScope, "isCampaignPricedScope");
function durationChoices(months, lang) {
  return months.map((m) => ({
    months: m,
    label: tr(lang, {
      ko: `${m}\uAC1C\uC6D4`,
      en: m === 1 ? "1 month" : `${m} months`,
      ja: `${m}\u304B\u6708`
    }),
    addonMonths: addonMonthsOf(m)
  }));
}
__name(durationChoices, "durationChoices");
function quantityBaseText(base, lang) {
  const text = proposalQuantityFields(base, lang).map((f) => {
    const value = f.value.toLocaleString(INTL_LOCALE[lang]);
    return lang === "en" ? `${f.label} ${value} ${f.unit}` : `${f.label} ${value}${f.unit}`;
  }).join(" \xB7 ");
  return text || null;
}
__name(quantityBaseText, "quantityBaseText");
function appearanceFields(scope, lang) {
  if (scope?.kind !== "APPEARANCE") return {
    appearanceMode: null,
    appearanceLabel: null,
    priceBasis: null
  };
  const label = APPEARANCE_VARIANT_LABELS_I18N[lang][appearanceVariantMode(scope.mode)];
  return {
    appearanceMode: scope.mode,
    appearanceLabel: label,
    priceBasis: `${label} \xB7 ${usagePriceBasis(scope, lang)}`
  };
}
__name(appearanceFields, "appearanceFields");
var BASE_FEE_LABEL = {
  ko: "\uC81C\uC548\uD560 \uAE30\uBCF8 \uC0AC\uC6A9\uB8CC",
  en: "Proposed base fee",
  ja: "\u63D0\u6848\u3059\u308B\u57FA\u672C\u4F7F\u7528\u6599"
};
function offerHasProposal(offer) {
  return offer.pricingModel === PricingModel.REVENUE_SHARE || offer.durationOptions.some((d) => !d.fixedAmount) || offer.usageScope?.kind === "APPEARANCE" && !!offer.usageScope.variants?.some((v) => v.fixedAmount == null);
}
__name(offerHasProposal, "offerHasProposal");
function proposalFormsOfOffer(offer, initialMonths, lang = DEFAULT_LANG) {
  const variants = offer.usageScope?.kind === "APPEARANCE" ? offer.usageScope.variants?.filter((v) => v.fixedAmount == null) : void 0;
  const offers = variants?.length ? variants.map((v) => appearanceOffer(offer, v.mode)) : [
    appearanceOffer(offer)
  ];
  return offers.map((o) => proposalFormOfOffer(o, initialMonths, lang));
}
__name(proposalFormsOfOffer, "proposalFormsOfOffer");
function proposalFormOfOffer(offer, initialMonths, lang) {
  const hasDuration = RIGHT_TYPE_FORM_CONFIG[offer.rightType].duration;
  const hasRoyalty = offer.pricingModel !== PricingModel.FIXED;
  const source = proposalSourceOf(offer);
  const appearance = offer.rightType === "APPEARANCE";
  const months = (offer.durationOptions.find((o) => o.months === initialMonths) ?? offer.durationOptions.find((o) => o.fixedAmount == null) ?? offer.durationOptions[0])?.months ?? (hasDuration ? 1 : 0);
  return {
    ...appearanceFields(offer.usageScope, lang),
    rightLabel: IP_RIGHT_LABELS_I18N[lang][offer.rightType],
    durations: hasDuration ? durationChoices(source.durationMonths, lang) : [],
    initialMonths: months,
    amountLabel: appearance ? tr(lang, {
      ko: "1\uD68C \uAE30\uBCF8 \uCD9C\uC5F0\uB8CC",
      en: "Base fee per appearance",
      ja: "1\u56DE\u306E\u57FA\u672C\u51FA\u6F14\u6599"
    }) : tr(lang, BASE_FEE_LABEL),
    // 0원으로 시작하면 그대로 보내기 쉽다 — 로열티만 받는 권리 말고는 비워 두고 직접 적게 한다
    initialAmount: offer.pricingModel === PricingModel.REVENUE_SHARE ? 0 : null,
    requirePositiveAmount: offer.pricingModel === PricingModel.FIXED,
    hasRoyalty,
    initialRoyaltyRateBp: hasRoyalty ? offer.royaltyRateBp ?? 500 : 0,
    initialRoyaltyPaymentDay: offer.royaltyPaymentDay ?? 10,
    quantityFields: proposalQuantityFields(offer.usageScope, lang),
    quantityBaseText: quantityBaseText(offer.usageScope, lang),
    optionGroups: proposalOptionGroups(source, lang),
    monthlyAddons: hasDuration,
    initialAddons: offer.usageScope?.kind === "APPEARANCE" ? {
      appearanceMode: offer.usageScope.mode,
      onsitePackageIds: offer.usageScope.onsitePackages?.map((item) => item.id)
    } : {},
    perCampaign: isCampaignPricedScope(offer.usageScope),
    initialCampaignCount: 1,
    appearanceNote: appearance
  };
}
__name(proposalFormOfOffer, "proposalFormOfOffer");
function proposalSourceOf(offer) {
  return {
    brandScope: offer.brandScope,
    usageScope: offer.usageScope,
    forbiddenIndustries: offer.forbiddenIndustries,
    durationMonths: offer.durationOptions.map((o) => o.months).filter((months) => months === 0 || OFFER_DURATION_MONTHS.includes(months))
  };
}
__name(proposalSourceOf, "proposalSourceOf");
function proposalFormOfTerms(terms, lang = DEFAULT_LANG) {
  const pricing = terms.proposalPricing ?? null;
  const hasDuration = RIGHT_TYPE_FORM_CONFIG[terms.rightType].duration;
  const hasRoyalty = terms.pricingModel !== PricingModel.FIXED;
  const source = pricing?.source;
  return {
    ...appearanceFields(terms.usageScope, lang),
    rightLabel: IP_RIGHT_LABELS_I18N[lang][terms.rightType],
    durations: hasDuration ? durationChoices(source?.durationMonths ?? OFFER_DURATION_MONTHS, lang) : [],
    initialMonths: hasDuration ? terms.durationMonths : 0,
    amountLabel: pricing ? tr(lang, BASE_FEE_LABEL) : tr(lang, {
      ko: "\uC120\uBD88",
      en: "Upfront",
      ja: "\u524D\u6255\u3044"
    }),
    initialAmount: pricing?.baseAmount ?? terms.upfrontAmount,
    requirePositiveAmount: false,
    hasRoyalty,
    initialRoyaltyRateBp: terms.royaltyRateBp ?? 0,
    initialRoyaltyPaymentDay: terms.royaltyPaymentDay ?? 10,
    quantityFields: proposalQuantityFields(terms.usageScope, lang),
    quantityBaseText: quantityBaseText(source?.usageScope ?? terms.usageScope, lang),
    optionGroups: source ? proposalOptionGroups(source, lang) : [],
    monthlyAddons: hasDuration,
    initialAddons: pricing?.addons ?? {},
    perCampaign: isCampaignPricedScope(source?.usageScope),
    initialCampaignCount: pricing?.campaignCount ?? 1,
    appearanceNote: false
  };
}
__name(proposalFormOfTerms, "proposalFormOfTerms");

// src/types/purchase-options.ts
function addonHint(scope, lang) {
  if (!scope || scope.kind === "NAME_BRAND") return null;
  if (scope.kind === "CO_BRANDING" && scope.campaignPricing === "PER_CAMPAIGN") return tr(lang, {
    ko: "\uC544\uB798 \uCD94\uAC00\uAE08\uC740 \uCEA0\uD398\uC778 1\uAC74\uC758 \uC6D4 \uAE08\uC561\uC774\uC5D0\uC694. \uC774\uC6A9 \uAC1C\uC6D4 \uC218\uC640 \uCEA0\uD398\uC778 \uC218\uB9CC\uD07C \uACF1\uD574\uC694.",
    en: "The add-on prices below are monthly, per campaign. They are multiplied by the months of use and the number of campaigns.",
    ja: "\u4EE5\u4E0B\u306E\u8FFD\u52A0\u6599\u91D1\u306F\u30AD\u30E3\u30F3\u30DA\u30FC\u30F31\u4EF6\u3042\u305F\u308A\u306E\u6708\u984D\u3067\u3059\u3002\u5229\u7528\u6708\u6570\u3068\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u6570\u3092\u639B\u3051\u307E\u3059\u3002"
  });
  if (scope.kind === "APPEARANCE") return tr(lang, {
    ko: "\uCD94\uAC00\uAE08\uC740 \uC774\uBC88 \uCD9C\uC5F0 \uCD2C\uC601\uBB3C\uC758 \uC124\uC815\uB41C \uC0AC\uC6A9 \uAE30\uAC04 \uC804\uCCB4\uC5D0 \uD55C \uBC88 \uC801\uC6A9\uB3FC\uC694.",
    en: "Add-on prices apply once for the full usage period set for this appearance\u2019s recordings.",
    ja: "\u8FFD\u52A0\u6599\u91D1\u306F\u4ECA\u56DE\u306E\u51FA\u6F14\u64AE\u5F71\u7269\u306B\u8A2D\u5B9A\u3055\u308C\u305F\u5229\u7528\u671F\u9593\u5168\u4F53\u306B\u4E00\u5EA6\u3060\u3051\u9069\u7528\u3055\u308C\u307E\u3059\u3002"
  });
  return tr(lang, {
    ko: "\uCD94\uAC00\uAE08\uC740 \uC6D4 \uAE08\uC561\uC774\uC5D0\uC694. \uACE0\uB978 \uC774\uC6A9 \uAC1C\uC6D4 \uC218\uB9CC\uD07C \uACF1\uD574 \uAE30\uBCF8 \uD3EC\uD568 \uC218\uB7C9 \uC804\uCCB4\uC5D0 \uC801\uC6A9\uB3FC\uC694.",
    en: "Add-on prices are monthly. They are multiplied by the months you choose and apply to the full included quantity.",
    ja: "\u8FFD\u52A0\u6599\u91D1\u306F\u6708\u984D\u3067\u3059\u3002\u9078\u3093\u3060\u5229\u7528\u6708\u6570\u3092\u639B\u3051\u3001\u57FA\u672C\u3067\u542B\u307E\u308C\u308B\u6570\u91CF\u5168\u4F53\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002"
  });
}
__name(addonHint, "addonHint");
function adultLabel(lang) {
  return tr(lang, {
    ko: "\uC131\uC778 \uC5C5\uC885 \uC0AC\uC6A9",
    en: "Use in adult industries",
    ja: "\u6210\u4EBA\u696D\u7A2E\u3067\u306E\u4F7F\u7528"
  });
}
__name(adultLabel, "adultLabel");
function groupsOf(offer, scope, lang) {
  const adult = /* @__PURE__ */ __name(() => ({
    group: "adultUsage",
    options: isAdultIndustryForbidden(offer.forbiddenIndustries) ? [] : [
      {
        key: "ADULT",
        addonAmount: scope?.kind === "MERCHANDISE" || scope?.kind === "CO_BRANDING" ? scope.adultUsage?.addonAmount ?? 0 : 0
      }
    ],
    all: [
      "ADULT"
    ],
    labels: {
      ADULT: adultLabel(lang)
    }
  }), "adult");
  if (offer.brandScope) {
    const assets = BRAND_ASSET_LABELS_I18N[lang];
    const placements = USAGE_PLACEMENT_LABELS_I18N[lang];
    const legalUses = BRAND_LEGAL_USE_LABELS_I18N[lang];
    return [
      {
        group: "assets",
        options: offer.brandScope.assets,
        all: Object.keys(assets),
        labels: assets
      },
      {
        group: "placements",
        options: offer.brandScope.placements,
        all: Object.keys(placements),
        labels: placements
      },
      {
        group: "legalUses",
        options: offer.brandScope.legalUses,
        all: Object.keys(legalUses),
        labels: legalUses
      }
    ];
  }
  if (scope?.kind === "MERCHANDISE") {
    const labels = MERCHANDISE_CHANNEL_LABELS_I18N[lang];
    return [
      {
        group: "merchandiseChannels",
        options: [
          ...scope.distributionChannels.map((key) => ({
            key,
            addonAmount: 0
          })),
          ...scope.distributionChannelAddons ?? []
        ],
        all: Object.keys(labels),
        labels
      },
      adult()
    ];
  }
  if (scope?.kind === "CO_BRANDING") {
    const labels = CO_BRANDING_CHANNEL_LABELS_I18N[lang];
    return [
      {
        group: "channels",
        options: [
          ...scope.channels.map((key) => ({
            key,
            addonAmount: 0
          })),
          ...scope.channelAddons ?? []
        ],
        all: Object.keys(labels),
        labels
      },
      adult()
    ];
  }
  if (scope?.kind === "APPEARANCE") {
    const labels = APPEARANCE_CHANNEL_LABELS_I18N[lang];
    return [
      {
        group: "channels",
        options: [
          ...scope.channels.map((key) => ({
            key,
            addonAmount: 0
          })),
          ...scope.channelAddons ?? []
        ],
        all: Object.keys(labels),
        labels
      }
    ];
  }
  if (!isMediaUsageScope(scope) || isPersonalUsage(scope)) return null;
  return [
    {
      group: "channels",
      options: [
        ...scope.channels.map((key) => ({
          key,
          addonAmount: 0
        })),
        ...scope.channelAddons ?? []
      ],
      all: mediaUsageChannels(scope),
      labels: USAGE_CHANNEL_LABELS_I18N[lang]
    }
  ];
}
__name(groupsOf, "groupsOf");
function optionSet(offer, scope, lang) {
  const groups = groupsOf(offer, scope, lang);
  if (!groups) return null;
  const label = /* @__PURE__ */ __name((labels, key) => labels[key] ?? key, "label");
  return {
    title: scope?.kind === "APPEARANCE" ? scope.mode === "AUDIO" ? tr(lang, {
      ko: "\uB179\uC74C\uBB3C \uC0AC\uC6A9 \uBC94\uC704",
      en: "Use of voice recordings",
      ja: "\u9332\u97F3\u7269\u306E\u5229\u7528\u7BC4\u56F2"
    }) : tr(lang, {
      ko: "\uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uBC94\uC704",
      en: "Use of recordings",
      ja: "\u64AE\u5F71\u7269\u306E\u5229\u7528\u7BC4\u56F2"
    }) : tr(lang, {
      ko: "\uC81C\uACF5 \uBC94\uC704",
      en: "Included scope",
      ja: "\u63D0\u4F9B\u7BC4\u56F2"
    }),
    included: groups.flatMap((g) => g.options.filter((o) => o.addonAmount === 0).map((o) => label(g.labels, o.key))),
    addons: groups.flatMap((g) => g.options.filter((o) => o.addonAmount > 0).map((o) => ({
      group: g.group,
      key: o.key,
      label: label(g.labels, o.key),
      amount: o.addonAmount
    }))),
    excluded: groups.flatMap((g) => g.all.filter((key) => !g.options.some((o) => o.key === key)).map((key) => label(g.labels, key))),
    addonHint: addonHint(scope, lang),
    monthly: RIGHT_TYPE_FORM_CONFIG[offer.rightType].duration
  };
}
__name(optionSet, "optionSet");
function recordingOf(scope, lang) {
  if (hasAppearancePackageRecordings(scope)) return {
    kind: "PACKAGES_PUBLIC",
    allowed: true,
    label: null
  };
  if (usesAppearanceSessionRecording(scope)) {
    const allowed = scope.recordingPolicy === AppearanceRecording.PUBLIC;
    if (scope.mode === "ONSITE") return {
      kind: "PACKAGES_ALL",
      allowed,
      label: null
    };
    return {
      kind: "FIXED",
      allowed,
      label: scope.mode === "AUDIO" ? tr(lang, {
        ko: "\uC628\uB77C\uC778 \uC74C\uC131 \uCD9C\uC5F0",
        en: "Online voice appearance",
        ja: "\u30AA\u30F3\u30E9\u30A4\u30F3\u97F3\u58F0\u51FA\u6F14"
      }) : tr(lang, {
        ko: "\uC628\uB77C\uC778 \uC601\uC0C1 \uCD9C\uC5F0",
        en: "Online video appearance",
        ja: "\u30AA\u30F3\u30E9\u30A4\u30F3\u52D5\u753B\u51FA\u6F14"
      })
    };
  }
  const activities = appearanceIncludedActivities(scope, lang).filter((item) => item.policy === AppearanceRecording.PUBLIC);
  return {
    kind: "FIXED",
    allowed: activities.length > 0,
    label: activities.map((item) => item.label).join(tr(lang, {
      ko: ", ",
      en: ", ",
      ja: "\u3001"
    }))
  };
}
__name(recordingOf, "recordingOf");
function offerPurchaseOptions(offer, lang = DEFAULT_LANG) {
  const scope = offer.usageScope;
  if (scope?.kind !== "APPEARANCE") return {
    options: optionSet(offer, scope, lang),
    appearance: []
  };
  const sessions = scope.variants ? scope.variants.map(appearanceVariantScope) : [
    scope
  ];
  return {
    options: null,
    appearance: sessions.map((session) => {
      return {
        mode: session.mode,
        options: optionSet(offer, session, lang),
        recording: recordingOf(session, lang)
      };
    })
  };
}
__name(offerPurchaseOptions, "offerPurchaseOptions");

// src/constants/business.ts
var BUSINESS = {
  /** 결제 대기 만료 시간 (시간 단위) — 무통장 미입금 자동 취소 기준 */
  PAYMENT_PENDING_EXPIRES_HOURS: 24,
  /** 약관 발행 후 오타 수정 허용 기간 (지나면 불변 — 개정은 새 버전) */
  POLICY_PUBLISHED_EDIT_WINDOW_DAYS: 7,
  /** 자동 구매확정 며칠 전에 구매자에게 알릴지 (구매확정 기한 자체는 어드민 결제 설정) */
  PURCHASE_CONFIRM_REMINDER_DAYS: 3,
  /** 라이선스 시작일을 오늘로부터 며칠 뒤까지 지정할 수 있는지 (판매자 발급 시) */
  LICENSE_START_MAX_DAYS_AHEAD: 90,
  /** 정산 회수 기한 (일) — 회수 요청 시각 + N일. 지나면 판매자 계정 접속 정지 */
  PAYOUT_CLAWBACK_DUE_DAYS: 14,
  /** 정산 회수 기한 며칠 전에 판매자에게 다시 알릴지 */
  PAYOUT_CLAWBACK_REMINDER_DAYS: 3,
  /** 로열티 지급일 며칠 전부터 매출 보고 리마인더를 보낼지 */
  ROYALTY_REPORT_REMINDER_DAYS: 3,
  /** 라이선스 만료 며칠 전에 구매자·판매자에게 알릴지 (긴 것부터, 단계마다 한 번) */
  LICENSE_EXPIRY_REMINDER_DAYS: [
    7,
    3
  ],
  /**
  * 탈퇴 회원 정보 보관 기간 (일) — 소프트 삭제 후 이 기간이 지나면 scheduler 가 개인정보를 지운다
  * (ANONYMIZE_WITHDRAWN_USERS). 개인정보 처리방침·수집 동의 원문의 "90일"과 같이 바꾼다
  */
  WITHDRAWN_USER_RETENTION_DAYS: 90,
  /** 거래·정산 기록과 라이선스 증서 보관 기간 (년) — 탈퇴해도 이 기간까지 보관 후 파기 (파기 작업은 아직 없음) */
  TRADE_RECORD_RETENTION_YEARS: 5
};

// src/types/license-draft-form.ts
var TARGET_RIGHTS = [
  IpRightType.FACE_PHOTO,
  IpRightType.CONTENT_SECONDARY,
  IpRightType.AI_VOICE
];
function specialTermsLabelOf(rightType, lang) {
  if (rightType === IpRightType.APPEARANCE) return tr(lang, {
    ko: "\uD655\uC815\uD55C \uCD9C\uC5F0 \uC870\uAC74",
    en: "Confirmed appearance terms",
    ja: "\u78BA\u5B9A\u3057\u305F\u51FA\u6F14\u6761\u4EF6"
  });
  if (rightType === IpRightType.CO_BRANDING) return tr(lang, {
    ko: "\uD655\uC815\uD55C \uACF5\uB3D9\uBE0C\uB79C\uB529 \uC870\uAC74",
    en: "Confirmed co-branding terms",
    ja: "\u78BA\u5B9A\u3057\u305F\u30B3\u30E9\u30DC\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u6761\u4EF6"
  });
  if (rightType === IpRightType.MERCHANDISE) return tr(lang, {
    ko: "\uD655\uC815\uD55C \uAD7F\uC988\xB7\uC81C\uC791\xB7\uD310\uB9E4 \uC870\uAC74",
    en: "Confirmed merchandise, production and sales terms",
    ja: "\u78BA\u5B9A\u3057\u305F\u30B0\u30C3\u30BA\u30FB\u5236\u4F5C\u30FB\u8CA9\u58F2\u6761\u4EF6"
  });
  return TARGET_RIGHTS.includes(rightType) ? tr(lang, {
    ko: "\uD655\uC815\uD55C \uB300\uC0C1\xB7\uC218\uB7C9\xB7\uC0AC\uC6A9 \uC870\uAC74",
    en: "Confirmed target, quantity and usage terms",
    ja: "\u78BA\u5B9A\u3057\u305F\u5BFE\u8C61\u30FB\u6570\u91CF\u30FB\u4F7F\u7528\u6761\u4EF6"
  }) : tr(lang, {
    ko: "\uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D",
    en: "Additional agreements",
    ja: "\u8FFD\u52A0\u306E\u5408\u610F\u4E8B\u9805"
  });
}
__name(specialTermsLabelOf, "specialTermsLabelOf");
var EXAMPLE_PREFIX = {
  ko: {
    match: /^예\)\s*/,
    replace: "\uC608: "
  },
  en: {
    match: /^e\.g\.\s*/,
    replace: "e.g. "
  },
  ja: {
    match: /^例[）)]\s*/,
    replace: "\u4F8B\uFF1A"
  }
};
function placeholdersOf(rightType, lang) {
  if (TARGET_RIGHTS.includes(rightType) || rightType === IpRightType.MERCHANDISE || rightType === IpRightType.CO_BRANDING) {
    const prefix = EXAMPLE_PREFIX[lang];
    return SPECIAL_TERMS_PLACEHOLDERS_I18N[lang][rightType].split("\n").filter((line) => prefix.match.test(line)).map((line) => line.replace(prefix.match, prefix.replace));
  }
  return [
    tr(lang, {
      ko: "\uD569\uC758\uD55C \uB0B4\uC6A9\uC744 \uD55C \uCE78\uC5D0 \uD558\uB098\uC529 \uC801\uC5B4 \uC8FC\uC138\uC694",
      en: "Write one agreed item per field",
      ja: "\u5408\u610F\u3057\u305F\u5185\u5BB9\u30921\u3064\u306E\u6B04\u306B1\u3064\u305A\u3064\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044"
    })
  ];
}
__name(placeholdersOf, "placeholdersOf");
var RIGHT_HINTS = {
  ko: {
    AI_VOICE: [
      "\uC0C8 \uC74C\uC131\uC744 \uC81C\uC791\uD55C\uB2E4\uBA74 \uCD5C\uC885 \uB300\uC0AC\xB7\uC74C\uC131 \uBD84\uB7C9\uACFC \uCD08\uC548 \uC804\uB2EC\uC77C\xB7\uC218\uC815 \uB0B4\uC6A9\uC744 \uD568\uAED8 \uAE30\uB85D\uD574 \uC8FC\uC138\uC694. \uAD6C\uB9E4\uC790\uAC00 AI \uC74C\uC131\uC744 \uC0DD\uC131\uD55C\uB2E4\uBA74 \uC0AC\uC6A9\uD560 \uBAA9\uC18C\uB9AC\xB7\uC11C\uBE44\uC2A4\xB7\uC811\uADFC \uC81C\uACF5 \uBC29\uBC95\uACFC \uC0DD\uC131 \uAC00\uB2A5 \uAE30\uAC04\uC744 \uAE30\uB85D\uD574 \uC8FC\uC138\uC694. \uC0AC\uC6A9 \uAE30\uAC04\uC740 \uACC4\uC57D\uC758 \uC0AC\uC6A9 \uC2DC\uC791\uC77C\uC744 \uAE30\uC900\uC73C\uB85C \uC801\uC6A9\uB3FC\uC694."
    ],
    APPEARANCE: [
      "\uCD9C\uC5F0 \uC77C\uC2DC\xB7\uC7A5\uC18C \uB610\uB294 \uC811\uC18D \uBC29\uBC95, \uC2E4\uC81C \uD65C\uB3D9\xB7\uAE30\uBCF8 \uC2DC\uAC04, \uAD50\uD1B5\xB7\uC219\uBC15\uBE44\uC640 \uC5F0\uC7A5 \uD569\uC758 \uB0B4\uC6A9\uC744 \uAE30\uB85D\uD574 \uC8FC\uC138\uC694. \uCD2C\uC601\uBB3C\uC740 \uAD6C\uB9E4\uD55C \uC0AC\uC6A9 \uC704\uCE58\uC640 \uCD9C\uC5F0\uC77C \uAE30\uC900 \uC0AC\uC6A9 \uAE30\uAC04 \uC548\uC5D0\uC11C \uC774\uC6A9\uD574\uC694. \uCD2C\uC601\xB7\uC6D0\uBCF8 \uC804\uB2EC\xB7\uD3B8\uC9D1 \uB2F4\uB2F9\uC790\uC640 \uC77C\uC815 \uBCC0\uACBD\xB7\uCDE8\uC18C \uC870\uAC74\uB3C4 \uD655\uC778\uD574 \uC8FC\uC138\uC694."
    ],
    CO_BRANDING: [
      "\uC2E4\uC81C \uC0C1\uB300 \uBE0C\uB79C\uB4DC\xB7\uCEA0\uD398\uC778\uBA85\xB7\uB450 \uBE0C\uB79C\uB4DC\uB97C \uD568\uAED8 \uD45C\uC2DC\uD560 \uBB38\uAD6C\xB7\uCD5C\uC885 \uC2DC\uC548\uC744 \uAD6C\uBD84\uD560 \uC218 \uC788\uAC8C \uAE30\uB85D\uD574 \uC8FC\uC138\uC694. \uC0AC\uC6A9 \uC704\uCE58\xB7\uAE30\uAC04\xB7\uCEA0\uD398\uC778 \uAC74\uC218\uC640 \uC885\uB8CC \uD6C4 \uCC98\uB9AC\uB294 \uAD6C\uB9E4\uD55C \uC870\uAC74 \uC548\uC5D0\uC11C \uD655\uC815\uD574\uC694. \uACF5\uC2DD \uD30C\uD2B8\uB108 \uD45C\uAE30\uB3C4 \uD574\uB2F9 \uCEA0\uD398\uC778\uACFC \uC774\uC6A9 \uAE30\uAC04\uC5D0\uB9CC \uC801\uC6A9\uB3FC\uC694."
    ],
    MERCHANDISE: [
      "\uC2E4\uC81C \uC0AC\uC6A9\uD560 \uC790\uB8CC\xB7\uCD5C\uC885 \uC2DC\uC548\xB7\uD488\uBAA9\uBCC4 \uC81C\uC791 \uC218\uB7C9\uACFC \uD310\uB9E4\xB7\uC99D\uC815 \uC218\uB7C9\uC744 \uAE30\uB85D\uD574 \uC8FC\uC138\uC694. \uC2B9\uC778\uC6A9 \uC0D8\uD50C\uB3C4 \uCD1D \uC81C\uC791 \uC218\uB7C9\uC5D0 \uD3EC\uD568\uD574\uC694. \uD310\uB9E4\xB7\uBC30\uD3EC \uACBD\uB85C\uC640 \uC794\uC5EC \uC7AC\uACE0 \uCC98\uB9AC \uBC29\uC2DD\uC740 \uAD6C\uB9E4\uD55C \uC870\uAC74 \uC548\uC5D0\uC11C \uD655\uC815\uD574\uC694. \uBE44\uB9E4\uD488 \uC804\uC6A9\uC740 \uD310\uB9E4\uD560 \uC218 \uC5C6\uC5B4\uC694. \uB85C\uC5F4\uD2F0\uAC00 \uC788\uB2E4\uBA74 \uD310\uB9E4\uBD84\uC758 \uC815\uC0B0 \uAE30\uC900\uB3C4 \uC801\uC5B4 \uC8FC\uC138\uC694."
    ]
  },
  en: {
    AI_VOICE: [
      "If you're producing new voice recordings, also record the final script and voice length, the draft delivery date, and revisions. If the buyer generates AI voice, record the voice to use, the service, how access is provided, and the generation period. The usage period runs from the contract's start date."
    ],
    APPEARANCE: [
      "Record the appearance date and time, place or how to join, the actual activities and base time, travel and lodging costs, and any extension agreement. Footage is used within the purchased placements and the usage period counted from the appearance date. Also confirm who handles filming, original file delivery and editing, and the terms for schedule changes and cancellations."
    ],
    CO_BRANDING: [
      "Record the actual partner brand, campaign name, the wording that shows both brands together, and the final mockup so each can be identified. Placements, period, number of campaigns, and what happens after the end are settled within the purchased terms. Official partner credits also apply only to that campaign and usage period."
    ],
    MERCHANDISE: [
      "Record the materials actually used, the final mockup, the production quantity per item, and the quantities for sale and giveaway. Approval samples count toward the total production quantity. Sales and distribution channels and how leftover stock is handled are settled within the purchased terms. Giveaway-only items can\u2019t be sold. If there\u2019s a royalty, also write the payout basis for units sold."
    ]
  },
  ja: {
    AI_VOICE: [
      "\u65B0\u3057\u304F\u97F3\u58F0\u3092\u5236\u4F5C\u3059\u308B\u5834\u5408\u306F\u3001\u6700\u7D42\u7684\u306A\u30BB\u30EA\u30D5\u30FB\u97F3\u58F0\u306E\u5206\u91CF\u3068\u3001\u521D\u7A3F\u306E\u7D0D\u54C1\u65E5\u30FB\u4FEE\u6B63\u5185\u5BB9\u3082\u3042\u308F\u305B\u3066\u8A18\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8CFC\u5165\u8005\u304CAI\u97F3\u58F0\u3092\u751F\u6210\u3059\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u3059\u308B\u58F0\u30FB\u30B5\u30FC\u30D3\u30B9\u30FB\u30A2\u30AF\u30BB\u30B9\u306E\u63D0\u4F9B\u65B9\u6CD5\u3068\u751F\u6210\u53EF\u80FD\u671F\u9593\u3092\u8A18\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F7F\u7528\u671F\u9593\u306F\u5951\u7D04\u306E\u4F7F\u7528\u958B\u59CB\u65E5\u3092\u57FA\u6E96\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002"
    ],
    APPEARANCE: [
      "\u51FA\u6F14\u65E5\u6642\u30FB\u5834\u6240\u307E\u305F\u306F\u63A5\u7D9A\u65B9\u6CD5\u3001\u5B9F\u969B\u306E\u6D3B\u52D5\u30FB\u57FA\u672C\u6642\u9593\u3001\u4EA4\u901A\u8CBB\u30FB\u5BBF\u6CCA\u8CBB\u3068\u5EF6\u9577\u306E\u5408\u610F\u5185\u5BB9\u3092\u8A18\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u64AE\u5F71\u7269\u306F\u8CFC\u5165\u3057\u305F\u4F7F\u7528\u5834\u6240\u3068\u3001\u51FA\u6F14\u65E5\u3092\u57FA\u6E96\u3068\u3057\u305F\u4F7F\u7528\u671F\u9593\u5185\u3067\u5229\u7528\u3057\u307E\u3059\u3002\u64AE\u5F71\u30FB\u5143\u30C7\u30FC\u30BF\u306E\u53D7\u3051\u6E21\u3057\u30FB\u7DE8\u96C6\u306E\u62C5\u5F53\u8005\u3068\u3001\u65E5\u7A0B\u5909\u66F4\u30FB\u30AD\u30E3\u30F3\u30BB\u30EB\u306E\u6761\u4EF6\u3082\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    ],
    CO_BRANDING: [
      "\u5B9F\u969B\u306E\u76F8\u624B\u30D6\u30E9\u30F3\u30C9\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u540D\u30FB\u4E21\u30D6\u30E9\u30F3\u30C9\u3092\u4F75\u8A18\u3059\u308B\u6587\u8A00\u30FB\u6700\u7D42\u6848\u3092\u533A\u5225\u3067\u304D\u308B\u3088\u3046\u306B\u8A18\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F7F\u7528\u5834\u6240\u30FB\u671F\u9593\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u4EF6\u6570\u3068\u7D42\u4E86\u5F8C\u306E\u6271\u3044\u306F\u3001\u8CFC\u5165\u3057\u305F\u6761\u4EF6\u306E\u7BC4\u56F2\u5185\u3067\u78BA\u5B9A\u3057\u307E\u3059\u3002\u516C\u5F0F\u30D1\u30FC\u30C8\u30CA\u30FC\u8868\u8A18\u3082\u3001\u305D\u306E\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u3068\u5229\u7528\u671F\u9593\u306B\u9650\u308A\u9069\u7528\u3055\u308C\u307E\u3059\u3002"
    ],
    MERCHANDISE: [
      "\u5B9F\u969B\u306B\u4F7F\u7528\u3059\u308B\u7D20\u6750\u30FB\u6700\u7D42\u6848\u30FB\u54C1\u76EE\u5225\u306E\u5236\u4F5C\u6570\u91CF\u3068\u8CA9\u58F2\u30FB\u914D\u5E03\u6570\u91CF\u3092\u8A18\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u627F\u8A8D\u7528\u30B5\u30F3\u30D7\u30EB\u3082\u7DCF\u5236\u4F5C\u6570\u91CF\u306B\u542B\u307F\u307E\u3059\u3002\u8CA9\u58F2\u30FB\u914D\u5E03\u7D4C\u8DEF\u3068\u6B8B\u308A\u5728\u5EAB\u306E\u6271\u3044\u306F\u3001\u8CFC\u5165\u3057\u305F\u6761\u4EF6\u306E\u7BC4\u56F2\u5185\u3067\u78BA\u5B9A\u3057\u307E\u3059\u3002\u975E\u58F2\u54C1\u5C02\u7528\u306F\u8CA9\u58F2\u3067\u304D\u307E\u305B\u3093\u3002\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u8CA9\u58F2\u5206\u306E\u7CBE\u7B97\u57FA\u6E96\u3082\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    ]
  }
};
var TARGET_HINT = {
  ko: "\uB300\uC0C1 \uD30C\uC77C\uBA85\xB7\uB300\uD654 \uC18D \uCCA8\uBD80\xB7\uAC8C\uC2DC\uBB3C \uC8FC\uC18C \uB4F1 \uAD6C\uBD84\uD560 \uC218 \uC788\uB294 \uC815\uBCF4\uB97C \uC801\uC5B4 \uC8FC\uC138\uC694. \uAE30\uBCF8 \uBD84\uB7C9\uC774\uB098 \uC0AC\uC6A9\uCC98\uAC00 \uBC14\uB00C\uBA74 \uBCC0\uACBD \uC804\xB7\uD6C4\uC640 \uCD94\uAC00\uAE08\uB3C4 \uD568\uAED8 \uAE30\uB85D\uD574\uC694. \uCD94\uAC00\uAE08 \uC785\uAE08\uB9CC\uC73C\uB85C \uC870\uAC74\uC774 \uC790\uB3D9 \uBCC0\uACBD\uB418\uC9C0\uB294 \uC54A\uC544\uC694.",
  en: "Write details that identify the target, such as the file name, an attachment in the chat, or the post URL. If the base quantity or placements change, also record the before and after and any add-on fee. Paying an add-on fee alone doesn\u2019t change the terms automatically.",
  ja: "\u5BFE\u8C61\u306E\u30D5\u30A1\u30A4\u30EB\u540D\u30FB\u30C1\u30E3\u30C3\u30C8\u5185\u306E\u6DFB\u4ED8\u30FB\u6295\u7A3F\u306EURL\u306A\u3069\u3001\u533A\u5225\u3067\u304D\u308B\u60C5\u5831\u3092\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u57FA\u672C\u306E\u5206\u91CF\u3084\u4F7F\u7528\u5148\u304C\u5909\u308F\u308B\u5834\u5408\u306F\u3001\u5909\u66F4\u524D\u5F8C\u3068\u8FFD\u52A0\u6599\u91D1\u3082\u3042\u308F\u305B\u3066\u8A18\u9332\u3057\u307E\u3059\u3002\u8FFD\u52A0\u6599\u91D1\u306E\u5165\u91D1\u3060\u3051\u3067\u6761\u4EF6\u304C\u81EA\u52D5\u7684\u306B\u5909\u308F\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
};
var COMMON_HINT = {
  ko: "\uC791\uC131\uD55C \uB0B4\uC6A9\uC740 \uCD5C\uC885 \uACC4\uC57D \uC870\uAC74\uC5D0 \uADF8\uB300\uB85C \uB2F4\uACA8\uC694.\n\uC798 \uBAA8\uB974\uACA0\uB2E4\uBA74 \uAC00\uC774\uB4DC\uC758 \uC608\uC2DC\uB97C \uCC38\uACE0\uD558\uACE0, \uACC4\uC57D \uC9C4\uD589\uC774 \uC5B4\uB824\uC6B0\uBA74 \uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uC5D0\uAC8C \uB3C4\uC6C0\uC744 \uC694\uCCAD\uD574 \uC8FC\uC138\uC694.",
  en: "What you write goes into the final contract terms as is.\nIf you\u2019re not sure, check the examples in the guide, and if the contract is hard to move forward, ask the Inflip team for help.",
  ja: "\u8A18\u5165\u3057\u305F\u5185\u5BB9\u306F\u3001\u305D\u306E\u307E\u307E\u6700\u7D42\u7684\u306A\u5951\u7D04\u6761\u4EF6\u306B\u542B\u307E\u308C\u307E\u3059\u3002\n\u308F\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u30AC\u30A4\u30C9\u306E\u4F8B\u3092\u53C2\u8003\u306B\u3057\u3001\u5951\u7D04\u3092\u9032\u3081\u308B\u306E\u304C\u96E3\u3057\u3044\u5834\u5408\u306FInflip\u904B\u55B6\u306B\u30B5\u30DD\u30FC\u30C8\u3092\u4F9D\u983C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
};
function licenseDraftFormOf(rightType, usageScope, lang = DEFAULT_LANG) {
  const appearance = rightType === IpRightType.APPEARANCE;
  const required = requiresIssueAgreement(usageScope);
  return {
    startLabel: appearance ? tr(lang, {
      ko: "\uACC4\uC57D \uC2DC\uC791\uC77C",
      en: "Contract start date",
      ja: "\u5951\u7D04\u958B\u59CB\u65E5"
    }) : tr(lang, {
      ko: "\uC0AC\uC6A9 \uC2DC\uC791\uC77C",
      en: "Start date",
      ja: "\u4F7F\u7528\u958B\u59CB\u65E5"
    }),
    startMaxDaysAhead: BUSINESS.LICENSE_START_MAX_DAYS_AHEAD,
    appearance,
    specialTermsLabel: specialTermsLabelOf(rightType, lang),
    required,
    placeholders: placeholdersOf(rightType, lang),
    guideTitle: IP_RIGHT_LABELS_I18N[lang][rightType],
    guidePreface: rightType === IpRightType.NAME_BRAND || TARGET_RIGHTS.includes(rightType) ? tr(lang, {
      ko: "\uD310\uB9E4\uC790 \uACC4\uC815\uC73C\uB85C \uAD11\uACE0\uB97C \uC9C4\uD589\uD558\uB294 \uACBD\uC6B0\uC5D0\uB294 \uC0AC\uC6A9\uD560 \uACC4\uC815\uACFC \uD310\uB9E4\uC790\uAC00 \uC9C4\uD589\uD560 \uC2B9\uC778 \uC808\uCC28\uB97C \uB300\uD654\uB85C \uD655\uC778\uD558\uACE0, \uD569\uC758\uD55C \uB0B4\uC6A9\uC744 \uAE30\uB85D\uD574 \uC8FC\uC138\uC694.",
      en: "If ads will run from the seller\u2019s accounts, confirm in chat which account will be used and the approval steps the seller will take, then record what you agreed.",
      ja: "\u8CA9\u58F2\u8005\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u5E83\u544A\u3092\u884C\u3046\u5834\u5408\u306F\u3001\u4F7F\u7528\u3059\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u3068\u8CA9\u58F2\u8005\u304C\u884C\u3046\u627F\u8A8D\u624B\u9806\u3092\u30C1\u30E3\u30C3\u30C8\u3067\u78BA\u8A8D\u3057\u3001\u5408\u610F\u3057\u305F\u5185\u5BB9\u3092\u8A18\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }) : null,
    // 이 주문에서 파는 권리의 예시만 — 첫 줄(공통 안내)은 뺀다
    guideBody: SPECIAL_TERMS_PLACEHOLDERS_I18N[lang][rightType].split("\n").slice(1).join("\n"),
    hints: [
      ...TARGET_RIGHTS.includes(rightType) ? [
        TARGET_HINT[lang]
      ] : [],
      ...RIGHT_HINTS[lang][rightType] ?? [],
      COMMON_HINT[lang]
    ],
    missingHint: appearance ? tr(lang, {
      ko: "\uB300\uD654\uB85C \uD655\uC815\uD55C \uCD9C\uC5F0 \uC77C\uC2DC\xB7\uC7A5\uC18C\xB7\uD65C\uB3D9\xB7\uC2DC\uAC04\uACFC \uCD2C\uC601\uBB3C \uC0AC\uC6A9 \uC870\uAC74\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.",
      en: "Write the appearance date and time, place, activities, duration, and footage usage terms you settled on in chat.",
      ja: "\u4F1A\u8A71\u3067\u78BA\u5B9A\u3057\u305F\u51FA\u6F14\u65E5\u6642\u30FB\u5834\u6240\u30FB\u6D3B\u52D5\u30FB\u6642\u9593\u3068\u64AE\u5F71\u7269\u306E\u4F7F\u7528\u6761\u4EF6\u3092\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }) : tr(lang, {
      ko: "\uB300\uD654\uB85C \uC815\uD55C \uB300\uC0C1\xB7\uCD5C\uC885 \uC218\uB7C9\xB7\uC0AC\uC6A9 \uC870\uAC74\uC744 \uC801\uC5B4 \uC8FC\uC138\uC694.",
      en: "Write the target, final quantity, and usage terms you settled on in chat.",
      ja: "\u4F1A\u8A71\u3067\u6C7A\u3081\u305F\u5BFE\u8C61\u30FB\u6700\u7D42\u6570\u91CF\u30FB\u4F7F\u7528\u6761\u4EF6\u3092\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    })
  };
}
__name(licenseDraftFormOf, "licenseDraftFormOf");

// src/constants/pagination.ts
var PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100
};

// src/constants/phone.ts
var TRUNK_ZERO_COUNTRY_CODES = /* @__PURE__ */ new Set([
  "+82",
  "+81",
  "+886",
  "+66",
  "+84",
  "+44",
  "+33",
  "+49"
]);
function normalizePhoneNumber(countryCode, raw) {
  const digits = raw.replace(/\D/g, "");
  if (TRUNK_ZERO_COUNTRY_CODES.has(countryCode) && digits.startsWith("0")) {
    return digits.slice(1);
  }
  return digits;
}
__name(normalizePhoneNumber, "normalizePhoneNumber");
function formatPhoneNumberLocal(countryCode, normalized) {
  if (TRUNK_ZERO_COUNTRY_CODES.has(countryCode)) return `0${normalized}`;
  return normalized;
}
__name(formatPhoneNumberLocal, "formatPhoneNumberLocal");
var PHONE_COUNTRY_CODES = [
  {
    code: "+82",
    label: "\u{1F1F0}\u{1F1F7} +82"
  },
  {
    code: "+1",
    label: "\u{1F1FA}\u{1F1F8} +1"
  },
  {
    code: "+81",
    label: "\u{1F1EF}\u{1F1F5} +81"
  },
  {
    code: "+86",
    label: "\u{1F1E8}\u{1F1F3} +86"
  },
  {
    code: "+886",
    label: "\u{1F1F9}\u{1F1FC} +886"
  },
  {
    code: "+65",
    label: "\u{1F1F8}\u{1F1EC} +65"
  },
  {
    code: "+66",
    label: "\u{1F1F9}\u{1F1ED} +66"
  },
  {
    code: "+84",
    label: "\u{1F1FB}\u{1F1F3} +84"
  }
];

// src/constants/nickname.ts
var NICKNAME_PATTERN = /^[\p{L}\p{N}]+$/u;
var NICKNAME_RULE_MESSAGE = "\uB2C9\uB124\uC784\uC740 \uACF5\uBC31\xB7\uD2B9\uC218\uBB38\uC790 \uC5C6\uC774 \uBB38\uC790\uC640 \uC22B\uC790\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694";
var NICKNAME_RULE_MESSAGE_I18N = {
  ko: NICKNAME_RULE_MESSAGE,
  en: "Nicknames can only use letters and numbers, with no spaces or special characters",
  ja: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0\u306B\u306F\u30B9\u30DA\u30FC\u30B9\u3084\u8A18\u53F7\u3092\u4F7F\u308F\u305A\u3001\u6587\u5B57\u3068\u6570\u5B57\u306E\u307F\u4F7F\u7528\u3067\u304D\u307E\u3059"
};
function sanitizeNickname(raw) {
  return raw.replace(/[^\p{L}\p{N}]/gu, "");
}
__name(sanitizeNickname, "sanitizeNickname");
var WITHDRAWN_LABEL = {
  ko: "\uD0C8\uD1F4\uD55C \uD68C\uC6D0",
  en: "Deleted account",
  ja: "\u9000\u4F1A\u3057\u305F\u4F1A\u54E1"
};
function memberDisplayName(user, lang) {
  if (!user.deletedAt) return user.name;
  const label = tr(lang, WITHDRAWN_LABEL);
  return user.anonymizedAt ? label : `${user.name}(${label})`;
}
__name(memberDisplayName, "memberDisplayName");

// src/constants/depositor-name.ts
var DEPOSITOR_NAME_MAX_LENGTH = 20;
function defaultDepositorName(nickname2) {
  return nickname2.trim().slice(0, DEPOSITOR_NAME_MAX_LENGTH);
}
__name(defaultDepositorName, "defaultDepositorName");

// src/constants/banks.ts
var PAYOUT_BANKS = [
  "\uAD6D\uBBFC\uC740\uD589",
  "\uC2E0\uD55C\uC740\uD589",
  "\uC6B0\uB9AC\uC740\uD589",
  "\uD558\uB098\uC740\uD589",
  "NH\uB18D\uD611\uC740\uD589",
  "IBK\uAE30\uC5C5\uC740\uD589",
  "\uCE74\uCE74\uC624\uBC45\uD06C",
  "\uD1A0\uC2A4\uBC45\uD06C",
  "\uCF00\uC774\uBC45\uD06C",
  "SC\uC81C\uC77C\uC740\uD589",
  "\uD55C\uAD6D\uC528\uD2F0\uC740\uD589",
  "KDB\uC0B0\uC5C5\uC740\uD589",
  "Sh\uC218\uD611\uC740\uD589",
  "\uBD80\uC0B0\uC740\uD589",
  "\uACBD\uB0A8\uC740\uD589",
  "iM\uBC45\uD06C(\uB300\uAD6C\uC740\uD589)",
  "\uAD11\uC8FC\uC740\uD589",
  "\uC804\uBD81\uC740\uD589",
  "\uC81C\uC8FC\uC740\uD589",
  "\uC6B0\uCCB4\uAD6D",
  "\uC0C8\uB9C8\uC744\uAE08\uACE0",
  "\uC2E0\uD611",
  "\uC9C0\uC5ED\uB18D\xB7\uCD95\uD611",
  "\uC800\uCD95\uC740\uD589"
];

// src/constants/simple-pin.ts
var SIMPLE_PIN_LENGTH = 6;
var SIMPLE_PIN_PATTERN = /^\d{6}$/;
var SIMPLE_PIN_MAX_ATTEMPTS = 5;
var SIMPLE_PIN_LOCK_MINUTES = 30;
function isTooSimplePin(pin) {
  if (!SIMPLE_PIN_PATTERN.test(pin)) return false;
  const digits = [
    ...pin
  ].map(Number);
  const steps = digits.slice(1).map((d, i) => d - digits[i]);
  return steps.every((s) => s === 0) || steps.every((s) => s === 1) || steps.every((s) => s === -1);
}
__name(isTooSimplePin, "isTooSimplePin");

// src/constants/schedule.ts
var SCHEDULES = {
  /** 입금 기한이 지난 무통장 주문 자동 취소 */
  EXPIRE_PAYMENTS: {
    title: "\uC785\uAE08 \uAE30\uD55C \uC9C0\uB09C \uC8FC\uBB38 \uCDE8\uC18C",
    cron: "*/5 * * * *",
    label: "5\uBD84\uB9C8\uB2E4"
  },
  /** 구매확정 기한이 지난 주문 자동 확정 + 확정된 주문 정산 생성 */
  CONFIRM_PURCHASES_AND_SETTLE: {
    title: "\uC790\uB3D9 \uAD6C\uB9E4\uD655\uC815\xB7\uC815\uC0B0 \uC0DD\uC131",
    cron: "0 * * * *",
    label: "\uB9E4\uC2DC \uC815\uAC01"
  },
  /** 자동 구매확정 예정 알림 */
  PURCHASE_CONFIRM_REMINDERS: {
    title: "\uC790\uB3D9 \uAD6C\uB9E4\uD655\uC815 \uC608\uC815 \uC54C\uB9BC",
    cron: "0 10 * * *",
    label: "\uB9E4\uC77C 10:00"
  },
  /** 계약 기간이 끝난 라이선스 만료 처리 */
  EXPIRE_LICENSES: {
    title: "\uAE30\uAC04 \uB05D\uB09C \uB77C\uC774\uC120\uC2A4 \uB9CC\uB8CC",
    cron: "0 0 * * *",
    label: "\uB9E4\uC77C 00:00"
  },
  /** 라이선스 만료 임박 알림 (만료 7일·3일 전) */
  LICENSE_EXPIRY_REMINDERS: {
    title: "\uB77C\uC774\uC120\uC2A4 \uB9CC\uB8CC \uC784\uBC15 \uC54C\uB9BC",
    cron: "0 10 * * *",
    label: "\uB9E4\uC77C 10:00"
  },
  /** 로열티 매출 보고 리마인더·연체 알림 */
  ROYALTY_REPORT_REMINDERS: {
    title: "\uB85C\uC5F4\uD2F0 \uBCF4\uACE0 \uB9AC\uB9C8\uC778\uB354\xB7\uC5F0\uCCB4 \uC54C\uB9BC",
    cron: "0 10 * * *",
    label: "\uB9E4\uC77C 10:00"
  },
  /** 정산 회수 기한 경과 처리(접속 정지) + 기한 임박 알림 */
  PAYOUT_CLAWBACK_DUE: {
    title: "\uC815\uC0B0 \uD68C\uC218 \uAE30\uD55C \uCC98\uB9AC",
    cron: "15 * * * *",
    label: "\uB9E4\uC2DC 15\uBD84"
  },
  /** 응답 기한이 지난 조건 협의 만료 */
  EXPIRE_PROPOSALS: {
    title: "\uC751\uB2F5 \uAE30\uD55C \uC9C0\uB09C \uD611\uC758 \uB9CC\uB8CC",
    cron: "30 * * * *",
    label: "\uB9E4\uC2DC 30\uBD84"
  },
  /** 방문 예정일이 지나도록 확정되지 않은 협찬 지원 자동 취소 */
  EXPIRE_SPONSORSHIP_APPLICATIONS: {
    title: "\uBBF8\uD655\uC815 \uD611\uCC2C \uC9C0\uC6D0 \uC790\uB3D9 \uCDE8\uC18C",
    cron: "45 * * * *",
    label: "\uB9E4\uC2DC 45\uBD84"
  },
  /** 발급 지연 안내 — 입금 확인 뒤 기준 일수가 지난 발급 전 주문의 판매자에게 (UTC 기준) */
  LICENSE_ISSUE_DELAY_REMINDERS: {
    title: "\uBC1C\uAE09 \uC9C0\uC5F0 \uC548\uB0B4",
    cron: "0 9 * * *",
    timeZone: "UTC",
    label: "UTC 09:00(\uD55C\uAD6D 18:00)"
  },
  /** 탈퇴 후 보관 기간(BUSINESS.WITHDRAWN_USER_RETENTION_DAYS)이 지난 회원의 개인정보 익명화 */
  ANONYMIZE_WITHDRAWN_USERS: {
    title: "\uD0C8\uD1F4 \uD68C\uC6D0 \uC815\uBCF4 \uC775\uBA85\uD654",
    cron: "30 3 * * *",
    label: "\uB9E4\uC77C 03:30"
  },
  /** 만료·폐기된 지 30일 지난 로그인 세션 행 삭제 (UTC 기준 — 서버 기본 시간대로 돌던 시각 그대로) */
  CLEANUP_SESSIONS: {
    title: "\uC624\uB798\uB41C \uB85C\uADF8\uC778 \uC138\uC158 \uC815\uB9AC",
    cron: "0 4 * * *",
    timeZone: "UTC",
    label: "UTC 04:00(\uD55C\uAD6D 13:00)"
  }
};
var SCHEDULER_JOB_KEYS = Object.keys(SCHEDULES);
var HOUR_MS = 36e5;
function alignPurchaseConfirmDue(at) {
  return new Date(Math.ceil(at.getTime() / HOUR_MS) * HOUR_MS);
}
__name(alignPurchaseConfirmDue, "alignPurchaseConfirmDue");

// src/constants/royalty-period.ts
var ROYALTY_REPORTABLE_ORDER_STATUSES = [
  OrderStatus.PAID,
  OrderStatus.LICENSE_ISSUED,
  OrderStatus.SETTLEMENT_PENDING,
  OrderStatus.PAYOUT_COMPLETED,
  // 해지 뒤에도 해지일이 있는 달까지는 보고한다 (기간 검사가 그 뒤 달을 막는다)
  OrderStatus.TERMINATED
];
function addPeriodMonths(period, months) {
  const [y = 0, m = 1] = period.split("-").map(Number);
  const total = y * 12 + (m - 1) + months;
  return `${Math.floor(total / 12)}-${String(total % 12 + 1).padStart(2, "0")}`;
}
__name(addPeriodMonths, "addPeriodMonths");
function lastDayOf(period) {
  const [y = 0, m = 1] = period.split("-").map(Number);
  return `${period}-${String(new Date(Date.UTC(y, m, 0)).getUTCDate()).padStart(2, "0")}`;
}
__name(lastDayOf, "lastDayOf");
function royaltyPeriodRange(contractStartsAt, contractExpiresAt, timeZone, now = /* @__PURE__ */ new Date(), terminatedAt = null) {
  const expiryEnd = contractExpiresAt ? addDateDays(zonedDateOf(contractExpiresAt, timeZone), -1) : null;
  const terminationEnd = terminatedAt ? zonedDateOf(terminatedAt, timeZone) : null;
  const contractEnd = expiryEnd && terminationEnd ? expiryEnd < terminationEnd ? expiryEnd : terminationEnd : expiryEnd ?? terminationEnd;
  return {
    first: zonedPeriodOf(contractStartsAt, timeZone),
    last: contractEnd ? contractEnd.slice(0, 7) : null,
    lastClosed: addPeriodMonths(zonedPeriodOf(now, timeZone), -1),
    contractStart: zonedDateOf(contractStartsAt, timeZone),
    contractEnd
  };
}
__name(royaltyPeriodRange, "royaltyPeriodRange");
function royaltyRangeOf(contract, now = /* @__PURE__ */ new Date()) {
  if (!contract.licenseStartsAt) return null;
  return royaltyPeriodRange(new Date(contract.licenseStartsAt), contract.licenseExpiresAt ? new Date(contract.licenseExpiresAt) : null, contract.timeZone, now, contract.terminatedAt ? new Date(contract.terminatedAt) : null);
}
__name(royaltyRangeOf, "royaltyRangeOf");
function royaltyPeriodWindow(period, range) {
  const monthStart = `${period}-01`;
  const monthEnd = lastDayOf(period);
  const from = period === range.first && range.contractStart > monthStart ? range.contractStart : monthStart;
  const to = range.contractEnd && period === range.last && range.contractEnd < monthEnd ? range.contractEnd : monthEnd;
  return {
    from,
    to,
    partial: from !== monthStart || to !== monthEnd
  };
}
__name(royaltyPeriodWindow, "royaltyPeriodWindow");
function reportableRoyaltyPeriods(range) {
  const end = range.last && range.last < range.lastClosed ? range.last : range.lastClosed;
  const periods = [];
  for (let p = range.first; p <= end; p = addPeriodMonths(p, 1)) periods.push(p);
  return periods;
}
__name(reportableRoyaltyPeriods, "reportableRoyaltyPeriods");
function periodLabel(p, lang) {
  if (lang === "ko") return `${p.slice(0, 4)}\uB144 ${Number(p.slice(5, 7))}\uC6D4`;
  return new Intl.DateTimeFormat(INTL_LOCALE[lang], {
    year: "numeric",
    month: "long",
    timeZone: "UTC"
  }).format(/* @__PURE__ */ new Date(`${p}-01T00:00:00Z`));
}
__name(periodLabel, "periodLabel");
function dayLabel(d, lang) {
  if (lang === "ko") return `${d.slice(0, 4)}\uB144 ${Number(d.slice(5, 7))}\uC6D4 ${Number(d.slice(8))}\uC77C`;
  return new Intl.DateTimeFormat(INTL_LOCALE[lang], {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC"
  }).format(/* @__PURE__ */ new Date(`${d}T00:00:00Z`));
}
__name(dayLabel, "dayLabel");
function royaltyPeriodError(period, range, lang = DEFAULT_LANG) {
  const label = /* @__PURE__ */ __name((p) => periodLabel(p, lang), "label");
  const day = /* @__PURE__ */ __name((d) => dayLabel(d, lang), "day");
  if (period < range.first) {
    return tr(lang, {
      ko: `\uACC4\uC57D\uC774 ${day(range.contractStart)}\uC5D0 \uC2DC\uC791\uD574\uC11C ${label(period)}\uC740 \uBCF4\uACE0\uD560 \uC218 \uC5C6\uC5B4\uC694. ${label(range.first)}\uBD80\uD130 \uBCF4\uACE0\uD574 \uC8FC\uC138\uC694.`,
      en: `The contract started on ${day(range.contractStart)}, so you can't report ${label(period)}. Please report from ${label(range.first)}.`,
      ja: `\u5951\u7D04\u306F${day(range.contractStart)}\u306B\u59CB\u307E\u3063\u305F\u305F\u3081\u3001${label(period)}\u306F\u5831\u544A\u3067\u304D\u307E\u305B\u3093\u3002${label(range.first)}\u304B\u3089\u5831\u544A\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    });
  }
  if (range.last && period > range.last) {
    return tr(lang, {
      ko: `\uACC4\uC57D\uC774 ${day(range.contractEnd)}\uC5D0 \uB05D\uB098\uC11C ${label(period)}\uC740 \uBCF4\uACE0\uD560 \uC218 \uC5C6\uC5B4\uC694.`,
      en: `The contract ended on ${day(range.contractEnd)}, so you can't report ${label(period)}.`,
      ja: `\u5951\u7D04\u306F${day(range.contractEnd)}\u306B\u7D42\u4E86\u3057\u305F\u305F\u3081\u3001${label(period)}\u306F\u5831\u544A\u3067\u304D\u307E\u305B\u3093\u3002`
    });
  }
  if (period > range.lastClosed) {
    return tr(lang, {
      ko: `${label(period)}\uC740 \uC544\uC9C1 \uB05D\uB098\uC9C0 \uC54A\uC740 \uB2EC\uC774\uB77C \uBCF4\uACE0\uD560 \uC218 \uC5C6\uC5B4\uC694. \uB2EC\uC774 \uB05D\uB09C \uB4A4 \uBCF4\uACE0\uD574 \uC8FC\uC138\uC694.`,
      en: `${label(period)} hasn't ended yet, so you can't report it. Please report after the month ends.`,
      ja: `${label(period)}\u306F\u307E\u3060\u7D42\u308F\u3063\u3066\u3044\u306A\u3044\u305F\u3081\u5831\u544A\u3067\u304D\u307E\u305B\u3093\u3002\u6708\u304C\u7D42\u308F\u3063\u3066\u304B\u3089\u5831\u544A\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    });
  }
  return null;
}
__name(royaltyPeriodError, "royaltyPeriodError");
function royaltyDueDate(period, paymentDay) {
  return `${addPeriodMonths(period, 1)}-${String(paymentDay).padStart(2, "0")}`;
}
__name(royaltyDueDate, "royaltyDueDate");
function isRoyaltyReportOverdue(period, paymentDay, timeZone, now = /* @__PURE__ */ new Date()) {
  const nextDay = addDateDays(royaltyDueDate(period, paymentDay), 1);
  return now.getTime() >= startOfZonedDate(nextDay, timeZone).getTime();
}
__name(isRoyaltyReportOverdue, "isRoyaltyReportOverdue");

// src/constants/license-period.ts
function addContractMonths(start, months, timeZone) {
  const p = zonedParts(start, timeZone);
  const ms = start.getTime() % 1e3;
  const m = p.month + months;
  const daysInTarget = new Date(Date.UTC(p.year, m, 0)).getUTCDate();
  return p.day > daysInTarget ? zonedTimeToUtc(timeZone, p.year, m + 1, 1, p.hour, p.minute, p.second, ms) : zonedTimeToUtc(timeZone, p.year, m, p.day, p.hour, p.minute, p.second, ms);
}
__name(addContractMonths, "addContractMonths");
function lastUseDateOf(expiresAt, timeZone) {
  return addDateDays(zonedDateOf(expiresAt, timeZone), -1);
}
__name(lastUseDateOf, "lastUseDateOf");

// src/constants/note-items.ts
var MAX_NOTE_ITEMS = 20;
var MAX_NOTE_ITEM_LENGTH = 500;
var LEADING_MARK = /^(?:\d{1,2}[.)]\s+|\(\d{1,2}\)\s*|[가나다라마바사아자차카타파하][.)]\s+|[-•·*]\s+)/;
function noteItemsOf(text) {
  if (!text) return [];
  return text.split(/\r?\n/).map((line) => line.trim().replace(LEADING_MARK, "").trim()).filter(Boolean);
}
__name(noteItemsOf, "noteItemsOf");
function joinNoteItems(items) {
  return noteItemsOf(items.join("\n")).join("\n");
}
__name(joinNoteItems, "joinNoteItems");
function numberedNoteText(text) {
  return noteItemsOf(text).map((item, i) => `${i + 1}. ${item}`).join("\n");
}
__name(numberedNoteText, "numberedNoteText");

// src/constants/license-issue-delay.ts
var DAY_MS2 = 24 * 36e5;
function licenseIssueDelayedDays(paidAt, delayDays, now = /* @__PURE__ */ new Date()) {
  if (!paidAt) return null;
  const elapsed = now.getTime() - new Date(paidAt).getTime();
  if (elapsed < delayDays * DAY_MS2) return null;
  return Math.floor(elapsed / DAY_MS2);
}
__name(licenseIssueDelayedDays, "licenseIssueDelayedDays");
function licenseIssueDelayCutoff(delayDays, now = /* @__PURE__ */ new Date()) {
  return new Date(now.getTime() - delayDays * DAY_MS2);
}
__name(licenseIssueDelayCutoff, "licenseIssueDelayCutoff");

// src/constants/social-channel-key.ts
function manualChannelKey(platform, rawUrl) {
  const url = parseLoose(rawUrl);
  if (!url) return null;
  const host = url.hostname.toLowerCase().replace(/\.$/, "");
  if (!CHANNEL_HOSTS[platform].some((base) => host === base || host.endsWith(`.${base}`))) {
    return null;
  }
  const segments = url.pathname.split("/").map((segment) => safeDecode(segment).trim().toLowerCase()).filter(Boolean);
  const id = CHANNEL_ID[platform](segments);
  return id && ID_PATTERN[platform].test(id) ? id : null;
}
__name(manualChannelKey, "manualChannelKey");
var MANUAL_CHANNEL_URL_HINT = {
  THREADS: "\uC2A4\uB808\uB4DC \uD504\uB85C\uD544 \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694. \uC608) https://www.threads.com/@\uC544\uC774\uB514",
  SOOP: "SOOP \uBC29\uC1A1\uAD6D \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694. \uC608) https://www.sooplive.co.kr/station/\uC544\uC774\uB514",
  PANDATV: "\uD32C\uB354TV \uCC44\uB110 \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694. \uC608) https://www.pandalive.co.kr/channel/\uC544\uC774\uB514"
};
var MANUAL_CHANNEL_URL_HINT_I18N = {
  ko: MANUAL_CHANNEL_URL_HINT,
  en: {
    THREADS: "Please enter your Threads profile URL. e.g. https://www.threads.com/@your-id",
    SOOP: "Please enter your SOOP station URL. e.g. https://www.sooplive.co.kr/station/your-id",
    PANDATV: "Please enter your PandaTV channel URL. e.g. https://www.pandalive.co.kr/channel/your-id"
  },
  ja: {
    THREADS: "Threads\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EBURL\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\uFF09https://www.threads.com/@ID",
    SOOP: "SOOP\u306E\u653E\u9001\u5C40URL\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\uFF09https://www.sooplive.co.kr/station/ID",
    PANDATV: "PandaTV\u306E\u30C1\u30E3\u30F3\u30CD\u30EBURL\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\uFF09https://www.pandalive.co.kr/channel/ID"
  }
};
var CHANNEL_HOSTS = {
  THREADS: [
    "threads.com",
    "threads.net"
  ],
  SOOP: [
    "sooplive.co.kr",
    "sooplive.com",
    "afreecatv.com"
  ],
  PANDATV: [
    "pandalive.co.kr"
  ]
};
var ID_PATTERN = {
  THREADS: /^[a-z0-9._]{1,30}$/,
  SOOP: /^[a-z0-9_]{2,40}$/,
  PANDATV: /^[a-z0-9_.-]{1,40}$/
};
var SOOP_RESERVED = /* @__PURE__ */ new Set([
  "directory",
  "search",
  "live",
  "player",
  "vod",
  "station",
  "my",
  "post"
]);
var CHANNEL_ID = {
  // threads.com/@아이디, threads.com/@아이디/post/… — 프로필 경로는 늘 @ 로 시작한다
  THREADS: /* @__PURE__ */ __name(([first]) => first?.startsWith("@") ? first.slice(1) : null, "THREADS"),
  // ch.sooplive.co.kr/아이디, play.sooplive.co.kr/아이디/방송번호, bj.afreecatv.com/아이디,
  // www.sooplive.co.kr/station/아이디
  SOOP: /* @__PURE__ */ __name((segments) => {
    const id = segments[0] === "station" ? segments[1] : segments[0];
    return id && !SOOP_RESERVED.has(id) ? id : null;
  }, "SOOP"),
  // pandalive.co.kr/channel/아이디, /play/아이디, /live/play/아이디
  PANDATV: /* @__PURE__ */ __name((segments) => {
    const at = segments.findIndex((segment) => segment === "channel" || segment === "play");
    return at >= 0 ? segments[at + 1] ?? null : null;
  }, "PANDATV")
};
function parseLoose(raw) {
  const cleaned = raw.replace(/[\s\u200B-\u200D\u2060\uFEFF]/g, "");
  if (!cleaned) return null;
  try {
    const url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(cleaned) ? cleaned : `https://${cleaned}`);
    return url.protocol === "http:" || url.protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}
__name(parseLoose, "parseLoose");
function safeDecode(segment) {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
__name(safeDecode, "safeDecode");

// src/constants/offer-edit-policy.ts
function durations(o) {
  return [
    ...o.durationOptions ?? []
  ].sort((a, b) => a.months - b.months);
}
__name(durations, "durations");
function priceOf(o) {
  return {
    fixed: durations(o).map((d) => [
      d.months,
      d.fixedAmount ?? null
    ]),
    royaltyRateBp: o.royaltyRateBp ?? null,
    royaltyPaymentDay: o.royaltyPaymentDay ?? null
  };
}
__name(priceOf, "priceOf");
function termsOf(o) {
  return {
    months: durations(o).map((d) => d.months),
    pricingModel: o.pricingModel ?? null,
    region: o.region ?? null,
    exclusivity: o.exclusivity ?? null,
    modificationRights: o.modificationRights ?? [],
    requiresPreApproval: o.requiresPreApproval ?? false,
    forbiddenIndustries: o.forbiddenIndustries ?? [],
    violationPolicies: o.violationPolicies ?? [],
    brandScope: o.brandScope ?? null,
    usageScope: o.usageScope ?? null
  };
}
__name(termsOf, "termsOf");
function stable(value) {
  const normalize = /* @__PURE__ */ __name((v) => {
    if (Array.isArray(v)) {
      const items = v.map(normalize);
      return items.every((item) => typeof item === "string") ? [
        ...items
      ].sort() : items;
    }
    if (v && typeof v === "object") {
      return Object.fromEntries(Object.entries(v).filter(([, inner]) => inner !== void 0).sort(([a], [b]) => a.localeCompare(b)).map(([key, inner]) => [
        key,
        normalize(inner)
      ]));
    }
    return v;
  }, "normalize");
  return JSON.stringify(normalize(value));
}
__name(stable, "stable");
function classifyOfferChange(previous, next) {
  if (stable(termsOf(previous)) !== stable(termsOf(next))) return "terms";
  if (stable(priceOf(previous)) !== stable(priceOf(next))) return "price";
  return "none";
}
__name(classifyOfferChange, "classifyOfferChange");

// src/constants/sponsorship-labels.ts
function followerUnit(platform, lang = DEFAULT_LANG) {
  return platform === "YOUTUBE" ? tr(lang, {
    ko: "\uAD6C\uB3C5\uC790",
    en: "subscribers",
    ja: "\u767B\u9332\u8005"
  }) : tr(lang, {
    ko: "\uD314\uB85C\uC6CC",
    en: "followers",
    ja: "\u30D5\u30A9\u30ED\u30EF\u30FC"
  });
}
__name(followerUnit, "followerUnit");
function formatFollowers(count, lang = DEFAULT_LANG) {
  if (count < 1e4) return count.toLocaleString(INTL_LOCALE[lang]);
  if (lang !== "ko") return new Intl.NumberFormat(INTL_LOCALE[lang], {
    notation: "compact",
    maximumFractionDigits: 1
  }).format(count);
  if (count >= 1e8) {
    const eok = Math.round(count / 1e7) / 10;
    return `${eok.toLocaleString("ko-KR")}\uC5B5`;
  }
  const man = Math.round(count / 1e3) / 10;
  return `${man.toLocaleString("ko-KR")}\uB9CC`;
}
__name(formatFollowers, "formatFollowers");
function atLeast(platform, min, lang) {
  const label = SOCIAL_PLATFORM_LABELS_I18N[lang][platform];
  const unit = followerUnit(platform, lang);
  const count = formatFollowers(min, lang);
  return tr(lang, {
    ko: `${label} ${unit} ${count} \uC774\uC0C1`,
    en: `${label} ${count}+ ${unit}`,
    ja: `${label}${unit}${count}\u4EE5\u4E0A`
  });
}
__name(atLeast, "atLeast");
function sponsorshipRequirementLabels(requirements, lang = DEFAULT_LANG) {
  return SPONSORSHIP_ELIGIBILITY_PLATFORMS.flatMap((platform) => {
    const min = requirements[platform];
    return min ? [
      atLeast(platform, min, lang)
    ] : [];
  });
}
__name(sponsorshipRequirementLabels, "sponsorshipRequirementLabels");
function sponsorshipViewConditions(minFollowers, lang = DEFAULT_LANG) {
  return SPONSORSHIP_ELIGIBILITY_PLATFORMS.flatMap((platform) => {
    const min = minFollowers[platform];
    if (min === void 0) return [];
    const label = SOCIAL_PLATFORM_LABELS_I18N[lang][platform];
    return [
      min > 0 ? atLeast(platform, min, lang) : tr(lang, {
        ko: `${label} \uC778\uC99D`,
        en: `${label} verified`,
        ja: `${label}\u8A8D\u8A3C`
      })
    ];
  });
}
__name(sponsorshipViewConditions, "sponsorshipViewConditions");

// src/constants/community-labels.ts
function communityActivityConditions(minFollowers, lang = DEFAULT_LANG) {
  const values = [
    ...new Set(Object.values(minFollowers))
  ];
  if (values.length !== 1) return sponsorshipViewConditions(minFollowers, lang);
  const min = values[0];
  if (min === 0) return [
    tr(lang, {
      ko: "SNS \uCC44\uB110 \uC778\uC99D",
      en: "Any verified social channel",
      ja: "SNS\u30C1\u30E3\u30F3\u30CD\u30EB\u8A8D\u8A3C"
    })
  ];
  const count = formatFollowers(min, lang);
  return [
    tr(lang, {
      ko: `\uC544\uBB34 \uCC44\uB110\uC774\uB098 \uD314\uB85C\uC6CC\xB7\uAD6C\uB3C5\uC790 ${count} \uC774\uC0C1`,
      en: `${count}+ followers or subscribers on any channel`,
      ja: `\u3044\u305A\u308C\u304B\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u3067\u30D5\u30A9\u30ED\u30EF\u30FC\u30FB\u767B\u9332\u8005${count}\u4EE5\u4E0A`
    })
  ];
}
__name(communityActivityConditions, "communityActivityConditions");

// src/constants/uuid-case.ts
var UUID_PATTERN = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
var WHOLE_UUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
function lowercaseUuidsInUrl(url) {
  return /[A-F]/.test(url) ? url.replace(UUID_PATTERN, (m) => m.toLowerCase()) : url;
}
__name(lowercaseUuidsInUrl, "lowercaseUuidsInUrl");
function lowercaseUuidValues(value) {
  if (typeof value === "string") return WHOLE_UUID.test(value) ? value.toLowerCase() : value;
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) value[i] = lowercaseUuidValues(value[i]);
    return value;
  }
  if (value && typeof value === "object" && Object.getPrototypeOf(value) === Object.prototype) {
    const record = value;
    for (const key of Object.keys(record)) record[key] = lowercaseUuidValues(record[key]);
  }
  return value;
}
__name(lowercaseUuidValues, "lowercaseUuidValues");

// src/constants/refund-notice.ts
var REFUND_NOTICE = {
  title: "\uD658\uBD88 \uC548\uB0B4",
  lines: [
    "\uC785\uAE08 \uD6C4 \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uAE30 \uC804\uC5D0\uB294 \uACB0\uC81C \uAE08\uC561 \uC804\uC561\uC744 \uD658\uBD88\uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.",
    "\uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uBA74 IP \uC0AC\uC6A9 \uD5C8\uB77D\uC774 \uBC14\uB85C \uC2DC\uC791\uB418\uC5B4 \uB2E8\uC21C \uBCC0\uC2EC\uC73C\uB85C\uB294 \uD658\uBD88(\uCCAD\uC57D\uCCA0\uD68C)\uD560 \uC218 \uC5C6\uC5B4\uC694.",
    "\uB77C\uC774\uC120\uC2A4 \uB0B4\uC6A9\uC774 \uC548\uB0B4\uC640 \uB2E4\uB974\uAC70\uB098 \uC57D\uC18D\uB300\uB85C \uC774\uD589\uB418\uC9C0 \uC54A\uC73C\uBA74 \uBD84\uC7C1\uC744 \uC2E0\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694."
  ]
};
var REFUND_NOTICE_I18N = {
  ko: REFUND_NOTICE,
  en: {
    title: "Refund policy",
    lines: [
      "After you pay, you can get a full refund of the payment until the license is issued.",
      "Once the license is issued, permission to use the IP begins right away, so you can't cancel for a refund just because you changed your mind.",
      "If the license differs from what was described or isn't fulfilled as promised, you can open a dispute."
    ]
  },
  ja: {
    title: "\u8FD4\u91D1\u306B\u3064\u3044\u3066",
    lines: [
      "\u5165\u91D1\u5F8C\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u308B\u307E\u3067\u306F\u6C7A\u6E08\u91D1\u984D\u306E\u5168\u984D\u3092\u8FD4\u91D1\u3067\u304D\u307E\u3059\u3002",
      "\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u308B\u3068IP\u306E\u4F7F\u7528\u8A31\u8AFE\u304C\u3059\u3050\u306B\u59CB\u307E\u308B\u305F\u3081\u3001\u304A\u5BA2\u69D8\u90FD\u5408\u306B\u3088\u308B\u8FD4\u91D1\uFF08\u7533\u8FBC\u307F\u306E\u64A4\u56DE\uFF09\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
      "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u5185\u5BB9\u304C\u6848\u5185\u3068\u7570\u306A\u308B\u5834\u5408\u3084\u7D04\u675F\u3069\u304A\u308A\u306B\u5C65\u884C\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u7D1B\u4E89\u3092\u7533\u3057\u7ACB\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
    ]
  }
};

// src/errors/korean-messages.ts
var ENTITY_LABELS = {
  User: "\uD68C\uC6D0",
  Listing: "IP",
  ListingOffer: "\uAD8C\uB9AC",
  OfferProposal: "\uC81C\uC548",
  Order: "\uC8FC\uBB38",
  OrderGroup: "\uBB36\uC74C \uC8FC\uBB38",
  Payment: "\uACB0\uC81C",
  "Payment(PENDING)": "\uC785\uAE08 \uB300\uAE30 \uC911\uC778 \uACB0\uC81C",
  "Payment(ADDON PENDING)": "\uC785\uAE08 \uB300\uAE30 \uC911\uC778 \uCD94\uAC00\uAE08",
  Refund: "\uD658\uBD88",
  CommunityPost: "\uAC8C\uC2DC\uAE00",
  CommunityComment: "\uB313\uAE00",
  Sponsorship: "\uD611\uCC2C",
  SponsorshipImage: "\uD611\uCC2C \uC774\uBBF8\uC9C0",
  SponsorshipApplication: "\uD611\uCC2C \uC9C0\uC6D0",
  PlatformAsset: "\uD50C\uB7AB\uD3FC \uC774\uBBF8\uC9C0",
  SocialChannelRequest: "\uCC44\uB110 \uC778\uC99D \uC694\uCCAD",
  ChatRoom: "\uCC44\uD305\uBC29"
};
var OTHER_STATUS_LABELS = {
  CONFIRMED: "\uD655\uC778\uB428",
  FAILED: "\uC2E4\uD328",
  EXPIRED: "\uB9CC\uB8CC\uB428",
  PENDING: "\uB300\uAE30",
  REQUESTED: "\uC694\uCCAD\uB428",
  APPROVED: "\uC2B9\uC778\uB428",
  COMPLETED: "\uC644\uB8CC",
  REJECTED: "\uBC18\uB824\uB428",
  PREPARING: "\uBC30\uC1A1 \uC900\uBE44",
  SHIPPED: "\uBC30\uC1A1 \uC911",
  DELIVERED: "\uBC30\uC1A1 \uC644\uB8CC",
  RETURNED: "\uBC18\uD488\uB428"
};
function entityLabel(entity) {
  return ENTITY_LABELS[entity] ?? "\uC694\uCCAD\uD55C \uC815\uBCF4";
}
__name(entityLabel, "entityLabel");
function statusLabel(status) {
  return ORDER_STATUS_LABELS[status] ?? OTHER_STATUS_LABELS[status] ?? status;
}
__name(statusLabel, "statusLabel");
function josa(word, withFinal, withoutFinal) {
  const last = word.charCodeAt(word.length - 1);
  if (last < 44032 || last > 55203) return `${word}${withoutFinal}`;
  const final = (last - 44032) % 28;
  if (withFinal === "\uC73C\uB85C" && final === 8) return `${word}\uB85C`;
  return `${word}${final ? withFinal : withoutFinal}`;
}
__name(josa, "josa");
var MESSAGE_KO = {
  // 인증
  "No refresh token": "\uB85C\uADF8\uC778\uC774 \uB9CC\uB8CC\uB410\uC5B4\uC694. \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.",
  "Invalid refresh token": "\uB85C\uADF8\uC778\uC774 \uB9CC\uB8CC\uB410\uC5B4\uC694. \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.",
  "Invalid token type": "\uB85C\uADF8\uC778\uC774 \uB9CC\uB8CC\uB410\uC5B4\uC694. \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.",
  Unauthorized: "\uB85C\uADF8\uC778\uC774 \uD544\uC694\uD574\uC694.",
  "Email already registered": "\uC774\uBBF8 \uAC00\uC785\uB41C \uC774\uBA54\uC77C\uC774\uC5D0\uC694.",
  "Invalid credentials": "\uC774\uBA54\uC77C \uB610\uB294 \uBE44\uBC00\uBC88\uD638\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.",
  "Use admin login": "\uC6B4\uC601\uC790 \uACC4\uC815\uC740 \uC5B4\uB4DC\uBBFC\uC5D0\uC11C \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.",
  "MFA code required": "\uC778\uC99D \uC571\uC758 6\uC790\uB9AC \uCF54\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "Invalid MFA code": "\uC778\uC99D \uCF54\uB4DC\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694. \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  // 권한
  Forbidden: "\uC774 \uC791\uC5C5\uC744 \uD560 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694.",
  "Forbidden resource": "\uC774 \uC791\uC5C5\uC744 \uD560 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694.",
  "Insufficient role": "\uC774 \uC791\uC5C5\uC744 \uD560 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694.",
  "Admin role required": "\uC6B4\uC601\uC790\uB9CC \uC774\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.",
  "IP not allowed": "\uD5C8\uC6A9\uB418\uC9C0 \uC54A\uC740 \uC811\uC18D \uC704\uCE58\uC608\uC694.",
  "MFA required for admin actions": "2\uB2E8\uACC4 \uC778\uC99D(OTP)\uC774 \uCF1C\uC838 \uC788\uC5B4\uC694. OTP \uCF54\uB4DC\uB85C \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.",
  // 채팅·첨부
  NOT_A_PARTICIPANT: "\uC774 \uCC44\uD305\uBC29\uC758 \uCC38\uC5EC\uC790\uAC00 \uC544\uB2C8\uC5D0\uC694.",
  CHAT_BLOCKED: "\uCC28\uB2E8 \uC0C1\uD0DC\uB77C \uCC44\uD305\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  RATE_LIMIT_EXCEEDED: "\uBA54\uC2DC\uC9C0\uB97C \uB108\uBB34 \uBE60\uB974\uAC8C \uBCF4\uB0B4\uACE0 \uC788\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uBCF4\uB0B4 \uC8FC\uC138\uC694.",
  CANNOT_LEAVE_ACTIVE_ORDER_ROOM: "\uC9C4\uD589 \uC911\uC778 \uAC70\uB798\uAC00 \uC788\uB294 \uCC44\uD305\uBC29\uC740 \uB098\uAC08 \uC218 \uC5C6\uC5B4\uC694.",
  CANNOT_CHAT_WITH_SELF: "\uB098\uC640\uC758 \uCC44\uD305\uC740 \uC5F4 \uC218 \uC5C6\uC5B4\uC694.",
  CANNOT_INQUIRE_OWN_LISTING: "\uB0B4 IP\uC5D0\uB294 \uBB38\uC758\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  LISTING_NOT_PUBLISHED: "\uD310\uB9E4 \uC911\uC778 IP\uC5D0\uB9CC \uBB38\uC758\uD560 \uC218 \uC788\uC5B4\uC694.",
  "room not found": "\uCC44\uD305\uBC29\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "order not found": "\uC8FC\uBB38\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "chat room not found for this order": "\uC774 \uC8FC\uBB38\uC758 \uCC44\uD305\uBC29\uC774 \uC544\uC9C1 \uC5C6\uC5B4\uC694.",
  "message not found in this room": "\uBA54\uC2DC\uC9C0\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "seller not found": "\uD310\uB9E4\uC790\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "listing not found": "IP\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "key does not belong to this room": "\uC774 \uCC44\uD305\uBC29\uC5D0 \uC62C\uB9B0 \uD30C\uC77C\uC774 \uC544\uB2C8\uC5D0\uC694.",
  "attachment not found in this room": "\uCCA8\uBD80 \uD30C\uC77C\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  // 파일 업로드 (multer)
  "File too large": "\uD30C\uC77C \uD558\uB098\uB294 10MB\uAE4C\uC9C0 \uC62C\uB9B4 \uC218 \uC788\uC5B4\uC694.",
  "Too many files": "\uD55C \uBC88\uC5D0 \uC62C\uB9B4 \uC218 \uC788\uB294 \uD30C\uC77C \uC218\uB97C \uB118\uC5C8\uC5B4\uC694.",
  "Unexpected field": "\uD30C\uC77C\uC744 \uC62C\uB9AC\uB294 \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694.",
  // 공통
  "Validation failed": "\uC785\uB825\uD55C \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "Not Found": "\uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "Bad Request": "\uC694\uCCAD\uC744 \uCC98\uB9AC\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC785\uB825\uD55C \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  Conflict: "\uC9C0\uAE08 \uC0C1\uD0DC\uC5D0\uC11C\uB294 \uCC98\uB9AC\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC0C8\uB85C\uACE0\uCE68\uD55C \uB4A4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "Too Many Requests": "\uC694\uCCAD\uC774 \uB108\uBB34 \uB9CE\uC544\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "ThrottlerException: Too Many Requests": "\uC694\uCCAD\uC774 \uB108\uBB34 \uB9CE\uC544\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "Internal server error": "\uC77C\uC2DC\uC801\uC778 \uC624\uB958\uAC00 \uC0DD\uACBC\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "Payload Too Large": "\uD30C\uC77C\uC774\uB098 \uC694\uCCAD \uB0B4\uC6A9\uC774 \uB108\uBB34 \uCEE4\uC694."
};
var PREFIX_KO = [
  [
    /^mime type not allowed/i,
    "\uC62C\uB9B4 \uC218 \uC5C6\uB294 \uD30C\uC77C \uD615\uC2DD\uC774\uC5D0\uC694."
  ],
  [
    /^Validation failed \(uuid/i,
    "\uC798\uBABB\uB41C \uC8FC\uC18C\uC608\uC694. \uBAA9\uB85D\uC5D0\uC11C \uB2E4\uC2DC \uC120\uD0DD\uD574 \uC8FC\uC138\uC694."
  ],
  [
    /^Validation failed \(numeric/i,
    "\uC22B\uC790\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694."
  ],
  [
    /^Cannot (GET|POST|PUT|PATCH|DELETE) /,
    "\uC5C6\uB294 \uAE30\uB2A5\uC774\uC5D0\uC694. \uD654\uBA74\uC744 \uC0C8\uB85C\uACE0\uCE68\uD574 \uC8FC\uC138\uC694."
  ],
  [
    /^Unexpected token|JSON/i,
    "\uC694\uCCAD \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694."
  ],
  [
    /^request entity too large/i,
    "\uD30C\uC77C\uC774\uB098 \uC694\uCCAD \uB0B4\uC6A9\uC774 \uB108\uBB34 \uCEE4\uC694."
  ]
];
var STATUS_KO = {
  400: "\uC694\uCCAD\uC744 \uCC98\uB9AC\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC785\uB825\uD55C \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  401: "\uB85C\uADF8\uC778\uC774 \uD544\uC694\uD574\uC694.",
  403: "\uC774 \uC791\uC5C5\uC744 \uD560 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694.",
  404: "\uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  405: "\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uC694\uCCAD\uC774\uC5D0\uC694.",
  409: "\uC9C0\uAE08 \uC0C1\uD0DC\uC5D0\uC11C\uB294 \uCC98\uB9AC\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC0C8\uB85C\uACE0\uCE68\uD55C \uB4A4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  413: "\uD30C\uC77C\uC774\uB098 \uC694\uCCAD \uB0B4\uC6A9\uC774 \uB108\uBB34 \uCEE4\uC694.",
  422: "\uCC98\uB9AC\uD560 \uC218 \uC5C6\uB294 \uC694\uCCAD\uC774\uC5D0\uC694. \uC785\uB825\uD55C \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  423: "\uC7A0\uACA8 \uC788\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  429: "\uC694\uCCAD\uC774 \uB108\uBB34 \uB9CE\uC544\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  500: "\uC77C\uC2DC\uC801\uC778 \uC624\uB958\uAC00 \uC0DD\uACBC\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694."
};
var HANGUL = /[가-힣]/;
function koreanErrorMessage(status, message) {
  const text = (message ?? "").trim();
  if (text && HANGUL.test(text)) return text;
  if (text && MESSAGE_KO[text]) return MESSAGE_KO[text];
  for (const [re, ko] of PREFIX_KO) if (re.test(text)) return ko;
  return STATUS_KO[status] ?? (status >= 500 ? STATUS_KO[500] : STATUS_KO[400]);
}
__name(koreanErrorMessage, "koreanErrorMessage");
function errorCodeFromMessage(message) {
  return message && /^[A-Z][A-Z0-9_]{2,}$/.test(message) ? message : void 0;
}
__name(errorCodeFromMessage, "errorCodeFromMessage");

// src/errors/error-messages.ts
var ENTITY_LABELS2 = {
  en: {
    User: "Member",
    Listing: "IP",
    ListingOffer: "Right",
    OfferProposal: "Offer",
    Order: "Order",
    OrderGroup: "Combined order",
    Payment: "Payment",
    "Payment(PENDING)": "Pending payment",
    "Payment(ADDON PENDING)": "Pending additional payment",
    Refund: "Refund",
    CommunityPost: "Post",
    CommunityComment: "Comment",
    Sponsorship: "Sponsorship",
    SponsorshipImage: "Sponsorship image",
    SponsorshipApplication: "Sponsorship application",
    PlatformAsset: "Platform image",
    SocialChannelRequest: "Channel verification request",
    ChatRoom: "Chat room"
  },
  ja: {
    User: "\u4F1A\u54E1",
    Listing: "IP",
    ListingOffer: "\u6A29\u5229",
    OfferProposal: "\u63D0\u6848",
    Order: "\u6CE8\u6587",
    OrderGroup: "\u307E\u3068\u3081\u6CE8\u6587",
    Payment: "\u6C7A\u6E08",
    "Payment(PENDING)": "\u5165\u91D1\u5F85\u3061\u306E\u6C7A\u6E08",
    "Payment(ADDON PENDING)": "\u5165\u91D1\u5F85\u3061\u306E\u8FFD\u52A0\u6599\u91D1",
    Refund: "\u8FD4\u91D1",
    CommunityPost: "\u6295\u7A3F",
    CommunityComment: "\u30B3\u30E1\u30F3\u30C8",
    Sponsorship: "\u6848\u4EF6",
    SponsorshipImage: "\u6848\u4EF6\u306E\u753B\u50CF",
    SponsorshipApplication: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF",
    PlatformAsset: "\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u753B\u50CF",
    SocialChannelRequest: "\u30C1\u30E3\u30F3\u30CD\u30EB\u8A8D\u8A3C\u30EA\u30AF\u30A8\u30B9\u30C8",
    ChatRoom: "\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0"
  }
};
var OTHER_STATUS_LABELS2 = {
  en: {
    CONFIRMED: "confirmed",
    FAILED: "failed",
    EXPIRED: "expired",
    PENDING: "pending",
    REQUESTED: "requested",
    APPROVED: "approved",
    COMPLETED: "completed",
    REJECTED: "rejected",
    PREPARING: "preparing shipment",
    SHIPPED: "shipped",
    DELIVERED: "delivered",
    RETURNED: "returned"
  },
  ja: {
    CONFIRMED: "\u78BA\u8A8D\u6E08\u307F",
    FAILED: "\u5931\u6557",
    EXPIRED: "\u671F\u9650\u5207\u308C",
    PENDING: "\u5F85\u6A5F\u4E2D",
    REQUESTED: "\u7533\u8ACB\u6E08\u307F",
    APPROVED: "\u627F\u8A8D\u6E08\u307F",
    COMPLETED: "\u5B8C\u4E86",
    REJECTED: "\u5374\u4E0B",
    PREPARING: "\u914D\u9001\u6E96\u5099\u4E2D",
    SHIPPED: "\u914D\u9001\u4E2D",
    DELIVERED: "\u914D\u9001\u5B8C\u4E86",
    RETURNED: "\u8FD4\u54C1\u6E08\u307F"
  }
};
function entityLabelIn(entity, lang) {
  if (lang === "ko") return entityLabel(entity);
  return ENTITY_LABELS2[lang][entity] ?? (lang === "en" ? "The requested item" : "\u3054\u6307\u5B9A\u306E\u60C5\u5831");
}
__name(entityLabelIn, "entityLabelIn");
function statusLabelIn(status, lang) {
  const order = ORDER_STATUS_LABELS_I18N[lang][status];
  if (order) return order;
  if (lang === "ko") return statusLabel(status);
  return OTHER_STATUS_LABELS2[lang][status] ?? status;
}
__name(statusLabelIn, "statusLabelIn");
var MESSAGES = {
  en: {
    "No refresh token": "Your session has expired. Please log in again.",
    "Invalid refresh token": "Your session has expired. Please log in again.",
    "Invalid token type": "Your session has expired. Please log in again.",
    Unauthorized: "Please log in.",
    "Email already registered": "This email is already registered.",
    "Invalid credentials": "The email or password is incorrect.",
    "Use admin login": "Please log in to operator accounts from the admin site.",
    "MFA code required": "Enter the 6-digit code from your authenticator app.",
    "Invalid MFA code": "The verification code is incorrect. Please check it again.",
    Forbidden: "You don't have permission to do this.",
    "Forbidden resource": "You don't have permission to do this.",
    "Insufficient role": "You don't have permission to do this.",
    "Admin role required": "Only operators can use this.",
    "IP not allowed": "Access from this location is not allowed.",
    "MFA required for admin actions": "Two-step verification (OTP) is on. Log in again with your OTP code.",
    NOT_A_PARTICIPANT: "You're not a participant in this chat room.",
    CHAT_BLOCKED: "You can't chat because of a block.",
    RATE_LIMIT_EXCEEDED: "You're sending messages too quickly. Please try again in a moment.",
    CANNOT_LEAVE_ACTIVE_ORDER_ROOM: "You can't leave a chat room with an ongoing transaction.",
    CANNOT_CHAT_WITH_SELF: "You can't open a chat with yourself.",
    CANNOT_INQUIRE_OWN_LISTING: "You can't inquire about your own IP.",
    LISTING_NOT_PUBLISHED: "You can only inquire about IP that is for sale.",
    "room not found": "We couldn't find the chat room.",
    "order not found": "We couldn't find the order.",
    "chat room not found for this order": "This order doesn't have a chat room yet.",
    "message not found in this room": "We couldn't find the message.",
    "seller not found": "We couldn't find the seller.",
    "listing not found": "We couldn't find the IP.",
    "key does not belong to this room": "This file wasn't uploaded to this chat room.",
    "attachment not found in this room": "We couldn't find the attachment.",
    "File too large": "Each file can be up to 10MB.",
    "Too many files": "You've exceeded the number of files you can upload at once.",
    "Unexpected field": "The file upload format is invalid.",
    "Validation failed": "Please check what you entered.",
    "Not Found": "We couldn't find it.",
    "Bad Request": "We couldn't process the request. Please check what you entered.",
    Conflict: "This can't be done in the current state. Refresh and try again.",
    "Too Many Requests": "Too many requests. Please try again in a moment.",
    "ThrottlerException: Too Many Requests": "Too many requests. Please try again in a moment.",
    "Internal server error": "A temporary error occurred. Please try again in a moment.",
    "Payload Too Large": "The file or request is too large."
  },
  ja: {
    "No refresh token": "\u30ED\u30B0\u30A4\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "Invalid refresh token": "\u30ED\u30B0\u30A4\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "Invalid token type": "\u30ED\u30B0\u30A4\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    Unauthorized: "\u30ED\u30B0\u30A4\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002",
    "Email already registered": "\u3059\u3067\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3067\u3059\u3002",
    "Invalid credentials": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    "Use admin login": "\u904B\u55B6\u8005\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u7BA1\u7406\u753B\u9762\u304B\u3089\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "MFA code required": "\u8A8D\u8A3C\u30A2\u30D7\u30EA\u306E6\u6841\u306E\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "Invalid MFA code": "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    Forbidden: "\u3053\u306E\u64CD\u4F5C\u3092\u884C\u3046\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    "Forbidden resource": "\u3053\u306E\u64CD\u4F5C\u3092\u884C\u3046\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    "Insufficient role": "\u3053\u306E\u64CD\u4F5C\u3092\u884C\u3046\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    "Admin role required": "\u904B\u55B6\u8005\u306E\u307F\u5229\u7528\u3067\u304D\u307E\u3059\u3002",
    "IP not allowed": "\u8A31\u53EF\u3055\u308C\u3066\u3044\u306A\u3044\u63A5\u7D9A\u5143\u3067\u3059\u3002",
    "MFA required for admin actions": "2\u6BB5\u968E\u8A8D\u8A3C\uFF08OTP\uFF09\u304C\u6709\u52B9\u3067\u3059\u3002OTP\u30B3\u30FC\u30C9\u3067\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    NOT_A_PARTICIPANT: "\u3053\u306E\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306E\u53C2\u52A0\u8005\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    CHAT_BLOCKED: "\u30D6\u30ED\u30C3\u30AF\u4E2D\u306E\u305F\u3081\u30C1\u30E3\u30C3\u30C8\u3067\u304D\u307E\u305B\u3093\u3002",
    RATE_LIMIT_EXCEEDED: "\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u9001\u4FE1\u304C\u901F\u3059\u304E\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    CANNOT_LEAVE_ACTIVE_ORDER_ROOM: "\u9032\u884C\u4E2D\u306E\u53D6\u5F15\u304C\u3042\u308B\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u304B\u3089\u306F\u9000\u51FA\u3067\u304D\u307E\u305B\u3093\u3002",
    CANNOT_CHAT_WITH_SELF: "\u81EA\u5206\u3068\u306E\u30C1\u30E3\u30C3\u30C8\u306F\u958B\u3051\u307E\u305B\u3093\u3002",
    CANNOT_INQUIRE_OWN_LISTING: "\u81EA\u5206\u306EIP\u306B\u306F\u554F\u3044\u5408\u308F\u305B\u3067\u304D\u307E\u305B\u3093\u3002",
    LISTING_NOT_PUBLISHED: "\u8CA9\u58F2\u4E2D\u306EIP\u306B\u306E\u307F\u554F\u3044\u5408\u308F\u305B\u3067\u304D\u307E\u3059\u3002",
    "room not found": "\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "order not found": "\u6CE8\u6587\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "chat room not found for this order": "\u3053\u306E\u6CE8\u6587\u306E\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002",
    "message not found in this room": "\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "seller not found": "\u8CA9\u58F2\u8005\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "listing not found": "IP\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "key does not belong to this room": "\u3053\u306E\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    "attachment not found in this room": "\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "File too large": "\u30D5\u30A1\u30A4\u30EB\u306F1\u3064\u3042\u305F\u308A10MB\u307E\u3067\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002",
    "Too many files": "\u4E00\u5EA6\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u308B\u30D5\u30A1\u30A4\u30EB\u6570\u3092\u8D85\u3048\u307E\u3057\u305F\u3002",
    "Unexpected field": "\u30D5\u30A1\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    "Validation failed": "\u5165\u529B\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    "Not Found": "\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    "Bad Request": "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3067\u304D\u307E\u305B\u3093\u3002\u5165\u529B\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    Conflict: "\u73FE\u5728\u306E\u72B6\u614B\u3067\u306F\u51E6\u7406\u3067\u304D\u307E\u305B\u3093\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    "Too Many Requests": "\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u591A\u3059\u304E\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    "ThrottlerException: Too Many Requests": "\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u591A\u3059\u304E\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    "Internal server error": "\u4E00\u6642\u7684\u306A\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    "Payload Too Large": "\u30D5\u30A1\u30A4\u30EB\u307E\u305F\u306F\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u5185\u5BB9\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002"
  }
};
var PREFIXES = [
  [
    /^mime type not allowed/i,
    {
      ko: "",
      en: "This file type can't be uploaded.",
      ja: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u3067\u3059\u3002"
    }
  ],
  [
    /^Validation failed \(uuid/i,
    {
      ko: "",
      en: "Invalid address. Please select again from the list.",
      ja: "\u7121\u52B9\u306A\u30A2\u30C9\u30EC\u30B9\u3067\u3059\u3002\u4E00\u89A7\u304B\u3089\u3082\u3046\u4E00\u5EA6\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }
  ],
  [
    /^Validation failed \(numeric/i,
    {
      ko: "",
      en: "Please enter a number.",
      ja: "\u6570\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }
  ],
  [
    /^Cannot (GET|POST|PUT|PATCH|DELETE) /,
    {
      ko: "",
      en: "This feature doesn't exist. Please refresh the page.",
      ja: "\u3053\u306E\u6A5F\u80FD\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u30DA\u30FC\u30B8\u3092\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }
  ],
  [
    /^Unexpected token|JSON/i,
    {
      ko: "",
      en: "The request format is invalid.",
      ja: "\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002"
    }
  ],
  [
    /^request entity too large/i,
    {
      ko: "",
      en: "The file or request is too large.",
      ja: "\u30D5\u30A1\u30A4\u30EB\u307E\u305F\u306F\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u5185\u5BB9\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002"
    }
  ]
];
var STATUS = {
  en: {
    400: "We couldn't process the request. Please check what you entered.",
    401: "Please log in.",
    403: "You don't have permission to do this.",
    404: "We couldn't find it.",
    405: "This request is not supported.",
    409: "This can't be done in the current state. Refresh and try again.",
    413: "The file or request is too large.",
    422: "This request can't be processed. Please check what you entered.",
    423: "It's locked. Please try again in a moment.",
    429: "Too many requests. Please try again in a moment.",
    500: "A temporary error occurred. Please try again in a moment."
  },
  ja: {
    400: "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u51E6\u7406\u3067\u304D\u307E\u305B\u3093\u3002\u5165\u529B\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    401: "\u30ED\u30B0\u30A4\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002",
    403: "\u3053\u306E\u64CD\u4F5C\u3092\u884C\u3046\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    404: "\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    405: "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u3059\u3002",
    409: "\u73FE\u5728\u306E\u72B6\u614B\u3067\u306F\u51E6\u7406\u3067\u304D\u307E\u305B\u3093\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    413: "\u30D5\u30A1\u30A4\u30EB\u307E\u305F\u306F\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u5185\u5BB9\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002",
    422: "\u51E6\u7406\u3067\u304D\u306A\u3044\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u3059\u3002\u5165\u529B\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    423: "\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    429: "\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u591A\u3059\u304E\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    500: "\u4E00\u6642\u7684\u306A\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"
  }
};
var HANGUL2 = /[가-힣]/;
function errorMessageIn(lang, status, message) {
  if (lang === "ko") return koreanErrorMessage(status, message);
  const text = (message ?? "").trim();
  if (text && MESSAGES[lang][text]) return MESSAGES[lang][text];
  for (const [re, l] of PREFIXES) if (re.test(text)) return l[lang];
  if (text && HANGUL2.test(text)) return text;
  return STATUS[lang][status] ?? (status >= 500 ? STATUS[lang][500] : STATUS[lang][400]);
}
__name(errorMessageIn, "errorMessageIn");
function inAllLangs(text) {
  return {
    ko: text("ko"),
    en: text("en"),
    ja: text("ja")
  };
}
__name(inAllLangs, "inAllLangs");

// src/errors/domain-error.ts
var DomainError = class extends Error {
  static {
    __name(this, "DomainError");
  }
  code;
  details;
  /** 세 언어 문구 — 문자열(한국어)로 만든 오류는 없다 */
  localized;
  constructor(code, message, details) {
    super(typeof message === "string" ? message : message.ko), this.code = code, this.details = details;
    this.name = this.constructor.name;
    if (typeof message !== "string") this.localized = message;
  }
  /** 그 언어 문구 — 번역이 없으면 한국어 */
  messageIn(lang) {
    return this.localized?.[lang] ?? this.message;
  }
};
var InvalidStateTransitionError = class extends DomainError {
  static {
    __name(this, "InvalidStateTransitionError");
  }
  constructor(from, to, actor) {
    super("INVALID_STATE_TRANSITION", {
      ko: `\uC9C0\uAE08 ${statusLabelIn(from, "ko")} \uC0C1\uD0DC\uB77C ${josa(statusLabelIn(to, "ko"), "\uC73C\uB85C", "\uB85C")} \uBC14\uAFC0 \uC218 \uC5C6\uC5B4\uC694.`,
      en: `Can't change from ${statusLabelIn(from, "en")} to ${statusLabelIn(to, "en")} right now.`,
      ja: `\u73FE\u5728\u300C${statusLabelIn(from, "ja")}\u300D\u306E\u305F\u3081\u300C${statusLabelIn(to, "ja")}\u300D\u306B\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002`
    }, {
      from,
      to,
      actor
    });
  }
};
var UnauthorizedActorError = class extends DomainError {
  static {
    __name(this, "UnauthorizedActorError");
  }
  constructor(actor, action) {
    super("UNAUTHORIZED_ACTOR", {
      ko: "\uC774 \uC791\uC5C5\uC744 \uD560 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694.",
      en: "You don't have permission to do this.",
      ja: "\u3053\u306E\u64CD\u4F5C\u3092\u884C\u3046\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002"
    }, {
      actor,
      action
    });
  }
};
var EntityNotFoundError = class extends DomainError {
  static {
    __name(this, "EntityNotFoundError");
  }
  constructor(entity, id) {
    super("ENTITY_NOT_FOUND", {
      ko: `${josa(entityLabelIn(entity, "ko"), "\uC744", "\uB97C")} \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.`,
      en: `${entityLabelIn(entity, "en")} not found.`,
      ja: `${entityLabelIn(entity, "ja")}\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002`
    }, {
      entity,
      id
    });
  }
};
var WithdrawalBlockedError = class extends DomainError {
  static {
    __name(this, "WithdrawalBlockedError");
  }
  constructor(message, details) {
    super("WITHDRAWAL_BLOCKED", message, details);
  }
};

// src/notices/template.ts
function fixedText(text) {
  return (_p, lang) => text[lang];
}
__name(fixedText, "fixedText");
function defineNotices(templates) {
  return templates;
}
__name(defineNotices, "defineNotices");
function defineChatMessages(templates) {
  return templates;
}
__name(defineChatMessages, "defineChatMessages");

// src/notices/account.ts
function accountLabel(p) {
  return `${p.bankName} \xB7\xB7\xB7${p.last4}`;
}
__name(accountLabel, "accountLabel");
var ACCOUNT_NOTICES = defineNotices({
  /** 간편비밀번호 변경 */
  "account.pinChanged": {
    title: fixedText({
      ko: "\uAC04\uD3B8\uBE44\uBC00\uBC88\uD638\uAC00 \uBC14\uB00C\uC5C8\uC5B4\uC694",
      en: "Your PIN was changed",
      ja: "\u7C21\u5358\u6697\u8A3C\u756A\u53F7\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uBCF8\uC778\uC774 \uBC14\uAFB8\uC9C0 \uC54A\uC558\uB2E4\uBA74 \uBC14\uB85C \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694.",
      en: "If you didn't change it, please let the Help center know right away.",
      ja: "\u3054\u672C\u4EBA\u304C\u5909\u66F4\u3057\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u3001\u3059\u3050\u306B\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u3078\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002"
    })
  },
  /** 정산 계좌 등록(changed=false)·변경(changed=true) */
  "account.payoutAccountSaved": {
    title: /* @__PURE__ */ __name((p, lang) => p.changed ? tr(lang, {
      ko: "\uC815\uC0B0 \uACC4\uC88C\uAC00 \uBCC0\uACBD\uB410\uC5B4\uC694",
      en: "Your payout account was changed",
      ja: "\u7CBE\u7B97\u53E3\u5EA7\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F"
    }) : tr(lang, {
      ko: "\uC815\uC0B0 \uACC4\uC88C\uAC00 \uB4F1\uB85D\uB410\uC5B4\uC694",
      en: "Your payout account was added",
      ja: "\u7CBE\u7B97\u53E3\u5EA7\u304C\u767B\u9332\u3055\u308C\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const to = accountLabel(p);
      return tr(lang, {
        ko: `${to} \uB85C \uD310\uB9E4 \uB300\uAE08\uC774 \uC9C0\uAE09\uB3FC\uC694. \uBCF8\uC778\uC774 \uD558\uC9C0 \uC54A\uC558\uB2E4\uBA74 \uBC14\uB85C \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694.`,
        en: `Sales proceeds will be paid to ${to}. If this wasn't you, please let the Help center know right away.`,
        ja: `\u8CA9\u58F2\u4EE3\u91D1\u306F${to}\u306B\u652F\u6255\u308F\u308C\u307E\u3059\u3002\u3054\u672C\u4EBA\u306E\u64CD\u4F5C\u3067\u306A\u3044\u5834\u5408\u306F\u3001\u3059\u3050\u306B\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u3078\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002`
      });
    }, "body")
  },
  /** 환불 계좌 등록·변경 — followed: 새 계좌로 바뀐 반환 대기 입금 반환 수 */
  "account.refundAccountSaved": {
    title: /* @__PURE__ */ __name((p, lang) => p.changed ? tr(lang, {
      ko: "\uD658\uBD88 \uACC4\uC88C\uAC00 \uBCC0\uACBD\uB410\uC5B4\uC694",
      en: "Your refund account was changed",
      ja: "\u8FD4\u91D1\u53E3\u5EA7\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F"
    }) : tr(lang, {
      ko: "\uD658\uBD88 \uACC4\uC88C\uAC00 \uB4F1\uB85D\uB410\uC5B4\uC694",
      en: "Your refund account was added",
      ja: "\u8FD4\u91D1\u53E3\u5EA7\u304C\u767B\u9332\u3055\u308C\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const to = accountLabel(p);
      const followed = p.followed ?? 0;
      return tr(lang, {
        ko: `${to} \uB85C \uD658\uBD88\uAE08\uC744 \uB3CC\uB824\uBC1B\uC544\uC694.${followed > 0 ? ` \uB3CC\uB824\uBC1B\uC744 \uC785\uAE08 ${followed}\uAC74\uB3C4 \uC774 \uACC4\uC88C\uB85C \uBC14\uB00C\uC5C8\uC5B4\uC694.` : ""} \uBCF8\uC778\uC774 \uD558\uC9C0 \uC54A\uC558\uB2E4\uBA74 \uBC14\uB85C \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694.`,
        en: `Refunds will be sent to ${to}.${followed > 0 ? ` ${followed} pending deposit return${followed === 1 ? "" : "s"} will also go to this account.` : ""} If this wasn't you, please let the Help center know right away.`,
        ja: `\u8FD4\u91D1\u306F${to}\u306B\u8FD4\u3055\u308C\u307E\u3059\u3002${followed > 0 ? `\u8FD4\u9084\u4E88\u5B9A\u306E\u5165\u91D1${followed}\u4EF6\u3082\u3053\u306E\u53E3\u5EA7\u306B\u5909\u66F4\u3055\u308C\u307E\u3057\u305F\u3002` : ""}\u3054\u672C\u4EBA\u306E\u64CD\u4F5C\u3067\u306A\u3044\u5834\u5408\u306F\u3001\u3059\u3050\u306B\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u3078\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002`
      });
    }, "body")
  }
});
var ACCOUNT_NOTICE_SAMPLES = {
  "account.pinChanged": {},
  "account.payoutAccountSaved": {
    bankName: "Shinhan Bank",
    last4: "1234",
    changed: true
  },
  "account.refundAccountSaved": {
    bankName: "Shinhan Bank",
    last4: "1234",
    changed: false,
    followed: 2
  }
};

// src/notices/admin.ts
var won3 = /* @__PURE__ */ __name((amount, lang) => formatWon(Math.abs(amount), lang), "won");
var ADMIN_NOTICES = defineNotices({
  // ── IP 심사 ──
  "admin.listingPublished": {
    title: fixedText({
      ko: "IP \uC2EC\uC0AC\uAC00 \uC2B9\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your IP was approved",
      ja: "IP\u306E\u5BE9\u67FB\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.listingTitle}" \uC774(\uAC00) \uB9C8\uCF13\uC5D0 \uACF5\uAC1C\uB418\uC5C8\uC5B4\uC694.`,
      en: `"${p.listingTitle}" is now live on the market.`,
      ja: `\u300C${p.listingTitle}\u300D\u304C\u30DE\u30FC\u30B1\u30C3\u30C8\u306B\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  "admin.listingRejected": {
    title: fixedText({
      ko: "IP \uC2EC\uC0AC\uAC00 \uBC18\uB824\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your IP was rejected",
      ja: "IP\u306E\u5BE9\u67FB\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.listingTitle}" \uBC18\uB824 \uC0AC\uC720: ${p.reason}`,
      en: `"${p.listingTitle}" rejection reason: ${p.reason}`,
      ja: `\u300C${p.listingTitle}\u300D\u5DEE\u3057\u623B\u3057\u7406\u7531: ${p.reason}`
    }), "body")
  },
  "admin.offerApproved": {
    title: fixedText({
      ko: "\uCD94\uAC00\uD55C \uAD8C\uB9AC\uAC00 \uC2B9\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your added right was approved",
      ja: "\u8FFD\u52A0\u3057\u305F\u6A29\u5229\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const right = IP_RIGHT_LABELS_I18N[lang][p.rightType];
      return tr(lang, {
        ko: `"${p.listingTitle}" \uC758 ${right} \uC774(\uAC00) \uACF5\uAC1C\uB418\uC5C8\uC5B4\uC694.`,
        en: `${right} for "${p.listingTitle}" is now live.`,
        ja: `\u300C${p.listingTitle}\u300D\u306E${right}\u304C\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002`
      });
    }, "body")
  },
  /** 승인된 적 없는 권리(추가한 권리)의 반려 — 상품에서 지운다 */
  "admin.offerRejected": {
    title: fixedText({
      ko: "\uCD94\uAC00\uD55C \uAD8C\uB9AC\uAC00 \uBC18\uB824\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your added right was rejected",
      ja: "\u8FFD\u52A0\u3057\u305F\u6A29\u5229\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const right = IP_RIGHT_LABELS_I18N[lang][p.rightType];
      return tr(lang, {
        ko: `"${p.listingTitle}" \uC758 ${right} \uC774(\uAC00) \uBC18\uB824\uB418\uC5B4 \uC0C1\uD488\uC5D0\uC11C \uC0AD\uC81C\uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason}`,
        en: `${right} for "${p.listingTitle}" was rejected and removed from the listing. Reason: ${p.reason}`,
        ja: `\u300C${p.listingTitle}\u300D\u306E${right}\u306F\u5DEE\u3057\u623B\u3055\u308C\u3001\u5546\u54C1\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002\u7406\u7531: ${p.reason}`
      });
    }, "body")
  },
  /** 승인된 권리를 고친 것의 승인 — 바뀐 조건으로 다시 공개 */
  "admin.offerEditApproved": {
    title: fixedText({
      ko: "\uC218\uC815\uD55C \uAD8C\uB9AC\uAC00 \uC2B9\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your edited right was approved",
      ja: "\u4FEE\u6B63\u3057\u305F\u6A29\u5229\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const right = IP_RIGHT_LABELS_I18N[lang][p.rightType];
      return tr(lang, {
        ko: `"${p.listingTitle}" \uC758 ${right} \uC774(\uAC00) \uBC14\uB010 \uC870\uAC74\uC73C\uB85C \uACF5\uAC1C\uB418\uC5C8\uC5B4\uC694.`,
        en: `${right} for "${p.listingTitle}" is now live with the new terms.`,
        ja: `\u300C${p.listingTitle}\u300D\u306E${right}\u304C\u5909\u66F4\u5F8C\u306E\u6761\u4EF6\u3067\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002`
      });
    }, "body")
  },
  /** 승인된 권리를 고친 것의 반려 — 이전 승인 조건으로 되돌려 판매를 이어 간다 */
  "admin.offerEditRejected": {
    title: fixedText({
      ko: "\uAD8C\uB9AC \uC218\uC815\uC774 \uBC18\uB824\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your right edit was rejected",
      ja: "\u6A29\u5229\u306E\u4FEE\u6B63\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const right = IP_RIGHT_LABELS_I18N[lang][p.rightType];
      return tr(lang, {
        ko: `"${p.listingTitle}" \uC758 ${right} \uC218\uC815\uC774 \uBC18\uB824\uB418\uC5B4 \uC774\uC804 \uC870\uAC74\uC73C\uB85C \uD310\uB9E4 \uC911\uC774\uC5D0\uC694. \uC0AC\uC720: ${p.reason}`,
        en: `The edit to ${right} for "${p.listingTitle}" was rejected, so it's on sale with the previous terms. Reason: ${p.reason}`,
        ja: `\u300C${p.listingTitle}\u300D\u306E${right}\u306E\u4FEE\u6B63\u306F\u5DEE\u3057\u623B\u3055\u308C\u3001\u4EE5\u524D\u306E\u6761\u4EF6\u3067\u8CA9\u58F2\u4E2D\u3067\u3059\u3002\u7406\u7531: ${p.reason}`
      });
    }, "body")
  },
  "admin.listingSuspended": {
    title: fixedText({
      ko: "IP \uD310\uB9E4\uAC00 \uC911\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Sales of your IP were paused",
      ja: "IP\u306E\u8CA9\u58F2\u304C\u505C\u6B62\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.listingTitle}" \uC911\uC9C0 \uC0AC\uC720: ${p.reason}`,
      en: `"${p.listingTitle}" pause reason: ${p.reason}`,
      ja: `\u300C${p.listingTitle}\u300D\u505C\u6B62\u7406\u7531: ${p.reason}`
    }), "body")
  },
  "admin.listingUnsuspended": {
    title: fixedText({
      ko: "IP \uD310\uB9E4\uAC00 \uB2E4\uC2DC \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Sales of your IP resumed",
      ja: "IP\u306E\u8CA9\u58F2\u304C\u518D\u958B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.listingTitle}" \uC774(\uAC00) \uB2E4\uC2DC \uB9C8\uCF13\uC5D0 \uACF5\uAC1C\uB418\uC5C8\uC5B4\uC694.`,
      en: `"${p.listingTitle}" is live on the market again.`,
      ja: `\u300C${p.listingTitle}\u300D\u304C\u518D\u3073\u30DE\u30FC\u30B1\u30C3\u30C8\u306B\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  // ── 협찬 ──
  "admin.sponsorshipApplicationApproved": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uC2B9\uC778\uB410\uC5B4\uC694",
      en: "Your sponsorship application was approved",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C\uC774 \uD655\uC815\uB410\uC5B4\uC694. \uC5C5\uCCB4\uC758 \uC548\uB0B4\uB97C \uAE30\uB2E4\uB824 \uC8FC\uC138\uC694.`,
      en: `You're confirmed for the "${p.sponsorshipTitle}" sponsorship. The brand will reach out with next steps.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306E\u6848\u4EF6\u304C\u78BA\u5B9A\u3057\u307E\u3057\u305F\u3002\u4F01\u696D\u304B\u3089\u306E\u3054\u6848\u5185\u3092\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  "admin.sponsorshipApplicationRejected": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uAC70\uC808\uB410\uC5B4\uC694",
      en: "Your sponsorship application was declined",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u898B\u9001\u3089\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C\uC5D0 \uD568\uAED8\uD558\uC9C0 \uBABB\uD558\uAC8C \uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `You won't be joining the "${p.sponsorshipTitle}" sponsorship. Reason: ${p.reason}`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306E\u6848\u4EF6\u306B\u306F\u3054\u53C2\u52A0\u3044\u305F\u3060\u3051\u306A\u3044\u3053\u3068\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u7406\u7531: ${p.reason}`
    }), "body")
  },
  "admin.sponsorshipPublished": {
    title: fixedText({
      ko: "\uD611\uCC2C\uC774 \uACF5\uAC1C\uB410\uC5B4\uC694",
      en: "Your sponsorship is live",
      ja: "\u6848\u4EF6\u304C\u516C\u958B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uC2EC\uC0AC\uAC00 \uB05D\uB098 \uD611\uCC2C \uBAA9\uB85D\uC5D0 \uACF5\uAC1C\uB410\uC5B4\uC694.`,
      en: `"${p.sponsorshipTitle}" passed review and is now listed.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306E\u5BE9\u67FB\u304C\u5B8C\u4E86\u3057\u3001\u6848\u4EF6\u4E00\u89A7\u306B\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  "admin.sponsorshipRejected": {
    title: fixedText({
      ko: "\uD611\uCC2C \uB4F1\uB85D\uC774 \uBC18\uB824\uB410\uC5B4\uC694",
      en: "Your sponsorship was rejected",
      ja: "\u6848\u4EF6\u306E\u767B\u9332\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \u2014 ${p.reason}`,
      en: `"${p.sponsorshipTitle}" \u2014 ${p.reason}`,
      ja: `\u300C${p.sponsorshipTitle}\u300D \u2014 ${p.reason}`
    }), "body")
  },
  "admin.sponsorshipTakenDown": {
    title: fixedText({
      ko: "\uD611\uCC2C \uACF5\uAC1C\uAC00 \uB0B4\uB824\uC84C\uC5B4\uC694",
      en: "Your sponsorship was taken down",
      ja: "\u6848\u4EF6\u306E\u516C\u958B\u304C\u53D6\u308A\u4E0B\u3052\u3089\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \u2014 ${p.reason}`,
      en: `"${p.sponsorshipTitle}" \u2014 ${p.reason}`,
      ja: `\u300C${p.sponsorshipTitle}\u300D \u2014 ${p.reason}`
    }), "body")
  },
  // ── SNS 채널 인증 ──
  "admin.socialChannelApproved": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const label = SOCIAL_PLATFORM_LABELS_I18N[lang][p.platform];
      return tr(lang, {
        ko: `${label} \uCC44\uB110 \uC778\uC99D\uC774 \uC644\uB8CC\uB410\uC5B4\uC694`,
        en: `Your ${label} channel is verified`,
        ja: `${label}\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u8A8D\u8A3C\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const label = SOCIAL_PLATFORM_LABELS_I18N[lang][p.platform];
      const count = p.followerCount.toLocaleString(INTL_LOCALE[lang]);
      return tr(lang, {
        ko: `\uC694\uCCAD\uD558\uC2E0 ${label} \uCC44\uB110\uC774 \uC778\uC99D\uB410\uC5B4\uC694. \uD314\uB85C\uC6CC ${count}\uBA85\uC73C\uB85C \uAE30\uB85D\uB410\uC5B4\uC694.`,
        en: `Your ${label} channel is verified, with ${count} followers recorded.`,
        ja: `\u3054\u4F9D\u983C\u306E${label}\u30C1\u30E3\u30F3\u30CD\u30EB\u304C\u8A8D\u8A3C\u3055\u308C\u307E\u3057\u305F\u3002\u30D5\u30A9\u30ED\u30EF\u30FC${count}\u4EBA\u3068\u3057\u3066\u8A18\u9332\u3055\u308C\u307E\u3057\u305F\u3002`
      });
    }, "body")
  },
  "admin.socialChannelRejected": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const label = SOCIAL_PLATFORM_LABELS_I18N[lang][p.platform];
      return tr(lang, {
        ko: `${label} \uCC44\uB110 \uC778\uC99D \uC694\uCCAD\uC774 \uAC70\uC808\uB410\uC5B4\uC694`,
        en: `Your ${label} channel verification request was declined`,
        ja: `${label}\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u8A8D\u8A3C\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC0AC\uC720: ${p.reason}
\uB0B4\uC6A9\uC744 \uD655\uC778\uD558\uACE0 \uB2E4\uC2DC \uC694\uCCAD\uD560 \uC218 \uC788\uC5B4\uC694.`,
      en: `Reason: ${p.reason}
Check the details and request again.`,
      ja: `\u7406\u7531: ${p.reason}
\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u518D\u5EA6\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u304D\u307E\u3059\u3002`
    }), "body")
  },
  "admin.socialChannelRevoked": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const label = SOCIAL_PLATFORM_LABELS_I18N[lang][p.platform];
      return tr(lang, {
        ko: `${label} \uCC44\uB110 \uC778\uC99D\uC774 \uD574\uC81C\uB410\uC5B4\uC694`,
        en: `Your ${label} channel verification was removed`,
        ja: `${label}\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u8A8D\u8A3C\u304C\u89E3\u9664\u3055\u308C\u307E\u3057\u305F`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC0AC\uC720: ${p.reason}
\uCC44\uB110\uC744 \uB2E4\uC2DC \uC778\uC99D\uD560 \uC218 \uC788\uC5B4\uC694.`,
      en: `Reason: ${p.reason}
You can verify the channel again.`,
      ja: `\u7406\u7531: ${p.reason}
\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u518D\u5EA6\u8A8D\u8A3C\u3067\u304D\u307E\u3059\u3002`
    }), "body")
  },
  // ── 회원·고객센터·커뮤니티·협의 ──
  "admin.simplePinReset": {
    title: fixedText({
      ko: "\uAC04\uD3B8\uBE44\uBC00\uBC88\uD638\uAC00 \uCD08\uAE30\uD654\uB410\uC5B4\uC694",
      en: "Your PIN was reset",
      ja: "\u7C21\u5358\u6697\u8A3C\u756A\u53F7\u304C\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uACE0\uAC1D\uC13C\uD130 \uC694\uCCAD\uC73C\uB85C \uAC04\uD3B8\uBE44\uBC00\uBC88\uD638\uB97C \uCD08\uAE30\uD654\uD588\uC5B4\uC694. \uBCF8\uC778\uC774 \uC694\uCCAD\uD558\uC9C0 \uC54A\uC558\uB2E4\uBA74 \uBC14\uB85C \uACE0\uAC1D\uC13C\uD130\uB85C \uC54C\uB824 \uC8FC\uC138\uC694.",
      en: "We reset your PIN at a Help center request. If you didn't ask for this, contact the Help center right away.",
      ja: "\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u3078\u306E\u3054\u4F9D\u983C\u306B\u3088\u308A\u7C21\u5358\u6697\u8A3C\u756A\u53F7\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002\u3054\u672C\u4EBA\u304C\u4F9D\u983C\u3057\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u3001\u3059\u3050\u306B\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC\u3078\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"
    })
  },
  "admin.supportInquiryAnswered": {
    title: fixedText({
      ko: "1:1 \uBB38\uC758\uC5D0 \uB2F5\uBCC0\uC774 \uB2EC\uB838\uC5B4\uC694",
      en: "Your inquiry got a reply",
      ja: "\u304A\u554F\u3044\u5408\u308F\u305B\u306B\u56DE\u7B54\u304C\u3042\u308A\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.inquiryTitle}" \uBB38\uC758\uC5D0 \uAD00\uB9AC\uC790\uAC00 \uB2F5\uD588\uC5B4\uC694.`,
      en: `Our team replied to your inquiry "${p.inquiryTitle}".`,
      ja: `\u304A\u554F\u3044\u5408\u308F\u305B\u300C${p.inquiryTitle}\u300D\u306B\u904B\u55B6\u30C1\u30FC\u30E0\u304C\u56DE\u7B54\u3057\u307E\u3057\u305F\u3002`
    }), "body")
  },
  "admin.communityPostRemoved": {
    title: fixedText({
      ko: "\uCEE4\uBBA4\uB2C8\uD2F0 \uAC8C\uC2DC\uAE00\uC774 \uC6B4\uC601 \uC815\uCC45\uC5D0 \uB530\uB77C \uC0AD\uC81C\uB418\uC5C8\uC5B4\uC694",
      en: "Your community post was removed under our policy",
      ja: "\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u6295\u7A3F\u304C\u904B\u55B6\u30DD\u30EA\u30B7\u30FC\u306B\u3088\u308A\u524A\u9664\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.postTitle}" \u2014 \uC0AC\uC720: ${p.note}`,
      en: `"${p.postTitle}" \u2014 Reason: ${p.note}`,
      ja: `\u300C${p.postTitle}\u300D \u2014 \u7406\u7531: ${p.note}`
    }), "body")
  },
  "admin.communityCommentRemoved": {
    title: fixedText({
      ko: "\uCEE4\uBBA4\uB2C8\uD2F0 \uB313\uAE00\uC774 \uC6B4\uC601 \uC815\uCC45\uC5D0 \uB530\uB77C \uC0AD\uC81C\uB418\uC5C8\uC5B4\uC694",
      en: "Your community comment was removed under our policy",
      ja: "\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u904B\u55B6\u30DD\u30EA\u30B7\u30FC\u306B\u3088\u308A\u524A\u9664\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.postTitle}"\uC5D0 \uC4F4 \uB313\uAE00 \u2014 \uC0AC\uC720: ${p.note}`,
      en: `Your comment on "${p.postTitle}" \u2014 Reason: ${p.note}`,
      ja: `\u300C${p.postTitle}\u300D\u3078\u306E\u30B3\u30E1\u30F3\u30C8 \u2014 \u7406\u7531: ${p.note}`
    }), "body")
  },
  "admin.proposalClosed": {
    title: fixedText({
      ko: "\uC6B4\uC601\uC790\uAC00 \uD611\uC758\uB97C \uC885\uB8CC\uD588\uC2B5\uB2C8\uB2E4",
      en: "Our team closed the negotiation",
      ja: "\u904B\u55B6\u8005\u304C\u6761\u4EF6\u4EA4\u6E09\u3092\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.listingTitle ? `"${p.listingTitle}" ` : ""}\uC870\uAC74 \uD611\uC758\uAC00 \uC885\uB8CC\uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `The negotiation${p.listingTitle ? ` for "${p.listingTitle}"` : ""} was closed. Reason: ${p.reason}`,
      ja: `${p.listingTitle ? `\u300C${p.listingTitle}\u300D\u306E` : ""}\u6761\u4EF6\u4EA4\u6E09\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u7406\u7531: ${p.reason}`
    }), "body")
  },
  // ── 정산 ──
  "admin.settlementPaidOut": {
    title: fixedText({
      ko: "\uD310\uB9E4 \uB300\uAE08\uC774 \uC9C0\uAE09\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your sales proceeds were paid out",
      ja: "\u8CA9\u58F2\u4EE3\u91D1\u304C\u652F\u6255\u308F\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.listingTitle ? `"${p.listingTitle}" ` : ""}\uD310\uB9E4 \uB300\uAE08 ${formatWon(p.amount, "ko")}(\uC218\uC218\uB8CC \uC81C\uC678)\uC774 \uC815\uC0B0 \uACC4\uC88C\uB85C \uC9C0\uAE09\uB418\uC5C8\uC5B4\uC694.`,
      en: `${formatWon(p.amount, "en")} (after fees)${p.listingTitle ? ` for "${p.listingTitle}"` : ""} was paid to your payout account.`,
      ja: `${p.listingTitle ? `\u300C${p.listingTitle}\u300D\u306E` : ""}\u8CA9\u58F2\u4EE3\u91D1${formatWon(p.amount, "ja")}\uFF08\u624B\u6570\u6599\u5DEE\u5F15\u5F8C\uFF09\u304C\u7CBE\u7B97\u53E3\u5EA7\u306B\u652F\u6255\u308F\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  // ── 주문: 입금 반환 ──
  "admin.depositReturnCreated": {
    title: fixedText({
      ko: "\uC785\uAE08\uD558\uC2E0 \uB3C8\uC744 \uB3CC\uB824\uB4DC\uB9B4 \uC608\uC815\uC774\uC5D0\uC694",
      en: "We'll return your deposit",
      ja: "\u3054\u5165\u91D1\u5206\u3092\u8FD4\u91D1\u3059\u308B\u4E88\u5B9A\u3067\u3059"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const kind = DEPOSIT_RETURN_KIND_LABELS_I18N[lang][p.kind];
      return tr(lang, {
        ko: `${kind} ${formatWon(p.amount, "ko")}\uC744 ${p.bank} \uACC4\uC88C\uB85C \uB3CC\uB824\uB4DC\uB824\uC694. \uC0AC\uC720: ${p.reason}`,
        en: `We'll return ${formatWon(p.amount, "en")} (${kind}) to your ${p.bank} account. Reason: ${p.reason}`,
        ja: `${kind} ${formatWon(p.amount, "ja")}\u3092${p.bank}\u306E\u53E3\u5EA7\u3078\u8FD4\u91D1\u3057\u307E\u3059\u3002\u7406\u7531: ${p.reason}`
      });
    }, "body")
  },
  "admin.depositReturned": {
    title: fixedText({
      ko: "\uC785\uAE08\uD558\uC2E0 \uB3C8\uC744 \uB3CC\uB824\uB4DC\uB838\uC5B4\uC694",
      en: "We returned your deposit",
      ja: "\u3054\u5165\u91D1\u5206\u3092\u8FD4\u91D1\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const kind = DEPOSIT_RETURN_KIND_LABELS_I18N[lang][p.kind];
      return tr(lang, {
        ko: `${kind} ${formatWon(p.amount, "ko")}\uC744 ${p.bank} ${p.accountNumber} \uACC4\uC88C\uB85C \uBCF4\uB0C8\uC5B4\uC694.`,
        en: `We sent ${formatWon(p.amount, "en")} (${kind}) to your ${p.bank} account ${p.accountNumber}.`,
        ja: `${kind} ${formatWon(p.amount, "ja")}\u3092${p.bank} ${p.accountNumber}\u306E\u53E3\u5EA7\u3078\u9001\u91D1\u3057\u307E\u3057\u305F\u3002`
      });
    }, "body")
  },
  // ── 주문: 위반 신고 ── (관리자 메모는 쓴 그대로)
  "admin.violationReportActioned": {
    title: fixedText({
      ko: "\uAD00\uB9AC\uC790\uAC00 \uC704\uBC18 \uC2E0\uACE0\uB97C \uD655\uC778\uD558\uACE0 \uC870\uCE58\uD588\uC5B4\uC694",
      en: "An admin reviewed the violation report and took action",
      ja: "\u7BA1\u7406\u8005\u304C\u9055\u53CD\u5831\u544A\u3092\u78BA\u8A8D\u3057\u3001\u5BFE\u5FDC\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p) => p.note, "body")
  },
  "admin.violationReportDismissed": {
    title: fixedText({
      ko: "\uAD00\uB9AC\uC790\uAC00 \uC704\uBC18 \uC2E0\uACE0\uB97C \uAE30\uAC01\uD588\uC5B4\uC694",
      en: "An admin dismissed the violation report",
      ja: "\u7BA1\u7406\u8005\u304C\u9055\u53CD\u5831\u544A\u3092\u5374\u4E0B\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p) => p.note, "body")
  },
  // ── 주문: 라이선스 사용 중지·수정 제안 ── (구매자·판매자 같은 문구)
  "admin.licenseSuspended": {
    title: /* @__PURE__ */ __name((p, lang) => LICENSE_SUSPENSION_NOTICES.SUSPENDED(p.listingTitle, p.reason, lang).title, "title"),
    body: /* @__PURE__ */ __name((p, lang) => LICENSE_SUSPENSION_NOTICES.SUSPENDED(p.listingTitle, p.reason, lang).body, "body")
  },
  "admin.licenseResumed": {
    title: /* @__PURE__ */ __name((p, lang) => LICENSE_SUSPENSION_NOTICES.RESUMED(p.listingTitle, lang).title, "title"),
    body: /* @__PURE__ */ __name((p, lang) => LICENSE_SUSPENSION_NOTICES.RESUMED(p.listingTitle, lang).body, "body")
  },
  "admin.licenseAmendmentProposed": {
    title: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.PROPOSED(p.listingTitle, lang).title, "title"),
    body: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.PROPOSED(p.listingTitle, lang).body, "body")
  },
  "admin.licenseAmendmentCancelled": {
    title: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.CANCELLED(p.listingTitle, lang).title, "title"),
    body: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.CANCELLED(p.listingTitle, lang).body, "body")
  },
  // ── 주문: 환불 ──
  "admin.refundApproved": {
    title: fixedText({
      ko: "\uD658\uBD88\uC774 \uC2B9\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your refund was approved",
      ja: "\u8FD4\u91D1\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    /** afterClawback — 판매자에게 지급된 정산금을 먼저 돌려받는 환불 */
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, p.afterClawback ? {
      ko: "\uD658\uBD88 \uC2E0\uCCAD\uC774 \uC2B9\uC778\uB410\uC5B4\uC694. \uD310\uB9E4\uC790\uC5D0\uAC8C \uC9C0\uAE09\uB41C \uC815\uC0B0\uAE08\uC744 \uB3CC\uB824\uBC1B\uC740 \uB4A4 \uB4F1\uB85D\uD558\uC2E0 \uACC4\uC88C\uB85C \uC785\uAE08\uD558\uACE0 \uB2E4\uC2DC \uC54C\uB824\uB4DC\uB9B4\uAC8C\uC694.",
      en: "Your refund request was approved. Once we recover the payout sent to the seller, we'll send the money to your account and let you know.",
      ja: "\u8FD4\u91D1\u7533\u8ACB\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002\u8CA9\u58F2\u8005\u306B\u652F\u6255\u3063\u305F\u7CBE\u7B97\u91D1\u3092\u56DE\u53CE\u3057\u305F\u5F8C\u3001\u3054\u767B\u9332\u306E\u53E3\u5EA7\u3078\u5165\u91D1\u3057\u3001\u6539\u3081\u3066\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002"
    } : {
      ko: "\uD658\uBD88 \uC2E0\uCCAD\uC774 \uC2B9\uC778\uB410\uC5B4\uC694. \uB4F1\uB85D\uD558\uC2E0 \uACC4\uC88C\uB85C \uC785\uAE08\uC774 \uC644\uB8CC\uB418\uBA74 \uB2E4\uC2DC \uC54C\uB824\uB4DC\uB9B4\uAC8C\uC694.",
      en: "Your refund request was approved. We'll let you know once the money reaches your account.",
      ja: "\u8FD4\u91D1\u7533\u8ACB\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002\u3054\u767B\u9332\u306E\u53E3\u5EA7\u3078\u306E\u5165\u91D1\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u6539\u3081\u3066\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002"
    }), "body")
  },
  "admin.refundRejected": {
    title: fixedText({
      ko: "\uD658\uBD88 \uC2E0\uCCAD\uC774 \uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uC5D0 \uC758\uD574 \uAC70\uC808\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your refund request was declined by the Inflip team",
      ja: "\u8FD4\u91D1\u7533\u8ACB\u304CInflip\u904B\u55B6\u8005\u306B\u3088\u308A\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC0AC\uC720: ${p.reason}`,
      en: `Reason: ${p.reason}`,
      ja: `\u7406\u7531: ${p.reason}`
    }), "body")
  },
  "admin.refundApprovalRevoked": {
    title: fixedText({
      ko: "\uD658\uBD88 \uC2B9\uC778\uC774 \uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uC5D0 \uC758\uD574 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your refund approval was canceled by the Inflip team",
      ja: "\u8FD4\u91D1\u306E\u627F\u8A8D\u304CInflip\u904B\u55B6\u8005\u306B\u3088\u308A\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC0AC\uC720: ${p.reason}`,
      en: `Reason: ${p.reason}`,
      ja: `\u7406\u7531: ${p.reason}`
    }), "body")
  },
  "admin.refundCompleted": {
    title: fixedText({
      ko: "\uD658\uBD88\uAE08\uC774 \uC785\uAE08\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your refund was sent",
      ja: "\u8FD4\u91D1\u984D\u304C\u5165\u91D1\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${formatWon(p.amount, "ko")}\uC774 \uB4F1\uB85D\uD558\uC2E0 \uACC4\uC88C\uB85C \uC785\uAE08 \uCC98\uB9AC\uB410\uC5B4\uC694.`,
      en: `${formatWon(p.amount, "en")} was sent to your registered account.`,
      ja: `${formatWon(p.amount, "ja")}\u304C\u3054\u767B\u9332\u306E\u53E3\u5EA7\u306B\u5165\u91D1\u3055\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  /** 판매자에게 — 본문은 거래방 SYSTEM 문구와 같다 */
  "admin.refundRejectedToSeller": {
    title: fixedText({
      ko: "\uAD6C\uB9E4\uC790 \uD658\uBD88 \uC2E0\uCCAD\uC774 \uC778\uD50C\uB9BD \uC6B4\uC601\uC790\uC5D0 \uC758\uD574 \uAC70\uC808\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "The buyer's refund request was declined by the Inflip team",
      ja: "\u8CFC\u5165\u8005\u306E\u8FD4\u91D1\u7533\u8ACB\u304CInflip\u904B\u55B6\u8005\u306B\u3088\u308A\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => refundRejectedChatMessage(IP_RIGHT_LABELS_I18N[lang][p.rightType], lang), "body")
  },
  // ── 주문: 추가금 ──
  "admin.addonConfirmedBuyer": {
    title: fixedText({
      ko: "\uCD94\uAC00\uAE08 \uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Additional payment confirmed",
      ja: "\u8FFD\u52A0\u6599\u91D1\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uCD94\uAC00\uAE08 ${formatWon(p.amount, "ko")} \uC785\uAE08\uC774 \uD655\uC778\uB410\uC5B4\uC694. \uD310\uB9E4\uC790\uAC00 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD558\uBA74 \uC54C\uB824\uB4DC\uB9B4\uAC8C\uC694.`,
      en: `We confirmed your additional payment of ${formatWon(p.amount, "en")}. We'll let you know when the seller issues the license.`,
      ja: `\u8FFD\u52A0\u6599\u91D1${formatWon(p.amount, "ja")}\u306E\u5165\u91D1\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002\u8CA9\u58F2\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3057\u305F\u3089\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002`
    }), "body")
  },
  "admin.addonConfirmedSeller": {
    title: fixedText({
      ko: "\uCD94\uAC00\uAE08 \uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Additional payment confirmed",
      ja: "\u8FFD\u52A0\u6599\u91D1\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uCD94\uAC00\uAE08 ${formatWon(p.amount, "ko")} \uC785\uAE08\uC774 \uD655\uC778\uB410\uC5B4\uC694. \uC138\uBD80 \uB0B4\uC6A9 \uD655\uC815\uC774 \uB05D\uB0AC\uB2E4\uBA74 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD574 \uC8FC\uC138\uC694.`,
      en: `The buyer's additional payment of ${formatWon(p.amount, "en")} was confirmed. If the details are finalized, please issue the license.`,
      ja: `\u8FFD\u52A0\u6599\u91D1${formatWon(p.amount, "ja")}\u306E\u5165\u91D1\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002\u8A73\u7D30\u306E\u78BA\u5B9A\u304C\u6E08\u3093\u3060\u3089\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  // ── 로열티 ── (period 는 'YYYY-MM' 그대로)
  "admin.royaltyDepositConfirmed": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Royalty payment confirmed",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const periods = p.periods.join(", ");
      return tr(lang, {
        ko: `${periods} \uB85C\uC5F4\uD2F0 ${formatWon(p.amount, "ko")} \uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC5B4\uC694.`,
        en: `We confirmed your royalty payment of ${formatWon(p.amount, "en")} for ${periods}.`,
        ja: `${periods}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3${formatWon(p.amount, "ja")}\u306E\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002`
      });
    }, "body")
  },
  "admin.royaltyRefundCompleted": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uD658\uAE09\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your royalty refund is complete",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u6255\u3044\u623B\u3057\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB85C\uC5F4\uD2F0 \uC815\uC815\uC73C\uB85C ${won3(p.amount, "ko")}\uC744 \uD658\uAE09\uD588\uC5B4\uC694.`,
      en: `We refunded ${won3(p.amount, "en")} after correcting the ${p.period} royalty.`,
      ja: `${p.period}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u8A02\u6B63\u306B\u3088\u308A${won3(p.amount, "ja")}\u3092\u6255\u3044\u623B\u3057\u307E\u3057\u305F\u3002`
    }), "body")
  },
  "admin.royaltyPaidOut": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uC815\uC0B0\uC774 \uC9C0\uAE09\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your royalty payout was sent",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u7CBE\u7B97\u304C\u652F\u6255\u308F\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB85C\uC5F4\uD2F0 \uC815\uC0B0 ${formatWon(p.amount, "ko")}\uC774 \uC9C0\uAE09\uB418\uC5C8\uC5B4\uC694.`,
      en: `Your ${p.period} royalty payout of ${formatWon(p.amount, "en")} was sent.`,
      ja: `${p.period}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u7CBE\u7B97${formatWon(p.amount, "ja")}\u304C\u652F\u6255\u308F\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  "admin.royaltyClawedBack": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uC815\uC815\uBD84 \uD68C\uC218\uAC00 \uCC98\uB9AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Royalty correction recovered",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u8A02\u6B63\u5206\u306E\u56DE\u53CE\u304C\u51E6\u7406\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB85C\uC5F4\uD2F0 \uC815\uC815\uC73C\uB85C \uACFC\uB2E4 \uC9C0\uAE09\uB41C ${won3(p.amount, "ko")}\uC774 \uD68C\uC218 \uCC98\uB9AC\uB418\uC5C8\uC5B4\uC694.`,
      en: `After correcting the ${p.period} royalty, the overpaid ${won3(p.amount, "en")} was recovered.`,
      ja: `${p.period}\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u8A02\u6B63\u306B\u3088\u308A\u3001\u904E\u5270\u306B\u652F\u6255\u308F\u308C\u305F${won3(p.amount, "ja")}\u304C\u56DE\u53CE\u3055\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  "admin.royaltyObjectionDismissed": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uBCF4\uACE0 \uC774\uC758\uAC00 \uAE30\uAC01\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "The royalty report objection was dismissed",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A\u3078\u306E\u7570\u8B70\u304C\u5374\u4E0B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uC5D0 \uB300\uD55C \uC774\uC758\uB97C \uD655\uC778\uD55C \uACB0\uACFC, \uBCF4\uACE0 \uB0B4\uC6A9\uC744 \uADF8\uB300\uB85C \uC720\uC9C0\uD574\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `We reviewed the objection to the ${p.period} sales report and are keeping the report as is. Reason: ${p.reason}`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u3078\u306E\u7570\u8B70\u3092\u78BA\u8A8D\u3057\u305F\u7D50\u679C\u3001\u5831\u544A\u5185\u5BB9\u3092\u305D\u306E\u307E\u307E\u7DAD\u6301\u3057\u307E\u3059\u3002\u7406\u7531: ${p.reason}`
    }), "body")
  },
  /** adjustment — 정정분 반려, reportAgain — 구매자에게 원래 보고를 다시 하라고 덧붙인다 */
  "admin.royaltyReportVoided": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uBCF4\uACE0\uAC00 \uBC18\uB824\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "The royalty report was rejected",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} ${p.adjustment ? "\uB85C\uC5F4\uD2F0 \uC815\uC815\uC774" : "\uB9E4\uCD9C \uBCF4\uACE0\uAC00"} \uBC18\uB824\uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `The ${p.period} ${p.adjustment ? "royalty correction" : "sales report"} was rejected. Reason: ${p.reason}`,
      ja: `${p.period}\u306E${p.adjustment ? "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u8A02\u6B63" : "\u58F2\u4E0A\u5831\u544A"}\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F\u3002\u7406\u7531: ${p.reason}`
    }) + (p.reportAgain ? tr(lang, {
      ko: " \uB9DE\uB294 \uB9E4\uCD9C\uB85C \uB2E4\uC2DC \uBCF4\uACE0\uD574 \uC8FC\uC138\uC694.",
      en: " Please report the correct sales again.",
      ja: " \u6B63\u3057\u3044\u58F2\u4E0A\u3067\u518D\u5EA6\u5831\u544A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    }) : ""), "body")
  },
  /** 구매자 — 정정으로 추가 입금 (delta > 0) */
  "admin.royaltyAdjustedAdditional": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uCD94\uAC00 \uC785\uAE08\uC774 \uD544\uC694\uD574\uC694",
      en: "Additional royalty payment needed",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u8FFD\u52A0\u5165\u91D1\u304C\u5FC5\u8981\u3067\u3059"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C\uC774 ${formatWon(p.correctedRevenue, "ko")}\uC73C\uB85C \uC815\uC815\uB418\uC5B4 \uB85C\uC5F4\uD2F0 ${won3(p.delta, "ko")}\uC744 \uCD94\uAC00\uB85C \uC785\uAE08\uD574 \uC8FC\uC138\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `Your ${p.period} sales were corrected to ${formatWon(p.correctedRevenue, "en")}, so please pay an additional ${won3(p.delta, "en")} in royalty. Reason: ${p.reason}`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u304C${formatWon(p.correctedRevenue, "ja")}\u306B\u8A02\u6B63\u3055\u308C\u305F\u305F\u3081\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3${won3(p.delta, "ja")}\u3092\u8FFD\u52A0\u3067\u3054\u5165\u91D1\u304F\u3060\u3055\u3044\u3002\u7406\u7531: ${p.reason}`
    }), "body")
  },
  /** 구매자 — 정정으로 과다 납부 환급 (delta ≤ 0) */
  "admin.royaltyAdjustedRefund": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uACFC\uB2E4 \uB0A9\uBD80\uBD84\uC744 \uB3CC\uB824\uB4DC\uB824\uC694",
      en: "We'll refund your royalty overpayment",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u904E\u6255\u3044\u5206\u3092\u304A\u8FD4\u3057\u3057\u307E\u3059"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C\uC774 ${formatWon(p.correctedRevenue, "ko")}\uC73C\uB85C \uC815\uC815\uB418\uC5B4 ${won3(p.delta, "ko")}\uC744 \uD658\uAE09\uD574 \uB4DC\uB824\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `Your ${p.period} sales were corrected to ${formatWon(p.correctedRevenue, "en")}, so we'll refund ${won3(p.delta, "en")}. Reason: ${p.reason}`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u304C${formatWon(p.correctedRevenue, "ja")}\u306B\u8A02\u6B63\u3055\u308C\u305F\u305F\u3081\u3001${won3(p.delta, "ja")}\u3092\u6255\u3044\u623B\u3057\u307E\u3059\u3002\u7406\u7531: ${p.reason}`
    }), "body")
  },
  /** 판매자 — 정산액 변화. clawedBack: 이미 지급된 금액에서 회수 */
  "admin.royaltyAdjustedSeller": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uB9E4\uCD9C\uC774 \uC815\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Royalty sales were corrected",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u58F2\u4E0A\u304C\u8A02\u6B63\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const revenue = formatWon(p.correctedRevenue, lang);
      const delta = won3(p.payoutDelta, lang);
      const up = p.payoutDelta >= 0;
      return tr(lang, {
        ko: `${p.period} \uB9E4\uCD9C\uC774 ${revenue}\uC73C\uB85C \uC815\uC815\uB418\uC5B4 \uC815\uC0B0\uC561\uC774 ${up ? `${delta} \uB298\uC5B4\uC694` : `${delta} \uC904\uC5B4\uC694${p.clawedBack ? " (\uC774\uBBF8 \uC9C0\uAE09\uB41C \uAE08\uC561\uC5D0\uC11C \uD68C\uC218)" : ""}`}. \uC0AC\uC720: ${p.reason}`,
        en: `The ${p.period} sales were corrected to ${revenue}, so your payout ${up ? `increases by ${delta}` : `decreases by ${delta}${p.clawedBack ? " (recovered from the amount already paid)" : ""}`}. Reason: ${p.reason}`,
        ja: `${p.period}\u306E\u58F2\u4E0A\u304C${revenue}\u306B\u8A02\u6B63\u3055\u308C\u3001\u7CBE\u7B97\u984D\u304C${up ? `${delta}\u5897\u3048\u307E\u3059` : `${delta}\u6E1B\u308A\u307E\u3059${p.clawedBack ? "\uFF08\u652F\u6255\u3044\u6E08\u307F\u306E\u91D1\u984D\u304B\u3089\u56DE\u53CE\uFF09" : ""}`}\u3002\u7406\u7531: ${p.reason}`
      });
    }, "body")
  }
});
var ADMIN_NOTICE_SAMPLES = {
  "admin.listingPublished": {
    listingTitle: "Cafe logo"
  },
  "admin.listingRejected": {
    listingTitle: "Cafe logo",
    reason: "Missing proof of rights"
  },
  "admin.offerApproved": {
    listingTitle: "Cafe logo",
    rightType: "MERCHANDISE"
  },
  "admin.offerRejected": {
    listingTitle: "Cafe logo",
    rightType: "MERCHANDISE",
    reason: "Unclear scope"
  },
  "admin.offerEditApproved": {
    listingTitle: "Cafe logo",
    rightType: "MERCHANDISE"
  },
  "admin.offerEditRejected": {
    listingTitle: "Cafe logo",
    rightType: "MERCHANDISE",
    reason: "Unclear scope"
  },
  "admin.listingSuspended": {
    listingTitle: "Cafe logo",
    reason: "Rights dispute"
  },
  "admin.listingUnsuspended": {
    listingTitle: "Cafe logo"
  },
  "admin.sponsorshipApplicationApproved": {
    sponsorshipTitle: "Summer drink review"
  },
  "admin.sponsorshipApplicationRejected": {
    sponsorshipTitle: "Summer drink review",
    reason: "Audience mismatch"
  },
  "admin.sponsorshipPublished": {
    sponsorshipTitle: "Summer drink review"
  },
  "admin.sponsorshipRejected": {
    sponsorshipTitle: "Summer drink review",
    reason: "Missing image"
  },
  "admin.sponsorshipTakenDown": {
    sponsorshipTitle: "Summer drink review",
    reason: "Spam"
  },
  "admin.socialChannelApproved": {
    platform: "YOUTUBE",
    followerCount: 12345
  },
  "admin.socialChannelRejected": {
    platform: "YOUTUBE",
    reason: "Channel not found"
  },
  "admin.socialChannelRevoked": {
    platform: "YOUTUBE",
    reason: "Impersonation"
  },
  "admin.simplePinReset": {},
  "admin.supportInquiryAnswered": {
    inquiryTitle: "Payout question"
  },
  "admin.communityPostRemoved": {
    postTitle: "Hello",
    note: "Advertising"
  },
  "admin.communityCommentRemoved": {
    postTitle: "Hello",
    note: "Abuse"
  },
  "admin.proposalClosed": {
    listingTitle: "Cafe logo",
    reason: "No response"
  },
  "admin.settlementPaidOut": {
    listingTitle: "Cafe logo",
    amount: 9e4
  },
  "admin.depositReturnCreated": {
    kind: "OVERPAYMENT",
    amount: 5e3,
    bank: "KB",
    reason: "Paid twice"
  },
  "admin.depositReturned": {
    kind: "OVERPAYMENT",
    amount: 5e3,
    bank: "KB",
    accountNumber: "123-456"
  },
  "admin.violationReportActioned": {
    note: "Warned the buyer"
  },
  "admin.violationReportDismissed": {
    note: "No violation found"
  },
  "admin.licenseSuspended": {
    listingTitle: "Cafe logo",
    reason: "Under review"
  },
  "admin.licenseResumed": {
    listingTitle: "Cafe logo"
  },
  "admin.licenseAmendmentProposed": {
    listingTitle: "Cafe logo"
  },
  "admin.licenseAmendmentCancelled": {
    listingTitle: "Cafe logo"
  },
  "admin.refundApproved": {
    afterClawback: true
  },
  "admin.refundRejected": {
    reason: "License already used"
  },
  "admin.refundApprovalRevoked": {
    reason: "Approved by mistake"
  },
  "admin.refundCompleted": {
    amount: 3e4
  },
  "admin.refundRejectedToSeller": {
    rightType: "MERCHANDISE"
  },
  "admin.addonConfirmedBuyer": {
    amount: 1e4
  },
  "admin.addonConfirmedSeller": {
    amount: 1e4
  },
  "admin.royaltyDepositConfirmed": {
    periods: [
      "2026-08",
      "2026-09"
    ],
    amount: 12e3
  },
  "admin.royaltyRefundCompleted": {
    period: "2026-08",
    amount: -3e3
  },
  "admin.royaltyPaidOut": {
    period: "2026-08",
    amount: 9e3
  },
  "admin.royaltyClawedBack": {
    period: "2026-08",
    amount: -2e3
  },
  "admin.royaltyObjectionDismissed": {
    period: "2026-08",
    reason: "Report matches receipts"
  },
  "admin.royaltyReportVoided": {
    period: "2026-08",
    adjustment: false,
    reason: "Wrong month",
    reportAgain: true
  },
  "admin.royaltyAdjustedAdditional": {
    period: "2026-08",
    correctedRevenue: 5e5,
    delta: 2e3,
    reason: "Missed sales"
  },
  "admin.royaltyAdjustedRefund": {
    period: "2026-08",
    correctedRevenue: 3e5,
    delta: -2e3,
    reason: "Double counted"
  },
  "admin.royaltyAdjustedSeller": {
    period: "2026-08",
    correctedRevenue: 3e5,
    payoutDelta: -1800,
    clawedBack: true,
    reason: "Double counted"
  }
};

// src/notices/chat-messages.ts
function orderLabelIn(order, lang) {
  const months = order.durationMonths;
  const period = months ? tr(lang, {
    ko: `${months}\uAC1C\uC6D4`,
    en: months === 1 ? "1 month" : `${months} months`,
    ja: `${months}\u304B\u6708`
  }) : null;
  const labels = IP_RIGHT_LABELS_I18N[lang];
  return `${labels[order.rightType] ?? order.rightType}${period ? ` \xB7 ${period}` : ""}`;
}
__name(orderLabelIn, "orderLabelIn");
function labelOf(p, lang) {
  if (!p.orders?.length) return null;
  return p.orders.map((o) => orderLabelIn(o, lang)).join(lang === "ja" ? "\u3001" : ", ");
}
__name(labelOf, "labelOf");
function prefixed(p, lang, text) {
  const label = labelOf(p, lang);
  return label ? `[${label}] ${text}` : text;
}
__name(prefixed, "prefixed");
var fixed = /* @__PURE__ */ __name((text) => (p, lang) => prefixed(p, lang, text[lang]), "fixed");
var CHAT_MESSAGES = defineChatMessages({
  // ─── 방 ───
  /** 주문 거래방이 처음 열릴 때 */
  "chat.roomWelcome": fixed(CHAT_ROOM_WELCOME_MESSAGE_I18N),
  /** 1:1 방이 처음 열릴 때 */
  "chat.directWelcome": fixed(CHAT_DIRECT_WELCOME_MESSAGE_I18N),
  /** 관리자 합류 */
  "chat.adminJoined": fixed(CHAT_ADMIN_JOINED_MESSAGE_I18N),
  /** 관리자 퇴장 */
  "chat.adminLeft": fixed(CHAT_ADMIN_LEFT_MESSAGE_I18N),
  /** 상대가 방을 나감 */
  "chat.participantLeft": fixed(CHAT_PARTICIPANT_LEFT_MESSAGE_I18N),
  /** 방의 주문이 모두 취소·환불로 끝나 방을 닫음 */
  "chat.roomClosed": fixed(CHAT_ROOM_CLOSED_MESSAGE_I18N),
  // ─── 주문 상태 전이 ───
  /** 상태 전이 — 문구가 있는 상태만 (PAID·LICENSE_ISSUED(기한 모를 때)·DISPUTED·REFUNDED·CANCELLED·PAYOUT_COMPLETED·SETTLEMENT_PENDING·TERMINATED) */
  "chat.orderStatus": /* @__PURE__ */ __name((p, lang) => {
    const ko = ORDER_STATUS_SYSTEM_MESSAGE_I18N.ko[p.status];
    if (!ko) throw new Error(`\uC0C1\uD0DC \uBB38\uAD6C \uC5C6\uC74C: ${p.status}`);
    return prefixed(p, lang, ORDER_STATUS_SYSTEM_MESSAGE_I18N[lang][p.status] ?? ko);
  }, "chat.orderStatus"),
  /** 발급 — 자동 구매확정 기한(ISO 시각, 계약 시간대로 표시) */
  "chat.licenseIssued": /* @__PURE__ */ __name((p, lang) => prefixed(p, lang, licenseIssuedChatMessage({
    purchaseConfirmDueAt: new Date(p.purchaseConfirmDueAt),
    issuedAt: new Date(p.issuedAt),
    startsAt: p.startsAt ? new Date(p.startsAt) : null,
    timeZone: p.timeZone
  }, lang)), "chat.licenseIssued"),
  /** 계약 해지 취소 — 해지 전 상태로 돌아갈 때 */
  "chat.terminationCancelled": fixed(TERMINATION_CANCELLED_SYSTEM_MESSAGE_I18N),
  /** 분쟁 기각 — to 는 돌아간 상태 */
  "chat.disputeDismissed": /* @__PURE__ */ __name((p, lang) => prefixed(p, lang, DISPUTE_DISMISSED_SYSTEM_MESSAGES_I18N[lang][p.to]), "chat.disputeDismissed"),
  // ─── 라이선스 ───
  /** 발급 예정 내용 등록·수정·구매자 확인 */
  "chat.licenseDraft": /* @__PURE__ */ __name((p, lang) => LICENSE_DRAFT_SYSTEM_MESSAGES[p.action](labelOf(p, lang), lang), "chat.licenseDraft"),
  /** 라이선스 수정 제안·동의·거절·반영·철회 — by 는 AGREED·DECLINED 일 때 */
  "chat.licenseAmendment": /* @__PURE__ */ __name((p, lang) => p.action === "AGREED" || p.action === "DECLINED" ? LICENSE_AMENDMENT_CHAT_MESSAGES[p.action](labelOf(p, lang), p.by ?? "BUYER", lang) : LICENSE_AMENDMENT_CHAT_MESSAGES[p.action](labelOf(p, lang), lang), "chat.licenseAmendment"),
  /** 라이선스 사용 중지 — 사유는 관리자가 쓴 원문 */
  "chat.licenseSuspended": /* @__PURE__ */ __name((p, lang) => LICENSE_SUSPENSION_CHAT_MESSAGES.SUSPENDED(labelOf(p, lang), p.reason, lang), "chat.licenseSuspended"),
  /** 라이선스 사용 중지 해제 */
  "chat.licenseResumed": /* @__PURE__ */ __name((p, lang) => LICENSE_SUSPENSION_CHAT_MESSAGES.RESUMED(labelOf(p, lang), lang), "chat.licenseResumed"),
  /** 발급 지연 안내 (판매자에게만) — days 는 입금 확인 뒤 지난 날수 */
  "chat.licenseIssueDelayed": /* @__PURE__ */ __name((p, lang) => licenseIssueDelayedChatMessage(labelOf(p, lang), p.days, p.draft, lang), "chat.licenseIssueDelayed"),
  /** 계약 기간 만료 */
  "chat.licenseExpired": fixed(LICENSE_EXPIRED_CHAT_MESSAGE_I18N),
  // ─── 추가금 ───
  /** 추가금 요청·취소·입금 확인 — amount 는 원 */
  "chat.addonPayment": /* @__PURE__ */ __name((p, lang) => ADDON_PAYMENT_SYSTEM_MESSAGES[p.action](formatWon(p.amount, lang), lang), "chat.addonPayment"),
  // ─── 구매확정 ───
  /** 구매확정 — by USER(구매자)·SYSTEM(기한 지나 자동), totalAmount 0 이면 정산 문구를 뺀다 */
  "chat.purchaseConfirmed": /* @__PURE__ */ __name((p, lang) => prefixed(p, lang, purchaseConfirmedChatMessage(p.by, p.totalAmount, lang)), "chat.purchaseConfirmed"),
  // ─── 환불 ───
  /** 구매자 환불 신청 — rightType 은 권리 종류 코드 */
  "chat.refundRequested": /* @__PURE__ */ __name((p, lang) => refundRequestedChatMessage(rightLabel(p.rightType, lang), lang), "chat.refundRequested"),
  /** 환불 신청 거절 (운영자) */
  "chat.refundRejected": /* @__PURE__ */ __name((p, lang) => refundRejectedChatMessage(rightLabel(p.rightType, lang), lang), "chat.refundRejected"),
  // ─── 판매자 위반 신고 ───
  "chat.violationReportOpened": /* @__PURE__ */ __name((_p, lang) => VIOLATION_REPORT_CHAT_MESSAGES_I18N[lang].OPENED, "chat.violationReportOpened"),
  /** 조치 완료 — note 는 관리자가 쓴 원문 */
  "chat.violationReportActioned": /* @__PURE__ */ __name((p, lang) => VIOLATION_REPORT_CHAT_MESSAGES_I18N[lang].ACTIONED(p.note), "chat.violationReportActioned"),
  /** 기각 — note 는 관리자가 쓴 원문 */
  "chat.violationReportDismissed": /* @__PURE__ */ __name((p, lang) => VIOLATION_REPORT_CHAT_MESSAGES_I18N[lang].DISMISSED(p.note), "chat.violationReportDismissed"),
  // ─── 로열티 (period 는 'YYYY-MM', 금액은 원, 사유는 쓴 사람의 원문) ───
  "chat.royaltyReported": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.REPORTED(p.period, p.royalty, lang), "chat.royaltyReported"),
  "chat.royaltyRevised": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.REVISED(p.period, p.before, p.after, lang), "chat.royaltyRevised"),
  "chat.royaltyVoided": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.VOIDED(p.period, p.by, p.reason, lang), "chat.royaltyVoided"),
  "chat.royaltyObjected": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.OBJECTED(p.period, lang), "chat.royaltyObjected"),
  "chat.royaltyObjectionDismissed": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.OBJECTION_DISMISSED(p.period, lang), "chat.royaltyObjectionDismissed"),
  /** 정정 — delta 양수면 추가 입금, 음수면 구매자 환급 */
  "chat.royaltyAdjusted": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.ADJUSTED(p.period, p.delta, lang), "chat.royaltyAdjusted"),
  "chat.royaltyDepositConfirmed": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.DEPOSIT_CONFIRMED(p.periods, p.total, lang), "chat.royaltyDepositConfirmed"),
  "chat.royaltyRefundCompleted": /* @__PURE__ */ __name((p, lang) => ROYALTY_CHAT_MESSAGES.REFUND_COMPLETED(p.period, p.amount, lang), "chat.royaltyRefundCompleted")
});
function rightLabel(rightType, lang) {
  return IP_RIGHT_LABELS_I18N[lang][rightType] ?? rightType;
}
__name(rightLabel, "rightLabel");
var GROUP = {
  orders: [
    {
      rightType: "CONTENT_SECONDARY",
      durationMonths: 6
    }
  ]
};
var CHAT_MESSAGE_SAMPLES = {
  "chat.roomWelcome": {},
  "chat.directWelcome": {},
  "chat.adminJoined": {},
  "chat.adminLeft": {},
  "chat.participantLeft": {},
  "chat.roomClosed": {},
  "chat.orderStatus": {
    status: "PAID",
    ...GROUP
  },
  "chat.licenseIssued": {
    purchaseConfirmDueAt: "2026-11-03T03:00:00.000Z",
    issuedAt: "2026-10-27T03:00:00.000Z",
    startsAt: null,
    timeZone: "Asia/Seoul"
  },
  "chat.terminationCancelled": {},
  "chat.disputeDismissed": {
    to: "SETTLEMENT_PENDING"
  },
  "chat.licenseDraft": {
    action: "CREATED",
    ...GROUP
  },
  "chat.licenseAmendment": {
    action: "AGREED",
    by: "SELLER",
    ...GROUP
  },
  "chat.licenseSuspended": {
    reason: "Used outside the agreed scope",
    ...GROUP
  },
  "chat.licenseResumed": {},
  "chat.licenseIssueDelayed": {
    days: 3,
    draft: "AWAITING_BUYER"
  },
  "chat.licenseExpired": GROUP,
  "chat.addonPayment": {
    action: "REQUESTED",
    amount: 15e4
  },
  "chat.purchaseConfirmed": {
    by: "USER",
    totalAmount: 3e4,
    ...GROUP
  },
  "chat.refundRequested": {
    rightType: "CONTENT_SECONDARY"
  },
  "chat.refundRejected": {
    rightType: "CONTENT_SECONDARY"
  },
  "chat.violationReportOpened": {},
  "chat.violationReportActioned": {
    note: "Warned the buyer"
  },
  "chat.violationReportDismissed": {
    note: "No violation found"
  },
  "chat.royaltyReported": {
    period: "2026-08",
    royalty: 12e3
  },
  "chat.royaltyRevised": {
    period: "2026-08",
    before: 12e3,
    after: 15e3
  },
  "chat.royaltyVoided": {
    period: "2026-08",
    by: "ADMIN",
    reason: "Wrong amount"
  },
  "chat.royaltyObjected": {
    period: "2026-08"
  },
  "chat.royaltyObjectionDismissed": {
    period: "2026-08"
  },
  "chat.royaltyAdjusted": {
    period: "2026-08",
    delta: -3e3
  },
  "chat.royaltyDepositConfirmed": {
    periods: [
      "2026-08",
      "2026-09"
    ],
    total: 27e3
  },
  "chat.royaltyRefundCompleted": {
    period: "2026-08",
    amount: 3e3
  }
};

// src/notices/community.ts
function koreanBoundary(n) {
  const trim = /* @__PURE__ */ __name((v) => String(Number(v.toFixed(2))), "trim");
  if (n >= 1e8) return `${trim(n / 1e8)}\uC5B5`;
  if (n >= 1e4) return `${trim(n / 1e4)}\uB9CC`;
  if (n >= 1e3) return `${trim(n / 1e3)}\uCC9C`;
  return String(n);
}
__name(koreanBoundary, "koreanBoundary");
function nickname(tier, lang) {
  const flipper = tr(lang, {
    ko: "\uD50C\uB9AC\uD37C",
    en: "Flipper",
    ja: "\u30D5\u30EA\u30C3\u30D1\u30FC"
  });
  if (tier === null) return flipper;
  if (lang === "ko") return `${koreanBoundary(tier)} ${flipper}`;
  const short = new Intl.NumberFormat(INTL_LOCALE[lang], {
    notation: "compact",
    maximumFractionDigits: 2
  }).format(tier);
  return lang === "en" ? `${short} ${flipper}` : `${short}${flipper}`;
}
__name(nickname, "nickname");
var COMMUNITY_NOTICES = defineNotices({
  /** 내 글 좋아요 — 본문은 글 제목 */
  "community.postLiked": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const n = nickname(p.tier, lang);
      return tr(lang, {
        ko: `${n}\uAC00 \uB0B4 \uAE00\uC744 \uC88B\uC544\uD574\uC694`,
        en: `${n} liked your post`,
        ja: `${n}\u3055\u3093\u304C\u3042\u306A\u305F\u306E\u6295\u7A3F\u306B\u3044\u3044\u306D\u3057\u307E\u3057\u305F`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p) => p.postTitle, "body")
  },
  /** 내 댓글에 답글 — 본문은 답글 미리보기 */
  "community.commentReplied": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const n = nickname(p.tier, lang);
      return tr(lang, {
        ko: `${n}\uAC00 \uB0B4 \uB313\uAE00\uC5D0 \uB2F5\uAE00\uC744 \uB0A8\uACBC\uC5B4\uC694`,
        en: `${n} replied to your comment`,
        ja: `${n}\u3055\u3093\u304C\u3042\u306A\u305F\u306E\u30B3\u30E1\u30F3\u30C8\u306B\u8FD4\u4FE1\u3057\u307E\u3057\u305F`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p) => p.preview, "body")
  },
  /** 내 글에 댓글 — 본문은 댓글 미리보기 */
  "community.postCommented": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const n = nickname(p.tier, lang);
      return tr(lang, {
        ko: `${n}\uAC00 \uB0B4 \uAE00\uC5D0 \uB313\uAE00\uC744 \uB0A8\uACBC\uC5B4\uC694`,
        en: `${n} commented on your post`,
        ja: `${n}\u3055\u3093\u304C\u3042\u306A\u305F\u306E\u6295\u7A3F\u306B\u30B3\u30E1\u30F3\u30C8\u3057\u307E\u3057\u305F`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p) => p.preview, "body")
  }
});
var COMMUNITY_NOTICE_SAMPLES = {
  "community.postLiked": {
    tier: 1e4,
    postTitle: "My first post"
  },
  "community.commentReplied": {
    tier: null,
    preview: "Thanks!"
  },
  "community.postCommented": {
    tier: 1e3,
    preview: "Great post"
  }
};

// src/notices/domain.ts
var CONSEQUENCE = {
  ko: "\uAE30\uD55C\uAE4C\uC9C0 \uC785\uAE08\uD558\uC9C0 \uC54A\uC73C\uBA74 \uACC4\uC815 \uC774\uC6A9(\uC811\uC18D)\uC774 \uC815\uC9C0\uB418\uACE0, \uB77C\uC774\uC120\uC2A4 \uACC4\uC57D\uACFC \uC774\uC6A9\uC57D\uAD00\uC5D0 \uB530\uB77C \uBC95\uC801 \uC870\uCE58\uB97C \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.",
  en: "If you don't pay by the deadline, your account access will be suspended and legal action may be taken under the license agreement and terms of service.",
  ja: "\u671F\u9650\u307E\u3067\u306B\u5165\u91D1\u3055\u308C\u306A\u3044\u5834\u5408\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5229\u7528\uFF08\u30ED\u30B0\u30A4\u30F3\uFF09\u304C\u505C\u6B62\u3055\u308C\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u5951\u7D04\u304A\u3088\u3073\u5229\u7528\u898F\u7D04\u306B\u57FA\u3065\u304D\u6CD5\u7684\u63AA\u7F6E\u3092\u53D7\u3051\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002"
};
var UNSUSPENDED = {
  ko: " \uACC4\uC815 \uC811\uC18D \uC815\uC9C0\uB3C4 \uD480\uB838\uC5B4\uC694.",
  en: " Your account access has also been restored.",
  ja: " \u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30ED\u30B0\u30A4\u30F3\u505C\u6B62\u3082\u89E3\u9664\u3055\u308C\u307E\u3057\u305F\u3002"
};
var amountIn = /* @__PURE__ */ __name((p, lang) => formatWon(p.amount, lang), "amountIn");
var dueIn = /* @__PURE__ */ __name((p, lang) => formatInTimeZone(p.dueAt, p.timeZone, {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit"
}, INTL_LOCALE[lang]), "dueIn");
var unsuspendedIn = /* @__PURE__ */ __name((p, lang) => p.unsuspended ? UNSUSPENDED[lang] : "", "unsuspendedIn");
function accountIn(p, lang) {
  const account = p.account;
  if (!account) {
    return tr(lang, {
      ko: "\uC815\uC0B0 \uB0B4\uC5ED\uC5D0 \uC548\uB0B4\uB41C \uD50C\uB7AB\uD3FC \uACC4\uC88C",
      en: "the platform account shown in your payout history",
      ja: "\u7CBE\u7B97\u5C65\u6B74\u306B\u8A18\u8F09\u3055\u308C\u305F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u53E3\u5EA7"
    });
  }
  return tr(lang, {
    ko: `${account.bankName} ${account.accountNumber} (\uC608\uAE08\uC8FC ${account.holderName})`,
    en: `${account.bankName} ${account.accountNumber} (account holder ${account.holderName})`,
    ja: `${account.bankName} ${account.accountNumber}\uFF08\u53E3\u5EA7\u540D\u7FA9 ${account.holderName}\uFF09`
  });
}
__name(accountIn, "accountIn");
var DOMAIN_NOTICES = defineNotices({
  "domain.payoutClawbackRequested": {
    title: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC815\uC0B0\uAE08 ${amountIn(p, lang)}\uC744 \uB3CC\uB824\uC8FC\uC154\uC57C \uD574\uC694`,
      en: `Please return ${amountIn(p, lang)} of your payout`,
      ja: `\u7CBE\u7B97\u91D1${amountIn(p, lang)}\u306E\u8FD4\u9084\u3092\u304A\u9858\u3044\u3057\u307E\u3059`
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC774\uBBF8 \uC9C0\uAE09\uD55C \uC815\uC0B0\uC758 \uC8FC\uBB38\uC744 \uD658\uBD88\uD558\uAC8C \uB3FC, \uD658\uBD88\uD560 \uBAAB ${amountIn(p, lang)}\uC744 \uBA3C\uC800 \uB3CC\uB824\uBC1B\uC544\uC694. ${dueIn(p, lang)}\uAE4C\uC9C0 ${accountIn(p, lang)}\uB85C \uC785\uAE08\uD574 \uC8FC\uC138\uC694. \uC785\uAE08\uC774 \uD655\uC778\uB418\uBA74 \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uD658\uBD88\uD574\uC694. ${CONSEQUENCE.ko}`,
      en: `An order from a payout we already sent is being refunded, so we need the refund share of ${amountIn(p, lang)} back first. Please send it to ${accountIn(p, lang)} by ${dueIn(p, lang)}. Once we confirm your payment, we'll refund the buyer. ${CONSEQUENCE.en}`,
      ja: `\u7CBE\u7B97\u6E08\u307F\u306E\u6CE8\u6587\u304C\u8FD4\u91D1\u3055\u308C\u308B\u305F\u3081\u3001\u8FD4\u91D1\u5206\u306E${amountIn(p, lang)}\u3092\u5148\u306B\u8FD4\u9084\u3044\u305F\u3060\u304D\u307E\u3059\u3002${dueIn(p, lang)}\u307E\u3067\u306B${accountIn(p, lang)}\u3078\u3054\u5165\u91D1\u304F\u3060\u3055\u3044\u3002\u5165\u91D1\u3092\u78BA\u8A8D\u5F8C\u3001\u8CFC\u5165\u8005\u306B\u8FD4\u91D1\u3057\u307E\u3059\u3002${CONSEQUENCE.ja}`
    }), "body")
  },
  "domain.payoutClawbackDue": {
    title: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC815\uC0B0\uAE08 \uD68C\uC218 \uAE30\uD55C\uC774 \uB2E4\uAC00\uC640\uC694 (${dueIn(p, lang)})`,
      en: `Payout clawback deadline is coming up (${dueIn(p, lang)})`,
      ja: `\u7CBE\u7B97\u91D1\u306E\u56DE\u53CE\u671F\u9650\u304C\u8FD1\u3065\u3044\u3066\u3044\u307E\u3059\uFF08${dueIn(p, lang)}\uFF09`
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${amountIn(p, lang)}\uC744 ${dueIn(p, lang)}\uAE4C\uC9C0 ${accountIn(p, lang)}\uB85C \uC785\uAE08\uD574 \uC8FC\uC138\uC694. ${CONSEQUENCE.ko}`,
      en: `Please send ${amountIn(p, lang)} to ${accountIn(p, lang)} by ${dueIn(p, lang)}. ${CONSEQUENCE.en}`,
      ja: `${amountIn(p, lang)}\u3092${dueIn(p, lang)}\u307E\u3067\u306B${accountIn(p, lang)}\u3078\u3054\u5165\u91D1\u304F\u3060\u3055\u3044\u3002${CONSEQUENCE.ja}`
    }), "body")
  },
  "domain.payoutClawbackOverdue": {
    title: fixedText({
      ko: "\uC815\uC0B0\uAE08 \uD68C\uC218 \uAE30\uD55C\uC774 \uC9C0\uB098 \uACC4\uC815 \uC811\uC18D\uC774 \uC815\uC9C0\uB410\uC5B4\uC694",
      en: "Your account access was suspended because the clawback deadline passed",
      ja: "\u7CBE\u7B97\u91D1\u306E\u56DE\u53CE\u671F\u9650\u304C\u904E\u304E\u305F\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30ED\u30B0\u30A4\u30F3\u304C\u505C\u6B62\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${amountIn(p, lang)}\uC744 ${accountIn(p, lang)}\uB85C \uC785\uAE08\uD558\uBA74 \uD655\uC778 \uD6C4 \uC811\uC18D \uC815\uC9C0\uB97C \uD480\uC5B4 \uB4DC\uB824\uC694. \uC785\uAE08\uD558\uC9C0 \uC54A\uC73C\uBA74 \uB77C\uC774\uC120\uC2A4 \uACC4\uC57D\uACFC \uC774\uC6A9\uC57D\uAD00\uC5D0 \uB530\uB77C \uBC95\uC801 \uC870\uCE58\uB97C \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.`,
      en: `Send ${amountIn(p, lang)} to ${accountIn(p, lang)} and we'll restore your access once we confirm it. If you don't pay, legal action may be taken under the license agreement and terms of service.`,
      ja: `${amountIn(p, lang)}\u3092${accountIn(p, lang)}\u3078\u3054\u5165\u91D1\u3044\u305F\u3060\u304F\u3068\u3001\u78BA\u8A8D\u5F8C\u306B\u30ED\u30B0\u30A4\u30F3\u505C\u6B62\u3092\u89E3\u9664\u3057\u307E\u3059\u3002\u5165\u91D1\u3055\u308C\u306A\u3044\u5834\u5408\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u5951\u7D04\u304A\u3088\u3073\u5229\u7528\u898F\u7D04\u306B\u57FA\u3065\u304D\u6CD5\u7684\u63AA\u7F6E\u3092\u53D7\u3051\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002`
    }), "body")
  },
  "domain.payoutClawbackCollected": {
    title: fixedText({
      ko: "\uC815\uC0B0\uAE08 \uD68C\uC218\uAC00 \uD655\uC778\uB410\uC5B4\uC694",
      en: "Payout clawback confirmed",
      ja: "\u7CBE\u7B97\u91D1\u306E\u56DE\u53CE\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${amountIn(p, lang)} \uC785\uAE08\uC774 \uD655\uC778\uB410\uC5B4\uC694.${unsuspendedIn(p, lang)}`,
      en: `We've confirmed your payment of ${amountIn(p, lang)}.${unsuspendedIn(p, lang)}`,
      ja: `${amountIn(p, lang)}\u306E\u5165\u91D1\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002${unsuspendedIn(p, lang)}`
    }), "body")
  },
  "domain.payoutClawbackCancelled": {
    title: fixedText({
      ko: "\uC815\uC0B0\uAE08 \uD68C\uC218 \uC694\uCCAD\uC774 \uCDE8\uC18C\uB410\uC5B4\uC694",
      en: "Payout clawback request canceled",
      ja: "\u7CBE\u7B97\u91D1\u306E\u56DE\u53CE\u4F9D\u983C\u304C\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uD658\uBD88\uC774 \uCDE8\uC18C\uB3FC ${amountIn(p, lang)}\uC744 \uB3CC\uB824\uC8FC\uC2E4 \uD544\uC694\uAC00 \uC5C6\uC5B4\uC84C\uC5B4\uC694.${unsuspendedIn(p, lang)}`,
      en: `The refund was canceled, so you no longer need to return ${amountIn(p, lang)}.${unsuspendedIn(p, lang)}`,
      ja: `\u8FD4\u91D1\u304C\u53D6\u308A\u6D88\u3055\u308C\u305F\u305F\u3081\u3001${amountIn(p, lang)}\u3092\u8FD4\u9084\u3044\u305F\u3060\u304F\u5FC5\u8981\u306F\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002${unsuspendedIn(p, lang)}`
    }), "body")
  }
});
var CLAWBACK_SAMPLE = {
  amount: 12e3,
  dueAt: "2026-11-01T00:00:00.000Z",
  timeZone: "Asia/Seoul",
  account: {
    bankName: "KB Bank",
    accountNumber: "123-456",
    holderName: "Inflip"
  },
  unsuspended: true
};
var DOMAIN_NOTICE_SAMPLES = {
  "domain.payoutClawbackRequested": {
    ...CLAWBACK_SAMPLE,
    account: null
  },
  "domain.payoutClawbackDue": CLAWBACK_SAMPLE,
  "domain.payoutClawbackOverdue": CLAWBACK_SAMPLE,
  "domain.payoutClawbackCollected": CLAWBACK_SAMPLE,
  "domain.payoutClawbackCancelled": CLAWBACK_SAMPLE
};

// src/notices/listings.ts
var LISTINGS_NOTICES = defineNotices({});
var LISTINGS_NOTICE_SAMPLES = {};

// src/notices/members.ts
var MEMBERS_NOTICES = defineNotices({
  /** 상대 회원 탈퇴로 진행 중이던 조건 협의가 닫힘 */
  "members.proposalClosedByWithdrawal": {
    title: fixedText({
      ko: "\uC870\uAC74 \uD611\uC758\uAC00 \uC885\uB8CC\uB410\uC5B4\uC694",
      en: "Negotiation ended",
      ja: "\u6761\u4EF6\u4EA4\u6E09\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uC0C1\uB300 \uD68C\uC6D0\uC774 \uD0C8\uD1F4\uD574 \uC9C4\uD589 \uC911\uC774\uB358 \uD611\uC758\uAC00 \uC885\uB8CC\uB410\uC5B4\uC694.",
      en: "The other member deleted their account, so the negotiation in progress has ended.",
      ja: "\u76F8\u624B\u306E\u4F1A\u54E1\u304C\u9000\u4F1A\u3057\u305F\u305F\u3081\u3001\u9032\u884C\u4E2D\u306E\u6761\u4EF6\u4EA4\u6E09\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002"
    })
  }
});
var MEMBERS_NOTICE_SAMPLES = {
  "members.proposalClosedByWithdrawal": {}
};

// src/notices/order-events.ts
var reasonSuffix = /* @__PURE__ */ __name((reason, lang) => reason ? tr(lang, {
  ko: ` \uC0AC\uC720: ${reason}`,
  en: ` Reason: ${reason}`,
  ja: `\u7406\u7531\uFF1A${reason}`
}) : "", "reasonSuffix");
var ORDER_EVENT_NOTICES = defineNotices({
  /** 정산 계좌 등록 — 구매확정돼 정산할 거래가 있는데 판매자에게 정산 계좌가 없을 때 */
  "order-events.payoutAccountRequired": {
    title: fixedText({
      ko: "\uC815\uC0B0 \uACC4\uC88C\uB97C \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694",
      en: "Please register a payout account",
      ja: "\u7CBE\u7B97\u53E3\u5EA7\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044"
    }),
    body: fixedText({
      ko: "\uAD6C\uB9E4\uD655\uC815\uB3FC \uC815\uC0B0\uD560 \uD310\uB9E4\uAC00 \uC788\uC5B4\uC694. \uC815\uC0B0 \uACC4\uC88C\uB97C \uB4F1\uB85D\uD574\uC57C \uD310\uB9E4 \uB300\uAE08\uC744 \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694.",
      en: "A purchase has been confirmed and you have a sale to be paid out. Register a payout account to receive your sales proceeds.",
      ja: "\u8CFC\u5165\u78BA\u5B9A\u3055\u308C\u3001\u7CBE\u7B97\u5BFE\u8C61\u306E\u8CA9\u58F2\u304C\u3042\u308A\u307E\u3059\u3002\u8CA9\u58F2\u4EE3\u91D1\u3092\u53D7\u3051\u53D6\u308B\u306B\u306F\u7CBE\u7B97\u53E3\u5EA7\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    })
  },
  // ─── 구매자 — 주문 상태 전이 ───
  /** 입금 확인 (PAID) */
  "order-events.paymentConfirmed": {
    title: fixedText({
      ko: "\uACB0\uC81C\uAC00 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Payment confirmed",
      ja: "\u304A\u652F\u6255\u3044\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC5B4\uC694. \uD310\uB9E4\uC790\uAC00 \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD558\uBA74 \uC54C\uB824\uB4DC\uB9B4\uAC8C\uC694.",
      en: "Your payment has been confirmed. We'll let you know when the seller issues the license.",
      ja: "\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F\u3002\u8CA9\u58F2\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3057\u305F\u3089\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002"
    })
  },
  /** 발급 (LICENSE_ISSUED) */
  "order-events.licenseIssued": {
    title: fixedText({
      ko: "\uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your license has been issued",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uC8FC\uBB38\uD558\uC2E0 IP \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB418\uC5C8\uC5B4\uC694. \uBC1B\uC740 \uC790\uB8CC\uB97C \uD655\uC778\uD558\uACE0 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uAD6C\uB9E4\uD655\uC815\uD574 \uC8FC\uC138\uC694. \uD655\uC815\uD558\uC9C0 \uC54A\uC544\uB3C4 \uAE30\uD55C\uC774 \uC9C0\uB098\uBA74 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB3FC\uC694.",
      en: "The IP license you ordered has been issued. Check the materials you received and confirm the purchase on the order details page. If you don't, it will be confirmed automatically once the deadline passes.",
      ja: "\u3054\u6CE8\u6587\u306EIP\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u307E\u3057\u305F\u3002\u53D7\u3051\u53D6\u3063\u305F\u8CC7\u6599\u3092\u78BA\u8A8D\u3057\u3001\u6CE8\u6587\u8A73\u7D30\u304B\u3089\u8CFC\u5165\u78BA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u78BA\u5B9A\u3057\u306A\u304F\u3066\u3082\u671F\u9650\u304C\u904E\u304E\u308B\u3068\u81EA\u52D5\u3067\u78BA\u5B9A\u3055\u308C\u307E\u3059\u3002"
    })
  },
  /** 전액 환불 (REFUNDED) */
  "order-events.refunded": {
    title: fixedText({
      ko: "\uD658\uBD88\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your refund is complete",
      ja: "\u8FD4\u91D1\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uD658\uBD88\uAE08 \uC9C0\uAE09\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      en: "Your refund has been paid out.",
      ja: "\u8FD4\u91D1\u306E\u304A\u652F\u6255\u3044\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"
    })
  },
  /** 분쟁 접수 (DISPUTED) */
  "order-events.disputeOpened": {
    title: fixedText({
      ko: "\uBD84\uC7C1\uC774 \uC811\uC218\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "A dispute has been filed",
      ja: "\u7D1B\u4E89\u304C\u53D7\u3051\u4ED8\u3051\u3089\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uAD00\uB9AC\uC790\uAC00 \uACE7 \uCC44\uD305\uC5D0 \uD569\uB958\uD574 \uC911\uC7AC\uB97C \uC2DC\uC791\uD569\uB2C8\uB2E4.",
      en: "An admin will join the chat shortly to mediate.",
      ja: "\u307E\u3082\u306A\u304F\u7BA1\u7406\u8005\u304C\u30C1\u30E3\u30C3\u30C8\u306B\u53C2\u52A0\u3057\u3001\u4EF2\u88C1\u3092\u59CB\u3081\u307E\u3059\u3002"
    })
  },
  /**
  * 취소 — 묶음 결제는 권리 수(count, 단건이면 1)를 적고, 입금 기한 만료(expired — 시스템 취소)는 사유를 적는다
  */
  "order-events.orderCancelled": {
    title: /* @__PURE__ */ __name((p, lang) => tr(lang, p.expired ? {
      ko: "\uC785\uAE08 \uAE30\uD55C\uC774 \uC9C0\uB098 \uC8FC\uBB38\uC774 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your order was cancelled because the payment deadline passed",
      ja: "\u5165\u91D1\u671F\u9650\u304C\u904E\u304E\u305F\u305F\u3081\u6CE8\u6587\u304C\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F"
    } : {
      ko: "\uC8FC\uBB38\uC774 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your order has been cancelled",
      ja: "\u6CE8\u6587\u304C\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const { expired, count } = p;
      const many = count > 1;
      return tr(lang, {
        ko: `${expired ? "\uAE30\uD55C \uB0B4 \uC785\uAE08\uC774 \uD655\uC778\uB418\uC9C0 \uC54A\uC544 " : ""}${many ? `\uAD8C\uB9AC ${count}\uAC74\uC774 \uBAA8\uB450` : "\uC8FC\uBB38\uC774"} \uCDE8\uC18C\uB418\uC5C8\uC5B4\uC694.${expired ? " \uD544\uC694\uD558\uBA74 \uB2E4\uC2DC \uAD6C\uB9E4\uD560 \uC218 \uC788\uC5B4\uC694." : ""}`,
        en: expired ? `We didn't receive your payment by the deadline, so ${many ? `all ${count} rights were` : "your order was"} cancelled. You can buy again if you need to.` : `${many ? `All ${count} rights were` : "Your order was"} cancelled.`,
        ja: `${expired ? "\u671F\u9650\u5185\u306B\u5165\u91D1\u304C\u78BA\u8A8D\u3067\u304D\u306A\u304B\u3063\u305F\u305F\u3081\u3001" : ""}${many ? `\u6A29\u5229${count}\u4EF6\u304C\u3059\u3079\u3066` : "\u6CE8\u6587\u304C"}\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002${expired ? "\u5FC5\u8981\u3067\u3042\u308C\u3070\u518D\u5EA6\u8CFC\u5165\u3067\u304D\u307E\u3059\u3002" : ""}`
      });
    }, "body")
  },
  // ─── 판매자 ───
  /** 입금 확인 → 판매자에게 발급 요청 */
  "order-events.licenseIssueRequested": {
    title: fixedText({
      ko: "\uC785\uAE08\uC774 \uD655\uC778\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Payment confirmed",
      ja: "\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uAD6C\uB9E4\uC790\uC640 \uCC44\uD305\uC73C\uB85C \uC2E4\uC81C \uC0AC\uC6A9\uCC98 \uB4F1 \uC138\uBD80 \uB0B4\uC6A9\uC744 \uC815\uD55C \uB4A4 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uC62C\uB824 \uC8FC\uC138\uC694. \uAD6C\uB9E4\uC790\uAC00 \uD655\uC778\uD558\uBA74 \uADF8 \uB0B4\uC6A9 \uADF8\uB300\uB85C \uBC1C\uAE09\uD560 \uC218 \uC788\uC5B4\uC694.",
      en: "Agree on details like the actual usage with the buyer in chat, then post the license draft. Once the buyer confirms it, you can issue it exactly as is.",
      ja: "\u8CFC\u5165\u8005\u3068\u30C1\u30E3\u30C3\u30C8\u3067\u5B9F\u969B\u306E\u4F7F\u7528\u5148\u306A\u3069\u306E\u8A73\u7D30\u3092\u6C7A\u3081\u305F\u3046\u3048\u3067\u3001\u767A\u884C\u4E88\u5B9A\u306E\u5185\u5BB9\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8CFC\u5165\u8005\u304C\u78BA\u8A8D\u3059\u308B\u3068\u3001\u305D\u306E\u5185\u5BB9\u3069\u304A\u308A\u306B\u767A\u884C\u3067\u304D\u307E\u3059\u3002"
    })
  },
  // ─── 분쟁 기각 (api-admin) — reason 은 관리자가 쓴 원문 (잘라 둔 것) ───
  "order-events.disputeDismissedBuyer": {
    title: fixedText({
      ko: "\uAD00\uB9AC\uC790\uAC00 \uBD84\uC7C1\uC744 \uC885\uB8CC\uD588\uC5B4\uC694",
      en: "An admin closed the dispute",
      ja: "\u7BA1\u7406\u8005\u304C\u7D1B\u4E89\u3092\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: "\uAC80\uD1A0 \uACB0\uACFC \uBD84\uC7C1\uC774 \uAE30\uAC01\uB418\uC5B4 \uAC70\uB798\uAC00 \uADF8\uB300\uB85C \uC9C4\uD589\uB3FC\uC694.",
      en: "After review, the dispute was dismissed and the transaction will continue as is.",
      ja: "\u78BA\u8A8D\u306E\u7D50\u679C\u3001\u7D1B\u4E89\u306F\u5374\u4E0B\u3055\u308C\u3001\u53D6\u5F15\u306F\u305D\u306E\u307E\u307E\u9032\u307F\u307E\u3059\u3002"
    }) + reasonSuffix(p.reason, lang), "body")
  },
  /** settlementResumed — 정산 대기로 돌아가 정산이 다시 진행되는지 */
  "order-events.disputeDismissedSeller": {
    title: /* @__PURE__ */ __name((p, lang) => tr(lang, p.settlementResumed ? {
      ko: "\uBD84\uC7C1\uC774 \uC885\uB8CC\uB418\uC5B4 \uC815\uC0B0\uC774 \uB2E4\uC2DC \uC9C4\uD589\uB3FC\uC694",
      en: "The dispute is closed and your payout will resume",
      ja: "\u7D1B\u4E89\u304C\u7D42\u4E86\u3057\u3001\u7CBE\u7B97\u304C\u518D\u958B\u3055\u308C\u307E\u3059"
    } : {
      ko: "\uBD84\uC7C1\uC774 \uC885\uB8CC\uB410\uC5B4\uC694",
      en: "The dispute has been closed",
      ja: "\u7D1B\u4E89\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: "\uAD00\uB9AC\uC790\uAC00 \uBD84\uC7C1\uC744 \uAE30\uAC01\uD588\uC5B4\uC694.",
      en: "An admin dismissed the dispute.",
      ja: "\u7BA1\u7406\u8005\u304C\u7D1B\u4E89\u3092\u5374\u4E0B\u3057\u307E\u3057\u305F\u3002"
    }) + reasonSuffix(p.reason, lang), "body")
  },
  // ─── 계약 해지 (api-admin) — 구매자·판매자 같은 문구 ───
  /** kind·refundMode 는 코드, refundAmount 는 원, hasRoyalty 는 로열티 계약인지, reason 은 관리자가 쓴 원문 */
  "order-events.contractTerminated": {
    title: fixedText({
      ko: "\uACC4\uC57D\uC774 \uD574\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "The contract has been terminated",
      ja: "\u5951\u7D04\u304C\u89E3\u9664\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, l) => {
      const amount = formatWon(p.refundAmount, l);
      const mode = TERMINATION_REFUND_MODE_LABELS_I18N[l][p.refundMode];
      const kind = TERMINATION_KIND_LABELS_I18N[l][p.kind];
      const money = p.refundMode === TerminationRefundMode.NONE ? tr(l, {
        ko: "\uC120\uBD88\uC740 \uB3CC\uB824\uC8FC\uC9C0 \uC54A\uC544\uC694(\uBE44\uD658\uBD88).",
        en: "The prepayment will not be refunded (non-refundable).",
        ja: "\u524D\u6255\u3044\u91D1\u306F\u8FD4\u91D1\u3055\u308C\u307E\u305B\u3093\uFF08\u8FD4\u91D1\u306A\u3057\uFF09\u3002"
      }) : p.refundMode === TerminationRefundMode.FULL ? tr(l, {
        ko: `\uC120\uBD88 ${amount}\uC744 \uC804\uBD80 \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uB3CC\uB824\uC918\uC694(${mode}). \uC1A1\uAE08\uC774 \uB05D\uB098\uBA74 \uB2E4\uC2DC \uC54C\uB824\uB4DC\uB9B4\uAC8C\uC694.`,
        en: `The full prepayment of ${amount} will be returned to the buyer (${mode}). We'll let you know once the transfer is done.`,
        ja: `\u524D\u6255\u3044\u91D1${amount}\u3092\u5168\u984D\u8CFC\u5165\u8005\u306B\u8FD4\u91D1\u3057\u307E\u3059\uFF08${mode}\uFF09\u3002\u9001\u91D1\u304C\u5B8C\u4E86\u3057\u305F\u3089\u6539\u3081\u3066\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002`
      }) : tr(l, {
        ko: `\uC120\uBD88 \uC911 ${amount}\uC744 \uAD6C\uB9E4\uC790\uC5D0\uAC8C \uB3CC\uB824\uC918\uC694(${mode}). \uC1A1\uAE08\uC774 \uB05D\uB098\uBA74 \uB2E4\uC2DC \uC54C\uB824\uB4DC\uB9B4\uAC8C\uC694.`,
        en: `${amount} of the prepayment will be returned to the buyer (${mode}). We'll let you know once the transfer is done.`,
        ja: `\u524D\u6255\u3044\u91D1\u306E\u3046\u3061${amount}\u3092\u8CFC\u5165\u8005\u306B\u8FD4\u91D1\u3057\u307E\u3059\uFF08${mode}\uFF09\u3002\u9001\u91D1\u304C\u5B8C\u4E86\u3057\u305F\u3089\u6539\u3081\u3066\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002`
      });
      const royalty = p.hasRoyalty ? tr(l, {
        ko: " \uD574\uC9C0\uC77C\uC774 \uC788\uB294 \uB2EC\uAE4C\uC9C0\uC758 \uB85C\uC5F4\uD2F0\uB294 \uACC4\uC18D \uBCF4\uACE0\xB7\uC815\uC0B0\uB3FC\uC694.",
        en: " Royalties through the month of termination will still be reported and paid out.",
        ja: "\u89E3\u9664\u65E5\u306E\u3042\u308B\u6708\u307E\u3067\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306F\u5F15\u304D\u7D9A\u304D\u5831\u544A\u30FB\u7CBE\u7B97\u3055\u308C\u307E\u3059\u3002"
      }) : "";
      return tr(l, {
        ko: `${kind} \uC0AC\uC720\uB85C \uACC4\uC57D\uC774 \uD574\uC9C0\uB410\uC5B4\uC694. ${money}${royalty} \uC0AC\uC720: ${p.reason}`,
        en: `The contract was terminated (${kind}). ${money}${royalty} Reason: ${p.reason}`,
        ja: `${kind}\u3092\u7406\u7531\u306B\u5951\u7D04\u304C\u89E3\u9664\u3055\u308C\u307E\u3057\u305F\u3002${money}${royalty}\u7406\u7531\uFF1A${p.reason}`
      });
    }, "body")
  },
  /** 해지 취소 — reason 은 관리자가 쓴 취소 사유 원문 (없으면 생략) */
  "order-events.contractTerminationCancelled": {
    title: fixedText({
      ko: "\uACC4\uC57D \uD574\uC9C0\uAC00 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "The contract termination has been cancelled",
      ja: "\u5951\u7D04\u89E3\u9664\u304C\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: "\uAD00\uB9AC\uC790\uAC00 \uACC4\uC57D \uD574\uC9C0\uB97C \uCDE8\uC18C\uD588\uC5B4\uC694. \uACC4\uC57D\uC740 \uD574\uC9C0 \uC804 \uC0C1\uD0DC\uB85C \uC774\uC5B4\uC9C0\uACE0, \uD574\uC9C0\uC640 \uD568\uAED8 \uC815\uD55C \uD658\uBD88\uB3C4 \uCDE8\uC18C\uB410\uC5B4\uC694.",
      en: "An admin cancelled the contract termination. The contract continues as it was before the termination, and the refund set with it has been cancelled.",
      ja: "\u7BA1\u7406\u8005\u304C\u5951\u7D04\u89E3\u9664\u3092\u53D6\u308A\u6D88\u3057\u307E\u3057\u305F\u3002\u5951\u7D04\u306F\u89E3\u9664\u524D\u306E\u72B6\u614B\u3067\u7D99\u7D9A\u3055\u308C\u3001\u89E3\u9664\u3068\u3042\u308F\u305B\u3066\u6C7A\u3081\u305F\u8FD4\u91D1\u3082\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F\u3002"
    }) + reasonSuffix(p.reason, lang), "body")
  }
});
var ORDER_EVENT_NOTICE_SAMPLES = {
  "order-events.payoutAccountRequired": {},
  "order-events.paymentConfirmed": {},
  "order-events.licenseIssued": {},
  "order-events.refunded": {},
  "order-events.disputeOpened": {},
  "order-events.orderCancelled": {
    expired: true,
    count: 2
  },
  "order-events.licenseIssueRequested": {},
  "order-events.disputeDismissedBuyer": {
    reason: "The license was used as agreed"
  },
  "order-events.disputeDismissedSeller": {
    settlementResumed: true,
    reason: "The license was used as agreed"
  },
  "order-events.contractTerminated": {
    kind: "BUYER_BREACH",
    refundMode: "PARTIAL",
    refundAmount: 5e4,
    hasRoyalty: true,
    reason: "Repeated misuse"
  },
  "order-events.contractTerminationCancelled": {
    reason: "Terminated by mistake"
  }
};

// src/notices/orders.ts
var ORDERS_NOTICES = defineNotices({
  /** 입금 안내 — 주문(묶음)을 만들면 구매자에게 */
  "orders.depositInstruction": {
    title: fixedText({
      ko: "\uC785\uAE08 \uC548\uB0B4\uAC00 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4",
      en: "Your payment instructions are here",
      ja: "\u5165\u91D1\u306E\u3054\u6848\u5185\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC785\uAE08\uC790\uBA85 ${p.depositorName} \uC73C\uB85C ${formatWon(p.amount, "ko")}\uC744 \uAE30\uD55C \uB0B4 \uC785\uAE08\uD574\uC8FC\uC138\uC694.`,
      en: `Please transfer ${formatWon(p.amount, "en")} under the depositor name ${p.depositorName} before the deadline.`,
      ja: `\u632F\u8FBC\u540D\u7FA9\u300C${p.depositorName}\u300D\u3067${formatWon(p.amount, "ja")}\u3092\u671F\u9650\u5185\u306B\u304A\u632F\u308A\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 추가금 입금 요청 — memo 는 판매자가 쓴 글 */
  "orders.addonPaymentRequested": {
    title: fixedText({
      ko: "\uCD94\uAC00\uAE08 \uC785\uAE08 \uC694\uCCAD\uC774 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4",
      en: "You have an additional payment request",
      ja: "\u8FFD\u52A0\u6599\u91D1\u306E\u5165\u91D1\u4F9D\u983C\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.memo} \u2014 \uC785\uAE08\uC790\uBA85 ${p.depositorName} \uC73C\uB85C ${formatWon(p.amount, "ko")}\uC744 \uAE30\uD55C \uB0B4 \uC785\uAE08\uD574\uC8FC\uC138\uC694.`,
      en: `${p.memo} \u2014 Please transfer ${formatWon(p.amount, "en")} under the depositor name ${p.depositorName} before the deadline.`,
      ja: `${p.memo} \u2014 \u632F\u8FBC\u540D\u7FA9\u300C${p.depositorName}\u300D\u3067${formatWon(p.amount, "ja")}\u3092\u671F\u9650\u5185\u306B\u304A\u632F\u308A\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 환불 신청 — 판매자에게 (본문은 거래방 기록과 같은 문장) */
  "orders.refundRequested": {
    title: fixedText({
      ko: "\uD310\uB9E4 \uAC74\uC5D0 \uD658\uBD88 \uC2E0\uCCAD\uC774 \uC811\uC218\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "A refund was requested for your sale",
      ja: "\u8CA9\u58F2\u3057\u305F\u53D6\u5F15\u306B\u8FD4\u91D1\u7533\u8ACB\u304C\u3042\u308A\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => refundRequestedChatMessage(IP_RIGHT_LABELS_I18N[lang][p.rightType] ?? p.rightType, lang), "body")
  },
  /** 분쟁 접수 — 판매자에게 */
  "orders.disputeOpened": {
    title: fixedText({
      ko: "\uD310\uB9E4 \uAC74\uC5D0 \uBD84\uC7C1\uC774 \uC811\uC218\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "A dispute was opened for your sale",
      ja: "\u8CA9\u58F2\u3057\u305F\u53D6\u5F15\u306B\u7D1B\u4E89\u306E\u7533\u3057\u7ACB\u3066\u304C\u3042\u308A\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uAD00\uB9AC\uC790\uAC00 \uCC44\uD305\uC5D0 \uD569\uB958\uD574 \uC911\uC7AC\uB97C \uC2DC\uC791\uD569\uB2C8\uB2E4. \uCC44\uD305\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.",
      en: "An admin will join the chat to mediate. Please check the chat.",
      ja: "\u7BA1\u7406\u8005\u304C\u30C1\u30E3\u30C3\u30C8\u306B\u53C2\u52A0\u3057\u3066\u4EF2\u88C1\u3092\u59CB\u3081\u307E\u3059\u3002\u30C1\u30E3\u30C3\u30C8\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
    })
  },
  /** 판매자 위반 신고 — 구매자에게 */
  "orders.violationReported": {
    title: fixedText({
      ko: "\uD310\uB9E4\uC790\uAC00 \uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uC704\uBC18\uC744 \uC2E0\uACE0\uD588\uC5B4\uC694",
      en: "The seller reported a license violation",
      ja: "\u8CA9\u58F2\u8005\u304C\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u9055\u53CD\u3092\u5831\u544A\u3057\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uAD00\uB9AC\uC790\uAC00 \uD655\uC778\uD560 \uC608\uC815\uC774\uC5D0\uC694. \uCC44\uD305\uC5D0\uC11C \uC0C1\uD669\uC744 \uC124\uBA85\uD574 \uC8FC\uC138\uC694.",
      en: "An admin will review it. Please explain the situation in the chat.",
      ja: "\u7BA1\u7406\u8005\u304C\u78BA\u8A8D\u3059\u308B\u4E88\u5B9A\u3067\u3059\u3002\u30C1\u30E3\u30C3\u30C8\u3067\u72B6\u6CC1\u3092\u3054\u8AAC\u660E\u304F\u3060\u3055\u3044\u3002"
    })
  },
  /** 구매확정 — 판매자에게 */
  "orders.purchaseConfirmed": {
    title: fixedText({
      ko: "\uAD6C\uB9E4\uC790\uAC00 \uAD6C\uB9E4\uD655\uC815\uD588\uC5B4\uC694",
      en: "The buyer confirmed the purchase",
      ja: "\u8CFC\u5165\u8005\u304C\u8CFC\u5165\u78BA\u5B9A\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.listingTitle}" \uAC70\uB798\uAC00 \uD655\uC815\uB418\uC5B4 \uC815\uC0B0\uC774 \uC2DC\uC791\uB3FC\uC694.`,
      en: `The "${p.listingTitle}" deal is confirmed, and your payout will begin.`,
      ja: `\u300C${p.listingTitle}\u300D\u306E\u53D6\u5F15\u304C\u78BA\u5B9A\u3057\u3001\u7CBE\u7B97\u304C\u59CB\u307E\u308A\u307E\u3059\u3002`
    }), "body")
  },
  /** 발급 예정 내용 확인 요청 — 판매자가 올리거나(CREATED) 고쳤을 때(UPDATED) 구매자에게 */
  "orders.licenseDraftConfirmRequested": {
    title: /* @__PURE__ */ __name((p, lang) => p.action === "CREATED" ? tr(lang, {
      ko: "\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694",
      en: "Please review the planned license details",
      ja: "\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044"
    }) : tr(lang, {
      ko: "\uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC774 \uBC14\uB00C\uC5C8\uC5B4\uC694. \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694",
      en: "The planned license details changed. Please review them again",
      ja: "\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const created = p.action === "CREATED";
      return tr(lang, {
        ko: `${p.listingTitle} \u2014 \uD310\uB9E4\uC790\uAC00 ${created ? "\uC62C\uB9B0" : "\uACE0\uCE5C"} \uC0AC\uC6A9 \uC2DC\uC791\uC77C\xB7\uCD94\uAC00 \uD569\uC758 \uC0AC\uD56D\uC744 \uD655\uC778\uD558\uBA74 \uADF8 \uB0B4\uC6A9\uC73C\uB85C \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB3FC\uC694.`,
        en: `${p.listingTitle} \u2014 Once you confirm the start date and additional agreements the seller ${created ? "posted" : "updated"}, the license will be issued with those details.`,
        ja: `${p.listingTitle} \u2014 \u8CA9\u58F2\u8005\u304C${created ? "\u767B\u9332\u3057\u305F" : "\u4FEE\u6B63\u3057\u305F"}\u4F7F\u7528\u958B\u59CB\u65E5\u30FB\u8FFD\u52A0\u5408\u610F\u4E8B\u9805\u3092\u78BA\u8A8D\u3059\u308B\u3068\u3001\u305D\u306E\u5185\u5BB9\u3067\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u307E\u3059\u3002`
      });
    }, "body")
  },
  /** 발급 예정 내용 확인됨 — 판매자에게. paid: 확인 시점에 입금 확인(PAID)이라 바로 발급할 수 있는지 */
  "orders.licenseDraftConfirmed": {
    title: fixedText({
      ko: "\uAD6C\uB9E4\uC790\uAC00 \uBC1C\uAE09 \uC608\uC815 \uB0B4\uC6A9\uC744 \uD655\uC778\uD588\uC5B4\uC694",
      en: "The buyer confirmed the planned license details",
      ja: "\u8CFC\u5165\u8005\u304C\u767A\u884C\u4E88\u5B9A\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => `${p.listingTitle} \u2014 ${p.paid ? tr(lang, {
      ko: "\uD655\uC778\uB41C \uB0B4\uC6A9 \uADF8\uB300\uB85C \uB77C\uC774\uC120\uC2A4\uB97C \uBC1C\uAE09\uD560 \uC218 \uC788\uC5B4\uC694.",
      en: "You can now issue the license exactly as confirmed.",
      ja: "\u78BA\u8A8D\u3055\u308C\u305F\u5185\u5BB9\u306E\u307E\u307E\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u767A\u884C\u3067\u304D\u307E\u3059\u3002"
    }) : tr(lang, {
      ko: "\uC785\uAE08\uC774 \uD655\uC778\uB418\uBA74 \uC774 \uB0B4\uC6A9 \uADF8\uB300\uB85C \uBC1C\uAE09\uD560 \uC218 \uC788\uC5B4\uC694.",
      en: "Once payment is confirmed, you can issue it exactly as is.",
      ja: "\u5165\u91D1\u304C\u78BA\u8A8D\u3055\u308C\u308B\u3068\u3001\u3053\u306E\u5185\u5BB9\u306E\u307E\u307E\u767A\u884C\u3067\u304D\u307E\u3059\u3002"
    })}`, "body")
  },
  /** 라이선스 수정 반영 — 구매자·판매자 모두에게 */
  "orders.licenseAmended": {
    title: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.APPLIED(p.listingTitle, lang).title, "title"),
    body: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.APPLIED(p.listingTitle, lang).body, "body")
  },
  /** 라이선스 수정 거절 — 구매자·판매자 모두에게. by: 거절한 쪽 */
  "orders.licenseAmendmentDeclined": {
    title: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.DECLINED(p.listingTitle, p.by, lang).title, "title"),
    body: /* @__PURE__ */ __name((p, lang) => LICENSE_AMENDMENT_NOTICES.DECLINED(p.listingTitle, p.by, lang).body, "body")
  }
});
var ORDERS_NOTICE_SAMPLES = {
  "orders.depositInstruction": {
    depositorName: "INFLIP1234",
    amount: 3e4
  },
  "orders.addonPaymentRequested": {
    memo: "Extra month",
    depositorName: "INFLIP1234",
    amount: 5e4
  },
  "orders.refundRequested": {
    rightType: "NAME_BRAND"
  },
  "orders.disputeOpened": {},
  "orders.violationReported": {},
  "orders.purchaseConfirmed": {
    listingTitle: "Cafe logo"
  },
  "orders.licenseDraftConfirmRequested": {
    listingTitle: "Cafe logo",
    action: "UPDATED"
  },
  "orders.licenseDraftConfirmed": {
    listingTitle: "Cafe logo",
    paid: true
  },
  "orders.licenseAmended": {
    listingTitle: "Cafe logo"
  },
  "orders.licenseAmendmentDeclined": {
    listingTitle: "Cafe logo",
    by: "SELLER"
  }
};

// src/notices/proposals.ts
var PROPOSALS_NOTICES = defineNotices({
  /** 새 제안 — 판매자에게. buyerName 은 회원 이름(없으면 "구매 희망자") */
  "proposals.received": {
    title: fixedText({
      ko: "\uC870\uAC74 \uD611\uC758 \uC81C\uC548\uC774 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4",
      en: "You received a new offer",
      ja: "\u6761\u4EF6\u4EA4\u6E09\u306E\u63D0\u6848\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.buyerName ?? "\uAD6C\uB9E4 \uD76C\uB9DD\uC790"} \uB2D8\uC774 "${p.listingTitle}" \uC5D0 \uACC4\uC57D \uC870\uAC74\uC744 \uC81C\uC548\uD588\uC5B4\uC694.`,
      en: `${p.buyerName ?? "A prospective buyer"} proposed contract terms for "${p.listingTitle}".`,
      ja: p.buyerName ? `${p.buyerName}\u3055\u3093\u304C\u300C${p.listingTitle}\u300D\u306B\u5951\u7D04\u6761\u4EF6\u3092\u63D0\u6848\u3057\u307E\u3057\u305F\u3002` : `\u8CFC\u5165\u5E0C\u671B\u8005\u304C\u300C${p.listingTitle}\u300D\u306B\u5951\u7D04\u6761\u4EF6\u3092\u63D0\u6848\u3057\u307E\u3057\u305F\u3002`
    }), "body")
  },
  /** 수정 제안 — 상대에게 */
  "proposals.countered": {
    title: fixedText({
      ko: "\uC218\uC815 \uC81C\uC548\uC774 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4",
      en: "You received a counteroffer",
      ja: "\u4FEE\u6B63\u63D0\u6848\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC0C1\uB300\uAC00 \uC870\uAC74\uC744 \uC218\uC815\uD574 \uB2E4\uC2DC \uC81C\uC548\uD588\uC5B4\uC694. (${p.round}\uBC88\uC9F8 \uC81C\uC548)`,
      en: `The other party revised the terms and sent a new offer. (Offer #${p.round})`,
      ja: `\u76F8\u624B\u304C\u6761\u4EF6\u3092\u4FEE\u6B63\u3057\u3066\u518D\u63D0\u6848\u3057\u307E\u3057\u305F\u3002(${p.round}\u56DE\u76EE\u306E\u63D0\u6848)`
    }), "body")
  },
  /** 제안한 사람이 응답 전에 자기 제안을 고침 */
  "proposals.amended": {
    title: fixedText({
      ko: "\uC0C1\uB300\uAC00 \uC81C\uC548\uC744 \uACE0\uCCE4\uC2B5\uB2C8\uB2E4",
      en: "The other party edited their offer",
      ja: "\u76F8\u624B\u304C\u63D0\u6848\u3092\u4FEE\u6B63\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC751\uB2F5\uD558\uAE30 \uC804\uC5D0 \uBC14\uB010 \uC870\uAC74\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694. (${p.round}\uBC88\uC9F8 \uC81C\uC548)`,
      en: `Please check the updated terms before you respond. (Offer #${p.round})`,
      ja: `\u56DE\u7B54\u3059\u308B\u524D\u306B\u5909\u66F4\u3055\u308C\u305F\u6761\u4EF6\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002(${p.round}\u56DE\u76EE\u306E\u63D0\u6848)`
    }), "body")
  },
  /** 제안한 사람이 제안을 거둠 */
  "proposals.withdrawn": {
    title: fixedText({
      ko: "\uC0C1\uB300\uAC00 \uC81C\uC548\uC744 \uCDE8\uC18C\uD588\uC2B5\uB2C8\uB2E4",
      en: "The other party withdrew their offer",
      ja: "\u76F8\u624B\u304C\u63D0\u6848\u3092\u53D6\u308A\u6D88\u3057\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uC0C1\uB300\uAC00 \uD611\uC758 \uC81C\uC548\uC744 \uAC70\uB46C \uD611\uC758\uAC00 \uB05D\uB0AC\uC5B4\uC694.",
      en: "The other party withdrew their offer, so the negotiation has ended.",
      ja: "\u76F8\u624B\u304C\u63D0\u6848\u3092\u53D6\u308A\u4E0B\u3052\u305F\u305F\u3081\u3001\u6761\u4EF6\u4EA4\u6E09\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002"
    })
  },
  /** 수락으로 주문이 생겨 구매자에게 입금 안내 */
  "proposals.depositInstruction": {
    title: fixedText({
      ko: "\uC785\uAE08 \uC548\uB0B4\uAC00 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4",
      en: "Your payment instructions are here",
      ja: "\u5165\u91D1\u306E\u3054\u6848\u5185\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `\uC785\uAE08\uC790\uBA85 ${p.depositorName} \uC73C\uB85C ${formatWon(p.amount, "ko")}\uC744 \uAE30\uD55C \uB0B4 \uC785\uAE08\uD574\uC8FC\uC138\uC694.`,
      en: `Please transfer ${formatWon(p.amount, "en")} under the depositor name ${p.depositorName} before the deadline.`,
      ja: `\u632F\u8FBC\u540D\u7FA9\u300C${p.depositorName}\u300D\u3067${formatWon(p.amount, "ja")}\u3092\u671F\u9650\u5185\u306B\u304A\u632F\u308A\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 제안 수락 — 제안한 사람에게. 선불이 있으면 입금 뒤 발급, 없으면 바로 체결 */
  "proposals.accepted": {
    title: fixedText({
      ko: "\uC81C\uC548\uC774 \uC218\uB77D\uB418\uC5B4 \uACC4\uC57D\uC774 \uC131\uB9BD\uD588\uC2B5\uB2C8\uB2E4",
      en: "Your offer was accepted and the contract is set",
      ja: "\u63D0\u6848\u304C\u627F\u8AFE\u3055\u308C\u3001\u5951\u7D04\u304C\u6210\u7ACB\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => p.upfrontAmount > 0 ? tr(lang, {
      ko: "\uD569\uC758 \uC870\uAC74\uC73C\uB85C \uC8FC\uBB38\uC774 \uC0DD\uC131\uB410\uC5B4\uC694. \uC785\uAE08 \uD655\uC778 \uD6C4 \uB77C\uC774\uC120\uC2A4\uAC00 \uBC1C\uAE09\uB429\uB2C8\uB2E4.",
      en: "An order was created with the agreed terms. The license will be issued once the payment is confirmed.",
      ja: "\u5408\u610F\u3057\u305F\u6761\u4EF6\u3067\u6CE8\u6587\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002\u5165\u91D1\u78BA\u8A8D\u5F8C\u306B\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u767A\u884C\u3055\u308C\u307E\u3059\u3002"
    }) : tr(lang, {
      ko: "\uC120\uBD88 \uC5C6\uB294 \uB85C\uC5F4\uD2F0 \uACC4\uC57D\uC774 \uCCB4\uACB0\uB410\uC5B4\uC694. \uB77C\uC774\uC120\uC2A4 \uBC1C\uAE09\uC774 \uC9C4\uD589\uB429\uB2C8\uB2E4.",
      en: "A royalty-only contract with no upfront payment has been signed. The license will now be issued.",
      ja: "\u524D\u6255\u3044\u306A\u3057\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5951\u7D04\u304C\u7DE0\u7D50\u3055\u308C\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u767A\u884C\u3092\u9032\u3081\u307E\u3059\u3002"
    }), "body")
  },
  /** 제안 거절 — 제안한 사람에게 */
  "proposals.declined": {
    title: fixedText({
      ko: "\uC81C\uC548\uC774 \uAC70\uC808\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
      en: "Your offer was declined",
      ja: "\u63D0\u6848\u304C\u65AD\u3089\u308C\u307E\u3057\u305F"
    }),
    body: fixedText({
      ko: "\uC0C1\uB300\uAC00 \uD611\uC758 \uC81C\uC548\uC744 \uAC70\uC808\uD588\uC5B4\uC694.",
      en: "The other party declined your offer.",
      ja: "\u76F8\u624B\u304C\u63D0\u6848\u3092\u65AD\u308A\u307E\u3057\u305F\u3002"
    })
  }
});
var PROPOSALS_NOTICE_SAMPLES = {
  "proposals.received": {
    buyerName: "Jane",
    listingTitle: "Cafe logo"
  },
  "proposals.countered": {
    round: 2
  },
  "proposals.amended": {
    round: 3
  },
  "proposals.withdrawn": {},
  "proposals.depositInstruction": {
    depositorName: "Jane",
    amount: 3e4
  },
  "proposals.accepted": {
    upfrontAmount: 0
  },
  "proposals.declined": {}
};

// src/notices/reminders.ts
function dateLabel(date, lang) {
  const [y, m, d] = date.split("-");
  if (lang === "ko") return `${y}\uB144 ${Number(m)}\uC6D4 ${Number(d)}\uC77C`;
  return formatInTimeZone(`${date}T00:00:00Z`, "UTC", {
    year: "numeric",
    month: "long",
    day: "numeric"
  }, INTL_LOCALE[lang]);
}
__name(dateLabel, "dateLabel");
function licenseParts(p, lang) {
  return {
    deal: `${p.listingTitle} \xB7 ${IP_RIGHT_LABELS_I18N[lang][p.rightType] ?? p.rightType}`,
    until: dateLabel(lastUseDateOf(new Date(p.expiresAt), p.timeZone), lang)
  };
}
__name(licenseParts, "licenseParts");
var PURCHASE_CONFIRMED_TITLE = {
  ko: "\uAD6C\uB9E4\uD655\uC815\uB418\uC5C8\uC5B4\uC694",
  en: "Purchase confirmed",
  ja: "\u8CFC\u5165\u304C\u78BA\u5B9A\u3057\u307E\u3057\u305F"
};
var REMINDERS_NOTICES = defineNotices({
  /** 라이선스 만료 임박 — 구매자. daysLeft 는 오늘을 포함해 쓸 수 있는 날 수 */
  "reminders.licenseExpiring": {
    title: /* @__PURE__ */ __name((p, lang) => p.daysLeft <= 1 ? tr(lang, {
      ko: "\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uAE30\uAC04\uC774 \uC624\uB298\uAE4C\uC9C0\uC608\uC694",
      en: "Your license period ends today",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u306F\u672C\u65E5\u307E\u3067\u3067\u3059"
    }) : tr(lang, {
      ko: `\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uAE30\uAC04\uC774 ${p.daysLeft}\uC77C \uB0A8\uC558\uC5B4\uC694`,
      en: `${p.daysLeft} days left on your license period`,
      ja: `\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u304C\u6B8B\u308A${p.daysLeft}\u65E5\u3067\u3059`
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const { deal, until } = licenseParts(p, lang);
      return tr(lang, {
        ko: `[${deal}] ${until}\uAE4C\uC9C0 \uC4F8 \uC218 \uC788\uC5B4\uC694. \uACC4\uC18D \uC4F0\uB824\uBA74 \uAE30\uAC04\uC774 \uB05D\uB098\uAE30 \uC804\uC5D0 IP \uC8FC\uBB38\uC744 \uB2E4\uC2DC \uC9C4\uD589\uD574 \uC8FC\uC138\uC694.`,
        en: `[${deal}] You can use it until ${until}. To keep using it, place a new IP order before the period ends.`,
        ja: `[${deal}] ${until}\u307E\u3067\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u306B\u306A\u308B\u5834\u5408\u306F\u3001\u671F\u9593\u304C\u7D42\u308F\u308B\u524D\u306BIP\u3092\u518D\u5EA6\u3054\u6CE8\u6587\u304F\u3060\u3055\u3044\u3002`
      });
    }, "body")
  },
  /** 라이선스 만료 임박 — 판매자 */
  "reminders.licenseExpiringSeller": {
    title: /* @__PURE__ */ __name((p, lang) => p.daysLeft <= 1 ? tr(lang, {
      ko: "\uD310\uB9E4\uD55C \uB77C\uC774\uC120\uC2A4\uC758 \uC0AC\uC6A9 \uAE30\uAC04\uC774 \uC624\uB298\uAE4C\uC9C0\uC608\uC694",
      en: "A license you sold ends today",
      ja: "\u8CA9\u58F2\u3057\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u306F\u672C\u65E5\u307E\u3067\u3067\u3059"
    }) : tr(lang, {
      ko: `\uD310\uB9E4\uD55C \uB77C\uC774\uC120\uC2A4\uC758 \uC0AC\uC6A9 \uAE30\uAC04\uC774 ${p.daysLeft}\uC77C \uB0A8\uC558\uC5B4\uC694`,
      en: `${p.daysLeft} days left on a license you sold`,
      ja: `\u8CA9\u58F2\u3057\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u304C\u6B8B\u308A${p.daysLeft}\u65E5\u3067\u3059`
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => {
      const { deal, until } = licenseParts(p, lang);
      return tr(lang, {
        ko: `[${deal}] \uAD6C\uB9E4\uC790\uC758 \uC0AC\uC6A9 \uAE30\uAC04\uC774 ${until}\uC5D0 \uB05D\uB098\uC694.`,
        en: `[${deal}] The buyer's usage period ends on ${until}.`,
        ja: `[${deal}] \u8CFC\u5165\u8005\u306E\u4F7F\u7528\u671F\u9593\u306F${until}\u306B\u7D42\u4E86\u3057\u307E\u3059\u3002`
      });
    }, "body")
  },
  /** 라이선스 만료됨 — 구매자 */
  "reminders.licenseExpired": {
    title: fixedText({
      ko: "\uB77C\uC774\uC120\uC2A4 \uC0AC\uC6A9 \uAE30\uAC04\uC774 \uB05D\uB0AC\uC5B4\uC694",
      en: "Your license period has ended",
      ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const { deal, until } = licenseParts(p, lang);
      return tr(lang, {
        ko: `[${deal}] \uACC4\uC57D \uAE30\uAC04\uC774 ${until}\uB85C \uB05D\uB0AC\uC5B4\uC694. \uACC4\uC18D \uC4F0\uB824\uBA74 IP \uC8FC\uBB38\uC744 \uB2E4\uC2DC \uC9C4\uD589\uD574 \uC8FC\uC138\uC694.`,
        en: `[${deal}] The contract period ended on ${until}. To keep using it, place a new IP order.`,
        ja: `[${deal}] \u5951\u7D04\u671F\u9593\u306F${until}\u3067\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u306B\u306A\u308B\u5834\u5408\u306F\u3001IP\u3092\u518D\u5EA6\u3054\u6CE8\u6587\u304F\u3060\u3055\u3044\u3002`
      });
    }, "body")
  },
  /** 라이선스 만료됨 — 판매자 */
  "reminders.licenseExpiredSeller": {
    title: fixedText({
      ko: "\uD310\uB9E4\uD55C \uB77C\uC774\uC120\uC2A4\uC758 \uC0AC\uC6A9 \uAE30\uAC04\uC774 \uB05D\uB0AC\uC5B4\uC694",
      en: "A license you sold has ended",
      ja: "\u8CA9\u58F2\u3057\u305F\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4F7F\u7528\u671F\u9593\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => {
      const { deal, until } = licenseParts(p, lang);
      return tr(lang, {
        ko: `[${deal}] \uACC4\uC57D \uAE30\uAC04\uC774 ${until}\uB85C \uB05D\uB0AC\uC5B4\uC694. \uAD6C\uB9E4\uC790\uAC00 \uB2E4\uC2DC \uC4F0\uB824\uBA74 \uC0C8\uB85C \uC8FC\uBB38\uD574\uC57C \uD574\uC694.`,
        en: `[${deal}] The contract period ended on ${until}. The buyer needs to place a new order to use it again.`,
        ja: `[${deal}] \u5951\u7D04\u671F\u9593\u306F${until}\u3067\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u8CFC\u5165\u8005\u304C\u518D\u5EA6\u5229\u7528\u3059\u308B\u306B\u306F\u65B0\u305F\u306A\u6CE8\u6587\u304C\u5FC5\u8981\u3067\u3059\u3002`
      });
    }, "body")
  },
  /** 로열티 매출 보고 기한 임박 — 구매자. period 'YYYY-MM', paymentDay 매달 N일 */
  "reminders.royaltyReportDue": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uB9E4\uCD9C \uBCF4\uACE0 \uAE30\uD55C\uC774 \uB2E4\uAC00\uC640\uC694",
      en: "Your royalty sales report is due soon",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u58F2\u4E0A\u5831\u544A\u306E\u671F\u9650\u304C\u8FD1\u3065\u3044\u3066\u3044\u307E\u3059"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uC640 \uB85C\uC5F4\uD2F0 \uC785\uAE08 \uAE30\uD55C\uC774 \uB9E4\uB2EC ${p.paymentDay}\uC77C\uC774\uC5D0\uC694.`,
      en: `The ${p.period} sales report and royalty payment are due on day ${p.paymentDay} of each month.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u3068\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5165\u91D1\u306E\u671F\u9650\u306F\u6BCE\u6708${p.paymentDay}\u65E5\u3067\u3059\u3002`
    }), "body")
  },
  /** 로열티 매출 보고 연체 — 구매자 */
  "reminders.royaltyReportOverdue": {
    title: fixedText({
      ko: "\uB85C\uC5F4\uD2F0 \uB9E4\uCD9C \uBCF4\uACE0\uAC00 \uC5F0\uCCB4\uB410\uC5B4\uC694",
      en: "Your royalty sales report is overdue",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u58F2\u4E0A\u5831\u544A\u304C\u5EF6\u6EDE\u3057\u3066\u3044\u307E\u3059"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0 \uAE30\uD55C(\uB9E4\uB2EC ${p.paymentDay}\uC77C)\uC774 \uC9C0\uB0AC\uC5B4\uC694. \uC9C0\uAE08 \uBCF4\uACE0\uD574 \uC8FC\uC138\uC694.`,
      en: `The ${p.period} sales report deadline (day ${p.paymentDay} of each month) has passed. Please report now.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u671F\u9650(\u6BCE\u6708${p.paymentDay}\u65E5)\u304C\u904E\u304E\u307E\u3057\u305F\u3002\u4ECA\u3059\u3050\u5831\u544A\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 로열티 매출 보고 연체 — 판매자 */
  "reminders.royaltyReportOverdueSeller": {
    title: fixedText({
      ko: "\uAD6C\uB9E4\uC790\uC758 \uB85C\uC5F4\uD2F0 \uBCF4\uACE0\uAC00 \uC9C0\uC5F0\uB418\uACE0 \uC788\uC5B4\uC694",
      en: "The buyer's royalty report is late",
      ja: "\u8CFC\u5165\u8005\u306E\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u5831\u544A\u304C\u9045\u308C\u3066\u3044\u307E\u3059"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uAC00 \uD569\uC758\uD55C \uC9C0\uAE09\uC77C(\uB9E4\uB2EC ${p.paymentDay}\uC77C)\uAE4C\uC9C0 \uB3C4\uCC29\uD558\uC9C0 \uC54A\uC558\uC5B4\uC694.`,
      en: `The ${p.period} sales report didn't arrive by the agreed payment date (day ${p.paymentDay} of each month).`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u304C\u3001\u5408\u610F\u3057\u305F\u652F\u6255\u65E5(\u6BCE\u6708${p.paymentDay}\u65E5)\u307E\u3067\u306B\u5C4A\u3044\u3066\u3044\u307E\u305B\u3093\u3002`
    }), "body")
  },
  /** 구매확정 기한이 지나 자동 확정 — 구매자 */
  "reminders.purchaseAutoConfirmed": {
    title: fixedText(PURCHASE_CONFIRMED_TITLE),
    body: fixedText({
      ko: "\uAD6C\uB9E4\uD655\uC815 \uAE30\uD55C\uC774 \uC9C0\uB098 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB410\uC5B4\uC694. \uACC4\uC57D \uAE30\uAC04 \uC911 \uBB38\uC81C\uAC00 \uC0DD\uAE30\uBA74 \uC8FC\uBB38 \uC0C1\uC138\uC5D0\uC11C \uBD84\uC7C1\uC744 \uC2E0\uCCAD\uD574 \uC8FC\uC138\uC694.",
      en: "The purchase confirmation deadline passed, so your purchase was confirmed automatically. If a problem comes up during the contract, open a dispute from the order details.",
      ja: "\u8CFC\u5165\u78BA\u5B9A\u306E\u671F\u9650\u304C\u904E\u304E\u305F\u305F\u3081\u3001\u81EA\u52D5\u3067\u78BA\u5B9A\u3057\u307E\u3057\u305F\u3002\u5951\u7D04\u671F\u9593\u4E2D\u306B\u554F\u984C\u304C\u751F\u3058\u305F\u5834\u5408\u306F\u3001\u6CE8\u6587\u8A73\u7D30\u304B\u3089\u7D1B\u4E89\u3092\u7533\u8ACB\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    })
  },
  /** 구매확정 기한이 지나 자동 확정 — 판매자 */
  "reminders.purchaseAutoConfirmedSeller": {
    title: fixedText(PURCHASE_CONFIRMED_TITLE),
    body: fixedText({
      ko: "\uAD6C\uB9E4\uD655\uC815 \uAE30\uD55C\uC774 \uC9C0\uB098 \uC790\uB3D9\uC73C\uB85C \uD655\uC815\uB418\uC5B4 \uC815\uC0B0\uC774 \uC2DC\uC791\uB3FC\uC694.",
      en: "The purchase confirmation deadline passed, so the purchase was confirmed automatically and your payout is starting.",
      ja: "\u8CFC\u5165\u78BA\u5B9A\u306E\u671F\u9650\u304C\u904E\u304E\u3066\u81EA\u52D5\u3067\u78BA\u5B9A\u3057\u305F\u305F\u3081\u3001\u7CBE\u7B97\u304C\u59CB\u307E\u308A\u307E\u3059\u3002"
    })
  },
  /** 자동 구매확정 임박 — 구매자. dueAt 은 구매확정 기한(ISO), timeZone 은 계약 시간대 */
  "reminders.purchaseConfirmDue": {
    title: /* @__PURE__ */ __name((p, lang) => {
      const date = formatInTimeZone(p.dueAt, p.timeZone, {
        month: "long",
        day: "numeric"
      }, INTL_LOCALE[lang]);
      return tr(lang, {
        ko: `${date}\uC5D0 \uC790\uB3D9 \uAD6C\uB9E4\uD655\uC815\uB3FC\uC694`,
        en: `Your purchase will be confirmed automatically on ${date}`,
        ja: `${date}\u306B\u81EA\u52D5\u3067\u8CFC\u5165\u78BA\u5B9A\u3055\u308C\u307E\u3059`
      });
    }, "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.listingTitle}" \uB77C\uC774\uC120\uC2A4\uB97C \uACC4\uC57D \uB0B4\uC6A9\uB300\uB85C \uBC1B\uC558\uB2E4\uBA74 \uAD6C\uB9E4\uD655\uC815\uC744 \uB20C\uB7EC \uC8FC\uC138\uC694. \uBB38\uC81C\uAC00 \uC788\uC73C\uBA74 \uD655\uC815 \uC804\uC5D0 \uBD84\uC7C1\uC744 \uC2E0\uCCAD\uD574 \uC8FC\uC138\uC694.`,
      en: `If you received the "${p.listingTitle}" license as agreed, tap Confirm purchase. If there's a problem, open a dispute before it's confirmed.`,
      ja: `\u300C${p.listingTitle}\u300D\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u5951\u7D04\u3069\u304A\u308A\u306B\u53D7\u3051\u53D6\u3063\u305F\u5834\u5408\u306F\u3001\u8CFC\u5165\u78BA\u5B9A\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u554F\u984C\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u78BA\u5B9A\u524D\u306B\u7D1B\u4E89\u3092\u7533\u8ACB\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 응답 기한이 지나 조건 협의 만료 — 당사자 둘 다. 상품을 못 찾으면 listingTitle null */
  "reminders.proposalExpired": {
    title: fixedText({
      ko: "\uC751\uB2F5 \uAE30\uD55C\uC774 \uC9C0\uB098 \uD611\uC758\uAC00 \uB05D\uB0AC\uC2B5\uB2C8\uB2E4",
      en: "The negotiation ended because the response deadline passed",
      ja: "\u56DE\u7B54\u671F\u9650\u304C\u904E\u304E\u305F\u305F\u3081\u3001\u6761\u4EF6\u4EA4\u6E09\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.listingTitle !== null ? `"${p.listingTitle}" ` : ""}\uC870\uAC74 \uD611\uC758\uC5D0 \uAE30\uD55C \uC548\uC5D0 \uC751\uB2F5\uC774 \uC5C6\uC5B4 \uD611\uC758\uAC00 \uB9CC\uB8CC\uB410\uC5B4\uC694. \uD544\uC694\uD558\uBA74 \uC0C8\uB85C \uC81C\uC548\uD574 \uC8FC\uC138\uC694.`,
      en: p.listingTitle !== null ? `No one responded to the negotiation for "${p.listingTitle}" in time, so it expired. Send a new offer if needed.` : "No one responded to the negotiation in time, so it expired. Send a new offer if needed.",
      ja: `${p.listingTitle !== null ? `\u300C${p.listingTitle}\u300D\u306E` : ""}\u6761\u4EF6\u4EA4\u6E09\u306B\u671F\u9650\u5185\u306E\u56DE\u7B54\u304C\u306A\u304B\u3063\u305F\u305F\u3081\u3001\u4EA4\u6E09\u306F\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u65B0\u3057\u304F\u63D0\u6848\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 방문 예정일까지 확정되지 않은 협찬 지원 자동 취소 — 지원자 */
  "reminders.sponsorshipApplicationExpired": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uC790\uB3D9 \uCDE8\uC18C\uB410\uC5B4\uC694",
      en: "Your sponsorship application was automatically canceled",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u81EA\u52D5\u3067\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C\uC774 \uBC29\uBB38 \uC608\uC815\uC77C\uAE4C\uC9C0 \uD655\uC815\uB418\uC9C0 \uC54A\uC544 \uC9C0\uC6D0\uC774 \uCDE8\uC18C\uB410\uC5B4\uC694. \uBAA8\uC9D1 \uC911\uC774\uBA74 \uB2E4\uB978 \uB0A0\uC9DC\uB85C \uB2E4\uC2DC \uC9C0\uC6D0\uD560 \uC218 \uC788\uC5B4\uC694.`,
      en: `Your application to "${p.sponsorshipTitle}" wasn't confirmed by the visit date, so it was canceled. If it's still recruiting, you can apply again with a different date.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u304C\u8A2A\u554F\u4E88\u5B9A\u65E5\u307E\u3067\u306B\u78BA\u5B9A\u3057\u306A\u304B\u3063\u305F\u305F\u3081\u3001\u5FDC\u52DF\u304C\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F\u3002\u52DF\u96C6\u4E2D\u3067\u3042\u308C\u3070\u5225\u306E\u65E5\u7A0B\u3067\u518D\u5EA6\u5FDC\u52DF\u3067\u304D\u307E\u3059\u3002`
    }), "body")
  }
});
var LICENSE_SAMPLE = {
  listingTitle: "Cafe logo",
  rightType: "CONTENT_SECONDARY",
  expiresAt: "2026-08-14T15:00:00.000Z",
  timeZone: "Asia/Seoul"
};
var REMINDERS_NOTICE_SAMPLES = {
  "reminders.licenseExpiring": {
    ...LICENSE_SAMPLE,
    daysLeft: 3
  },
  "reminders.licenseExpiringSeller": {
    ...LICENSE_SAMPLE,
    daysLeft: 1
  },
  "reminders.licenseExpired": {
    ...LICENSE_SAMPLE
  },
  "reminders.licenseExpiredSeller": {
    ...LICENSE_SAMPLE
  },
  "reminders.royaltyReportDue": {
    period: "2026-09",
    paymentDay: 10
  },
  "reminders.royaltyReportOverdue": {
    period: "2026-09",
    paymentDay: 10
  },
  "reminders.royaltyReportOverdueSeller": {
    period: "2026-09",
    paymentDay: 10
  },
  "reminders.purchaseAutoConfirmed": {},
  "reminders.purchaseAutoConfirmedSeller": {},
  "reminders.purchaseConfirmDue": {
    listingTitle: "Cafe logo",
    dueAt: "2026-10-14T03:00:00.000Z",
    timeZone: "Asia/Seoul"
  },
  "reminders.proposalExpired": {
    listingTitle: null
  },
  "reminders.sponsorshipApplicationExpired": {
    sponsorshipTitle: "Cafe visit"
  }
};

// src/notices/royalties.ts
var ROYALTIES_NOTICES = defineNotices({
  /** 판매자 이의에 구매자가 증빙을 추가 → 판매자 */
  "royalties.evidenceAdded": {
    title: /* @__PURE__ */ __name((_p, lang) => tr(lang, {
      ko: "\uAD6C\uB9E4\uC790\uAC00 \uB9E4\uCD9C \uC99D\uBE59\uC744 \uCD94\uAC00\uD588\uC5B4\uC694",
      en: "The buyer added sales evidence",
      ja: "\u8CFC\u5165\u8005\u304C\u58F2\u4E0A\u306E\u8A3C\u6191\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uC5D0 \uB300\uD55C \uC774\uC758\uC5D0 \uAD6C\uB9E4\uC790\uAC00 \uC99D\uBE59\uC744 \uC62C\uB838\uC5B4\uC694. \uAD00\uB9AC\uC790\uAC00 \uD655\uC778\uD574\uC694.`,
      en: `The buyer uploaded evidence for your objection to the ${p.period} sales report. An admin will review it.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u3078\u306E\u7570\u8B70\u306B\u5BFE\u3057\u3001\u8CFC\u5165\u8005\u304C\u8A3C\u6191\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002\u7BA1\u7406\u8005\u304C\u78BA\u8A8D\u3057\u307E\u3059\u3002`
    }), "body")
  },
  /** 판매자가 매출 보고를 반려 → 구매자 */
  "royalties.sellerVoided": {
    title: /* @__PURE__ */ __name((_p, lang) => tr(lang, {
      ko: "\uD310\uB9E4\uC790\uAC00 \uB9E4\uCD9C \uBCF4\uACE0\uB97C \uBC18\uB824\uD588\uC5B4\uC694",
      en: "The seller rejected your sales report",
      ja: "\u8CA9\u58F2\u8005\u304C\u58F2\u4E0A\u5831\u544A\u3092\u5DEE\u3057\u623B\u3057\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uAC00 \uBC18\uB824\uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason} \uB9DE\uB294 \uB9E4\uCD9C\uACFC \uC99D\uBE59\uC73C\uB85C \uB2E4\uC2DC \uBCF4\uACE0\uD574 \uC8FC\uC138\uC694.`,
      en: `Your ${p.period} sales report was rejected. Reason: ${p.reason} Please report again with the correct sales and evidence.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u304C\u5DEE\u3057\u623B\u3055\u308C\u307E\u3057\u305F\u3002\u7406\u7531\uFF1A${p.reason} \u6B63\u3057\u3044\u58F2\u4E0A\u3068\u8A3C\u6191\u3067\u518D\u5EA6\u5831\u544A\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 판매자 이의 제기 → 구매자 */
  "royalties.objected": {
    title: /* @__PURE__ */ __name((_p, lang) => tr(lang, {
      ko: "\uD310\uB9E4\uC790\uAC00 \uB9E4\uCD9C \uBCF4\uACE0\uC5D0 \uC774\uC758\uB97C \uC81C\uAE30\uD588\uC5B4\uC694",
      en: "The seller objected to your sales report",
      ja: "\u8CA9\u58F2\u8005\u304C\u58F2\u4E0A\u5831\u544A\u306B\u7570\u8B70\u3092\u7533\u3057\u7ACB\u3066\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uC5D0 \uB300\uD574 \uC774\uC758\uAC00 \uC811\uC218\uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason} \uB9E4\uCD9C \uC99D\uBE59\uC744 \uC62C\uB824 \uC8FC\uC2DC\uBA74 \uAD00\uB9AC\uC790\uAC00 \uD655\uC778\uD574\uC694.`,
      en: `An objection was filed against your ${p.period} sales report. Reason: ${p.reason} Upload sales evidence and an admin will review it.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u306B\u7570\u8B70\u304C\u7533\u3057\u7ACB\u3066\u3089\u308C\u307E\u3057\u305F\u3002\u7406\u7531\uFF1A${p.reason} \u58F2\u4E0A\u306E\u8A3C\u6191\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u3044\u305F\u3060\u3051\u308C\u3070\u3001\u7BA1\u7406\u8005\u304C\u78BA\u8A8D\u3057\u307E\u3059\u3002`
    }), "body")
  },
  /** 구매자 매출 보고 → 판매자 */
  "royalties.reported": {
    title: /* @__PURE__ */ __name((_p, lang) => tr(lang, {
      ko: "\uB85C\uC5F4\uD2F0 \uB9E4\uCD9C \uBCF4\uACE0\uAC00 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4",
      en: "A royalty sales report has arrived",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u58F2\u4E0A\u5831\u544A\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0 \u2014 \uB85C\uC5F4\uD2F0 ${p.royaltyAmount.toLocaleString("ko-KR")}\uC6D0\uC774 \uC0B0\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4.`,
      en: `${p.period} sales report: a royalty of ${formatWon(p.royaltyAmount, "en")} was calculated.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A \u2014 \u30ED\u30A4\u30E4\u30EA\u30C6\u30A3${formatWon(p.royaltyAmount, "ja")}\u304C\u7B97\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002`
    }), "body")
  },
  /** 구매자가 입금 확인 전 매출 정정 → 판매자 */
  "royalties.corrected": {
    title: /* @__PURE__ */ __name((_p, lang) => tr(lang, {
      ko: "\uB85C\uC5F4\uD2F0 \uB9E4\uCD9C \uBCF4\uACE0\uAC00 \uC218\uC815\uB410\uC5B4\uC694",
      en: "A royalty sales report was updated",
      ja: "\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u306E\u58F2\u4E0A\u5831\u544A\u304C\u4FEE\u6B63\u3055\u308C\u307E\u3057\u305F"
    }), "title"),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.period} \uB9E4\uCD9C \uBCF4\uACE0\uAC00 \uC218\uC815\uB418\uC5B4 \uB85C\uC5F4\uD2F0\uAC00 ${p.before.toLocaleString("ko-KR")}\uC6D0 \u2192 ${p.after.toLocaleString("ko-KR")}\uC6D0\uC73C\uB85C \uBC14\uB00C\uC5C8\uC5B4\uC694.`,
      en: `The ${p.period} sales report was updated, changing the royalty from ${formatWon(p.before, "en")} to ${formatWon(p.after, "en")}.`,
      ja: `${p.period}\u306E\u58F2\u4E0A\u5831\u544A\u304C\u4FEE\u6B63\u3055\u308C\u3001\u30ED\u30A4\u30E4\u30EA\u30C6\u30A3\u304C${formatWon(p.before, "ja")}\u304B\u3089${formatWon(p.after, "ja")}\u306B\u5909\u308F\u308A\u307E\u3057\u305F\u3002`
    }), "body")
  }
});
var ROYALTIES_NOTICE_SAMPLES = {
  "royalties.evidenceAdded": {
    period: "2026-09"
  },
  "royalties.sellerVoided": {
    period: "2026-09",
    reason: "Revenue does not match the invoice."
  },
  "royalties.objected": {
    period: "2026-09",
    reason: "Revenue looks lower than actual sales."
  },
  "royalties.reported": {
    period: "2026-09",
    royaltyAmount: 12e4
  },
  "royalties.corrected": {
    period: "2026-09",
    before: 12e4,
    after: 9e4
  }
};

// src/notices/sponsorships.ts
var REJECTED_TITLE = {
  ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uAC70\uC808\uB410\uC5B4\uC694",
  en: "Your sponsorship application was declined",
  ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u898B\u9001\u3089\u308C\u307E\u3057\u305F"
};
var SPONSORSHIPS_NOTICES = defineNotices({
  /** 등록자가 협찬 내용을 바꿔 승인 대기 지원이 취소됨 — 지원자에게 */
  "sponsorships.applicationCancelledByEdit": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uCDE8\uC18C\uB410\uC5B4\uC694",
      en: "Your sponsorship application was canceled",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C \uB0B4\uC6A9\uC774 \uBC14\uB00C\uC5B4 \uB300\uAE30 \uC911\uC774\uB358 \uC9C0\uC6D0\uC774 \uCDE8\uC18C\uB410\uC5B4\uC694. \uBC14\uB010 \uB0B4\uC6A9\uC774 \uB2E4\uC2DC \uACF5\uAC1C\uB418\uBA74 \uD655\uC778\uD558\uACE0 \uB2E4\uC2DC \uC9C0\uC6D0\uD574 \uC8FC\uC138\uC694.`,
      en: `"${p.sponsorshipTitle}" was updated, so your pending application was canceled. Once the updated sponsorship is published again, check it and reapply.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306E\u5185\u5BB9\u304C\u5909\u66F4\u3055\u308C\u305F\u305F\u3081\u3001\u627F\u8A8D\u5F85\u3061\u306E\u5FDC\u52DF\u304C\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F\u3002\u5909\u66F4\u5185\u5BB9\u304C\u518D\u516C\u958B\u3055\u308C\u305F\u3089\u3054\u78BA\u8A8D\u306E\u3046\u3048\u3001\u518D\u5EA6\u3054\u5FDC\u52DF\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 모집 마감으로 승인 대기 지원 거절 */
  "sponsorships.rejectedByClose": {
    title: fixedText(REJECTED_TITLE),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C \uBAA8\uC9D1\uC774 \uB9C8\uAC10\uB3FC \uD568\uAED8\uD558\uC9C0 \uBABB\uD558\uAC8C \uB410\uC5B4\uC694.`,
      en: `Recruiting for "${p.sponsorshipTitle}" has closed, so you won't be joining this time.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306E\u52DF\u96C6\u304C\u7DE0\u3081\u5207\u3089\u308C\u305F\u305F\u3081\u3001\u4ECA\u56DE\u306F\u3054\u4E00\u7DD2\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002`
    }), "body")
  },
  /** 자동 승인 협찬에 지원 — 등록자에게 */
  "sponsorships.appliedConfirmed": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uD655\uC815\uB410\uC5B4\uC694",
      en: "A sponsorship application was confirmed",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u78BA\u5B9A\u3057\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.applicantName ?? "\uC9C0\uC6D0\uC790"} \uB2D8\uC774 "${p.sponsorshipTitle}" \uD611\uCC2C\uC5D0 \uC9C0\uC6D0\uD574 \uBC14\uB85C \uD655\uC815\uB410\uC5B4\uC694.`,
      en: `${p.applicantName ?? "An applicant"} applied to "${p.sponsorshipTitle}" and was confirmed right away.`,
      ja: `${p.applicantName ? `${p.applicantName}\u3055\u3093` : "\u5FDC\u52DF\u8005"}\u304C\u300C${p.sponsorshipTitle}\u300D\u306B\u5FDC\u52DF\u3057\u3001\u3059\u3050\u306B\u78BA\u5B9A\u3057\u307E\u3057\u305F\u3002`
    }), "body")
  },
  /** 직접 승인 협찬에 지원 — 등록자에게 */
  "sponsorships.applied": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uB3C4\uCC29\uD588\uC5B4\uC694",
      en: "You received a sponsorship application",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u5C4A\u304D\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.applicantName ?? "\uC9C0\uC6D0\uC790"} \uB2D8\uC774 "${p.sponsorshipTitle}" \uD611\uCC2C\uC5D0 \uC9C0\uC6D0\uD588\uC5B4\uC694. \uD655\uC778\uD558\uACE0 \uC2B9\uC778\uD574 \uC8FC\uC138\uC694.`,
      en: `${p.applicantName ?? "An applicant"} applied to "${p.sponsorshipTitle}". Check and approve the application.`,
      ja: `${p.applicantName ? `${p.applicantName}\u3055\u3093` : "\u5FDC\u52DF\u8005"}\u304C\u300C${p.sponsorshipTitle}\u300D\u306B\u5FDC\u52DF\u3057\u307E\u3057\u305F\u3002\u78BA\u8A8D\u3057\u3066\u627F\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 미션 처음 등록 — 등록자에게 */
  "sponsorships.missionSubmitted": {
    title: fixedText({
      ko: "\uD611\uCC2C \uBBF8\uC158\uC774 \uB4F1\uB85D\uB410\uC5B4\uC694",
      en: "A sponsorship mission was submitted",
      ja: "\u6848\u4EF6\u306E\u30DF\u30C3\u30B7\u30E7\u30F3\u304C\u767B\u9332\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `${p.applicantName ?? "\uC9C0\uC6D0\uC790"} \uB2D8\uC774 "${p.sponsorshipTitle}" \uD611\uCC2C \uBBF8\uC158\uC744 \uC644\uB8CC\uD588\uC5B4\uC694. \uD655\uC778\uD558\uACE0 \uBBF8\uC158 \uD655\uC778\uC744 \uB20C\uB7EC \uC8FC\uC138\uC694.`,
      en: `${p.applicantName ?? "An applicant"} completed the mission for "${p.sponsorshipTitle}". Check it and tap Confirm mission.`,
      ja: `${p.applicantName ? `${p.applicantName}\u3055\u3093` : "\u5FDC\u52DF\u8005"}\u304C\u300C${p.sponsorshipTitle}\u300D\u306E\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u300C\u30DF\u30C3\u30B7\u30E7\u30F3\u78BA\u8A8D\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 미션 확인 — 지원자에게 */
  "sponsorships.missionConfirmed": {
    title: fixedText({
      ko: "\uD611\uCC2C \uBBF8\uC158\uC774 \uD655\uC778\uB410\uC5B4\uC694",
      en: "Your sponsorship mission was confirmed",
      ja: "\u6848\u4EF6\u306E\u30DF\u30C3\u30B7\u30E7\u30F3\u304C\u78BA\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C \uBBF8\uC158\uC744 \uC5C5\uCCB4\uAC00 \uD655\uC778\uD588\uC5B4\uC694. \uD611\uCC2C\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uB9C8\uBB34\uB9AC\uB418\uC5C8\uC5B4\uC694.`,
      en: `The business confirmed your mission for "${p.sponsorshipTitle}". The sponsorship is complete.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306E\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u4E8B\u696D\u8005\u304C\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002\u6848\u4EF6\u304C\u7121\u4E8B\u306B\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002`
    }), "body")
  },
  /** 등록자 승인 — 지원자에게 */
  "sponsorships.approved": {
    title: fixedText({
      ko: "\uD611\uCC2C \uC9C0\uC6D0\uC774 \uC2B9\uC778\uB410\uC5B4\uC694",
      en: "Your sponsorship application was approved",
      ja: "\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u304C\u627F\u8A8D\u3055\u308C\u307E\u3057\u305F"
    }),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C\uC774 \uD655\uC815\uB410\uC5B4\uC694. \uC5C5\uCCB4\uC758 \uC548\uB0B4\uB97C \uAE30\uB2E4\uB824 \uC8FC\uC138\uC694.`,
      en: `You're confirmed for "${p.sponsorshipTitle}". Please wait for instructions from the business.`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u3078\u306E\u53C2\u52A0\u304C\u78BA\u5B9A\u3057\u307E\u3057\u305F\u3002\u4E8B\u696D\u8005\u304B\u3089\u306E\u3054\u6848\u5185\u3092\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002`
    }), "body")
  },
  /** 등록자 거절 — reason 은 등록자가 쓴 글 */
  "sponsorships.rejected": {
    title: fixedText(REJECTED_TITLE),
    body: /* @__PURE__ */ __name((p, lang) => tr(lang, {
      ko: `"${p.sponsorshipTitle}" \uD611\uCC2C\uC5D0 \uD568\uAED8\uD558\uC9C0 \uBABB\uD558\uAC8C \uB410\uC5B4\uC694. \uC0AC\uC720: ${p.reason}`,
      en: `You won't be joining "${p.sponsorshipTitle}" this time. Reason: ${p.reason}`,
      ja: `\u300C${p.sponsorshipTitle}\u300D\u306B\u306F\u4ECA\u56DE\u3054\u4E00\u7DD2\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002\u7406\u7531: ${p.reason}`
    }), "body")
  }
});
var SPONSORSHIPS_NOTICE_SAMPLES = {
  "sponsorships.applicationCancelledByEdit": {
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.rejectedByClose": {
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.appliedConfirmed": {
    applicantName: "Jane",
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.applied": {
    applicantName: null,
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.missionSubmitted": {
    applicantName: "Jane",
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.missionConfirmed": {
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.approved": {
    sponsorshipTitle: "Cafe visit"
  },
  "sponsorships.rejected": {
    sponsorshipTitle: "Cafe visit",
    reason: "Dates are full"
  }
};

// src/notices/index.ts
var NOTICES = {
  ...ORDER_EVENT_NOTICES,
  ...DOMAIN_NOTICES,
  ...ORDERS_NOTICES,
  ...ACCOUNT_NOTICES,
  ...LISTINGS_NOTICES,
  ...ROYALTIES_NOTICES,
  ...PROPOSALS_NOTICES,
  ...SPONSORSHIPS_NOTICES,
  ...COMMUNITY_NOTICES,
  ...MEMBERS_NOTICES,
  ...REMINDERS_NOTICES,
  ...ADMIN_NOTICES
};
var NOTICE_SAMPLES = {
  ...ORDER_EVENT_NOTICE_SAMPLES,
  ...DOMAIN_NOTICE_SAMPLES,
  ...ORDERS_NOTICE_SAMPLES,
  ...ACCOUNT_NOTICE_SAMPLES,
  ...LISTINGS_NOTICE_SAMPLES,
  ...ROYALTIES_NOTICE_SAMPLES,
  ...PROPOSALS_NOTICE_SAMPLES,
  ...SPONSORSHIPS_NOTICE_SAMPLES,
  ...COMMUNITY_NOTICE_SAMPLES,
  ...MEMBERS_NOTICE_SAMPLES,
  ...REMINDERS_NOTICE_SAMPLES,
  ...ADMIN_NOTICE_SAMPLES
};
function renderNotice(key, params, lang) {
  if (!key) return null;
  const template = NOTICES[key];
  if (!template) return null;
  try {
    const p = params ?? {};
    return {
      title: template.title(p, lang),
      body: template.body(p, lang)
    };
  } catch {
    return null;
  }
}
__name(renderNotice, "renderNotice");
function renderChatMessage(key, params, lang) {
  if (!key) return null;
  const template = CHAT_MESSAGES[key];
  if (!template) return null;
  try {
    return template(params ?? {}, lang);
  } catch {
    return null;
  }
}
__name(renderChatMessage, "renderChatMessage");
function chatMessageInAllLangs(key, params) {
  const out = {};
  for (const lang of LANGS) {
    const text = renderChatMessage(key, params, lang);
    if (text === null) return null;
    out[lang] = text;
  }
  return out;
}
__name(chatMessageInAllLangs, "chatMessageInAllLangs");
function notice(key, params) {
  const ko = renderNotice(key, params, "ko");
  if (!ko) throw new Error(`\uC54C\uB9BC \uD2C0\uC744 \uADF8\uB9AC\uC9C0 \uBABB\uD588\uC5B4\uC694: ${key}`);
  return {
    title: ko.title,
    body: ko.body,
    messageKey: key,
    params
  };
}
__name(notice, "notice");
function chatMessage(key, params) {
  const ko = renderChatMessage(key, params, "ko");
  if (ko === null) throw new Error(`\uCC44\uD305 \uBA54\uC2DC\uC9C0 \uD2C0\uC744 \uADF8\uB9AC\uC9C0 \uBABB\uD588\uC5B4\uC694: ${key}`);
  return {
    content: ko,
    messageKey: key,
    messageParams: params
  };
}
__name(chatMessage, "chatMessage");
export {
  ACTIVE_IP_RIGHT_TYPES,
  ADDON_PAYMENT_SYSTEM_MESSAGES,
  ADMIN_ROLES,
  APPEARANCE_ACTIVITY_LABELS,
  APPEARANCE_ACTIVITY_LABELS_I18N,
  APPEARANCE_BOUNDARY,
  APPEARANCE_BOUNDARY_I18N,
  APPEARANCE_CHANNEL_LABELS,
  APPEARANCE_CHANNEL_LABELS_I18N,
  APPEARANCE_MODE_LABELS,
  APPEARANCE_MODE_LABELS_I18N,
  APPEARANCE_ONLINE_FORM_LABELS,
  APPEARANCE_ONLINE_FORM_LABELS_I18N,
  APPEARANCE_OVERTIME_LABELS,
  APPEARANCE_OVERTIME_LABELS_I18N,
  APPEARANCE_PARTICIPATION_LABELS,
  APPEARANCE_PARTICIPATION_LABELS_I18N,
  APPEARANCE_RECORDING_LABELS,
  APPEARANCE_RECORDING_LABELS_I18N,
  APPEARANCE_SERVICE_AREA_NATIONWIDE,
  APPEARANCE_TRAVEL_LABELS,
  APPEARANCE_TRAVEL_LABELS_I18N,
  APPEARANCE_VARIANT_LABELS,
  APPEARANCE_VARIANT_LABELS_I18N,
  APP_PLATFORM_HEADER,
  APP_PLATFORM_LABELS,
  AppPlatform,
  AppearanceActivity,
  AppearanceChannel,
  AppearanceMode,
  AppearanceOvertime,
  AppearanceRecording,
  AppearanceTravel,
  AuthProvider,
  BRAND_ASSET_LABELS,
  BRAND_ASSET_LABELS_I18N,
  BRAND_EXPRESSION_LABELS,
  BRAND_EXPRESSION_LABELS_I18N,
  BRAND_LEGAL_USE_LABELS,
  BRAND_LEGAL_USE_LABELS_I18N,
  BUSINESS,
  BrandAsset,
  BrandExpression,
  BrandLegalUse,
  CHAT_ADDON_PAYMENT_EVENT,
  CHAT_ADMIN_JOINED_MESSAGE,
  CHAT_ADMIN_JOINED_MESSAGE_I18N,
  CHAT_ADMIN_LEFT_MESSAGE,
  CHAT_ADMIN_LEFT_MESSAGE_I18N,
  CHAT_DIRECT_WELCOME_MESSAGE,
  CHAT_DIRECT_WELCOME_MESSAGE_I18N,
  CHAT_LICENSE_AMENDMENT_EVENT,
  CHAT_LICENSE_DRAFT_EVENT,
  CHAT_LICENSE_EXPIRED_EVENT,
  CHAT_LICENSE_ISSUE_DELAYED_EVENT,
  CHAT_LICENSE_SUSPENSION_EVENT,
  CHAT_LISTING_INQUIRY_EVENT_PREFIX,
  CHAT_MESSAGES,
  CHAT_MESSAGE_SAMPLES,
  CHAT_PARTICIPANT_LEFT_MESSAGE,
  CHAT_PARTICIPANT_LEFT_MESSAGE_I18N,
  CHAT_PURCHASE_CONFIRMED_EVENT,
  CHAT_REFUND_EVENT,
  CHAT_REPORT_REASON_LABELS,
  CHAT_REPORT_REASON_LABELS_I18N,
  CHAT_ROOM_CLOSED_MESSAGE_I18N,
  CHAT_ROOM_TYPE_LABELS,
  CHAT_ROOM_TYPE_LABELS_I18N,
  CHAT_ROOM_WELCOME_MESSAGE,
  CHAT_ROOM_WELCOME_MESSAGE_I18N,
  CHAT_ROYALTY_EVENT,
  CHAT_VIOLATION_REPORT_EVENT,
  COMMUNITY_POST_CATEGORY_LABELS,
  COMMUNITY_POST_CATEGORY_LABELS_I18N,
  CO_BRANDING_ARCHIVE_BOUNDARY,
  CO_BRANDING_ARCHIVE_BOUNDARY_I18N,
  CO_BRANDING_ASSET_LABELS,
  CO_BRANDING_ASSET_LABELS_I18N,
  CO_BRANDING_BOUNDARY,
  CO_BRANDING_BOUNDARY_I18N,
  CO_BRANDING_CHANNEL_LABELS,
  CO_BRANDING_CHANNEL_LABELS_I18N,
  CO_BRANDING_EXCLUSIONS,
  CO_BRANDING_EXCLUSIONS_I18N,
  CO_BRANDING_EXPIRY_LABELS,
  CO_BRANDING_EXPIRY_LABELS_I18N,
  CO_BRANDING_WORDING_EXAMPLES,
  CO_BRANDING_WORDING_EXAMPLES_I18N,
  CO_BRANDING_WORDING_GUIDE,
  CO_BRANDING_WORDING_GUIDE_I18N,
  ChatMessageShortcut,
  ChatMessageType,
  ChatParticipantRole,
  ChatReportReason,
  ChatRoomStatus,
  ChatRoomType,
  CoBrandingAsset,
  CoBrandingChannel,
  CoBrandingExpiry,
  CommunityPostCategory,
  ContractTerminationStatus,
  DATE_NUMERIC,
  DATE_TIME,
  DEFAULT_LANG,
  DEFAULT_TIME_ZONE,
  DEPOSITOR_NAME_MAX_LENGTH,
  DEPOSIT_RETURN_KIND_LABELS,
  DEPOSIT_RETURN_KIND_LABELS_I18N,
  DEPOSIT_RETURN_STATUS_LABELS,
  DISPUTABLE_ORDER_STATUSES,
  DISPUTE_DISMISSED_SYSTEM_MESSAGES,
  DISPUTE_DISMISSED_SYSTEM_MESSAGES_I18N,
  DISPUTE_RESOLUTION_LABELS,
  DepositReturnKind,
  DepositReturnStatus,
  DisputeResolution,
  DomainError,
  EXCLUSIVITY_LABELS,
  EXCLUSIVITY_LABELS_I18N,
  EntityNotFoundError,
  Exclusivity,
  FORBIDDEN_INDUSTRY_LABELS,
  FORBIDDEN_INDUSTRY_LABELS_I18N,
  ForbiddenIndustry,
  FulfillmentType,
  INTL_LOCALE,
  IP_RIGHT_LABELS,
  IP_RIGHT_LABELS_I18N,
  InvalidStateTransitionError,
  IpRightType,
  LANGS,
  LICENSE_AMENDMENT_CHAT_MESSAGES,
  LICENSE_AMENDMENT_NOTICES,
  LICENSE_AMENDMENT_STATUS_LABELS,
  LICENSE_AMENDMENT_STATUS_LABELS_I18N,
  LICENSE_DRAFT_SYSTEM_MESSAGES,
  LICENSE_EXPIRED_CHAT_MESSAGE,
  LICENSE_EXPIRED_CHAT_MESSAGE_I18N,
  LICENSE_SUSPENSION_CHAT_MESSAGES,
  LICENSE_SUSPENSION_NOTICES,
  LICENSE_VIEW_STATES,
  LedgerCounterparty,
  LedgerEntryType,
  LicenseAmendmentStatus,
  LicenseStatus,
  ListingOfferStatus,
  ListingStatus,
  MANUAL_CHANNEL_URL_HINT,
  MANUAL_CHANNEL_URL_HINT_I18N,
  MANUAL_SOCIAL_PLATFORMS,
  MAX_CUSTOM_FORBIDDEN_INDUSTRIES,
  MAX_FORBIDDEN_INDUSTRY_LENGTH,
  MAX_NOTE_ITEMS,
  MAX_NOTE_ITEM_LENGTH,
  MEDIA_USAGE_DESCRIPTION,
  MEDIA_USAGE_DESCRIPTION_I18N,
  MERCHANDISE_ASSET_LABELS,
  MERCHANDISE_ASSET_LABELS_I18N,
  MERCHANDISE_CHANNEL_LABELS,
  MERCHANDISE_CHANNEL_LABELS_I18N,
  MERCHANDISE_DISTRIBUTION_LABELS,
  MERCHANDISE_DISTRIBUTION_LABELS_I18N,
  MERCHANDISE_INVENTORY_LABELS,
  MERCHANDISE_INVENTORY_LABELS_I18N,
  MERCHANDISE_MAX_QUANTITY,
  MERCHANDISE_PRODUCT_LABELS,
  MERCHANDISE_PRODUCT_LABELS_I18N,
  MERCHANDISE_QUANTITY_BASIS,
  MERCHANDISE_QUANTITY_BASIS_I18N,
  MERCHANDISE_REPRODUCTION_LABELS,
  MERCHANDISE_REPRODUCTION_LABELS_I18N,
  MERCHANDISE_USAGE_BOUNDARY,
  MERCHANDISE_USAGE_BOUNDARY_I18N,
  MODIFICATION_RIGHT_LABELS,
  MODIFICATION_RIGHT_LABELS_I18N,
  MerchandiseAsset,
  MerchandiseChannel,
  MerchandiseDistribution,
  MerchandiseInventory,
  MerchandiseProduct,
  MerchandiseReproduction,
  ModificationRight,
  NICKNAME_PATTERN,
  NICKNAME_RULE_MESSAGE,
  NICKNAME_RULE_MESSAGE_I18N,
  NOTICES,
  NOTICE_SAMPLES,
  NotificationCategory,
  NotificationType,
  OAUTH_PROVIDERS,
  OFFER_DURATION_MONTHS,
  OFFER_TERM_ROW_KEYS,
  OPTIONAL_NOTIFICATION_CATEGORIES,
  ORDER_ISSUE_LABELS,
  ORDER_ISSUE_LABELS_I18N,
  ORDER_STATUS_LABELS,
  ORDER_STATUS_LABELS_I18N,
  ORDER_STATUS_SYSTEM_MESSAGE,
  ORDER_STATUS_SYSTEM_MESSAGE_I18N,
  ORDER_STATUS_TRANSITIONS,
  OUTSTANDING_PAYOUT_CLAWBACK_STATUSES,
  OrderIssue,
  OrderStatus,
  PAGINATION,
  PAYMENT_STATUS_TRANSITIONS,
  PAYOUT_BANKS,
  PAYOUT_CLAWBACK_STATUS_LABELS,
  PAYOUT_CLAWBACK_STATUS_LABELS_I18N,
  PAYOUT_CLAWBACK_SUSPEND_REASON,
  PAYOUT_CLAWBACK_SUSPEND_REASON_I18N,
  PERSONAL_USAGE_BOUNDARY,
  PERSONAL_USAGE_BOUNDARY_I18N,
  PHONE_COUNTRY_CODES,
  POLICY_DEFAULT_LANGUAGE,
  POLICY_LANGUAGES,
  POLICY_LANGUAGE_LABELS,
  POLICY_LANGUAGE_LABELS_I18N,
  POLICY_VERSION_STATUS_LABELS,
  PRICING_MODEL_LABELS,
  PRICING_MODEL_LABELS_I18N,
  PROPOSAL_PRICE_ROW_KEYS,
  PROPOSAL_STATUS_LABELS,
  PROPOSAL_STATUS_LABELS_I18N,
  PUBLIC_VISIBLE_LISTING_STATUSES,
  PaymentKind,
  PaymentMethod,
  PaymentStatus,
  PayoutClawbackStatus,
  PolicyLanguage,
  PolicyVersionStatus,
  PricingModel,
  ProposalListTab,
  ProposalStatus,
  PushPlatform,
  REFUND_NOTICE,
  REFUND_NOTICE_I18N,
  REFUND_STATUS_TRANSITIONS,
  REPORT_STATUS_LABELS,
  RIGHT_TYPE_FORM_CONFIG,
  RIGHT_TYPE_REGION_LABELS,
  RIGHT_TYPE_REGION_LABELS_I18N,
  ROYALTY_CHAT_MESSAGES,
  ROYALTY_FILE_RULES,
  ROYALTY_REPORTABLE_ORDER_STATUSES,
  RefundStatus,
  ReportStatus,
  RoyaltyObjectionStatus,
  RoyaltyReportKind,
  RoyaltyReportStatus,
  SCHEDULER_JOB_KEYS,
  SCHEDULER_JOB_STATUS_LABELS,
  SCHEDULES,
  SHIPMENT_STATUS_TRANSITIONS,
  SIMPLE_PIN_LENGTH,
  SIMPLE_PIN_LOCK_MINUTES,
  SIMPLE_PIN_MAX_ATTEMPTS,
  SIMPLE_PIN_PATTERN,
  SOCIAL_CHANNEL_REQUEST_STATUS_LABELS,
  SOCIAL_PLATFORM_LABELS,
  SOCIAL_PLATFORM_LABELS_I18N,
  SPECIAL_TERMS_PLACEHOLDERS,
  SPECIAL_TERMS_PLACEHOLDERS_I18N,
  SPONSORSHIP_APPLICATION_STATUS_LABELS,
  SPONSORSHIP_APPLICATION_STATUS_LABELS_I18N,
  SPONSORSHIP_APPROVAL_MODE_LABELS,
  SPONSORSHIP_APPROVAL_MODE_LABELS_I18N,
  SPONSORSHIP_ELIGIBILITY_PLATFORMS,
  SPONSORSHIP_MISSION_LINKS_MAX,
  SPONSORSHIP_MISSION_TEXT_MAX,
  SPONSORSHIP_REGION_LABELS,
  SPONSORSHIP_REGION_LABELS_I18N,
  SPONSORSHIP_STATUS_LABELS,
  SPONSORSHIP_STATUS_LABELS_I18N,
  SUPPORT_INQUIRY_BODY_MAX,
  SUPPORT_INQUIRY_BODY_MIN,
  SUPPORT_INQUIRY_CATEGORY_LABELS,
  SUPPORT_INQUIRY_CATEGORY_LABELS_I18N,
  SUPPORT_INQUIRY_OPEN_MAX,
  SUPPORT_INQUIRY_STATUS_LABELS,
  SUPPORT_INQUIRY_STATUS_LABELS_I18N,
  SUPPORT_INQUIRY_TITLE_MAX,
  SchedulerJobStatus,
  SessionClient,
  SettlementStatus,
  ShipmentStatus,
  SocialChannelRequestStatus,
  SocialPlatform,
  SponsorshipApplicationStatus,
  SponsorshipApprovalMode,
  SponsorshipRegion,
  SponsorshipStatus,
  SupportInquiryCategory,
  SupportInquiryStatus,
  SupportMessageAuthor,
  TERMINAL_ORDER_STATUSES,
  TERMINAL_PAYMENT_STATUSES,
  TERMINAL_REFUND_STATUSES,
  TERMINATION_CANCELLED_SYSTEM_MESSAGE,
  TERMINATION_CANCELLED_SYSTEM_MESSAGE_I18N,
  TERMINATION_KIND_LABELS,
  TERMINATION_KIND_LABELS_I18N,
  TERMINATION_REFUND_MODE_LABELS,
  TERMINATION_REFUND_MODE_LABELS_I18N,
  TerminationKind,
  TerminationRefundMode,
  USAGE_CHANNEL_LABELS,
  USAGE_CHANNEL_LABELS_I18N,
  USAGE_PLACEMENT_LABELS,
  USAGE_PLACEMENT_LABELS_I18N,
  USAGE_PURPOSE_LABELS,
  USAGE_PURPOSE_LABELS_I18N,
  USAGE_REGION_LABELS,
  USAGE_REGION_LABELS_I18N,
  USAGE_SCOPE_ROW_KEYS,
  UnauthorizedActorError,
  UsageChannel,
  UsagePlacement,
  UsagePurpose,
  UsageRegion,
  UserRole,
  VIOLATION_POLICY_LABELS,
  VIOLATION_POLICY_LABELS_I18N,
  VIOLATION_REPORTABLE_ORDER_STATUSES,
  VIOLATION_REPORT_CHAT_MESSAGES,
  VIOLATION_REPORT_CHAT_MESSAGES_I18N,
  VIOLATION_REPORT_RESOLUTION_LABELS,
  VOICE_GENERATION_BOUNDARY,
  VOICE_GENERATION_BOUNDARY_I18N,
  VOICE_GENERATION_EXPIRY,
  VOICE_GENERATION_EXPIRY_I18N,
  VOICE_GENERATION_METHOD_LABELS,
  VOICE_GENERATION_METHOD_LABELS_I18N,
  VOICE_OFFERING_LABELS,
  VOICE_OFFERING_LABELS_I18N,
  VOICE_SERVICE_COST_LABELS,
  VOICE_SERVICE_COST_LABELS_I18N,
  VOICE_SOURCE_LABELS,
  VOICE_SOURCE_LABELS_I18N,
  VOICE_USAGE_BOUNDARY,
  VOICE_USAGE_BOUNDARY_I18N,
  ViolationPolicy,
  ViolationReportResolution,
  VoiceGenerationMethod,
  VoiceOfferingMode,
  VoiceServiceCostBearer,
  VoiceSource,
  WithdrawalBlockedError,
  addContractMonths,
  addDateDays,
  addMoney,
  addPeriodMonths,
  addonMonthsOf,
  alignPurchaseConfirmDue,
  appearanceActivityLabel,
  appearanceActivityLabels,
  appearanceActivityRecordings,
  appearanceAllowsPublicRecording,
  appearanceContractSelection,
  appearanceIncludedActivities,
  appearanceMinimumPrice,
  appearanceOffer,
  appearancePackageMinimum,
  appearancePackageRequiresRecording,
  appearancePackageTotal,
  appearancePriceBasis,
  appearancePublicActivities,
  appearancePublicRecordingLabel,
  appearanceScopeRows,
  appearanceSessionOffer,
  appearanceVariantMode,
  appearanceVariantScope,
  appearanceVariants,
  asAssetId,
  asLicenseId,
  asListingId,
  asOrderId,
  asSettlementId,
  asUserId,
  buildPage,
  chatMessage,
  chatMessageInAllLangs,
  chatMessageShortcutOf,
  classifyOfferChange,
  coBrandingContractSelection,
  coBrandingPriceBasis,
  coBrandingScopeRows,
  communityActivityConditions,
  defaultAppearanceScope,
  defaultCoBrandingScope,
  defaultDepositorName,
  defaultMerchandiseScope,
  defaultUsageScope,
  defineChatMessages,
  defineNotices,
  entityLabel,
  entityLabelIn,
  err,
  errorCodeFromMessage,
  errorMessageIn,
  feeRateLabel,
  fixedText,
  followerUnit,
  forbiddenIndustryKey,
  forbiddenIndustryLabel,
  formatDateDots,
  formatFollowers,
  formatInTimeZone,
  formatPhoneNumberLocal,
  formatWon,
  getUsagePurpose,
  hasAppearancePackageRecordings,
  inAllLangs,
  inheritedAppearancePackageRecording,
  inquiryListingIdOf,
  isAdminRole,
  isAdultIndustryForbidden,
  isAppearanceChannel,
  isCampaignPricedScope,
  isCategoryPushEnabled,
  isCoBrandingChannel,
  isEmailNotification,
  isGiveawayOnly,
  isMediaUsageScope,
  isPersonalUsage,
  isPresetForbiddenIndustry,
  isProposalOptionSelected,
  isPushEnabled,
  isRoyaltyReportOverdue,
  isSimpleOnlineAppearance,
  isTerminalOrderStatus,
  isTooSimplePin,
  isValidDateOnly,
  isValidTimeZone,
  joinNoteItems,
  josa,
  koreanErrorMessage,
  krw,
  lastUseDateOf,
  licenseDraftFormOf,
  licenseIssueDelayCutoff,
  licenseIssueDelayedChatMessage,
  licenseIssueDelayedDays,
  licenseIssuedChatMessage,
  licenseViewStateOf,
  lowercaseUuidValues,
  lowercaseUuidsInUrl,
  manualChannelKey,
  mediaUsageChannels,
  memberDisplayName,
  merchandiseContractSelection,
  merchandisePriceBasis,
  merchandiseScopeRows,
  monthlyAddonLabel,
  multiplyMoney,
  normalizeForbiddenIndustry,
  normalizePhoneNumber,
  noteItemsOf,
  notice,
  notificationCategoryOf,
  notificationTypesOf,
  numberedNoteText,
  offerHasProposal,
  offerPurchaseOptions,
  offerTermsRows,
  ok,
  platformFeeOf,
  proposalAddonAmount,
  proposalFormOfTerms,
  proposalFormsOfOffer,
  proposalOptionGroups,
  proposalPriceRows,
  proposalQuantityFields,
  proposalSourceOf,
  purchaseConfirmedChatMessage,
  rateBpLabel,
  refundRejectedChatMessage,
  refundRequestedChatMessage,
  renderChatMessage,
  renderNotice,
  reportableRoyaltyPeriods,
  requiresIssueAgreement,
  royaltyDueDate,
  royaltyPeriodError,
  royaltyPeriodRange,
  royaltyPeriodWindow,
  royaltyRangeOf,
  sanitizeNickname,
  sellerShareOf,
  sessionClientOf,
  sponsorshipRequirementLabels,
  sponsorshipViewConditions,
  startOfZonedDate,
  statusLabel,
  statusLabelIn,
  subtractMoney,
  supportsUsagePurpose,
  timeZoneLabel,
  toLang,
  toPolicyLanguage,
  tr,
  usagePriceBasis,
  usageScopeRows,
  usesAppearanceSessionRecording,
  voiceUsageBoundary,
  withAppearanceActivityRecordings,
  withAppearancePackages,
  withAppearanceRecordingPolicy,
  zonedDateOf,
  zonedParts,
  zonedPeriodOf,
  zonedTimeToUtc
};
//# sourceMappingURL=index.js.map